(self["webpackChunkheyholy_ss_theme"] = self["webpackChunkheyholy_ss_theme"] || []).push([["/assets/quiz-v2"],{

/***/ "./node_modules/lz-string/libs/lz-string.js":
/*!**************************************************!*\
  !*** ./node_modules/lz-string/libs/lz-string.js ***!
  \**************************************************/
/***/ ((module, exports, __webpack_require__) => {

var __WEBPACK_AMD_DEFINE_RESULT__;// Copyright (c) 2013 Pieroxy <pieroxy@pieroxy.net>
// This work is free. You can redistribute it and/or modify it
// under the terms of the WTFPL, Version 2
// For more information see LICENSE.txt or http://www.wtfpl.net/
//
// For more information, the home page:
// http://pieroxy.net/blog/pages/lz-string/testing.html
//
// LZ-based compression algorithm, version 1.4.5
var LZString = (function() {

// private property
var f = String.fromCharCode;
var keyStrBase64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
var keyStrUriSafe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$";
var baseReverseDic = {};

function getBaseValue(alphabet, character) {
  if (!baseReverseDic[alphabet]) {
    baseReverseDic[alphabet] = {};
    for (var i=0 ; i<alphabet.length ; i++) {
      baseReverseDic[alphabet][alphabet.charAt(i)] = i;
    }
  }
  return baseReverseDic[alphabet][character];
}

var LZString = {
  compressToBase64 : function (input) {
    if (input == null) return "";
    var res = LZString._compress(input, 6, function(a){return keyStrBase64.charAt(a);});
    switch (res.length % 4) { // To produce valid Base64
    default: // When could this happen ?
    case 0 : return res;
    case 1 : return res+"===";
    case 2 : return res+"==";
    case 3 : return res+"=";
    }
  },

  decompressFromBase64 : function (input) {
    if (input == null) return "";
    if (input == "") return null;
    return LZString._decompress(input.length, 32, function(index) { return getBaseValue(keyStrBase64, input.charAt(index)); });
  },

  compressToUTF16 : function (input) {
    if (input == null) return "";
    return LZString._compress(input, 15, function(a){return f(a+32);}) + " ";
  },

  decompressFromUTF16: function (compressed) {
    if (compressed == null) return "";
    if (compressed == "") return null;
    return LZString._decompress(compressed.length, 16384, function(index) { return compressed.charCodeAt(index) - 32; });
  },

  //compress into uint8array (UCS-2 big endian format)
  compressToUint8Array: function (uncompressed) {
    var compressed = LZString.compress(uncompressed);
    var buf=new Uint8Array(compressed.length*2); // 2 bytes per character

    for (var i=0, TotalLen=compressed.length; i<TotalLen; i++) {
      var current_value = compressed.charCodeAt(i);
      buf[i*2] = current_value >>> 8;
      buf[i*2+1] = current_value % 256;
    }
    return buf;
  },

  //decompress from uint8array (UCS-2 big endian format)
  decompressFromUint8Array:function (compressed) {
    if (compressed===null || compressed===undefined){
        return LZString.decompress(compressed);
    } else {
        var buf=new Array(compressed.length/2); // 2 bytes per character
        for (var i=0, TotalLen=buf.length; i<TotalLen; i++) {
          buf[i]=compressed[i*2]*256+compressed[i*2+1];
        }

        var result = [];
        buf.forEach(function (c) {
          result.push(f(c));
        });
        return LZString.decompress(result.join(''));

    }

  },


  //compress into a string that is already URI encoded
  compressToEncodedURIComponent: function (input) {
    if (input == null) return "";
    return LZString._compress(input, 6, function(a){return keyStrUriSafe.charAt(a);});
  },

  //decompress from an output of compressToEncodedURIComponent
  decompressFromEncodedURIComponent:function (input) {
    if (input == null) return "";
    if (input == "") return null;
    input = input.replace(/ /g, "+");
    return LZString._decompress(input.length, 32, function(index) { return getBaseValue(keyStrUriSafe, input.charAt(index)); });
  },

  compress: function (uncompressed) {
    return LZString._compress(uncompressed, 16, function(a){return f(a);});
  },
  _compress: function (uncompressed, bitsPerChar, getCharFromInt) {
    if (uncompressed == null) return "";
    var i, value,
        context_dictionary= {},
        context_dictionaryToCreate= {},
        context_c="",
        context_wc="",
        context_w="",
        context_enlargeIn= 2, // Compensate for the first entry which should not count
        context_dictSize= 3,
        context_numBits= 2,
        context_data=[],
        context_data_val=0,
        context_data_position=0,
        ii;

    for (ii = 0; ii < uncompressed.length; ii += 1) {
      context_c = uncompressed.charAt(ii);
      if (!Object.prototype.hasOwnProperty.call(context_dictionary,context_c)) {
        context_dictionary[context_c] = context_dictSize++;
        context_dictionaryToCreate[context_c] = true;
      }

      context_wc = context_w + context_c;
      if (Object.prototype.hasOwnProperty.call(context_dictionary,context_wc)) {
        context_w = context_wc;
      } else {
        if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate,context_w)) {
          if (context_w.charCodeAt(0)<256) {
            for (i=0 ; i<context_numBits ; i++) {
              context_data_val = (context_data_val << 1);
              if (context_data_position == bitsPerChar-1) {
                context_data_position = 0;
                context_data.push(getCharFromInt(context_data_val));
                context_data_val = 0;
              } else {
                context_data_position++;
              }
            }
            value = context_w.charCodeAt(0);
            for (i=0 ; i<8 ; i++) {
              context_data_val = (context_data_val << 1) | (value&1);
              if (context_data_position == bitsPerChar-1) {
                context_data_position = 0;
                context_data.push(getCharFromInt(context_data_val));
                context_data_val = 0;
              } else {
                context_data_position++;
              }
              value = value >> 1;
            }
          } else {
            value = 1;
            for (i=0 ; i<context_numBits ; i++) {
              context_data_val = (context_data_val << 1) | value;
              if (context_data_position ==bitsPerChar-1) {
                context_data_position = 0;
                context_data.push(getCharFromInt(context_data_val));
                context_data_val = 0;
              } else {
                context_data_position++;
              }
              value = 0;
            }
            value = context_w.charCodeAt(0);
            for (i=0 ; i<16 ; i++) {
              context_data_val = (context_data_val << 1) | (value&1);
              if (context_data_position == bitsPerChar-1) {
                context_data_position = 0;
                context_data.push(getCharFromInt(context_data_val));
                context_data_val = 0;
              } else {
                context_data_position++;
              }
              value = value >> 1;
            }
          }
          context_enlargeIn--;
          if (context_enlargeIn == 0) {
            context_enlargeIn = Math.pow(2, context_numBits);
            context_numBits++;
          }
          delete context_dictionaryToCreate[context_w];
        } else {
          value = context_dictionary[context_w];
          for (i=0 ; i<context_numBits ; i++) {
            context_data_val = (context_data_val << 1) | (value&1);
            if (context_data_position == bitsPerChar-1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
            value = value >> 1;
          }


        }
        context_enlargeIn--;
        if (context_enlargeIn == 0) {
          context_enlargeIn = Math.pow(2, context_numBits);
          context_numBits++;
        }
        // Add wc to the dictionary.
        context_dictionary[context_wc] = context_dictSize++;
        context_w = String(context_c);
      }
    }

    // Output the code for w.
    if (context_w !== "") {
      if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate,context_w)) {
        if (context_w.charCodeAt(0)<256) {
          for (i=0 ; i<context_numBits ; i++) {
            context_data_val = (context_data_val << 1);
            if (context_data_position == bitsPerChar-1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
          }
          value = context_w.charCodeAt(0);
          for (i=0 ; i<8 ; i++) {
            context_data_val = (context_data_val << 1) | (value&1);
            if (context_data_position == bitsPerChar-1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
            value = value >> 1;
          }
        } else {
          value = 1;
          for (i=0 ; i<context_numBits ; i++) {
            context_data_val = (context_data_val << 1) | value;
            if (context_data_position == bitsPerChar-1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
            value = 0;
          }
          value = context_w.charCodeAt(0);
          for (i=0 ; i<16 ; i++) {
            context_data_val = (context_data_val << 1) | (value&1);
            if (context_data_position == bitsPerChar-1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
            value = value >> 1;
          }
        }
        context_enlargeIn--;
        if (context_enlargeIn == 0) {
          context_enlargeIn = Math.pow(2, context_numBits);
          context_numBits++;
        }
        delete context_dictionaryToCreate[context_w];
      } else {
        value = context_dictionary[context_w];
        for (i=0 ; i<context_numBits ; i++) {
          context_data_val = (context_data_val << 1) | (value&1);
          if (context_data_position == bitsPerChar-1) {
            context_data_position = 0;
            context_data.push(getCharFromInt(context_data_val));
            context_data_val = 0;
          } else {
            context_data_position++;
          }
          value = value >> 1;
        }


      }
      context_enlargeIn--;
      if (context_enlargeIn == 0) {
        context_enlargeIn = Math.pow(2, context_numBits);
        context_numBits++;
      }
    }

    // Mark the end of the stream
    value = 2;
    for (i=0 ; i<context_numBits ; i++) {
      context_data_val = (context_data_val << 1) | (value&1);
      if (context_data_position == bitsPerChar-1) {
        context_data_position = 0;
        context_data.push(getCharFromInt(context_data_val));
        context_data_val = 0;
      } else {
        context_data_position++;
      }
      value = value >> 1;
    }

    // Flush the last char
    while (true) {
      context_data_val = (context_data_val << 1);
      if (context_data_position == bitsPerChar-1) {
        context_data.push(getCharFromInt(context_data_val));
        break;
      }
      else context_data_position++;
    }
    return context_data.join('');
  },

  decompress: function (compressed) {
    if (compressed == null) return "";
    if (compressed == "") return null;
    return LZString._decompress(compressed.length, 32768, function(index) { return compressed.charCodeAt(index); });
  },

  _decompress: function (length, resetValue, getNextValue) {
    var dictionary = [],
        next,
        enlargeIn = 4,
        dictSize = 4,
        numBits = 3,
        entry = "",
        result = [],
        i,
        w,
        bits, resb, maxpower, power,
        c,
        data = {val:getNextValue(0), position:resetValue, index:1};

    for (i = 0; i < 3; i += 1) {
      dictionary[i] = i;
    }

    bits = 0;
    maxpower = Math.pow(2,2);
    power=1;
    while (power!=maxpower) {
      resb = data.val & data.position;
      data.position >>= 1;
      if (data.position == 0) {
        data.position = resetValue;
        data.val = getNextValue(data.index++);
      }
      bits |= (resb>0 ? 1 : 0) * power;
      power <<= 1;
    }

    switch (next = bits) {
      case 0:
          bits = 0;
          maxpower = Math.pow(2,8);
          power=1;
          while (power!=maxpower) {
            resb = data.val & data.position;
            data.position >>= 1;
            if (data.position == 0) {
              data.position = resetValue;
              data.val = getNextValue(data.index++);
            }
            bits |= (resb>0 ? 1 : 0) * power;
            power <<= 1;
          }
        c = f(bits);
        break;
      case 1:
          bits = 0;
          maxpower = Math.pow(2,16);
          power=1;
          while (power!=maxpower) {
            resb = data.val & data.position;
            data.position >>= 1;
            if (data.position == 0) {
              data.position = resetValue;
              data.val = getNextValue(data.index++);
            }
            bits |= (resb>0 ? 1 : 0) * power;
            power <<= 1;
          }
        c = f(bits);
        break;
      case 2:
        return "";
    }
    dictionary[3] = c;
    w = c;
    result.push(c);
    while (true) {
      if (data.index > length) {
        return "";
      }

      bits = 0;
      maxpower = Math.pow(2,numBits);
      power=1;
      while (power!=maxpower) {
        resb = data.val & data.position;
        data.position >>= 1;
        if (data.position == 0) {
          data.position = resetValue;
          data.val = getNextValue(data.index++);
        }
        bits |= (resb>0 ? 1 : 0) * power;
        power <<= 1;
      }

      switch (c = bits) {
        case 0:
          bits = 0;
          maxpower = Math.pow(2,8);
          power=1;
          while (power!=maxpower) {
            resb = data.val & data.position;
            data.position >>= 1;
            if (data.position == 0) {
              data.position = resetValue;
              data.val = getNextValue(data.index++);
            }
            bits |= (resb>0 ? 1 : 0) * power;
            power <<= 1;
          }

          dictionary[dictSize++] = f(bits);
          c = dictSize-1;
          enlargeIn--;
          break;
        case 1:
          bits = 0;
          maxpower = Math.pow(2,16);
          power=1;
          while (power!=maxpower) {
            resb = data.val & data.position;
            data.position >>= 1;
            if (data.position == 0) {
              data.position = resetValue;
              data.val = getNextValue(data.index++);
            }
            bits |= (resb>0 ? 1 : 0) * power;
            power <<= 1;
          }
          dictionary[dictSize++] = f(bits);
          c = dictSize-1;
          enlargeIn--;
          break;
        case 2:
          return result.join('');
      }

      if (enlargeIn == 0) {
        enlargeIn = Math.pow(2, numBits);
        numBits++;
      }

      if (dictionary[c]) {
        entry = dictionary[c];
      } else {
        if (c === dictSize) {
          entry = w + w.charAt(0);
        } else {
          return null;
        }
      }
      result.push(entry);

      // Add w+entry[0] to the dictionary.
      dictionary[dictSize++] = w + entry.charAt(0);
      enlargeIn--;

      w = entry;

      if (enlargeIn == 0) {
        enlargeIn = Math.pow(2, numBits);
        numBits++;
      }

    }
  }
};
  return LZString;
})();

if (true) {
  !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () { return LZString; }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else // removed by dead control flow
{}


/***/ }),

/***/ "./src/assets/js/quiz-components-v2/breed-radio-selector.js":
/*!******************************************************************!*\
  !*** ./src/assets/js/quiz-components-v2/breed-radio-selector.js ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
/**
 * Breed Radio Selector Component
 * Handles radio button interactions for breed selection
 * Shows/hides breed dropdowns based on selection
 */
var BreedRadioSelector = /*#__PURE__*/function (_HTMLElement) {
  function BreedRadioSelector() {
    var _this;
    _classCallCheck(this, BreedRadioSelector);
    _this = _callSuper(this, BreedRadioSelector);
    _this.radioButtons = null;
    _this.nextButton = null;
    _this.quizContainer = null;
    _this.breedDropdown1 = null;
    _this.breedDropdown2 = null;
    _this.entry = _this.dataset.entry;
    _this.boundHandleRadioChange = _this.handleRadioChange.bind(_this);
    _this.initialized = false;
    _this.nothingFoundText = null;
    _this.lastTrackedValue = null;
    _this.lastTrackedTime = 0;
    _this.slideIndex = null; // Store slide index when component is initialized
    return _this;
  }
  _inherits(BreedRadioSelector, _HTMLElement);
  return _createClass(BreedRadioSelector, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      var currentSlide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      // Always update references to ensure they're fresh
      this.quizContainer = this.closest('quiz-container');
      this.radioButtons = this.querySelectorAll('.custom-radio-button__input');
      this.nextButton = document.querySelector('.button--next');

      // Get dropdown wrappers by radio group
      this.purebredDropdown = this.querySelector('[data-for-radio="purebred"]');
      this.mixedDropdowns = this.querySelector('[data-for-radio="mixed"]');
      this.nothingFoundText = this.dataset.nonameText;
      this.titleContainer = this.querySelector('.title-label');
      if (!this.radioButtons.length) return;

      // CRITICAL: Always update slideIndex when init() is called
      // This ensures correct tracking even when navigating back/forward
      if (this.quizContainer && this.quizContainer.activeSlider) {
        this.slideIndex = this.quizContainer.activeSlider.activeIndex;
        console.log('breed-radio-selector: Updated slideIndex to', this.slideIndex);
      }

      // If already initialized, only update references and re-validate
      if (this.initialized) {
        console.log('breed-radio-selector: Re-initializing (updating references)');

        // CRITICAL: Only update and validate if this component is currently visible
        // Use currentSlide if provided (more reliable than CSS class during transitions)
        // This prevents invisible breed-selector from affecting button state
        // when user navigates to other slides (e.g., back to custom-input-text)
        var isOnCurrentSlide = currentSlide ? currentSlide.contains(this) : this.isVisible();
        if (!isOnCurrentSlide) {
          console.log('breed-radio-selector: Not on current slide, skipping all validation and button control');
          return;
        }

        // Update dog name
        this.updateDogName();

        // Re-validate current state only when visible
        // Pass currentSlide to validateSelection for reliable button control
        this.validateSelection(currentSlide);
        return;
      }

      // First-time initialization
      this.initialized = true;
      console.log('breed-radio-selector: First-time initialization, slideIndex:', this.slideIndex);

      // Initially disable next button (force disable without visibility check)
      if (this.nextButton) {
        this.nextButton.classList.add('button--disabled');
        this.nextButton.disabled = true;
      }

      // Hide all dropdowns initially
      this.hideAllDropdowns();

      // Add event listeners to all radio buttons
      this.radioButtons.forEach(function (radio) {
        radio.addEventListener('click', _this2.boundHandleRadioChange, {
          passive: true
        });
      });

      // Add event listeners to breed inputs for validation
      this.addInputListeners();

      // Listen for slide changes to update dog name
      this.setupSlideChangeListener();

      // Check if there's saved state
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      var hasSavedState = quizData.dropdownStates && quizData.dropdownStates[this.entry];
      if (hasSavedState) {
        // Restore state if exists
        this.restoreState();
      } else {
        // Initialize with first radio button checked and dropdown visible
        this.initializeDefaultState();
      }

      // Initial validation after setup
      setTimeout(function () {
        _this2.validateSelection();
      }, 100);
    }
  }, {
    key: "setupSlideChangeListener",
    value: function setupSlideChangeListener() {
      var _this3 = this;
      document.addEventListener('sliderChange', function () {
        // Only update if this component is visible (on current slide)
        if (_this3.isVisible()) {
          _this3.updateDogName();
        }
      });
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      // Check if component is in the active swiper slide
      var swiperSlide = this.closest('.swiper-slide');
      if (swiperSlide && !swiperSlide.classList.contains('swiper-slide-active')) {
        return false;
      }
      return this.offsetParent !== null && window.getComputedStyle(this).display !== 'none';
    }
  }, {
    key: "updateDogName",
    value: function updateDogName() {
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      var dogName = quizData.dogName || quizData.name;
      var nameSpan = this.querySelector('.dog-name');

      // If there's a .dog-name placeholder
      if (nameSpan) {
        if (dogName && dogName.trim() !== '') {
          // Update with actual dog name
          nameSpan.textContent = dogName;
        } else if (this.titleContainer && this.nothingFoundText) {
          // Show "Nothing found" only if name placeholder exists but no name available
          this.titleContainer.innerHTML = this.nothingFoundText;
        }
      }
      // If no .dog-name placeholder exists, do nothing (title doesn't need dog name)
    }
  }, {
    key: "initializeDefaultState",
    value: function initializeDefaultState() {
      var firstRadio = this.querySelector('.custom-radio-button__input[value="purebred"]');
      if (firstRadio) {
        firstRadio.checked = true;
        this.updateRadioStates();
        this.showDropdown(this.purebredDropdown);
        this.restoreDropdownValues(this.purebredDropdown);
        this.validateSelection();
      }
    }
  }, {
    key: "addInputListeners",
    value: function addInputListeners() {
      var _this4 = this;
      var inputs = this.querySelectorAll('.breed-dropdown__wrapper__text');
      inputs.forEach(function (input) {
        input.addEventListener('input', function () {
          console.log('Input event triggered on:', input.id || input.name);
          _this4.validateSelection();
        });
        input.addEventListener('change', function () {
          console.log('Change event triggered on:', input.id || input.name);
          _this4.validateSelection();
        });
        input.addEventListener('blur', function () {
          console.log('Blur event triggered on:', input.id || input.name);
          _this4.validateSelection();
        });
      });
    }
  }, {
    key: "handleRadioChange",
    value: function handleRadioChange(event) {
      var _this5 = this;
      var radio = event.target;

      // Uncheck all other radios first
      this.radioButtons.forEach(function (r) {
        if (r !== radio) {
          r.checked = false;
        }
      });

      // Check the clicked radio
      radio.checked = true;
      var selectedValue = radio.value;

      // Update visual state immediately
      requestAnimationFrame(function () {
        _this5.updateRadioStates();
        _this5.handleDropdownVisibility(selectedValue);
        _this5.saveDropdownState(); // Save immediately when radio changes
        _this5.validateSelection();
      });
    }
  }, {
    key: "handleDropdownVisibility",
    value: function handleDropdownVisibility(selectedValue) {
      var _quizData$dropdownSta;
      this.hideAllDropdowns();

      // Get current saved state
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      var savedString = (_quizData$dropdownSta = quizData.dropdownStates) === null || _quizData$dropdownSta === void 0 ? void 0 : _quizData$dropdownSta[this.entry];
      var parsedData = savedString ? this.parseDropdownState(savedString) : null;
      switch (selectedValue) {
        case 'purebred':
          this.showDropdown(this.purebredDropdown);

          // Only restore if saved state matches current selection
          if ((parsedData === null || parsedData === void 0 ? void 0 : parsedData.breedType) === 'purebred') {
            this.restoreDropdownValues(this.purebredDropdown);
          } else {
            // Clear purebred dropdown if switching from other type
            this.clearDropdownValues(this.purebredDropdown);
          }
          this.validateSelection();
          break;
        case 'mixed':
          this.showDropdown(this.mixedDropdowns);

          // Only restore if saved state matches current selection
          if ((parsedData === null || parsedData === void 0 ? void 0 : parsedData.breedType) === 'mixed') {
            this.restoreDropdownValues(this.mixedDropdowns);
          } else {
            // Clear mixed dropdowns if switching from other type
            this.clearDropdownValues(this.mixedDropdowns);
          }
          this.validateSelection();
          break;
        case 'not_sure':
          // Clear any previously selected dropdown values to prevent data contamination
          if (this.purebredDropdown) {
            this.clearDropdownValues(this.purebredDropdown);
          }
          if (this.mixedDropdowns) {
            this.clearDropdownValues(this.mixedDropdowns);
          }
          this.enableNextButton();

          // Immediately dispatch tracking event for "not_sure" selection
          // This ensures data layer is updated even if saveDropdownState is delayed
          this.dispatchBreedTrackingEvent('not_sure');
          break;
      }
    }
  }, {
    key: "hideAllDropdowns",
    value: function hideAllDropdowns() {
      if (this.purebredDropdown) {
        this.purebredDropdown.style.display = 'none';
      }
      if (this.mixedDropdowns) {
        this.mixedDropdowns.style.display = 'none';
      }
    }
  }, {
    key: "showDropdown",
    value: function showDropdown(dropdown) {
      if (dropdown) {
        dropdown.style.display = 'block';
      }
    }
  }, {
    key: "restoreDropdownValues",
    value: function restoreDropdownValues(container) {
      var _this6 = this;
      if (!container) return;
      var dropdowns = container.querySelectorAll('custom-dropdown');
      dropdowns.forEach(function (dropdown) {
        if (dropdown && typeof dropdown.restoreState === 'function') {
          dropdown.restoreState();
        }
        if (dropdown && typeof dropdown.updateIconVisibility === 'function') {
          dropdown.updateIconVisibility();
        }
      });
      setTimeout(function () {
        _this6.validateSelection();
      }, 50);
    }
  }, {
    key: "clearDropdownValues",
    value: function clearDropdownValues(container) {
      var _this7 = this;
      if (!container) return;
      var dropdowns = container.querySelectorAll('custom-dropdown');
      dropdowns.forEach(function (dropdown) {
        if (dropdown.inputText) {
          dropdown.inputText.value = '';
          dropdown.isValid = false;

          // Remove selected class from all items
          var dropdownList = dropdown.querySelector('.breed-dropdown__list');
          if (dropdownList) {
            dropdownList.querySelectorAll('.breed-dropdown-item').forEach(function (item) {
              item.classList.remove('selected');
            });
          }

          // Update icon visibility
          if (typeof dropdown.updateIconVisibility === 'function') {
            dropdown.updateIconVisibility();
          }
        }
      });

      // Clear validation state
      setTimeout(function () {
        _this7.validateSelection();
      }, 50);
    }
  }, {
    key: "updateRadioStates",
    value: function updateRadioStates() {
      // Safety check: ensure radioButtons is not null
      if (!this.radioButtons || !this.radioButtons.length) {
        return;
      }
      this.radioButtons.forEach(function (radio) {
        var label = radio.closest('.custom-radio-button');
        if (label) {
          if (radio.checked) {
            label.classList.add('is-active');
          } else {
            label.classList.remove('is-active');
          }
        }
      });
    }
  }, {
    key: "validateSelection",
    value: function validateSelection() {
      var currentSlide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      console.log('breed-radio-selector: validateSelection() called');
      var selectedRadio = this.querySelector('.custom-radio-button__input:checked');
      if (!selectedRadio) {
        console.log('breed-radio-selector: No radio selected, disabling button');
        this.disableNextButton(currentSlide);
        return;
      }
      var selectedValue = selectedRadio.value;
      console.log('breed-radio-selector: Selected radio value:', selectedValue);
      if (selectedValue === 'not_sure') {
        console.log('breed-radio-selector: "not_sure" selected, enabling button');
        this.enableNextButton(currentSlide);
        return;
      }
      if (selectedValue === 'purebred') {
        var _this$purebredDropdow, _purebredDropdown$inp;
        var purebredDropdown = (_this$purebredDropdow = this.purebredDropdown) === null || _this$purebredDropdow === void 0 ? void 0 : _this$purebredDropdow.querySelector('custom-dropdown');
        if (!purebredDropdown) {
          console.log('breed-radio-selector: No purebred dropdown found, disabling button');
          this.disableNextButton(currentSlide);
          return;
        }
        var inputValue = ((_purebredDropdown$inp = purebredDropdown.inputText) === null || _purebredDropdown$inp === void 0 ? void 0 : _purebredDropdown$inp.value) || '';
        var isValid = purebredDropdown.isValid === true;
        console.log('breed-radio-selector: Purebred validation - inputValue:', inputValue, 'isValid:', isValid);
        if (inputValue.trim() !== '' && isValid) {
          console.log('breed-radio-selector: Purebred valid, enabling button');
          this.enableNextButton(currentSlide);
        } else {
          console.log('breed-radio-selector: Purebred invalid, disabling button');
          this.disableNextButton(currentSlide);
        }
        return;
      }
      if (selectedValue === 'mixed') {
        var _this$mixedDropdowns, _firstDropdown$inputT;
        var mixedDropdownElements = (_this$mixedDropdowns = this.mixedDropdowns) === null || _this$mixedDropdowns === void 0 ? void 0 : _this$mixedDropdowns.querySelectorAll('custom-dropdown');
        if (!mixedDropdownElements || mixedDropdownElements.length === 0) {
          console.log('breed-radio-selector: No mixed dropdowns found, disabling button');
          this.disableNextButton(currentSlide);
          return;
        }
        var firstDropdown = mixedDropdownElements[0];
        var firstInputValue = (firstDropdown === null || firstDropdown === void 0 || (_firstDropdown$inputT = firstDropdown.inputText) === null || _firstDropdown$inputT === void 0 ? void 0 : _firstDropdown$inputT.value) || '';
        var firstIsValid = (firstDropdown === null || firstDropdown === void 0 ? void 0 : firstDropdown.isValid) === true;
        console.log('breed-radio-selector: Mixed validation - firstInputValue:', firstInputValue, 'firstIsValid:', firstIsValid);
        if (firstInputValue.trim() !== '' && firstIsValid) {
          console.log('breed-radio-selector: Mixed valid, enabling button');
          this.enableNextButton(currentSlide);
        } else {
          console.log('breed-radio-selector: Mixed invalid, disabling button');
          this.disableNextButton(currentSlide);
        }
        return;
      }
      console.log('breed-radio-selector: No matching condition, disabling button');
      this.disableNextButton(currentSlide);
    }
  }, {
    key: "disableNextButton",
    value: function disableNextButton() {
      var currentSlide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      // Check if this component is on the current slide
      // Use currentSlide if provided (more reliable than CSS class during transitions)
      var isOnCurrentSlide = currentSlide ? currentSlide.contains(this) : this.isVisible();

      // Only affect button if this component is on the current visible slide
      if (!isOnCurrentSlide) {
        console.log('breed-radio-selector: Not on current slide, skipping button disable');
        return;
      }
      if (this.nextButton) {
        this.nextButton.classList.add('button--disabled');
        this.nextButton.disabled = true;
        console.log('breed-radio-selector: Disabled Next button');
      }
    }
  }, {
    key: "enableNextButton",
    value: function enableNextButton() {
      var currentSlide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      // Check if this component is on the current slide
      // Use currentSlide if provided (more reliable than CSS class during transitions)
      var isOnCurrentSlide = currentSlide ? currentSlide.contains(this) : this.isVisible();

      // Only affect button if this component is on the current visible slide
      if (!isOnCurrentSlide) {
        console.log('breed-radio-selector: Not on current slide, skipping button enable');
        return;
      }
      if (this.nextButton) {
        this.nextButton.classList.remove('button--disabled');
        this.nextButton.disabled = false;
        console.log('breed-radio-selector: Enabled Next button');
      }
    }

    // NEW METHOD: Save combined dropdown state in new format
  }, {
    key: "saveDropdownState",
    value: function saveDropdownState() {
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      if (!quizData.dropdownStates) {
        quizData.dropdownStates = {};
      }
      var selectedRadio = this.querySelector('.custom-radio-button__input:checked');
      if (!selectedRadio) return;
      var selectedValue = selectedRadio.value;
      var stateString = '';
      if (selectedValue === 'not_sure') {
        // Format: "not_sure"
        stateString = 'not_sure';
      } else if (selectedValue === 'purebred') {
        var _this$purebredDropdow2, _purebredDropdown$inp2;
        // Format: "breedTypeStates: purebred; value: Breed Name"
        var purebredDropdown = (_this$purebredDropdow2 = this.purebredDropdown) === null || _this$purebredDropdow2 === void 0 ? void 0 : _this$purebredDropdow2.querySelector('custom-dropdown');
        var breedValue = (purebredDropdown === null || purebredDropdown === void 0 || (_purebredDropdown$inp2 = purebredDropdown.inputText) === null || _purebredDropdown$inp2 === void 0 ? void 0 : _purebredDropdown$inp2.value) || '';
        if (breedValue.trim() !== '' && purebredDropdown !== null && purebredDropdown !== void 0 && purebredDropdown.isValid) {
          stateString = "breedTypeStates: purebred; value: ".concat(breedValue);
        }
      } else if (selectedValue === 'mixed') {
        var _this$mixedDropdowns2;
        // Format: "breedTypeStates: mixed; value_1: Breed1; value_2: Breed2"
        var mixedDropdowns = (_this$mixedDropdowns2 = this.mixedDropdowns) === null || _this$mixedDropdowns2 === void 0 ? void 0 : _this$mixedDropdowns2.querySelectorAll('custom-dropdown');
        if (mixedDropdowns && mixedDropdowns.length >= 1) {
          var _firstDropdown$inputT2, _secondDropdown$input;
          var firstDropdown = mixedDropdowns[0];
          var secondDropdown = mixedDropdowns[1];
          var value1 = (firstDropdown === null || firstDropdown === void 0 || (_firstDropdown$inputT2 = firstDropdown.inputText) === null || _firstDropdown$inputT2 === void 0 ? void 0 : _firstDropdown$inputT2.value) || '';
          var value2 = (secondDropdown === null || secondDropdown === void 0 || (_secondDropdown$input = secondDropdown.inputText) === null || _secondDropdown$input === void 0 ? void 0 : _secondDropdown$input.value) || '';
          var isValid1 = firstDropdown === null || firstDropdown === void 0 ? void 0 : firstDropdown.isValid;
          var isValid2 = secondDropdown === null || secondDropdown === void 0 ? void 0 : secondDropdown.isValid;

          // Only save if first dropdown has valid value
          if (value1.trim() !== '' && isValid1) {
            stateString = "breedTypeStates: mixed; value_1: ".concat(value1);
            if (value2.trim() !== '' && isValid2) {
              stateString += "; value_2: ".concat(value2);
            }
          }
        }
      }
      if (stateString !== '') {
        quizData.dropdownStates[this.entry] = stateString;
        localStorage.setItem('quiz', JSON.stringify(quizData));

        // Dispatch tracking event after saving state
        this.dispatchBreedTrackingEvent();
      } else {
        delete quizData.dropdownStates[this.entry];
        localStorage.setItem('quiz', JSON.stringify(quizData));
      }
    }

    /**
     * Get current slide index - uses stored index from initialization
     * Falls back to quiz-container activeIndex if not stored
     * @returns {number} Current slide index
     */
  }, {
    key: "getCurrentSlideIndex",
    value: function getCurrentSlideIndex() {
      // Use stored index from initialization (most reliable)
      if (this.slideIndex !== null) {
        return this.slideIndex;
      }

      // Fallback: get from quiz-container
      if (this.quizContainer && this.quizContainer.activeSlider) {
        return this.quizContainer.activeSlider.activeIndex;
      }
      return 0;
    }

    /**
     * Dispatch tracking event with proper breed data structure
     * For mixed breeds, sends array of values
     * @param {string} forceValue - Optional value to force (used for immediate "not_sure" dispatch)
     */
  }, {
    key: "dispatchBreedTrackingEvent",
    value: function dispatchBreedTrackingEvent() {
      var forceValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var selectedValue = forceValue;
      if (!selectedValue) {
        var selectedRadio = this.querySelector('.custom-radio-button__input:checked');
        if (!selectedRadio) return;
        selectedValue = selectedRadio.value;
      }
      var trackingValue = null;
      var trackingLabel = null;
      if (selectedValue === 'not_sure') {
        trackingValue = 'not_sure';
        trackingLabel = 'Not Sure';
      } else if (selectedValue === 'purebred') {
        var _this$purebredDropdow3, _purebredDropdown$inp3;
        var purebredDropdown = (_this$purebredDropdow3 = this.purebredDropdown) === null || _this$purebredDropdow3 === void 0 ? void 0 : _this$purebredDropdow3.querySelector('custom-dropdown');
        var breedValue = (purebredDropdown === null || purebredDropdown === void 0 || (_purebredDropdown$inp3 = purebredDropdown.inputText) === null || _purebredDropdown$inp3 === void 0 ? void 0 : _purebredDropdown$inp3.value) || '';
        if (breedValue.trim() !== '' && purebredDropdown !== null && purebredDropdown !== void 0 && purebredDropdown.isValid) {
          trackingValue = breedValue;
          trackingLabel = breedValue;
        }
      } else if (selectedValue === 'mixed') {
        var _this$mixedDropdowns3;
        var mixedDropdowns = (_this$mixedDropdowns3 = this.mixedDropdowns) === null || _this$mixedDropdowns3 === void 0 ? void 0 : _this$mixedDropdowns3.querySelectorAll('custom-dropdown');
        if (mixedDropdowns && mixedDropdowns.length >= 1) {
          var _firstDropdown$inputT3, _secondDropdown$input2;
          var firstDropdown = mixedDropdowns[0];
          var secondDropdown = mixedDropdowns[1];
          var value1 = (firstDropdown === null || firstDropdown === void 0 || (_firstDropdown$inputT3 = firstDropdown.inputText) === null || _firstDropdown$inputT3 === void 0 ? void 0 : _firstDropdown$inputT3.value) || '';
          var value2 = (secondDropdown === null || secondDropdown === void 0 || (_secondDropdown$input2 = secondDropdown.inputText) === null || _secondDropdown$input2 === void 0 ? void 0 : _secondDropdown$input2.value) || '';
          var isValid1 = firstDropdown === null || firstDropdown === void 0 ? void 0 : firstDropdown.isValid;
          var isValid2 = secondDropdown === null || secondDropdown === void 0 ? void 0 : secondDropdown.isValid;

          // Build array of valid values
          var values = [];
          if (value1.trim() !== '' && isValid1) {
            values.push(value1);
          }
          if (value2.trim() !== '' && isValid2) {
            values.push(value2);
          }
          if (values.length > 0) {
            trackingValue = values;
            trackingLabel = values.join(' + ');
          }
        }
      }

      // Only dispatch if we have valid tracking data
      if (trackingValue !== null) {
        // Prevent duplicate events within 100ms for same value
        var now = Date.now();
        var valueKey = JSON.stringify(trackingValue);
        if (valueKey === this.lastTrackedValue && now - this.lastTrackedTime < 100) {
          console.log('🔔 Skipping duplicate breed tracking event');
          return;
        }
        this.lastTrackedValue = valueKey;
        this.lastTrackedTime = now;

        // Get actual slide index from DOM
        var slideIndex = this.getCurrentSlideIndex();
        document.dispatchEvent(new CustomEvent('quiz:input-changed', {
          detail: {
            type: 'breed-selector',
            fieldKey: this.entry,
            value: trackingValue,
            valueLabel: trackingLabel,
            breedType: selectedValue,
            slideIndex: slideIndex
          }
        }));
        console.log('🔔 Breed tracking event dispatched:', {
          type: 'breed-selector',
          fieldKey: this.entry,
          value: trackingValue,
          valueLabel: trackingLabel,
          breedType: selectedValue,
          slideIndex: slideIndex
        });
      }
    }

    // UPDATED: Restore state from new format
  }, {
    key: "restoreState",
    value: function restoreState() {
      var _this8 = this;
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      if (quizData.dropdownStates && quizData.dropdownStates[this.entry]) {
        var savedString = quizData.dropdownStates[this.entry];
        var parsedData = this.parseDropdownState(savedString);
        if (!parsedData) {
          return;
        }

        // Check the appropriate radio button
        var radioValue = parsedData.breedType;
        if (radioValue === 'not_sure') {
          radioValue = 'not_sure';
        }
        this.radioButtons.forEach(function (radio) {
          if (radio.value === radioValue) {
            radio.checked = true;
            _this8.updateRadioStates();
            _this8.handleDropdownVisibility(radioValue);
          }
        });

        // Restore dropdown values - handled by CustomDropdown.restoreState()
        // which will be called via restoreDropdownValues()
      }
    }

    // Helper: parse new localStorage format
  }, {
    key: "parseDropdownState",
    value: function parseDropdownState(stateString) {
      if (stateString === 'not_sure') {
        return {
          breedType: 'not_sure'
        };
      }

      // Parse format like "breedTypeStates: mixed; value_1: Breed1; value_2: Breed2"
      var parts = stateString.split(';').map(function (s) {
        return s.trim();
      });
      var result = {};
      parts.forEach(function (part) {
        var _part$split = part.split(':'),
          _part$split2 = _toArray(_part$split),
          key = _part$split2[0],
          valueParts = _part$split2.slice(1);
        var value = valueParts.join(':').trim(); // Handle breed names with colons

        if (key.trim() === 'breedTypeStates') {
          result.breedType = value;
        } else if (key.trim() === 'value') {
          result.value = value;
        } else if (key.trim() === 'value_1') {
          result.value_1 = value;
        } else if (key.trim() === 'value_2') {
          result.value_2 = value;
        }
      });
      return result;
    }

    /**
     * Reset component to initial state (called on quiz restart)
     */
  }, {
    key: "reset",
    value: function reset() {
      // Reset initialized flag so init() will run again when slide becomes active
      this.initialized = false;

      // Reset tracking state
      this.lastTrackedValue = null;
      this.lastTrackedTime = 0;

      // Keep slideIndex - it shouldn't change unless quiz is fully restarted
      // slideIndex will be re-saved on next init()

      // Re-query radioButtons to ensure fresh references
      this.radioButtons = this.querySelectorAll('.custom-radio-button__input');

      // Uncheck all radio buttons and remove active classes
      if (this.radioButtons && this.radioButtons.length) {
        this.radioButtons.forEach(function (radio) {
          radio.checked = false;
          var label = radio.closest('.custom-radio-button');
          if (label) {
            label.classList.remove('is-active');
          }
        });
      }

      // Reset all dropdowns using their reset method
      var dropdowns = this.querySelectorAll('custom-dropdown');
      dropdowns.forEach(function (dropdown) {
        if (dropdown && typeof dropdown.reset === 'function') {
          dropdown.reset();
        }
      });

      // Hide all dropdowns
      this.hideAllDropdowns();

      // Clear dropdown state from localStorage
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      if (quizData.dropdownStates && this.entry) {
        delete quizData.dropdownStates[this.entry];
        localStorage.setItem('quiz', JSON.stringify(quizData));
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this9 = this,
        _this$radioButtons;
      if (this.radioButtons) {
        this.radioButtons.forEach(function (radio) {
          radio.removeEventListener('click', _this9.boundHandleRadioChange);
          radio.checked = false;
        });
      }
      var inputs = this.querySelectorAll('.breed-dropdown__wrapper__text');
      inputs.forEach(function (input) {
        var _input$parentNode;
        var newInput = input.cloneNode(true);
        (_input$parentNode = input.parentNode) === null || _input$parentNode === void 0 || _input$parentNode.replaceChild(newInput, input);
      });
      var dropdowns = this.querySelectorAll('custom-dropdown');
      dropdowns.forEach(function (dropdown) {
        if (dropdown && typeof dropdown.destroy === 'function') {
          dropdown.destroy();
        }
      });
      this.hideAllDropdowns();
      (_this$radioButtons = this.radioButtons) === null || _this$radioButtons === void 0 || _this$radioButtons.forEach(function (radio) {
        var label = radio.closest('.custom-radio-button');
        if (label) {
          label.classList.remove('is-active');
        }
      });
      this.initialized = false;
      this.lastTrackedValue = null;
      this.lastTrackedTime = 0;
      this.slideIndex = null; // Reset slide index on destroy
      this.disableNextButton();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _this0 = this;
      if (this.radioButtons) {
        this.radioButtons.forEach(function (radio) {
          radio.removeEventListener('click', _this0.boundHandleRadioChange);
        });
      }
      this.initialized = false;
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BreedRadioSelector);

/***/ }),

/***/ "./src/assets/js/quiz-components-v2/component-protein-v2.js":
/*!******************************************************************!*\
  !*** ./src/assets/js/quiz-components-v2/component-protein-v2.js ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var ComponentProteinV2 = /*#__PURE__*/function (_HTMLElement) {
  function ComponentProteinV2() {
    var _this;
    _classCallCheck(this, ComponentProteinV2);
    _this = _callSuper(this, ComponentProteinV2);
    _this.swiper = null;
    _this.proteinSelections = {};
    _this.currentIngredient = null;
    _this.totalIngredients = 0;
    _this.quizContainer = null;
    _this.lastSlideIndex = 0;
    _this.slideIndex = null;
    _this.isAnimating = false;
    return _this;
  }
  _inherits(ComponentProteinV2, _HTMLElement);
  return _createClass(ComponentProteinV2, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      setTimeout(function () {
        return _this2.init();
      }, 10);
    }
  }, {
    key: "init",
    value: function init() {
      var _this$titleContainer,
        _this3 = this;
      this.quizContainer = this.closest('quiz-container');
      this.titleContainer = this.querySelector('.title-label');
      this.nothingFoundText = ((_this$titleContainer = this.titleContainer) === null || _this$titleContainer === void 0 || (_this$titleContainer = _this$titleContainer.dataset) === null || _this$titleContainer === void 0 ? void 0 : _this$titleContainer.nonameText) || '';
      if (this.titleContainer && !this.titleContainer.dataset.originalHtml) {
        this.titleContainer.dataset.originalHtml = this.titleContainer.innerHTML;
      }
      if (this.quizContainer && this.quizContainer.activeSlider) {
        this.slideIndex = this.quizContainer.activeSlider.activeIndex;
        console.log('component-protein-v2: Stored slideIndex:', this.slideIndex);
      }
      this.loadSavedSelections();
      this.initSwiper();
      this.setupEventListeners();
      this.setupQuizSlideChangeListener();
      requestAnimationFrame(function () {
        _this3.restoreLastSlide();
        _this3.updateCurrentIngredient();
        requestAnimationFrame(function () {
          _this3.updateProgress();
          _this3.updateDogName();
          _this3.updateProteinName();
          _this3.updateNextButtonState();
          _this3.triggerFadeInAnimation();
        });
      });
    }
  }, {
    key: "setupQuizSlideChangeListener",
    value: function setupQuizSlideChangeListener() {
      var _this4 = this;
      var parentSlide = this.closest('.swiper-slide');
      if (parentSlide) {
        var observer = new MutationObserver(function () {
          if (parentSlide.classList.contains('swiper-slide-active')) {
            requestAnimationFrame(function () {
              _this4.updateCurrentIngredient();
              _this4.updateProgress();
              requestAnimationFrame(function () {
                _this4.updateDogName();
                _this4.updateProteinName();
                _this4.updateNextButtonState();
                _this4.triggerFadeInAnimation();
              });
            });
          }
        });
        observer.observe(parentSlide, {
          attributes: true,
          attributeFilter: ['class']
        });
      }
    }
  }, {
    key: "initSwiper",
    value: function initSwiper() {
      var _this5 = this;
      var swiperContainer = this.querySelector('.protein-swiper');
      if (!swiperContainer) return;
      var slides = swiperContainer.querySelectorAll('.swiper-slide');
      this.totalIngredients = slides.length;
      this.swiper = new Swiper(swiperContainer, {
        slidesPerView: 1,
        spaceBetween: 0,
        allowTouchMove: false,
        speed: 0,
        // We control animation manually
        on: {
          slideChange: function slideChange() {
            _this5.handleSlideChange();
          }
        }
      });
      this.updateCurrentIngredient();
    }
  }, {
    key: "handleSlideChange",
    value: function handleSlideChange() {
      var _this6 = this;
      console.log('handleSlideChange: activeIndex =', this.swiper.activeIndex);
      this.updateCurrentIngredient();
      this.updateProgress();
      this.saveLastSlideIndex();
      requestAnimationFrame(function () {
        _this6.updateDogName();
        _this6.updateProteinName();
        _this6.triggerFadeInAnimation();
      });
    }
  }, {
    key: "setupEventListeners",
    value: function setupEventListeners() {
      var _this7 = this;
      var yesBtn = this.querySelector('[data-action="yes"]');
      if (yesBtn) {
        yesBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          _this7.handleSelection('yes');
        });
      }
      var noBtn = this.querySelector('[data-action="no"]');
      if (noBtn) {
        noBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          _this7.handleSelection('no');
        });
      }
      this.inputChangeHandler = function (event) {
        requestAnimationFrame(function () {
          _this7.updateDogName();
          _this7.updateProteinName();
        });
      };
      document.addEventListener('quiz:input-changed', this.inputChangeHandler);
    }
  }, {
    key: "updateCurrentIngredient",
    value: function updateCurrentIngredient() {
      if (!this.swiper || !this.swiper.slides) return;
      var activeSlide = this.swiper.slides[this.swiper.activeIndex];
      if (activeSlide && activeSlide.dataset && activeSlide.dataset.ingredient) {
        this.currentIngredient = activeSlide.dataset.ingredient;
        console.log('updateCurrentIngredient:', this.currentIngredient);
      } else {
        var firstSlide = this.querySelector('.swiper-slide[data-ingredient]');
        if (firstSlide && firstSlide.dataset && firstSlide.dataset.ingredient) {
          this.currentIngredient = firstSlide.dataset.ingredient;
          console.log('updateCurrentIngredient (fallback):', this.currentIngredient);
        }
      }
    }
  }, {
    key: "handleSelection",
    value: function handleSelection(choice) {
      var _this8 = this;
      if (!this.currentIngredient || this.isAnimating) return;
      console.log('handleSelection:', choice, 'for', this.currentIngredient);

      // Prevent multiple clicks during animation
      this.isAnimating = true;

      // Add button click animation
      var clickedBtn = this.querySelector("[data-action=\"".concat(choice, "\"]"));
      if (clickedBtn) {
        clickedBtn.classList.add('btn-clicked');
        setTimeout(function () {
          return clickedBtn.classList.remove('btn-clicked');
        }, 250);
      }

      // Save selection
      this.proteinSelections[this.currentIngredient] = choice;
      this.saveToLocalStorage();
      this.trackSelection(choice);
      var isLastIngredient = this.swiper.activeIndex >= this.totalIngredients - 1;
      console.log('Current slide:', this.swiper.activeIndex, 'Total:', this.totalIngredients, 'Is last:', isLastIngredient);

      // Start animations simultaneously:
      // 1. Current card swipes away
      // 2. Next card reveals (if not last)
      this.animateCardSwipe(choice);
      if (!isLastIngredient) {
        this.revealNextCard();
      }

      // Wait for animation to complete
      setTimeout(function () {
        if (!isLastIngredient && _this8.swiper) {
          // Move to next card (instant, no animation as visual already done)
          _this8.swiper.slideNext();
        }

        // Handle completion for last card
        if (isLastIngredient) {
          setTimeout(function () {
            _this8.dispatchCompletionEvent();
            requestAnimationFrame(function () {
              _this8.updateNextButtonState();

              // Auto-transition to next quiz slide
              if (_this8.quizContainer && _this8.quizContainer.activeSlider) {
                _this8.quizContainer.activeSlider.slideNext();
                console.log('ComponentProteinV2: Auto-transitioning to next slide');
              }
            });
          }, 50);
        }
        _this8.isAnimating = false;
      }, 400); // Match animation duration
    }

    /**
     * Animate current card with Tinder-like swipe effect
     */
  }, {
    key: "animateCardSwipe",
    value: function animateCardSwipe(direction) {
      if (!this.swiper) return;
      var activeSlide = this.swiper.slides[this.swiper.activeIndex];
      if (!activeSlide) return;
      var card = activeSlide.querySelector('.protein-ingredient');
      if (!card) return;

      // Remove any existing animation classes
      card.classList.remove('swipe-right', 'swipe-left');

      // Force reflow
      void card.offsetWidth;

      // Add appropriate swipe animation
      var animationClass = direction === 'yes' ? 'swipe-right' : 'swipe-left';
      card.classList.add(animationClass);

      // Clean up animation class after completion
      setTimeout(function () {
        card.classList.remove(animationClass);
      }, 400);
    }

    /**
     * Reveal next card as current card swipes away (Tinder effect)
     */
  }, {
    key: "revealNextCard",
    value: function revealNextCard() {
      if (!this.swiper) return;
      var nextSlide = this.swiper.slides[this.swiper.activeIndex + 1];
      if (!nextSlide) return;

      // Add reveal animation class
      nextSlide.classList.add('revealing-next');

      // Clean up after animation
      setTimeout(function () {
        nextSlide.classList.remove('revealing-next');
      }, 400);
    }
  }, {
    key: "updateProgress",
    value: function updateProgress() {
      var progressFill = this.querySelector('.protein-progress__fill');
      if (!progressFill || !this.swiper) return;
      var currentIndex = this.swiper.activeIndex;
      var progress = (currentIndex + 1) / this.totalIngredients * 100;
      progressFill.style.width = "".concat(progress, "%");
    }
  }, {
    key: "saveToLocalStorage",
    value: function saveToLocalStorage() {
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      quizData.proteinSelections = this.proteinSelections;
      quizData.proteinLastSlideIndex = this.lastSlideIndex;
      localStorage.setItem('quiz', JSON.stringify(quizData));
    }
  }, {
    key: "loadSavedSelections",
    value: function loadSavedSelections() {
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      if (quizData.proteinSelections) {
        this.proteinSelections = quizData.proteinSelections;
      }
      if (typeof quizData.proteinLastSlideIndex === 'number') {
        this.lastSlideIndex = quizData.proteinLastSlideIndex;
      }
    }
  }, {
    key: "saveLastSlideIndex",
    value: function saveLastSlideIndex() {
      if (!this.swiper) return;
      this.lastSlideIndex = this.swiper.activeIndex;
      this.saveToLocalStorage();
    }
  }, {
    key: "restoreLastSlide",
    value: function restoreLastSlide() {
      if (!this.swiper) return;
      var targetIndex = this.lastSlideIndex;
      var ingredientsList = Array.from(this.querySelectorAll('.swiper-slide')).map(function (slide) {
        return slide.dataset.ingredient;
      });
      for (var i = 0; i < ingredientsList.length; i++) {
        if (!this.proteinSelections[ingredientsList[i]]) {
          targetIndex = i;
          break;
        }
      }
      if (targetIndex > 0 && targetIndex < this.totalIngredients) {
        this.swiper.slideTo(targetIndex, 0);
      }
    }
  }, {
    key: "updateDogName",
    value: function updateDogName() {
      var _this9 = this;
      if (!this.titleContainer) return;
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      var dogName = quizData.dogName || quizData.name;
      var nameSpan = this.querySelector('.dog-name');
      if (dogName && dogName.trim() !== '') {
        if (!nameSpan && this.titleContainer.dataset.originalHtml) {
          this.titleContainer.innerHTML = this.titleContainer.dataset.originalHtml;
          nameSpan = this.querySelector('.dog-name');
        }
        if (nameSpan) {
          nameSpan.textContent = dogName;
        }
        requestAnimationFrame(function () {
          _this9.updateProteinName();
        });
      } else if (this.nothingFoundText) {
        var newHTML = this.nothingFoundText;
        newHTML = newHTML.replace('[protein]', '<span class="protein-name"></span>');
        this.titleContainer.innerHTML = newHTML;
        requestAnimationFrame(function () {
          _this9.updateProteinName();
        });
      }
    }
  }, {
    key: "updateProteinName",
    value: function updateProteinName() {
      if (!this.currentIngredient) {
        this.updateCurrentIngredient();
      }
      if (!this.currentIngredient) {
        console.warn('updateProteinName: currentIngredient is still not set');
        return;
      }
      var capitalized = this.currentIngredient.charAt(0).toUpperCase() + this.currentIngredient.slice(1);
      var proteinNameSpan = this.querySelector('.protein-name');
      if (proteinNameSpan) {
        proteinNameSpan.textContent = capitalized;
        console.log('updateProteinName: Set to', capitalized);
        return;
      }
      if (this.titleContainer) {
        var currentHTML = this.titleContainer.innerHTML;
        if (currentHTML.includes('[protein]')) {
          var newHTML = currentHTML.replace('[protein]', "<span class=\"protein-name\">".concat(capitalized, "</span>"));
          this.titleContainer.innerHTML = newHTML;
          console.log('updateProteinName: Created protein-name span with', capitalized);
        }
      }
    }
  }, {
    key: "triggerFadeInAnimation",
    value: function triggerFadeInAnimation() {
      if (!this.swiper) return;
      var activeSlide = this.swiper.slides[this.swiper.activeIndex];
      if (!activeSlide) return;
      var image = activeSlide.querySelector('.protein-ingredient img');
      if (!image) return;
      image.classList.remove('protein-image-fadein');
      void image.offsetWidth;
      image.classList.add('protein-image-fadein');
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      var swiperSlide = this.closest('.swiper-slide');
      if (swiperSlide && !swiperSlide.classList.contains('swiper-slide-active')) {
        return false;
      }
      return this.offsetParent !== null && window.getComputedStyle(this).display !== 'none';
    }
  }, {
    key: "isComplete",
    value: function isComplete() {
      var _this0 = this;
      var ingredientSlides = this.querySelectorAll('.swiper-slide[data-ingredient]');
      if (ingredientSlides.length === 0) {
        console.warn('ComponentProteinV2: No ingredient slides found');
        return false;
      }
      var ingredientsList = Array.from(ingredientSlides).map(function (slide) {
        return slide.dataset.ingredient;
      });
      var allAnswered = ingredientsList.every(function (ingredient) {
        return !!_this0.proteinSelections[ingredient];
      });
      return allAnswered;
    }
  }, {
    key: "updateNextButtonState",
    value: function updateNextButtonState() {
      var currentSlide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var isOnCurrentSlide = currentSlide ? currentSlide.contains(this) : this.isVisible();
      if (!isOnCurrentSlide) {
        return;
      }
      var nextButton = document.querySelector('.button--next');
      if (!nextButton) {
        console.warn('ComponentProteinV2: button--next not found');
        return;
      }
      var isComplete = this.isComplete();
      if (isComplete) {
        this.enableNextButton(currentSlide);
      } else {
        this.disableNextButton(currentSlide);
      }
    }
  }, {
    key: "enableNextButton",
    value: function enableNextButton() {
      var currentSlide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var isOnCurrentSlide = currentSlide ? currentSlide.contains(this) : this.isVisible();
      if (!isOnCurrentSlide) {
        console.log('ComponentProteinV2: Not on current slide, skipping enable');
        return;
      }
      var nextButton = document.querySelector('.button--next');
      if (nextButton) {
        nextButton.disabled = false;
        nextButton.classList.remove('button--disabled');
        console.log('ComponentProteinV2: Button ENABLED');
      }
    }
  }, {
    key: "disableNextButton",
    value: function disableNextButton() {
      var currentSlide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var isOnCurrentSlide = currentSlide ? currentSlide.contains(this) : this.isVisible();
      if (!isOnCurrentSlide) {
        console.log('ComponentProteinV2: Not on current slide, skipping disable');
        return;
      }
      var nextButton = document.querySelector('.button--next');
      if (nextButton) {
        nextButton.disabled = true;
        nextButton.classList.add('button--disabled');
        console.log('ComponentProteinV2: Button DISABLED');
      }
    }
  }, {
    key: "isOnActiveSlide",
    value: function isOnActiveSlide() {
      return this.isVisible();
    }
  }, {
    key: "trackSelection",
    value: function trackSelection(choice) {
      // No individual tracking needed - only the complete step is tracked
      // via dispatchCompletionEvent() which sends step_7_protein
    }
  }, {
    key: "dispatchCompletionEvent",
    value: function dispatchCompletionEvent() {
      var _this$quizContainer;
      document.dispatchEvent(new CustomEvent('quiz:input-changed', {
        detail: {
          type: 'protein',
          fieldKey: 'protein_selections',
          value: this.proteinSelections,
          slideIndex: ((_this$quizContainer = this.quizContainer) === null || _this$quizContainer === void 0 || (_this$quizContainer = _this$quizContainer.activeSlider) === null || _this$quizContainer === void 0 ? void 0 : _this$quizContainer.activeIndex) || 0
        }
      }));
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return this.isComplete();
    }
  }, {
    key: "getFormattedSelections",
    value: function getFormattedSelections() {
      return Object.entries(this.proteinSelections).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          ingredient = _ref2[0],
          choice = _ref2[1];
        var capitalized = ingredient.charAt(0).toUpperCase() + ingredient.slice(1);
        var choiceLabel = choice === 'yes' ? 'Yes' : 'No';
        return "".concat(capitalized, ": ").concat(choiceLabel);
      }).join(', ');
    }
  }, {
    key: "reset",
    value: function reset() {
      this.proteinSelections = {};
      this.lastSlideIndex = 0;
      this.isAnimating = false;
      this.saveToLocalStorage();
      if (this.swiper) {
        this.swiper.slideTo(0, 0);
      }
      this.updateProgress();
      this.updateDogName();
      this.updateProteinName();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this.inputChangeHandler) {
        document.removeEventListener('quiz:input-changed', this.inputChangeHandler);
      }
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('component-protein-v2')) {
  customElements.define('component-protein-v2', ComponentProteinV2);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ComponentProteinV2);

/***/ }),

/***/ "./src/assets/js/quiz-components-v2/custom-dropdown.js":
/*!*************************************************************!*\
  !*** ./src/assets/js/quiz-components-v2/custom-dropdown.js ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var CustomDropdown = /*#__PURE__*/function (_HTMLElement) {
  function CustomDropdown() {
    var _this;
    _classCallCheck(this, CustomDropdown);
    _this = _callSuper(this, CustomDropdown);
    _this.quizContainer = null;
    _this.breedSearchDropdown = null;
    _this.inputText = null;
    _this.dropdownList = null;
    _this.icon = null;
    _this.inputId = '';
    _this.breedsData = null;
    _this.dropdownBreedItem = null;
    _this.breedInner = null;
    _this.breedWrapper = null;
    _this.nothingText = 'Nothing found';
    _this.dropdownVisible = false;
    _this.select = null;
    _this.selectElements = null;
    _this.type = null;
    _this.entry = null;
    _this.isSelectForRange = false;
    _this.isValid = false; // Track validity - true only when value selected from list
    _this.dropdownIndex = null; // '1' or '2' for mixed breeds
    _this.fuse = null;
    _this.allBreeds = [];
    _this.debounceTimer = null;
    _this.fuseLoaded = false;
    _this.isInteractingWithDropdown = false; // Track if user is interacting with dropdown list
    _this.scrollTimeout = null; // Track scroll end timing
    _this.touchStartY = null; // Track touch start position for scroll detection
    _this.touchMoveDetected = false; // Distinguish tap from scroll
    _this.lastSelectionTime = 0; // Prevent double-selection from touch + click

    // Load popular breeds from translations
    _this.popularBreeds = [];
    return _this;
  }

  /**
   * Get popular breeds from translation files
   * Falls back to empty array if translations are not available
   * Expects window.quizTranslations.popular_breeds to be a comma-separated string
   */
  _inherits(CustomDropdown, _HTMLElement);
  return _createClass(CustomDropdown, [{
    key: "getPopularBreedsFromTranslations",
    value: function getPopularBreedsFromTranslations() {
      try {
        // Check if translations are available globally
        if (window.quizTranslations && window.quizTranslations.popular_breeds) {
          var breedsString = window.quizTranslations.popular_breeds;

          // If it's already an array, return it
          if (Array.isArray(breedsString)) {
            return breedsString;
          }

          // If it's a string, split by comma and trim whitespace
          if (typeof breedsString === 'string' && breedsString.trim() !== '') {
            return breedsString.split(',').map(function (breed) {
              return breed.trim();
            }).filter(function (breed) {
              return breed !== '';
            }); // Remove empty strings
          }
        }

        // Fallback: try to read from theme.strings if available
        if (window.theme && window.theme.strings && window.theme.strings.quiz && window.theme.strings.quiz.popular_breeds) {
          var _breedsString = window.theme.strings.quiz.popular_breeds;

          // If it's already an array, return it
          if (Array.isArray(_breedsString)) {
            return _breedsString;
          }

          // If it's a string, split by comma and trim whitespace
          if (typeof _breedsString === 'string' && _breedsString.trim() !== '') {
            return _breedsString.split(',').map(function (breed) {
              return breed.trim();
            }).filter(function (breed) {
              return breed !== '';
            }); // Remove empty strings
          }
        }
        console.warn('Popular breeds translations not found. Using empty array.');
        return [];
      } catch (error) {
        console.error('Error loading popular breeds from translations:', error);
        return [];
      }
    }
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$breedSearchDrop, _this$breedSearchDrop2, _this$select;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.quizContainer = this.closest('quiz-container');
              this.breedSearchDropdown = this.querySelector('.breed-dropdown');
              this.inputText = this.querySelector('.breed-dropdown__wrapper__text');
              this.dropdownList = this.querySelector('.breed-dropdown__list');
              this.icon = this.querySelector('.breed-dropdown__icon');
              this.inputId = ((_this$breedSearchDrop = this.breedSearchDropdown) === null || _this$breedSearchDrop === void 0 ? void 0 : _this$breedSearchDrop.getAttribute('data-id')) || '';

              // Defer accessing window.breedSearchData slightly or ensure it's available
              // In connectedCallback, the script tags inside the snippet should have run if they are before this element
              // But since this element is likely inside the same container, we should be fine.
              this.breedsData = window['breedSearchData' + this.inputId];

              // Add defensive check
              if (!this.breedsData) {
                console.warn("Breed data not found for ".concat(this.inputId, ", will retry in initBreedDropdown"));
              }
              this.dropdownBreedItem = this.querySelector('.breed-dropdown-item');
              this.breedInner = this.querySelector('.breed-dropdown__wrapper-inner');
              this.breedWrapper = this.querySelector('.breed-dropdown__wrapper');
              this.nothingText = ((_this$breedSearchDrop2 = this.breedSearchDropdown) === null || _this$breedSearchDrop2 === void 0 ? void 0 : _this$breedSearchDrop2.getAttribute('data-nothing-text')) || 'Nothing found';
              this.select = this.querySelector('.select');
              this.selectElements = (_this$select = this.select) === null || _this$select === void 0 ? void 0 : _this$select.querySelectorAll('option');
              this.type = this.dataset.type;
              this.entry = this.dataset.entry;
              this.isSelectForRange = this.dataset.type === 'select-for-range';
              this.dropdownIndex = this.dataset.dropdownIndex;
              this.popularBreeds = this.getPopularBreedsFromTranslations();
              if (!this.isSelectForRange) {
                _context.n = 1;
                break;
              }
              this.initSelectForRange();
              _context.n = 3;
              break;
            case 1:
              _context.n = 2;
              return this.loadFuseLibrary();
            case 2:
              this.initBreedDropdown();
            case 3:
              this.assignEventListeners();
              this.restoreState();
            case 4:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
    /**
     * Load Fuse.js library for fuzzy search
     */
  }, {
    key: "loadFuseLibrary",
    value: (function () {
      var _loadFuseLibrary = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!(this.fuseLoaded || window.Fuse)) {
                _context2.n = 1;
                break;
              }
              this.fuseLoaded = true;
              return _context2.a(2);
            case 1:
              _context2.p = 1;
              _context2.n = 2;
              return this.loadScript('https://cdn.jsdelivr.net/npm/fuse.js@7.1.0/dist/fuse.min.js');
            case 2:
              this.fuseLoaded = true;
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              console.warn('Fuse.js loading failed, using simple search:', _t);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function loadFuseLibrary() {
        return _loadFuseLibrary.apply(this, arguments);
      }
      return loadFuseLibrary;
    }()
    /**
     * Load external script dynamically
     */
    )
  }, {
    key: "loadScript",
    value: function loadScript(src) {
      return new Promise(function (resolve, reject) {
        if (document.querySelector("script[src=\"".concat(src, "\"]"))) {
          resolve();
          return;
        }
        var script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }
  }, {
    key: "initSelectForRange",
    value: function initSelectForRange() {
      if (this.select) {
        this.select.addEventListener('change', this.handleSelectChange.bind(this));
      }
    }
  }, {
    key: "initBreedDropdown",
    value: function initBreedDropdown() {
      // Retry loading breed data if it wasn't available in connectedCallback
      if (!this.breedsData) {
        this.breedsData = window['breedSearchData' + this.inputId];
      }
      if (!this.breedsData) {
        console.error("Breed data still not available for ".concat(this.inputId));
        return;
      }
      if (this.breedsData) {
        // Get all unique breeds
        this.allBreeds = _toConsumableArray(new Set(this.breedsData.flatMap(function (data) {
          return data.breedList;
        })));

        // Sort with priority: popular pure breeds first, then others alphabetically
        var sortedBreeds = this.sortBreedsByPriority(this.allBreeds);

        // Initialize Fuse.js for fuzzy search
        if (window.Fuse) {
          this.fuse = new window.Fuse(this.allBreeds, {
            includeScore: true,
            threshold: 0.4,
            ignoreLocation: true
          });
        }

        // Render initial list (limited to 20 items)
        this.renderBreedList(sortedBreeds.slice(0, 20));
      }
    }

    /**
     * Sort breeds by priority: popular pure breeds first, then mixes, then alphabetically
     */
  }, {
    key: "sortBreedsByPriority",
    value: function sortBreedsByPriority(breeds) {
      var _this2 = this;
      return breeds.sort(function (a, b) {
        var aIsPopular = _this2.popularBreeds.includes(a);
        var bIsPopular = _this2.popularBreeds.includes(b);
        var aIsMix = _this2.isMixedBreed(a);
        var bIsMix = _this2.isMixedBreed(b);

        // Popular pure breeds first
        if (aIsPopular && !bIsPopular) return -1;
        if (!aIsPopular && bIsPopular) return 1;

        // Pure breeds before mixes
        if (!aIsMix && bIsMix) return -1;
        if (aIsMix && !bIsMix) return 1;

        // If both popular or both not, sort alphabetically
        if (aIsPopular === bIsPopular) {
          return a.localeCompare(b);
        }

        // Within same category, sort alphabetically
        return a.localeCompare(b);
      });
    }

    /**
     * Check if breed name indicates a mixed breed
     */
  }, {
    key: "isMixedBreed",
    value: function isMixedBreed(breedName) {
      var mixIndicators = [' x ', ' / ', 'Mix', 'Mischling', 'Cross'];
      return mixIndicators.some(function (indicator) {
        return breedName.includes(indicator);
      });
    }

    /**
     * Render breed list HTML
     */
  }, {
    key: "renderBreedList",
    value: function renderBreedList(breeds) {
      var _this3 = this;
      var dropdownAddHTML = breeds.map(function (breed) {
        if (breed !== null) {
          return "<div class=\"breed-dropdown-item\" data-breed=\"".concat(breed, "\">").concat(breed, "</div>");
        }
        return '';
      }).join('');
      this.dropdownList.innerHTML = dropdownAddHTML;
      this.dropdownList.querySelectorAll('.breed-dropdown-item').forEach(function (item) {
        // Click handler for desktop and fallback
        item.addEventListener('click', _this3.selectBreed.bind(_this3));

        // Touch handler for mobile - handles tap vs scroll distinction
        item.addEventListener('touchend', function (event) {
          // Only handle if this was a tap, not a scroll
          if (!_this3.touchMoveDetected) {
            // Prevent the subsequent click event from firing
            event.preventDefault();
            // Call selectBreed with the touch event
            _this3.selectBreed(event);
          }
        }, {
          passive: false
        }); // passive: false to allow preventDefault
      });
    }
  }, {
    key: "assignEventListeners",
    value: function assignEventListeners() {
      var _this4 = this;
      if (this.isSelectForRange) {
        var _this$select2;
        (_this$select2 = this.select) === null || _this$select2 === void 0 || _this$select2.addEventListener('change', this.handleSelectChange.bind(this));
      } else {
        var _this$inputText, _this$dropdownList, _this$dropdownList2, _this$dropdownList3, _this$dropdownList4, _this$dropdownList5, _this$dropdownList6, _this$dropdownList7, _this$inputText2, _this$inputText3, _this$inputText4, _this$inputText5, _this$inputText6;
        (_this$inputText = this.inputText) === null || _this$inputText === void 0 || _this$inputText.addEventListener('focus', function () {
          _this4.closeOtherDropdowns();
          _this4.dropdownVisible = true;
          _this4.dropdownList.classList.add('active');
          _this4.breedInner.classList.add('active');

          // Remove z-index from buttons-wrapper if this is the second dropdown
          if (_this4.dropdownIndex === '2') {
            _this4.removeButtonsWrapperZIndex();
          }

          // Ensure breed list is rendered when opening dropdown
          // This fixes the issue where clicking out and back in shows no options
          if (_this4.allBreeds && _this4.allBreeds.length > 0) {
            var currentValue = _this4.inputText.value.trim();

            // If input is empty, show initial sorted list
            if (currentValue === '') {
              var sortedBreeds = _this4.sortBreedsByPriority(_this4.allBreeds);
              _this4.renderBreedList(sortedBreeds.slice(0, 20));
              _this4.dropdownList.style.height = '180px';
              _this4.hideNothingFound();
            }
            // If input has value, the input event will handle filtering
          }
        });

        // Track when user starts interacting with dropdown list
        (_this$dropdownList = this.dropdownList) === null || _this$dropdownList === void 0 || _this$dropdownList.addEventListener('mousedown', function () {
          _this4.isInteractingWithDropdown = true;
        });

        // Touch start: record position and reset movement flag
        (_this$dropdownList2 = this.dropdownList) === null || _this$dropdownList2 === void 0 || _this$dropdownList2.addEventListener('touchstart', function (event) {
          _this4.isInteractingWithDropdown = true;
          _this4.touchStartY = event.touches[0].clientY;
          _this4.touchMoveDetected = false;
        }, {
          passive: true
        });

        // Touch move: detect if user is scrolling
        (_this$dropdownList3 = this.dropdownList) === null || _this$dropdownList3 === void 0 || _this$dropdownList3.addEventListener('touchmove', function (event) {
          if (_this4.touchStartY !== null) {
            var deltaY = Math.abs(event.touches[0].clientY - _this4.touchStartY);
            if (deltaY > 10) {
              // 10px threshold for scroll detection
              _this4.touchMoveDetected = true;
            }
          }
        }, {
          passive: true
        });

        // Track when user stops interacting with dropdown list
        (_this$dropdownList4 = this.dropdownList) === null || _this$dropdownList4 === void 0 || _this$dropdownList4.addEventListener('mouseup', function () {
          // Small delay to allow click events to fire
          setTimeout(function () {
            _this4.isInteractingWithDropdown = false;
          }, 100);
        });
        (_this$dropdownList5 = this.dropdownList) === null || _this$dropdownList5 === void 0 || _this$dropdownList5.addEventListener('touchend', function () {
          // Increased delay for mobile browsers to process click events
          setTimeout(function () {
            _this4.isInteractingWithDropdown = false;
            _this4.touchStartY = null;
            _this4.touchMoveDetected = false;
          }, 300);
        });

        // Prevent dropdown from closing when clicking on the list itself
        (_this$dropdownList6 = this.dropdownList) === null || _this$dropdownList6 === void 0 || _this$dropdownList6.addEventListener('click', function (event) {
          // Only stop propagation if clicking on the list itself, not on items
          if (event.target === _this4.dropdownList) {
            event.stopPropagation();
          }
        });

        // Track scrolling to prevent dropdown from closing
        (_this$dropdownList7 = this.dropdownList) === null || _this$dropdownList7 === void 0 || _this$dropdownList7.addEventListener('scroll', function () {
          _this4.isInteractingWithDropdown = true;
          // Reset flag after scroll ends (increased timeout for mobile)
          clearTimeout(_this4.scrollTimeout);
          _this4.scrollTimeout = setTimeout(function () {
            _this4.isInteractingWithDropdown = false;
          }, 250);
        });
        document.addEventListener('click', function (event) {
          if (!event.target.closest('.breed-dropdown__wrapper') && _this4.dropdownVisible) {
            // Clear any pending timeouts
            clearTimeout(_this4.scrollTimeout);
            _this4.isInteractingWithDropdown = false;
            _this4.dropdownVisible = false;
            _this4.dropdownList.classList.remove('active');
            _this4.breedInner.classList.remove('active');

            // Restore z-index to buttons-wrapper if this is the second dropdown
            if (_this4.dropdownIndex === '2') {
              _this4.restoreButtonsWrapperZIndex();
            }

            // Save state when dropdown closes
            if (_this4.isValid) {
              _this4.saveStateToParent();
            }
            _this4.notifyBreedRadioSelector();
            _this4.updateIconVisibility();
          }
        });
        (_this$inputText2 = this.inputText) === null || _this$inputText2 === void 0 || _this$inputText2.addEventListener('change', function () {
          console.log('Dropdown change event:', _this4.entry);
          if (_this4.isValid) {
            _this4.saveStateToParent();
          }
          _this4.notifyBreedRadioSelector();
          _this4.updateIconVisibility();
        });
        (_this$inputText3 = this.inputText) === null || _this$inputText3 === void 0 || _this$inputText3.addEventListener('input', function (event) {
          console.log('Dropdown input event:', _this4.entry, 'value:', event.target.value);

          // Reset validity when user types manually
          _this4.isValid = false;
          if (event.target.value.trim() === '') {
            console.log('Input cleared - marking as invalid');
            _this4.isValid = false;
          }
          _this4.filterBreedsDebounced(event);
          _this4.notifyBreedRadioSelector();
          _this4.updateIconVisibility();
        });
        (_this$inputText4 = this.inputText) === null || _this$inputText4 === void 0 || _this$inputText4.addEventListener('keyup', function (event) {
          if (event.target.value.trim() === '') {
            console.log('Input emptied via keyboard - marking as invalid');
            _this4.isValid = false;
            _this4.notifyBreedRadioSelector();
            _this4.updateIconVisibility();
          }
        });

        // Handle blur event (iOS "Готово/Done" button and focus loss)
        (_this$inputText5 = this.inputText) === null || _this$inputText5 === void 0 || _this$inputText5.addEventListener('blur', function (event) {
          // Increased delay to allow touch events on dropdown items to fire first
          setTimeout(function () {
            // Don't close if user is interacting with dropdown list (scrolling or clicking)
            if (_this4.isInteractingWithDropdown) {
              console.log('User is interacting with dropdown, keeping it open');
              return;
            }
            var typedValue = event.target.value.trim();

            // Only validate if there's a value and dropdown is closing
            if (typedValue !== '' && !_this4.isValid) {
              // Check if the typed value exists in the breed list (case-insensitive)
              var matchingBreed = _this4.allBreeds.find(function (breed) {
                return breed.toLowerCase() === typedValue.toLowerCase();
              });
              if (matchingBreed) {
                // Valid breed - set the exact breed name and mark as valid
                _this4.inputText.value = matchingBreed;
                _this4.isValid = true;

                // Update selected class
                _this4.dropdownList.querySelectorAll('.breed-dropdown-item').forEach(function (item) {
                  item.classList.remove('selected');
                  if (item.dataset.breed === matchingBreed) {
                    item.classList.add('selected');
                  }
                });
                console.log('✅ Blur validation - Valid breed:', matchingBreed);

                // Save state and notify
                _this4.saveStateToParent();

                // Dispatch tracking event only if not inside breed-radio-selector
                var breedRadioSelector = _this4.closest('breed-radio-selector');
                if (!breedRadioSelector) {
                  _this4.dispatchTrackingEvent(matchingBreed);
                } else {
                  // Force breed-radio-selector to dispatch tracking immediately
                  if (typeof breedRadioSelector.dispatchBreedTrackingEvent === 'function') {
                    breedRadioSelector.dispatchBreedTrackingEvent();
                  }
                }
                _this4.notifyBreedRadioSelector();
                _this4.updateIconVisibility();
              } else {
                // Invalid breed - just mark as invalid
                console.log('❌ Blur validation - Invalid breed:', typedValue);
              }
            }

            // Close dropdown when input loses focus
            if (_this4.dropdownVisible) {
              _this4.dropdownVisible = false;
              _this4.dropdownList.classList.remove('active');
              _this4.breedInner.classList.remove('active');

              // Restore z-index to buttons-wrapper if this is the second dropdown
              if (_this4.dropdownIndex === '2') {
                _this4.restoreButtonsWrapperZIndex();
              }
            }
          }, 300);
        });

        // Handle Enter key (desktop and some mobile browsers)
        (_this$inputText6 = this.inputText) === null || _this$inputText6 === void 0 || _this$inputText6.addEventListener('keydown', function (event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            var typedValue = event.target.value.trim();
            if (typedValue !== '') {
              // Check if the typed value exists in the breed list (case-insensitive)
              var matchingBreed = _this4.allBreeds.find(function (breed) {
                return breed.toLowerCase() === typedValue.toLowerCase();
              });
              if (matchingBreed) {
                // Valid breed - set the exact breed name and mark as valid
                _this4.inputText.value = matchingBreed;
                _this4.isValid = true;

                // Update selected class
                _this4.dropdownList.querySelectorAll('.breed-dropdown-item').forEach(function (item) {
                  item.classList.remove('selected');
                  if (item.dataset.breed === matchingBreed) {
                    item.classList.add('selected');
                  }
                });
                console.log('✅ Enter pressed - Valid breed:', matchingBreed);

                // Save state and notify
                _this4.saveStateToParent();

                // Dispatch tracking event only if not inside breed-radio-selector
                var breedRadioSelector = _this4.closest('breed-radio-selector');
                if (!breedRadioSelector) {
                  _this4.dispatchTrackingEvent(matchingBreed);
                } else {
                  // Force breed-radio-selector to dispatch tracking immediately
                  if (typeof breedRadioSelector.dispatchBreedTrackingEvent === 'function') {
                    breedRadioSelector.dispatchBreedTrackingEvent();
                  }
                }
              } else {
                // Invalid breed - just mark as invalid
                _this4.isValid = false;
                console.log('❌ Enter pressed - Invalid breed:', typedValue);
              }
            }

            // Close dropdown regardless of validity
            _this4.dropdownVisible = false;
            _this4.dropdownList.classList.remove('active');
            _this4.breedInner.classList.remove('active');
            _this4.inputText.blur();

            // Restore z-index to buttons-wrapper if this is the second dropdown
            if (_this4.dropdownIndex === '2') {
              _this4.restoreButtonsWrapperZIndex();
            }

            // Notify parent to validate and update button state
            _this4.notifyBreedRadioSelector();
            _this4.updateIconVisibility();
          }
        });
      }
    }

    /**
     * Check if this dropdown is on the active slide
     * Prevents affecting button state when not visible
     */
  }, {
    key: "isVisible",
    value: function isVisible() {
      // Check if component is in the active swiper slide
      var swiperSlide = this.closest('.swiper-slide');
      if (swiperSlide && !swiperSlide.classList.contains('swiper-slide-active')) {
        return false;
      }
      return this.offsetParent !== null && window.getComputedStyle(this).display !== 'none';
    }
  }, {
    key: "closeOtherDropdowns",
    value: function closeOtherDropdowns() {
      var _this5 = this;
      var wrapper = this.closest('.breed-dropdowns-wrapper');
      if (!wrapper) return;
      var allDropdowns = wrapper.querySelectorAll('custom-dropdown');
      allDropdowns.forEach(function (dropdown) {
        if (dropdown !== _this5) {
          var list = dropdown.querySelector('.breed-dropdown__list');
          var inner = dropdown.querySelector('.breed-dropdown__wrapper-inner');
          if (list) list.classList.remove('active');
          if (inner) inner.classList.remove('active');
          if (dropdown.dropdownVisible !== undefined) {
            dropdown.dropdownVisible = false;
          }
        }
      });
    }
  }, {
    key: "notifyBreedRadioSelector",
    value: function notifyBreedRadioSelector() {
      // CRITICAL: Only notify parent if this dropdown is on the active slide
      // This prevents affecting button state when navigating to other slides
      if (!this.isVisible()) {
        console.log('custom-dropdown: Not visible, skipping parent validation notification');
        return;
      }
      var breedRadioSelector = this.closest('breed-radio-selector');
      if (breedRadioSelector && typeof breedRadioSelector.validateSelection === 'function') {
        console.log('Notifying BreedRadioSelector to validate');
        breedRadioSelector.validateSelection();
      }
    }
  }, {
    key: "handleSelectChange",
    value: function handleSelectChange(event) {
      var _document$querySelect;
      var selectedValue = event.target.value;
      this.updateRangeInput(selectedValue);
      (_document$querySelect = document.querySelector('quiz-container')) === null || _document$querySelect === void 0 || (_document$querySelect = _document$querySelect.activeSlider) === null || _document$querySelect === void 0 || _document$querySelect.update();
    }
  }, {
    key: "updateRangeInput",
    value: function updateRangeInput(value) {
      var rangeInput = this.closest('.swiper-slide').querySelector('custom-input-range');
      if (rangeInput && rangeInput.sliderInstance) {
        var index = Array.from(this.select.options).findIndex(function (option) {
          return option.value === value;
        });
        rangeInput.sliderInstance.set(index);
      }
    }

    // New method: notify parent to save combined state
  }, {
    key: "saveStateToParent",
    value: function saveStateToParent() {
      var breedRadioSelector = this.closest('breed-radio-selector');
      if (breedRadioSelector && typeof breedRadioSelector.saveDropdownState === 'function') {
        breedRadioSelector.saveDropdownState();
      }
    }
  }, {
    key: "restoreState",
    value: function restoreState() {
      // Ensure breed data is loaded before restoring
      if (!this.breedsData && !this.isSelectForRange) {
        this.breedsData = window['breedSearchData' + this.inputId];
      }
      if (!this.breedsData && !this.isSelectForRange) {
        console.warn("Cannot restore state - breed data not available for ".concat(this.inputId));
        return;
      }
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      if (quizData.dropdownStates && quizData.dropdownStates[this.entry]) {
        var savedString = quizData.dropdownStates[this.entry];

        // Parse the new format
        var parsedData = this.parseDropdownState(savedString);
        if (!parsedData) return;

        // Handle select-for-range type
        if (this.isSelectForRange && this.select) {
          // Not applicable for breed selection
          return;
        }

        // Handle breed dropdowns
        if (this.inputText) {
          var valueToRestore = null;

          // Determine which value to use based on dropdown index
          if (parsedData.breedType === 'purebred') {
            valueToRestore = parsedData.value;
          } else if (parsedData.breedType === 'mixed') {
            if (this.dropdownIndex === '1') {
              valueToRestore = parsedData.value_1;
            } else if (this.dropdownIndex === '2') {
              valueToRestore = parsedData.value_2;
            }
          }
          if (valueToRestore) {
            this.inputText.value = valueToRestore;
            this.isValid = true; // Mark as valid since it's from saved state

            console.log('Restored state for', this.entry, 'dropdown', this.dropdownIndex, '- Value:', valueToRestore);

            // Restore selected class on the matching breed item
            if (this.dropdownList) {
              this.dropdownList.querySelectorAll('.breed-dropdown-item').forEach(function (item) {
                if (item.dataset.breed === valueToRestore) {
                  item.classList.add('selected');
                }
              });
            }
            this.updateIconVisibility();
          }
        }
      } else {
        console.log('No saved state for', this.entry);
      }
    }

    // Helper: parse new localStorage format
  }, {
    key: "parseDropdownState",
    value: function parseDropdownState(stateString) {
      if (stateString === 'not_sure') {
        return {
          breedType: 'not_sure'
        };
      }

      // Parse format like "breedTypeStates: mixed; value_1: Breed1; value_2: Breed2"
      var parts = stateString.split(';').map(function (s) {
        return s.trim();
      });
      var result = {};
      parts.forEach(function (part) {
        var _part$split = part.split(':'),
          _part$split2 = _toArray(_part$split),
          key = _part$split2[0],
          valueParts = _part$split2.slice(1);
        var value = valueParts.join(':').trim(); // Handle breed names with colons

        if (key.trim() === 'breedTypeStates') {
          result.breedType = value;
        } else if (key.trim() === 'value') {
          result.value = value;
        } else if (key.trim() === 'value_1') {
          result.value_1 = value;
        } else if (key.trim() === 'value_2') {
          result.value_2 = value;
        }
      });
      return result;
    }
  }, {
    key: "selectBreed",
    value: function selectBreed(event) {
      event.preventDefault();
      event.stopPropagation();

      // Prevent double-selection from both touch and click events
      var now = Date.now();
      if (now - this.lastSelectionTime < 500) {
        console.log('Ignoring duplicate selection event');
        return;
      }
      this.lastSelectionTime = now;
      var breed = event.target.dataset.breed;
      this.inputText.value = breed;

      // Mark as valid when selected from list
      this.isValid = true;
      this.saveStateToParent();
      console.log('✅ Breed selected from list:', breed, '- isValid:', this.isValid);

      // Reset interaction flag and clear timeouts
      clearTimeout(this.scrollTimeout);
      this.isInteractingWithDropdown = false;
      this.touchStartY = null;
      this.touchMoveDetected = false;
      this.dropdownVisible = false;
      this.dropdownList.classList.remove('active');
      this.breedInner.classList.remove('active');

      // Restore z-index to buttons-wrapper if this is the second dropdown
      if (this.dropdownIndex === '2') {
        this.restoreButtonsWrapperZIndex();
      }

      // Remove selected class from all items
      this.dropdownList.querySelectorAll('.breed-dropdown-item').forEach(function (item) {
        item.classList.remove('selected');
      });

      // Add selected class to clicked item
      event.target.classList.add('selected');
      this.notifyBreedRadioSelector();
      this.updateIconVisibility();

      // Dispatch tracking event only if not inside breed-radio-selector
      // breed-radio-selector will handle tracking for all breed types
      var breedRadioSelector = this.closest('breed-radio-selector');
      if (!breedRadioSelector) {
        this.dispatchTrackingEvent(breed);
      } else {
        // Force breed-radio-selector to dispatch tracking immediately after selection
        if (typeof breedRadioSelector.dispatchBreedTrackingEvent === 'function') {
          breedRadioSelector.dispatchBreedTrackingEvent();
        }
      }
    }

    /**
     * Get current slide index from parent quiz container
     */
  }, {
    key: "getCurrentSlideIndex",
    value: function getCurrentSlideIndex() {
      var quizContainer = this.closest('quiz-container');
      if (quizContainer && quizContainer.activeSlider) {
        return quizContainer.activeSlider.activeIndex;
      }
      return 0;
    }

    /**
     * Dispatch tracking event for breed selection
     */
  }, {
    key: "dispatchTrackingEvent",
    value: function dispatchTrackingEvent(breed) {
      document.dispatchEvent(new CustomEvent('quiz:input-changed', {
        detail: {
          type: 'dropdown',
          fieldKey: this.entry,
          value: breed,
          valueLabel: breed,
          slideIndex: this.getCurrentSlideIndex()
        }
      }));
    }

    /**
     * Debounced filter breeds
     */
  }, {
    key: "filterBreedsDebounced",
    value: function filterBreedsDebounced(event) {
      var _this6 = this;
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(function () {
        _this6.filterBreeds(event);
      }, 300);
    }

    /**
     * Filter breeds with priority: popular pure breeds first, then others
     * Uses two-stage search: simple includes + Fuse.js fuzzy search
     */
  }, {
    key: "filterBreeds",
    value: function filterBreeds(event) {
      var searchTerm = event.target.value.trim().toLowerCase();

      // If empty, show initial sorted list (limited to 20)
      if (searchTerm === '') {
        var sortedBreeds = this.sortBreedsByPriority(this.allBreeds);
        this.renderBreedList(sortedBreeds.slice(0, 20));
        this.dropdownList.style.height = '180px';
        this.hideNothingFound();
        return;
      }

      // Stage 1: Simple includes search
      var matchedBreeds = this.allBreeds.filter(function (breed) {
        return breed.toLowerCase().includes(searchTerm);
      });

      // Stage 2: If no results, try Fuse.js fuzzy search
      if (matchedBreeds.length === 0 && this.fuse) {
        var fuseResults = this.fuse.search(searchTerm);
        if (fuseResults.length > 0) {
          matchedBreeds = fuseResults.map(function (result) {
            return result.item;
          });
        }
      }

      // Sort matched breeds by priority
      var sortedMatches = this.sortBreedsByPriority(matchedBreeds);

      // Limit to 20 results
      var limitedMatches = sortedMatches.slice(0, 20);
      if (limitedMatches.length === 0) {
        this.dropdownList.innerHTML = '';
        this.showNothingFound();
        this.dropdownList.style.height = 'auto';
      } else {
        this.renderBreedList(limitedMatches);
        this.hideNothingFound();
        this.dropdownList.style.height = limitedMatches.length > 4 ? '180px' : 'auto';
      }
    }
  }, {
    key: "showNothingFound",
    value: function showNothingFound() {
      var existingMessage = this.dropdownList.querySelector('.found-nothing');
      if (existingMessage) {
        existingMessage.remove();
      }
      var messageEl = document.createElement('div');
      messageEl.classList.add('found-nothing');
      messageEl.textContent = this.nothingText;
      this.dropdownList.appendChild(messageEl);
      messageEl.addEventListener('mousedown', function (e) {
        e.preventDefault();
        e.stopPropagation();
      });
    }
  }, {
    key: "hideNothingFound",
    value: function hideNothingFound() {
      var message = this.dropdownList.querySelector('.found-nothing');
      if (message) {
        message.remove();
      }
    }
  }, {
    key: "updateIconVisibility",
    value: function updateIconVisibility() {
      if (this.type !== 'breed' || !this.icon) return;
      if (this.inputText && this.inputText.value.trim() !== '' && this.isValid) {
        this.showIcon();
      } else {
        this.hideIcon();
      }
    }
  }, {
    key: "showIcon",
    value: function showIcon() {
      if (this.icon) {
        this.icon.classList.remove('tw-hidden');
      }
    }
  }, {
    key: "hideIcon",
    value: function hideIcon() {
      if (this.icon) {
        this.icon.classList.add('tw-hidden');
      }
    }

    /**
     * Reset dropdown to initial state
     */
  }, {
    key: "reset",
    value: function reset() {
      // Clear input value (multiple approaches for iOS compatibility)
      if (this.inputText) {
        var _Object$getOwnPropert;
        // Use native setter for iOS WebKit compatibility
        var nativeInputValueSetter = (_Object$getOwnPropert = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value')) === null || _Object$getOwnPropert === void 0 ? void 0 : _Object$getOwnPropert.set;
        if (nativeInputValueSetter) {
          nativeInputValueSetter.call(this.inputText, '');
        } else {
          this.inputText.value = '';
        }
        this.inputText.setAttribute('value', '');

        // Force blur to ensure iOS releases the input
        if (document.activeElement === this.inputText) {
          this.inputText.blur();
        }
      }

      // Reset validity
      this.isValid = false;

      // Hide icon
      this.hideIcon();

      // Restore initial sorted list (limited to 20)
      if (this.allBreeds && this.allBreeds.length > 0) {
        var sortedBreeds = this.sortBreedsByPriority(this.allBreeds);
        this.renderBreedList(sortedBreeds.slice(0, 20));
      }

      // Reset dropdown list height
      if (this.dropdownList) {
        this.dropdownList.style.height = '';
      }

      // Close dropdown if open
      this.dropdownVisible = false;
      if (this.dropdownList) {
        this.dropdownList.classList.remove('active');
      }
      if (this.breedInner) {
        this.breedInner.classList.remove('active');
      }

      // Remove nothing found message
      this.hideNothingFound();
      console.log('CustomDropdown reset:', this.entry, 'isValid:', this.isValid);
    }

    /**
     * Remove z-index from .sticky-wrapper (called when second dropdown opens)
     */
  }, {
    key: "removeButtonsWrapperZIndex",
    value: function removeButtonsWrapperZIndex() {
      var stickyWrapper = document.querySelector('.sticky-wrapper');
      if (stickyWrapper) {
        stickyWrapper.classList.add('dropdown-open-no-z');
      }
    }

    /**
     * Restore z-index to .sticky-wrapper (called when second dropdown closes)
     */
  }, {
    key: "restoreButtonsWrapperZIndex",
    value: function restoreButtonsWrapperZIndex() {
      var stickyWrapper = document.querySelector('.sticky-wrapper');
      if (stickyWrapper) {
        stickyWrapper.classList.remove('dropdown-open-no-z');
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomDropdown);

/***/ }),

/***/ "./src/assets/js/quiz-components-v2/custom-image-slider.js":
/*!*****************************************************************!*\
  !*** ./src/assets/js/quiz-components-v2/custom-image-slider.js ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var CustomImageSlider = /*#__PURE__*/function (_HTMLElement) {
  function CustomImageSlider() {
    var _this$sliderItem;
    var _this;
    _classCallCheck(this, CustomImageSlider);
    _this = _callSuper(this, CustomImageSlider);
    _this.swiper = null;
    _this.sliderItem = _this.querySelector('.swiper');
    _this.sliderSlides = ((_this$sliderItem = _this.sliderItem) === null || _this$sliderItem === void 0 ? void 0 : _this$sliderItem.querySelectorAll('.swiper-slide')) || [];
    _this.prevButton = _this.querySelector('.custom-image-slider__nav-prev');
    _this.nextButton = _this.querySelector('.custom-image-slider__nav-next');
    _this.pagination = _this.querySelector('.custom-image-slider__pagination');
    _this.autoplay = _this.dataset.autoplay;
    _this.currentBreedGroup = null;
    return _this;
  }
  _inherits(CustomImageSlider, _HTMLElement);
  return _createClass(CustomImageSlider, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      // Enable next button immediately
      this.enableNextButton();

      // Listen for breed changes
      this.listenToBreedChanges();

      // Wait for Swiper to be available
      var checkSwiper = setInterval(function () {
        if (typeof Swiper !== 'undefined') {
          _this2.filterAndInitSlider();
          clearInterval(checkSwiper);
        }
      }, 100);
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      // Check if component is in the active swiper slide
      var swiperSlide = this.closest('.swiper-slide');
      if (swiperSlide && !swiperSlide.classList.contains('swiper-slide-active')) {
        return false;
      }
      return this.offsetParent !== null && window.getComputedStyle(this).display !== 'none';
    }
  }, {
    key: "enableNextButton",
    value: function enableNextButton() {
      // Only enable if visible on current slide
      if (!this.isVisible()) {
        return;
      }
      var nextButton = document.querySelector('.button--next');
      if (nextButton) {
        nextButton.classList.remove('button--disabled');
        nextButton.disabled = false;
      }
    }

    /**
     * Listen to breed selection changes from localStorage
     */
  }, {
    key: "listenToBreedChanges",
    value: function listenToBreedChanges() {
      var _this3 = this;
      // Initial check
      this.checkAndUpdateSlides();

      // Listen for storage changes
      window.addEventListener('storage', function () {
        _this3.checkAndUpdateSlides();
      });

      // Listen for custom quiz events
      document.addEventListener('quiz:input-changed', function (event) {
        if (event.detail.type === 'dropdown' && event.detail.fieldKey === 'entry.62437307') {
          setTimeout(function () {
            _this3.checkAndUpdateSlides();
          }, 100);
        }
      });

      // Poll for changes (fallback)
      setInterval(function () {
        _this3.checkAndUpdateSlides();
      }, 1000);
    }

    /**
     * Check localStorage and update slides if breed changed
     */
  }, {
    key: "checkAndUpdateSlides",
    value: function checkAndUpdateSlides() {
      var _quizData$dropdownSta;
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      var breedDataString = (_quizData$dropdownSta = quizData.dropdownStates) === null || _quizData$dropdownSta === void 0 ? void 0 : _quizData$dropdownSta['entry.62437307'];
      if (!breedDataString) {
        // Default to retrievers
        this.updateSlidesForBreedGroup('retriever');
        return;
      }
      var breedData = this.parseBreedData(breedDataString);
      if (breedData.breedType === 'not_sure') {
        // Use default (retrievers)
        this.updateSlidesForBreedGroup('retriever');
      } else if (breedData.breeds.length > 0) {
        // Use first breed to determine group
        var primaryBreed = breedData.breeds[0];
        var groupKey = this.findGroupByBreedName(primaryBreed);
        this.updateSlidesForBreedGroup(groupKey);
      }
    }

    /**
     * Parse breed data from localStorage string
     */
  }, {
    key: "parseBreedData",
    value: function parseBreedData(breedDataString) {
      if (!breedDataString) {
        return {
          breedType: 'unknown',
          breeds: []
        };
      }
      if (breedDataString === 'not_sure') {
        return {
          breedType: 'not_sure',
          breeds: []
        };
      }
      var parts = breedDataString.split(';').map(function (s) {
        return s.trim();
      });
      var result = {
        breedType: 'unknown',
        breeds: []
      };
      parts.forEach(function (part) {
        var _part$split = part.split(':'),
          _part$split2 = _toArray(_part$split),
          key = _part$split2[0],
          valueParts = _part$split2.slice(1);
        var value = valueParts.join(':').trim();
        if (key.trim() === 'breedTypeStates') {
          result.breedType = value;
        } else if (key.trim() === 'value') {
          result.breeds.push(value);
        } else if (key.trim() === 'value_1') {
          result.breeds.push(value);
        } else if (key.trim() === 'value_2') {
          result.breeds.push(value);
        }
      });
      return result;
    }

    /**
     * Find breed group by breed name
     */
  }, {
    key: "findGroupByBreedName",
    value: function findGroupByBreedName(breedName) {
      if (!breedName) return 'retriever';
      var lower = breedName.toLowerCase();
      var list = window.breedSearchDatabreed_1 || [];

      // Search by URL in breed data
      var _iterator = _createForOfIteratorHelper(list),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var entry = _step.value;
          if (entry.breedList.some(function (b) {
            return b.toLowerCase() === lower;
          })) {
            var url = (entry.breedUrl || '').toLowerCase();
            if (url.includes('bulldogs') || url.includes('bully')) return 'bulldogen';
            if (url.includes('ravishing-retrievers')) return 'retriever';
            if (url.includes('shine-bright-shepherds')) return 'shepherd';
            if (url.includes('collections/minis') || url.includes('marvelous-minis')) return 'mini';
            if (url.includes('happy-herders')) return 'herders';
            if (url.includes('hearty-hunters')) return 'kleine_jagdhunde';
            if (url.includes('big-buddies')) return 'molosser';
            if (url.includes('heroic-hunters')) return 'grosse_jagdhunde';
          }
        }

        // Fallback: search by keywords in breed name
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (lower.includes('bulldog') || lower.includes('frenchie') || lower.includes('mops') || lower.includes('boston')) return 'bulldogen';
      if (lower.includes('retriever') || lower.includes('labrador') || lower.includes('golden')) return 'retriever';
      if (lower.includes('schäfer') || lower.includes('shepherd') || lower.includes('malinois')) return 'shepherd';
      if (lower.includes('chihuahua') || lower.includes('york') || lower.includes('malteser') || lower.includes('havaneser') || lower.includes('jack russell')) return 'mini';
      if (lower.includes('collie') || lower.includes('australian shepherd') || lower.includes('border')) return 'herders';
      if (lower.includes('mastiff') || lower.includes('cane corso') || lower.includes('rottweiler') || lower.includes('dogge')) return 'molosser';
      if (lower.includes('weimaraner') || lower.includes('vizsla') || lower.includes('pointer') || lower.includes('setter')) return 'grosse_jagdhunde';
      if (lower.includes('beagle') || lower.includes('dackel') || lower.includes('terrier')) return 'kleine_jagdhunde';

      // Default to retriever
      return 'retriever';
    }

    /**
     * Update slides visibility for specific breed group
     */
  }, {
    key: "updateSlidesForBreedGroup",
    value: function updateSlidesForBreedGroup(groupKey) {
      if (this.currentBreedGroup === groupKey) {
        // Already showing this breed group
        return;
      }
      console.log("Updating slides for breed group: ".concat(groupKey));
      this.currentBreedGroup = groupKey;

      // Re-initialize slider with filtered slides
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
      this.filterAndInitSlider();
    }

    /**
     * Normalize breed string for comparison
     * Converts to lowercase and replaces hyphens with underscores
     */
  }, {
    key: "normalizeBreed",
    value: function normalizeBreed(breed) {
      if (!breed) return '';
      return breed.toLowerCase().replace(/-/g, '_');
    }

    /**
     * Filter slides and initialize Swiper
     */
  }, {
    key: "filterAndInitSlider",
    value: function filterAndInitSlider() {
      var _this4 = this;
      if (!this.sliderItem) return;

      // Get all slides
      var allSlides = this.sliderItem.querySelectorAll('.swiper-slide');
      if (allSlides.length === 0) {
        console.warn('No slides found in slider');
        return;
      }

      // Determine which breed group to show
      var breedGroup = this.currentBreedGroup || 'retriever';
      var normalizedBreedGroup = this.normalizeBreed(breedGroup);
      console.log("Filtering slides for breed group: ".concat(breedGroup, " (normalized: ").concat(normalizedBreedGroup, ")"));

      // Show/hide slides based on data-breed attribute
      var visibleCount = 0;
      var breedCounts = {};
      allSlides.forEach(function (slide) {
        var slideBreed = slide.dataset.breed;
        var normalizedSlideBreed = _this4.normalizeBreed(slideBreed);

        // Track all breed types for debugging
        if (!breedCounts[slideBreed]) {
          breedCounts[slideBreed] = 0;
        }
        breedCounts[slideBreed]++;
        if (!slideBreed || normalizedSlideBreed === normalizedBreedGroup) {
          slide.style.display = '';
          visibleCount++;
        } else {
          slide.style.display = 'none';
        }
      });

      // Initialize Swiper only if there are visible slides
      if (visibleCount > 0) {
        this.initSlider();
      } else {
        console.warn("No slides found for breed group: ".concat(breedGroup, " (normalized: ").concat(normalizedBreedGroup, ")"));
      }
    }
  }, {
    key: "initSlider",
    value: function initSlider() {
      if (!this.sliderItem) return;
      this.swiper = new Swiper(this.sliderItem, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        allowTouchMove: true,
        autoplay: this.autoplay ? {
          autoplay: {
            delay: 3500,
            disableOnInteraction: true
          }
        } : false,
        navigation: {
          nextEl: this.nextButton,
          prevEl: this.prevButton
        },
        pagination: {
          el: this.pagination,
          clickable: true,
          bulletClass: 'swiper-pagination-bullet',
          bulletActiveClass: 'swiper-pagination-bullet-active'
        }
      });
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      // Cleanup Swiper instance
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomImageSlider);

/***/ }),

/***/ "./src/assets/js/quiz-components-v2/custom-input-checkbox.js":
/*!*******************************************************************!*\
  !*** ./src/assets/js/quiz-components-v2/custom-input-checkbox.js ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
/**
 * Custom Input Checkbox Component
 * Handles checkbox interactions and state management with visual feedback
 */
var CustomInputCheckbox = /*#__PURE__*/function (_HTMLElement) {
  function CustomInputCheckbox() {
    var _this;
    _classCallCheck(this, CustomInputCheckbox);
    _this = _callSuper(this, CustomInputCheckbox);
    _this.quizContainer = null;
    _this.entry = null;
    _this.name = null;
    _this.inputs = null;
    _this.closestStep = null;
    _this.hasBottomDesc = false;
    _this.quizFooter = null;
    _this.labels = null;
    _this.limitChoice = null;
    _this.nothingFoundText = null;
    _this.hasTrackedInitial = false;
    _this.wasVisibleBefore = false;
    _this.customIssueInput = null;
    return _this;
  }
  _inherits(CustomInputCheckbox, _HTMLElement);
  return _createClass(CustomInputCheckbox, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.init();
    }
  }, {
    key: "init",
    value: function init() {
      var _this$quizContainer,
        _this2 = this;
      // Initialize properties
      this.quizContainer = this.closest('quiz-container');
      this.entry = this.dataset.entry;
      this.name = this.dataset.name;
      this.inputs = this.querySelectorAll('.custom-input-checkbox__input');
      this.closestStep = this.closest('.swiper-slide--step');
      this.hasBottomDesc = this.dataset.bottomdesc === 'true';
      this.quizFooter = (_this$quizContainer = this.quizContainer) === null || _this$quizContainer === void 0 ? void 0 : _this$quizContainer.querySelector('quiz-footer');
      this.labels = this.querySelectorAll('.custom-input-checkbox__label');
      this.limitChoice = this.dataset.limit ? parseInt(this.dataset.limit) : null;
      this.nothingFoundText = this.dataset.nonameText;
      this.titleContainer = this.querySelector('.title-label');
      this.customIssueInput = this.querySelector('.custom-issue__input');

      // Hide custom input by default (will be shown when non-dog-issue is selected)
      if (this.customIssueInput) {
        this.customIssueInput.classList.add('tw-hidden');
      }

      // Initialize visibility state
      this.wasVisibleBefore = this.isVisible();

      // Restore state and set listeners
      this.restoreCheckboxState();
      this.updateCheckboxStates();
      this.setEventListeners();
      this.setupCustomInputListener();

      // Update dog name in headline
      // this.updateDogName();

      // Initial validation
      this.validateCheckboxes();

      // Listen for slide changes to synchronize state
      document.addEventListener('sliderChange', function (event) {
        _this2.handleSlideChange();
      });
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      // Check if component is in the active swiper slide
      var swiperSlide = this.closest('.swiper-slide');
      if (swiperSlide && !swiperSlide.classList.contains('swiper-slide-active')) {
        return false;
      }
      return this.offsetParent !== null && window.getComputedStyle(this).display !== 'none';
    }

    /**
     * Handle slide change - synchronize checkbox states when component becomes visible
     */
  }, {
    key: "handleSlideChange",
    value: function handleSlideChange() {
      var _this3 = this;
      var wasVisible = this.wasVisibleBefore;
      var isVisibleNow = this.isVisible();

      // Store current visibility state for next check
      this.wasVisibleBefore = isVisibleNow;
      if (!isVisibleNow) {
        // Component became hidden
        return;
      }

      // Only sync states when component BECOMES visible (transition from hidden to visible)
      // This prevents unnecessary updates when staying on the same slide
      var justBecameVisible = !wasVisible && isVisibleNow;
      if (justBecameVisible || !this.hasTrackedInitial) {
        // Wait for Swiper animation to complete (200ms) + small buffer
        setTimeout(function () {
          // Double-check visibility after animation
          if (!_this3.isVisible()) return;

          // Restore checkbox states from localStorage
          _this3.restoreCheckboxState();

          // Update visual states immediately after restore
          _this3.updateCheckboxStates();

          // Track initial selection if not yet tracked
          if (!_this3.hasTrackedInitial) {
            _this3.trackInitialSelection();
          }

          // Validate checkboxes
          _this3.validateCheckboxes();
        }, 300);
      }
    }

    /**
     * Get current slide index from parent quiz container
     */
  }, {
    key: "getCurrentSlideIndex",
    value: function getCurrentSlideIndex() {
      var quizContainer = this.closest('quiz-container');
      if (quizContainer && quizContainer.activeSlider) {
        return quizContainer.activeSlider.activeIndex;
      }
      return 0;
    }

    /**
     * Get the expected slide index for this component
     * (index of the swiper-slide that contains this component)
     */
  }, {
    key: "getExpectedSlideIndex",
    value: function getExpectedSlideIndex() {
      var swiperSlide = this.closest('.swiper-slide');
      if (!swiperSlide) return null;

      // Get the main quiz container's swiper wrapper (not nested swipers like protein)
      var quizContainer = this.closest('quiz-container');
      if (!quizContainer) return null;
      var mainSwiperWrapper = quizContainer.querySelector('.swiper > .swiper-wrapper');
      if (!mainSwiperWrapper) return null;

      // Only count direct children slides of main swiper (excludes nested swiper slides)
      var allSlides = Array.from(mainSwiperWrapper.children).filter(function (el) {
        return el.classList.contains('swiper-slide');
      });
      return allSlides.indexOf(swiperSlide);
    }

    /**
     * Validate that slideIndex matches component position
     */
  }, {
    key: "validateSlideIndex",
    value: function validateSlideIndex(slideIndex) {
      var expectedIndex = this.getExpectedSlideIndex();
      if (expectedIndex === null) return true; // Cannot validate

      if (slideIndex !== expectedIndex) {
        console.warn("[CustomInputCheckbox] slideIndex mismatch for \"".concat(this.entry, "\":"), "\n  Current slideIndex: ".concat(slideIndex), "\n  Expected slideIndex: ".concat(expectedIndex), "\n  Component:", this);
        return false;
      }
      return true;
    }

    /**
     * Trim value to text before /-/ separator and remove invisible characters
     * @param {string} value - Full value string
     * @returns {string} Trimmed value
     */
  }, {
    key: "trimValueBeforeSeparator",
    value: function trimValueBeforeSeparator(value) {
      if (!value) return value;
      var parts = value.split('/-/');
      // Remove invisible characters (zero-width spaces, etc.) and trim
      return parts[0].replace(/[\u200B-\u200D\uFEFF]/g, '').trim();
    }

    /**
     * Track initial/default selection when component becomes visible
     * Only fires once per component lifecycle to avoid duplicate tracking
     * Flag is reset only on restart or value change
     */
  }, {
    key: "trackInitialSelection",
    value: function trackInitialSelection() {
      if (!this.isVisible()) return;

      // Only track once - flag persists across slide navigation
      if (this.hasTrackedInitial) return;

      // Query fresh DOM elements and track initial state (even if nothing is selected)
      var currentInputs = this.querySelectorAll('.custom-input-checkbox__input');
      var checkedInputs = Array.from(currentInputs).filter(function (i) {
        return i.checked;
      });

      // Filter by dog-issue type
      var selected = this.filterByDogIssueType(checkedInputs);

      // Remove duplicates
      var uniqueSelected = _toConsumableArray(new Set(selected));
      var slideIndex = this.getCurrentSlideIndex();

      // Validate slideIndex
      this.validateSlideIndex(slideIndex);
      document.dispatchEvent(new CustomEvent('quiz:input-changed', {
        detail: {
          type: 'checkbox',
          fieldKey: this.entry,
          // Send null if nothing is selected (helps analytics identify missing answers)
          selected: uniqueSelected.length > 0 ? uniqueSelected : null,
          slideIndex: slideIndex
        }
      }));
      this.hasTrackedInitial = true;
    }

    /**
     * Filter checkbox selections by dog-issue type
     * Rules:
     * - If non-dog-issue is selected, return ONLY non-dog-issue values (mutually exclusive)
     * - If dog-issues are selected (and no non-dog-issue), return ONLY dog-issue values
     * - Never mix both types in the output
     * @param {Array} checkedInputs - Array of checked input elements
     * @returns {Array} Filtered array of values
     */
  }, {
    key: "filterByDogIssueType",
    value: function filterByDogIssueType(checkedInputs) {
      var _this4 = this;
      // Separate inputs by type
      var nonDogInputs = checkedInputs.filter(function (input) {
        return input.getAttribute('data-non-dog-issue') === 'true';
      });
      var dogInputs = checkedInputs.filter(function (input) {
        return input.getAttribute('data-dog-issue') === 'true';
      });
      var hasNonDogIssue = nonDogInputs.length > 0;
      var hasDogIssue = dogInputs.length > 0;

      // Priority: non-dog-issue takes precedence (mutually exclusive selection)
      // If non-dog-issue is selected, return ONLY non-dog-issue values
      if (hasNonDogIssue) {
        var filtered = nonDogInputs.map(function (input) {
          var value = input.getAttribute('data-textvalue') || input.value;
          return _this4.trimValueBeforeSeparator(value);
        });
        return filtered;
      }

      // If only dog-issues are selected (no non-dog-issue), return dog-issue values
      if (hasDogIssue) {
        var _filtered = dogInputs.map(function (input) {
          var value = input.getAttribute('data-textvalue') || input.value;
          return _this4.trimValueBeforeSeparator(value);
        });
        console.log('[CHECKBOX] Returning dog-issues only:', _filtered);
        return _filtered;
      }

      // Fallback: return all values if no dog-issue attributes are set
      var all = checkedInputs.map(function (input) {
        var value = input.getAttribute('data-textvalue') || input.value;
        return _this4.trimValueBeforeSeparator(value);
      });
      console.log('[CHECKBOX] Returning all (no dog-issue attrs):', all);
      return all;
    }
  }, {
    key: "validateCheckboxes",
    value: function validateCheckboxes() {
      // Food-type step requires at least one selection
      // Check by entry OR by name attribute
      var isFoodType = this.entry === 'entry.306846565' || this.name === 'food-type';
      var isMandatory = this.dataset.mandatory === 'true';
      if (isFoodType || isMandatory) {
        var currentInputs = this.querySelectorAll('.custom-input-checkbox__input');
        var hasSelection = Array.from(currentInputs).some(function (input) {
          return input.checked;
        });
        if (hasSelection) {
          this.enableNextButton();
        } else {
          this.disableNextButton();
        }
        return;
      }

      // Only enable if visible on current slide for non-food-type
      if (!this.isVisible()) {
        return;
      }

      // Other checkboxes should always have enabled button
      this.enableNextButton();
    }
  }, {
    key: "enableNextButton",
    value: function enableNextButton() {
      var nextButton = document.querySelector('.button--next');
      if (nextButton) {
        nextButton.classList.remove('button--disabled');
        nextButton.disabled = false;
      }
    }
  }, {
    key: "disableNextButton",
    value: function disableNextButton() {
      var nextButton = document.querySelector('.button--next');
      if (nextButton) {
        nextButton.classList.add('button--disabled');
        nextButton.disabled = true;
      }
    }
  }, {
    key: "updateDogName",
    value: function updateDogName() {
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      var dogName = quizData.dogName || quizData.name;
      var nameSpan = this.querySelector('.dog-name');
      if (nameSpan && dogName && dogName.trim() !== '') {
        nameSpan.textContent = dogName;
      } else if (this.titleContainer && this.nothingFoundText) {
        this.titleContainer.innerHTML = this.nothingFoundText;
      }
    }

    /**
     * Save checkbox state to localStorage
     */
  }, {
    key: "saveCheckboxState",
    value: function saveCheckboxState() {
      var _this$customIssueInpu;
      // Query fresh DOM elements
      var currentInputs = this.querySelectorAll('.custom-input-checkbox__input');
      var state = Array.from(currentInputs).map(function (input) {
        return {
          id: input.id,
          checked: input.checked,
          value: input.value,
          textValue: input.getAttribute('data-textvalue'),
          img: input.getAttribute('data-image-src'),
          isDogIssue: input.getAttribute('data-dog-issue') === 'true',
          isNonDogIssue: input.getAttribute('data-non-dog-issue') === 'true'
        };
      });
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      quizData.checkboxStates = quizData.checkboxStates || {};
      quizData.checkboxStates[this.entry] = state;

      // Save custom input text for non-dog-issue
      var customInput = (_this$customIssueInpu = this.customIssueInput) === null || _this$customIssueInpu === void 0 ? void 0 : _this$customIssueInpu.querySelector('input');
      if (customInput) {
        quizData.customIssueText = quizData.customIssueText || {};
        quizData.customIssueText[this.entry] = customInput.value.trim();
      }
      localStorage.setItem('quiz', JSON.stringify(quizData));

      // Dispatch tracking event
      if (this.isVisible()) {
        // Get checked inputs from DOM for filtering
        var checkedInputs = Array.from(currentInputs).filter(function (i) {
          return i.checked;
        });

        // Filter by dog-issue type
        var selected = this.filterByDogIssueType(checkedInputs);

        // Remove duplicates
        var uniqueSelected = _toConsumableArray(new Set(selected));

        // Check if non-dog-issue is selected and get custom text
        var hasNonDogIssue = checkedInputs.some(function (i) {
          return i.getAttribute('data-non-dog-issue') === 'true';
        });
        var customText = (customInput === null || customInput === void 0 ? void 0 : customInput.value.trim()) || '';

        // Prepare event detail based on selection type
        var eventDetail = {
          type: 'checkbox',
          fieldKey: this.entry,
          slideIndex: this.getCurrentSlideIndex()
        };
        if (hasNonDogIssue && customText) {
          // For non-dog-issue with custom text, send as object
          eventDetail.selected = {
            issue: uniqueSelected[0] || 'Keine',
            problem_description: customText
          };
        } else {
          // For dog-issues or empty custom text, send as array
          // Send null if nothing is selected (helps analytics identify missing answers)
          eventDetail.selected = uniqueSelected.length > 0 ? uniqueSelected : null;
        }
        document.dispatchEvent(new CustomEvent('quiz:input-changed', {
          detail: eventDetail
        }));
      }
    }

    /**
     * Restore checkbox state from localStorage
     * Applies dog/non-dog mutual exclusivity rules
     */
  }, {
    key: "restoreCheckboxState",
    value: function restoreCheckboxState() {
      var _this5 = this;
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      var state = quizData.checkboxStates && quizData.checkboxStates[this.entry];
      if (state && Array.isArray(state)) {
        // Get all current inputs
        var currentInputs = this.querySelectorAll('.custom-input-checkbox__input');

        // First pass: restore all checked states
        state.forEach(function (_ref) {
          var id = _ref.id,
            checked = _ref.checked;
          var input = null;
          try {
            input = _this5.querySelector("#".concat(CSS.escape(id)));
          } catch (e) {
            input = Array.from(currentInputs).find(function (inp) {
              return inp.id === id;
            });
          }
          if (input) {
            input.checked = checked;
          }
        });

        // Second pass: apply mutual exclusivity rules
        // If both dog and non-dog issues are checked, keep only non-dog (Keine takes priority)
        var checkedInputs = Array.from(currentInputs).filter(function (i) {
          return i.checked;
        });
        var hasNonDog = checkedInputs.some(function (i) {
          return i.getAttribute('data-non-dog-issue') === 'true';
        });
        var hasDog = checkedInputs.some(function (i) {
          return i.getAttribute('data-dog-issue') === 'true';
        });

        // If both types are selected, uncheck dog issues (non-dog takes priority)
        if (hasNonDog && hasDog) {
          console.log('[CHECKBOX] Restore: conflict detected, unchecking dog-issues');
          checkedInputs.forEach(function (input) {
            if (input.getAttribute('data-dog-issue') === 'true') {
              input.checked = false;
            }
          });
          // Save corrected state
          this.saveCheckboxState();
        }

        // Restore custom input text and visibility for non-dog-issue
        if (hasNonDog && this.customIssueInput) {
          var _quizData$customIssue;
          var customInput = this.customIssueInput.querySelector('input');
          var savedText = ((_quizData$customIssue = quizData.customIssueText) === null || _quizData$customIssue === void 0 ? void 0 : _quizData$customIssue[this.entry]) || '';
          if (customInput && savedText) {
            customInput.value = savedText;
          }

          // Show custom input if non-dog-issue is selected
          this.customIssueInput.classList.remove('tw-hidden');
        }
      }
    }

    /**
     * Update visual states for all checkboxes
     */
  }, {
    key: "updateCheckboxStates",
    value: function updateCheckboxStates() {
      // Always query fresh DOM elements to avoid stale references
      var currentInputs = this.querySelectorAll('.custom-input-checkbox__input');
      currentInputs.forEach(function (input) {
        var item = input.closest('.custom-input-checkbox__item');
        if (!item) return;
        var activeIcon = item.querySelector('.custom-input-checkbox__check-icon--active');
        var inactiveIcon = item.querySelector('.custom-input-checkbox__check-icon--inactive');
        var bgImage = item.querySelector('.custom-input-checkbox__bg-image');
        if (input.checked) {
          // Active state
          item.classList.add('is-active');
          activeIcon === null || activeIcon === void 0 || activeIcon.classList.remove('tw-hidden');
          inactiveIcon === null || inactiveIcon === void 0 || inactiveIcon.classList.add('tw-hidden');
          if (bgImage) {
            bgImage.style.opacity = '1';
          }
        } else {
          // Inactive state
          item.classList.remove('is-active');
          activeIcon === null || activeIcon === void 0 || activeIcon.classList.add('tw-hidden');
          inactiveIcon === null || inactiveIcon === void 0 || inactiveIcon.classList.remove('tw-hidden');
          if (bgImage) {
            bgImage.style.opacity = '0.4';
          }
        }
      });
    }

    /**
     * Handle checkbox change event
     */
  }, {
    key: "handleCheckboxChange",
    value: function handleCheckboxChange(input) {
      var _this6 = this;
      var currentInputs = this.querySelectorAll('.custom-input-checkbox__input');
      var checkedInputs = Array.from(currentInputs).filter(function (i) {
        return i.checked;
      }).length;

      // Check limit
      if (this.limitChoice !== null && checkedInputs > this.limitChoice) {
        var _window$quizLocales;
        var message = ((_window$quizLocales = window.quizLocales) === null || _window$quizLocales === void 0 || (_window$quizLocales = _window$quizLocales.errors) === null || _window$quizLocales === void 0 || (_window$quizLocales = _window$quizLocales.limits) === null || _window$quizLocales === void 0 ? void 0 : _window$quizLocales.replace('{{limit}}', this.limitChoice)) || "Maximum ".concat(this.limitChoice, " selections allowed");
        alert(message);
        input.checked = false;
        return;
      }

      // Reset tracking flag when checkbox state changes (allow re-tracking)
      this.hasTrackedInitial = false;

      // --- DOG vs NON-DOG LOGIC ---
      var isDog = input.dataset.dogIssue === 'true';
      var isNonDog = input.dataset.nonDogIssue === 'true';
      if (input.checked && (isDog || isNonDog)) {
        var allInputs = this.querySelectorAll('.custom-input-checkbox__input');
        allInputs.forEach(function (inp) {
          if (inp === input) return;
          var inpIsDog = inp.dataset.dogIssue === 'true';
          var inpIsNonDog = inp.dataset.nonDogIssue === 'true';
          if (isDog && inpIsNonDog) {
            inp.checked = false;
            _this6.customIssueInput.classList.add('tw-hidden');
          }
          if (isNonDog && inpIsDog) {
            inp.checked = false;
            _this6.customIssueInput.classList.remove('tw-hidden');
            _this6.customIssueInput.querySelector('input').value = '';
            _this6.customIssueInput.querySelector('input').focus();
          }
        });
      }

      // If non-dog issue is being unchecked, hide the custom input
      if (!input.checked && isNonDog && this.customIssueInput) {
        this.customIssueInput.classList.add('tw-hidden');
        var customInput = this.customIssueInput.querySelector('input');
        if (customInput) {
          customInput.value = '';
        }
      }
      this.updateCheckboxStates();
      this.saveCheckboxState();
      this.validateCheckboxes();
    }

    /**
     * Handle bottom description update
     */
  }, {
    key: "handleBottomDescUpdate",
    value: function handleBottomDescUpdate(label) {
      var _this7 = this;
      var input = label.previousElementSibling;
      setTimeout(function () {
        if (input && input.checked) {
          var _this7$quizFooter;
          (_this7$quizFooter = _this7.quizFooter) === null || _this7$quizFooter === void 0 || _this7$quizFooter.updateBoth(label.dataset.labelvalue || '', label.dataset.labeltext || '');
        } else {
          var _this7$closestStep, _this7$quizContainer, _this7$quizContainer$, _this7$quizContainer$2, _this7$quizFooter2;
          var defaultTitle = ((_this7$closestStep = _this7.closestStep) === null || _this7$closestStep === void 0 || (_this7$closestStep = _this7$closestStep.dataset) === null || _this7$closestStep === void 0 ? void 0 : _this7$closestStep.title) || '';
          var defaultText = ((_this7$quizContainer = _this7.quizContainer) === null || _this7$quizContainer === void 0 || (_this7$quizContainer$ = _this7$quizContainer.returnExtractedText) === null || _this7$quizContainer$ === void 0 ? void 0 : _this7$quizContainer$.call(_this7$quizContainer, (_this7$quizContainer$2 = _this7.quizContainer.activeSlider) === null || _this7$quizContainer$2 === void 0 ? void 0 : _this7$quizContainer$2.activeIndex)) || '';
          (_this7$quizFooter2 = _this7.quizFooter) === null || _this7$quizFooter2 === void 0 || _this7$quizFooter2.updateBoth(defaultTitle, defaultText);
        }
      }, 200);
    }

    /**
     * Set up event listeners using event delegation
     */
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this8 = this;
      // Track if we're currently processing a click to avoid double-handling
      var isProcessingClick = false;

      // Use event delegation for checkbox changes to avoid stale references
      this.addEventListener('change', function (e) {
        // Skip if we're already processing a click
        if (isProcessingClick) return;
        var input = e.target;
        if (input.classList.contains('custom-input-checkbox__input')) {
          _this8.handleCheckboxChange(input);
        }
      });

      // Handle clicks on the component to ensure single-click responsiveness
      this.addEventListener('click', function (e) {
        var label = e.target.closest('.custom-input-checkbox__label');
        if (!label) return;

        // Find the associated input
        var inputId = label.getAttribute('for');
        if (!inputId) return;
        var input = _this8.querySelector("#".concat(CSS.escape(inputId)));
        if (!input) return;

        // Set flag to prevent double-handling
        isProcessingClick = true;

        // Toggle the checkbox state manually
        input.checked = !input.checked;

        // Handle the change
        _this8.handleCheckboxChange(input);

        // Bottom description update if needed
        if (_this8.hasBottomDesc) {
          _this8.handleBottomDescUpdate(label);
        }

        // Reset flag after a short delay
        setTimeout(function () {
          isProcessingClick = false;
        }, 50);

        // Prevent default to avoid double-toggle
        e.preventDefault();
      });
    }

    /**
     * Setup event listener for custom input text
     */
  }, {
    key: "setupCustomInputListener",
    value: function setupCustomInputListener() {
      var _this9 = this;
      if (!this.customIssueInput) return;
      var customInput = this.customIssueInput.querySelector('input');
      if (!customInput) return;

      // Save custom input text on input change
      customInput.addEventListener('input', function () {
        _this9.saveCheckboxState();
      });

      // Also save on blur to ensure data is persisted
      customInput.addEventListener('blur', function () {
        _this9.saveCheckboxState();
      });
    }

    /**
     * Reset component to initial state
     */
  }, {
    key: "reset",
    value: function reset() {
      // Reset tracking flags
      this.hasTrackedInitial = false;
      this.wasVisibleBefore = false;

      // Re-query DOM elements to ensure fresh references
      this.inputs = this.querySelectorAll('.custom-input-checkbox__input');

      // Uncheck all checkboxes
      if (this.inputs) {
        this.inputs.forEach(function (input) {
          input.checked = false;
        });
      }

      // Clear custom input text and hide it
      if (this.customIssueInput) {
        var customInput = this.customIssueInput.querySelector('input');
        if (customInput) {
          customInput.value = '';
        }
        this.customIssueInput.classList.add('tw-hidden');
      }

      // Update visual states
      this.updateCheckboxStates();

      // Clear checkbox state and custom text from localStorage
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      if (quizData.checkboxStates && this.entry) {
        delete quizData.checkboxStates[this.entry];
      }
      if (quizData.customIssueText && this.entry) {
        delete quizData.customIssueText[this.entry];
      }
      localStorage.setItem('quiz', JSON.stringify(quizData));
      console.log('CustomInputCheckbox reset:', this.entry);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      // Event delegation listeners are automatically removed when component is disconnected
      // No manual cleanup needed
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomInputCheckbox);

/***/ }),

/***/ "./src/assets/js/quiz-components-v2/custom-input-radio.js":
/*!****************************************************************!*\
  !*** ./src/assets/js/quiz-components-v2/custom-input-radio.js ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var CustomInputRadio = /*#__PURE__*/function (_HTMLElement) {
  function CustomInputRadio() {
    var _this;
    _classCallCheck(this, CustomInputRadio);
    _this = _callSuper(this, CustomInputRadio);
    _this.quizContainer = _this.closest('quiz-container');
    _this.entry = _this.dataset.entry;
    _this.inputs = _this.querySelectorAll('input[type="radio"]');
    _this.radioLabels = _this.querySelectorAll('.custom-label-radio__with-img');
    _this.radioBlocks = _this.querySelectorAll('.custom-block-radio__with-img');
    _this.nothingFoundText = _this.dataset.nonameText;
    _this.titleContainer = _this.querySelector('.title-label');
    _this.nextButton = document.querySelector('.button--next');
    _this.style = _this.dataset.style;
    _this.hasTrackedInitial = false;
    _this.breedImages = null;
    _this.imageElements = _this.querySelectorAll('.custom-image-radio');
    _this.preselectedValue = _this.dataset.preselected || '';
    return _this;
  }

  /**
   * Update active class on parent blocks based on checked state
   */
  _inherits(CustomInputRadio, _HTMLElement);
  return _createClass(CustomInputRadio, [{
    key: "updateActiveStyles",
    value: function updateActiveStyles() {
      var hasActive = false;
      this.inputs.forEach(function (input) {
        var parentBlock = input.closest('.custom-block-radio__with-img') || input.closest('.custom-block-radio__gender') || input.closest('.custom-block-radio__with-bg') || input.closest('.custom-block-radio');
        if (parentBlock) {
          if (input.checked) {
            parentBlock.classList.add('active');
            hasActive = true;
          } else {
            parentBlock.classList.remove('active');
          }
        }
      });
      return hasActive;
    }

    // updateDogName() {
    //   const quizData = JSON.parse(localStorage.getItem('quiz')) || {};
    //   const dogName = quizData.dogName || quizData.name;
    //   const nameSpan = this.querySelector('.dog-name');

    //   // If there's a .dog-name placeholder
    //   if (nameSpan) {
    //     if (dogName && dogName.trim() !== '') {
    //       // Update with actual dog name
    //       nameSpan.textContent = dogName;
    //     } else if (this.titleContainer && this.nothingFoundText) {
    //       // Show "Nothing found" only if name placeholder exists but no name available
    //       this.titleContainer.innerHTML = this.nothingFoundText;
    //     }
    //   }
    //   // If no .dog-name placeholder exists, do nothing (title doesn't need dog name)
    // }
  }, {
    key: "checkRadioSelection",
    value: function checkRadioSelection() {
      var currentSlide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var isSelected = Array.from(this.inputs).some(function (input) {
        return input.checked;
      });
      var hasActiveClass = this.querySelector('.custom-block-radio__with-img.active, .custom-block-radio__gender.active, .custom-block-radio__with-bg.active, .custom-block-radio.active') !== null;
      if (isSelected || hasActiveClass) {
        this.enableNextButton(currentSlide);
      } else {
        this.disableNextButton(currentSlide);
      }
    }
  }, {
    key: "saveRadioState",
    value: function saveRadioState() {
      var selectedInput = Array.from(this.inputs).find(function (input) {
        return input.checked;
      });
      var selected = selectedInput === null || selectedInput === void 0 ? void 0 : selectedInput.value;
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      if (!quizData.radioStates) {
        quizData.radioStates = {};
      }

      // Check if value changed
      var oldValue = quizData.radioStates[this.entry];
      var valueChanged = oldValue !== selected;
      quizData.radioStates[this.entry] = selected;
      localStorage.setItem('quiz', JSON.stringify(quizData));

      // Reset tracking flag if value changed (allow re-tracking)
      if (valueChanged) {
        this.hasTrackedInitial = false;
      }

      // Dispatch tracking event
      if (selected && this.isVisible()) {
        var _selectedInput$datase, _selectedInput$nextEl;
        var valueLabel = (selectedInput === null || selectedInput === void 0 || (_selectedInput$datase = selectedInput.dataset) === null || _selectedInput$datase === void 0 ? void 0 : _selectedInput$datase.label) || (selectedInput === null || selectedInput === void 0 || (_selectedInput$nextEl = selectedInput.nextElementSibling) === null || _selectedInput$nextEl === void 0 || (_selectedInput$nextEl = _selectedInput$nextEl.textContent) === null || _selectedInput$nextEl === void 0 ? void 0 : _selectedInput$nextEl.trim()) || selected;
        document.dispatchEvent(new CustomEvent('quiz:input-changed', {
          detail: {
            type: 'radio',
            fieldKey: this.entry,
            value: selected,
            valueLabel: valueLabel,
            slideIndex: this.getCurrentSlideIndex()
          }
        }));
      }
    }
  }, {
    key: "restoreRadioSelection",
    value: function restoreRadioSelection() {
      this.restoreRadioState();
    }
  }, {
    key: "restoreRadioState",
    value: function restoreRadioState() {
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      var restored = false;

      // Check if there's already a checked input from HTML (e.g., preselected_variant)
      var isAnyChecked = Array.from(this.inputs).some(function (input) {
        return input.checked;
      });
      if (quizData && quizData.radioStates && quizData.radioStates[this.entry]) {
        var selectedValue = quizData.radioStates[this.entry];
        var toCheck = Array.from(this.inputs).find(function (input) {
          return input.value === selectedValue;
        });
        if (toCheck) {
          toCheck.checked = true;
          restored = true;
        }
      }

      // If no saved state or saved input not found, and no preselected input, select first radio by default
      if (!restored && !isAnyChecked && this.inputs.length > 0) {
        this.inputs[0].checked = true;
      }
    }
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this2 = this;
      this.inputs.forEach(function (input) {
        input.addEventListener('input', function () {
          _this2.saveRadioState();
          _this2.checkRadioSelection();
          _this2.updateActiveStyles();
        });
      });
      var allLabels = this.querySelectorAll('.custom-label-radio__with-img, .custom-label-radio__gender, .custom-label-radio__with-bg, .custom-label-radio');
      allLabels.forEach(function (label) {
        label.addEventListener('click', function () {
          var radioInput = label.previousElementSibling;
          if (radioInput && radioInput.type === 'radio') {
            radioInput.checked = true;
            _this2.saveRadioState();
            _this2.checkRadioSelection();
            _this2.updateActiveStyles();
          }
        });
      });
    }
  }, {
    key: "disableNextButton",
    value: function disableNextButton() {
      var currentSlide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      // Check if this component is on the current slide
      // Use currentSlide if provided (more reliable than CSS class during transitions)
      var isOnCurrentSlide = currentSlide ? currentSlide.contains(this) : this.isVisible();

      // Only affect button if this component is on the current visible slide
      if (!isOnCurrentSlide) {
        console.log('custom-input-radio: Not on current slide, skipping button disable');
        return;
      }
      if (this.nextButton) {
        this.nextButton.classList.add('button--disabled');
        this.nextButton.disabled = true;
        console.log('custom-input-radio: Disabled Next button');
      }
    }
  }, {
    key: "enableNextButton",
    value: function enableNextButton() {
      var currentSlide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      // Check if this component is on the current slide
      // Use currentSlide if provided (more reliable than CSS class during transitions)
      var isOnCurrentSlide = currentSlide ? currentSlide.contains(this) : this.isVisible();

      // Only affect button if this component is on the current visible slide
      if (!isOnCurrentSlide) {
        console.log('custom-input-radio: Not on current slide, skipping button enable');
        return;
      }
      if (this.nextButton) {
        this.nextButton.classList.remove('button--disabled');
        this.nextButton.disabled = false;
        console.log('custom-input-radio: Enabled Next button');
      }
    }

    /**
     * Reset component to initial state
     */
  }, {
    key: "reset",
    value: function reset() {
      var _this3 = this;
      // Re-query DOM elements to ensure fresh references
      this.inputs = this.querySelectorAll('input[type="radio"]');
      this.radioBlocks = this.querySelectorAll('.custom-block-radio__with-img');
      this.radioLabels = this.querySelectorAll('.custom-label-radio__with-img');

      // Reset tracking flag
      this.hasTrackedInitial = false;

      // Uncheck all radios and remove active classes
      if (this.inputs && this.inputs.length) {
        this.inputs.forEach(function (input) {
          input.checked = false;
        });
      }
      if (this.radioBlocks && this.radioBlocks.length) {
        this.radioBlocks.forEach(function (block) {
          block.classList.remove('active');
        });
      }

      // Determine which radio to check: preselected value or first one
      var radioToCheck = null;
      if (this.preselectedValue && this.preselectedValue.trim() !== '') {
        // Try to find input matching preselected value
        radioToCheck = Array.from(this.inputs).find(function (input) {
          return input.value === _this3.preselectedValue;
        });
      }

      // If no preselected or not found, use first radio
      if (!radioToCheck && this.inputs.length > 0) {
        radioToCheck = this.inputs[0];
      }

      // Check the selected radio and add active class
      if (radioToCheck) {
        radioToCheck.checked = true;
        var parentBlock = radioToCheck.closest('.custom-block-radio__with-img');
        if (parentBlock) {
          parentBlock.classList.add('active');
        }

        // Save the reset state to localStorage
        this.saveRadioState();
      }

      // Update button state
      this.checkRadioSelection();

      // Update all active styles to ensure consistency
      this.updateActiveStyles();
      console.log('CustomInputRadio reset:', this.entry);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this4 = this;
      this.restoreRadioState();
      this.setEventListeners();
      // this.updateDogName();
      this.checkRadioSelection();
      this.saveRadioState();
      this.updateActiveStyles();

      // Listen for slide changes
      document.addEventListener('sliderChange', function (event) {
        var _event$detail;
        var currentSlideIndex = (_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : _event$detail.activeIndex;
        var mySlideIndex = _this4.getCurrentSlideIndex();

        // Track initial selection when this slide becomes active
        // Only track once - flag is reset only on restart or value change
        if (currentSlideIndex === mySlideIndex && !_this4.hasTrackedInitial) {
          _this4.trackInitialSelection();
        }
      });

      // Load breed images and listen for breed changes
      this.loadBreedImages();
      this.listenToBreedChanges();
    }

    /**
     * Load breed images from JSON script tag
     */
  }, {
    key: "loadBreedImages",
    value: function loadBreedImages() {
      try {
        // Search for script tag inside this component
        var scriptTag = this.querySelector('script[type="application/json"]');
        if (scriptTag) {
          var parsedData = JSON.parse(scriptTag.textContent);

          // Ensure it's an array
          if (Array.isArray(parsedData)) {
            this.breedImages = parsedData;
            console.log('Breed images loaded:', this.breedImages.length, 'images');
          } else {
            console.error('Breed images data is not an array:', parsedData);
            this.breedImages = [];
          }
        } else {
          console.warn('No breed images script tag found in component');
          this.breedImages = [];
        }
      } catch (error) {
        console.error('Error loading breed images:', error);
        this.breedImages = [];
      }
    }

    /**
     * Listen to breed selection changes from localStorage
     */
  }, {
    key: "listenToBreedChanges",
    value: function listenToBreedChanges() {
      var _this5 = this;
      // Initial check
      this.checkAndUpdateImages();

      // Listen for storage changes
      window.addEventListener('storage', function () {
        _this5.checkAndUpdateImages();
      });

      // Listen for custom quiz events
      document.addEventListener('quiz:input-changed', function (event) {
        if (event.detail.type === 'dropdown' && event.detail.fieldKey === 'entry.62437307') {
          setTimeout(function () {
            _this5.checkAndUpdateImages();
          }, 100);
        }
      });

      // Poll for changes (fallback)
      setInterval(function () {
        _this5.checkAndUpdateImages();
      }, 1000);
    }

    /**
     * Check localStorage and update images if breed changed
     */
  }, {
    key: "checkAndUpdateImages",
    value: function checkAndUpdateImages() {
      var _quizData$dropdownSta;
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      var breedDataString = (_quizData$dropdownSta = quizData.dropdownStates) === null || _quizData$dropdownSta === void 0 ? void 0 : _quizData$dropdownSta['entry.62437307'];
      if (!breedDataString) return;
      var breedData = this.parseBreedData(breedDataString);
      if (breedData.breedType === 'not_sure') {
        // Use default images (retrievers)
        this.updateImagesForBreedGroup('retrievers');
      } else if (breedData.breeds.length > 0) {
        // Use first breed to determine group
        var primaryBreed = breedData.breeds[0];
        var groupKey = this.findGroupByBreedName(primaryBreed);
        this.updateImagesForBreedGroup(groupKey);
      }
    }

    /**
     * Parse breed data from localStorage string
     */
  }, {
    key: "parseBreedData",
    value: function parseBreedData(breedDataString) {
      if (!breedDataString) {
        return {
          breedType: 'unknown',
          breeds: []
        };
      }
      if (breedDataString === 'not_sure') {
        return {
          breedType: 'not_sure',
          breeds: []
        };
      }
      var parts = breedDataString.split(';').map(function (s) {
        return s.trim();
      });
      var result = {
        breedType: 'unknown',
        breeds: []
      };
      parts.forEach(function (part) {
        var _part$split = part.split(':'),
          _part$split2 = _toArray(_part$split),
          key = _part$split2[0],
          valueParts = _part$split2.slice(1);
        var value = valueParts.join(':').trim();
        if (key.trim() === 'breedTypeStates') {
          result.breedType = value;
        } else if (key.trim() === 'value') {
          result.breeds.push(value);
        } else if (key.trim() === 'value_1') {
          result.breeds.push(value);
        } else if (key.trim() === 'value_2') {
          result.breeds.push(value);
        }
      });
      return result;
    }

    /**
     * Find breed group by breed name (similar to custom-product-output.js)
     */
  }, {
    key: "findGroupByBreedName",
    value: function findGroupByBreedName(breedName) {
      if (!breedName) return 'retrievers';
      var lower = breedName.toLowerCase();
      var list = window.breedSearchDatabreed_1 || [];

      // Search by URL in breed data
      var _iterator = _createForOfIteratorHelper(list),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var entry = _step.value;
          if (entry.breedList.some(function (b) {
            return b.toLowerCase() === lower;
          })) {
            var url = (entry.breedUrl || '').toLowerCase();
            if (url.includes('bulldogs') || url.includes('bully')) return 'bully';
            if (url.includes('ravishing-retrievers')) return 'retrievers';
            if (url.includes('shine-bright-shepherds')) return 'shepherds';
            if (url.includes('collections/minis') || url.includes('marvelous-minis')) return 'mini';
            if (url.includes('happy-herders')) return 'herders';
            if (url.includes('hearty-hunters')) return 'kleine_jagdhunde';
            if (url.includes('big-buddies')) return 'molosser';
            if (url.includes('heroic-hunters')) return 'grosse_jagdhunde';
          }
        }

        // Fallback: search by keywords in breed name
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (lower.includes('bulldog') || lower.includes('frenchie') || lower.includes('mops') || lower.includes('boston')) return 'bully';
      if (lower.includes('retriever') || lower.includes('labrador') || lower.includes('golden')) return 'retrievers';
      if (lower.includes('schäfer') || lower.includes('shepherd') || lower.includes('malinois')) return 'shepherds';
      if (lower.includes('chihuahua') || lower.includes('york') || lower.includes('malteser') || lower.includes('havaneser') || lower.includes('jack russell')) return 'mini';
      if (lower.includes('collie') || lower.includes('australian shepherd') || lower.includes('border')) return 'herders';
      if (lower.includes('mastiff') || lower.includes('cane corso') || lower.includes('rottweiler') || lower.includes('dogge')) return 'molosser';
      if (lower.includes('weimaraner') || lower.includes('vizsla') || lower.includes('pointer') || lower.includes('setter')) return 'grosse_jagdhunde';

      // Default to retrievers
      return 'retrievers';
    }

    /**
     * Update images for specific breed group
     */
  }, {
    key: "updateImagesForBreedGroup",
    value: function updateImagesForBreedGroup(groupKey) {
      if (!this.breedImages || !Array.isArray(this.breedImages) || this.breedImages.length === 0) {
        // console.warn('Breed images not loaded or empty');
        return;
      }

      // Filter images by group name
      var groupImages = this.breedImages.filter(function (img) {
        return img.name === groupKey;
      });

      // If no images for this group, use retrievers as default
      var imagesToUse = groupImages.length > 0 ? groupImages : this.breedImages.filter(function (img) {
        return img.name === 'retrievers';
      });
      if (imagesToUse.length === 0) {
        console.warn("No images found for group ".concat(groupKey, " or retrievers"));
        return;
      }

      // Update each image element
      this.imageElements.forEach(function (imgElement, index) {
        // Use modulo to cycle through available images
        var imageData = imagesToUse[index % imagesToUse.length];
        if (imageData && imageData.src) {
          imgElement.src = imageData.src;
        }
      });
    }

    /**
     * Get current slide index from parent quiz container
     */
  }, {
    key: "getCurrentSlideIndex",
    value: function getCurrentSlideIndex() {
      var quizContainer = this.closest('quiz-container');
      if (quizContainer && quizContainer.activeSlider) {
        return quizContainer.activeSlider.activeIndex;
      }
      return 0;
    }

    /**
     * Get the expected slide index for this component
     * (index of the swiper-slide that contains this component)
     */
  }, {
    key: "getExpectedSlideIndex",
    value: function getExpectedSlideIndex() {
      var swiperSlide = this.closest('.swiper-slide');
      if (!swiperSlide) return null;

      // Get the main quiz container's swiper wrapper (not nested swipers like protein)
      var quizContainer = this.closest('quiz-container');
      if (!quizContainer) return null;
      var mainSwiperWrapper = quizContainer.querySelector('.swiper > .swiper-wrapper');
      if (!mainSwiperWrapper) return null;

      // Only count direct children slides of main swiper (excludes nested swiper slides)
      var allSlides = Array.from(mainSwiperWrapper.children).filter(function (el) {
        return el.classList.contains('swiper-slide');
      });
      return allSlides.indexOf(swiperSlide);
    }

    /**
     * Validate that slideIndex matches component position
     */
  }, {
    key: "validateSlideIndex",
    value: function validateSlideIndex(slideIndex) {
      var expectedIndex = this.getExpectedSlideIndex();
      if (expectedIndex === null) return true; // Cannot validate

      if (slideIndex !== expectedIndex) {
        console.warn("[CustomInputRadio] slideIndex mismatch for \"".concat(this.entry, "\":"), "\n  Current slideIndex: ".concat(slideIndex), "\n  Expected slideIndex: ".concat(expectedIndex), "\n  Component:", this);
        return false;
      }
      return true;
    }

    /**
     * Track initial/default selection when component becomes visible
     * Only fires once per component lifecycle to avoid duplicate tracking
     * Flag is reset only on restart or value change
     */
  }, {
    key: "trackInitialSelection",
    value: function trackInitialSelection() {
      if (!this.isVisible()) return;

      // Only track once - flag persists across slide navigation
      if (this.hasTrackedInitial) return;
      var selectedInput = Array.from(this.inputs).find(function (input) {
        return input.checked;
      });
      if (selectedInput) {
        var _selectedInput$datase2, _selectedInput$nextEl2;
        var selected = selectedInput.value;
        var valueLabel = (selectedInput === null || selectedInput === void 0 || (_selectedInput$datase2 = selectedInput.dataset) === null || _selectedInput$datase2 === void 0 ? void 0 : _selectedInput$datase2.label) || (selectedInput === null || selectedInput === void 0 || (_selectedInput$nextEl2 = selectedInput.nextElementSibling) === null || _selectedInput$nextEl2 === void 0 || (_selectedInput$nextEl2 = _selectedInput$nextEl2.textContent) === null || _selectedInput$nextEl2 === void 0 ? void 0 : _selectedInput$nextEl2.trim()) || selected;
        var slideIndex = this.getCurrentSlideIndex();

        // Validate slideIndex
        this.validateSlideIndex(slideIndex);
        document.dispatchEvent(new CustomEvent('quiz:input-changed', {
          detail: {
            type: 'radio',
            fieldKey: this.entry,
            value: selected,
            valueLabel: valueLabel,
            slideIndex: slideIndex
          }
        }));
        this.hasTrackedInitial = true;
      }
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      // Check if component is in the active swiper slide
      var swiperSlide = this.closest('.swiper-slide');
      if (swiperSlide && !swiperSlide.classList.contains('swiper-slide-active')) {
        return false;
      }
      return this.offsetParent !== null && window.getComputedStyle(this).display !== 'none';
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomInputRadio);

/***/ }),

/***/ "./src/assets/js/quiz-components-v2/custom-input-range-image-v2.js":
/*!*************************************************************************!*\
  !*** ./src/assets/js/quiz-components-v2/custom-input-range-image-v2.js ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
/**
 * Custom Input Range Image V2 Component
 * Body Type Slider with 6 snap positions
 *
 * Features:
 * - Free-drag slider with snap-on-release to 6 positions
 * - Maps 6 positions to 3 output values (1-2→1, 3-4→2, 5-6→3)
 * - Visual highlight of selected position
 * - Enables/disables Next CTA based on selection
 */
var CustomInputRangeImageV2 = /*#__PURE__*/function (_HTMLElement) {
  function CustomInputRangeImageV2() {
    var _this;
    _classCallCheck(this, CustomInputRangeImageV2);
    _this = _callSuper(this, CustomInputRangeImageV2);

    // State
    _this.isDragging = false;
    _this.currentPosition = null; // 1-6
    _this.currentPercentage = 50; // 0-100
    _this.livePosition = null; // Nearest snap while dragging
    _this.snapPositions = [{
      position: 1,
      percentage: 10,
      mappedValue: 1
    }, {
      position: 2,
      percentage: 25,
      mappedValue: 1
    }, {
      position: 3,
      percentage: 50,
      mappedValue: 3
    }, {
      position: 4,
      percentage: 75,
      mappedValue: 5
    }, {
      position: 5,
      percentage: 90,
      mappedValue: 5
    }];

    // DOM elements
    _this.container = null;
    _this.handle = null;
    _this.divider = null;
    _this.rightImage = null;
    _this.leftImage = null;
    _this.handleLabel = null;
    _this.hiddenInput = null;
    _this.labels = [];
    _this.titleContainer = null;
    _this.nothingFoundText = null;

    // Breed images
    _this.breedImages = null;
    _this.currentBreedGroup = 'retrievers';

    // Bounds
    _this.containerRect = null;

    // Tracking
    _this.hasTrackedInitial = false;

    // Bind methods
    _this.handlePointerDown = _this.handlePointerDown.bind(_this);
    _this.handlePointerMove = _this.handlePointerMove.bind(_this);
    _this.handlePointerUp = _this.handlePointerUp.bind(_this);
    _this.handleLabelClick = _this.handleLabelClick.bind(_this);
    _this.handleResize = _this.handleResize.bind(_this);
    return _this;
  }
  _inherits(CustomInputRangeImageV2, _HTMLElement);
  return _createClass(CustomInputRangeImageV2, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      setTimeout(function () {
        return _this2.init();
      }, 10);

      // Enable next button immediately
      this.enableNextButton();

      // Listen for slide changes
      document.addEventListener('sliderChange', function (event) {
        var _event$detail;
        var currentSlideIndex = (_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : _event$detail.activeIndex;
        var mySlideIndex = _this2.getCurrentSlideIndex();

        // Track initial selection when this slide becomes active
        // Only track once - flag is reset only on restart or value change
        if (currentSlideIndex === mySlideIndex && !_this2.hasTrackedInitial) {
          _this2.trackInitialSelection();
        }
      });

      // Listen for restart event
      document.addEventListener('quiz:restart', function () {
        _this2.reset();
      });
    }

    /**
     * Get current slide index from parent quiz container
     */
  }, {
    key: "getCurrentSlideIndex",
    value: function getCurrentSlideIndex() {
      var quizContainer = this.closest('quiz-container');
      if (quizContainer && quizContainer.activeSlider) {
        return quizContainer.activeSlider.activeIndex;
      }
      return 0;
    }

    /**
     * Get the expected slide index for this component
     * (index of the swiper-slide that contains this component)
     */
  }, {
    key: "getExpectedSlideIndex",
    value: function getExpectedSlideIndex() {
      var swiperSlide = this.closest('.swiper-slide');
      if (!swiperSlide) return null;

      // Get the main quiz container's swiper wrapper (not nested swipers like protein)
      var quizContainer = this.closest('quiz-container');
      if (!quizContainer) return null;
      var mainSwiperWrapper = quizContainer.querySelector('.swiper > .swiper-wrapper');
      if (!mainSwiperWrapper) return null;

      // Only count direct children slides of main swiper (excludes nested swiper slides)
      var allSlides = Array.from(mainSwiperWrapper.children).filter(function (el) {
        return el.classList.contains('swiper-slide');
      });
      return allSlides.indexOf(swiperSlide);
    }

    /**
     * Validate that slideIndex matches component position
     */
  }, {
    key: "validateSlideIndex",
    value: function validateSlideIndex(slideIndex) {
      var expectedIndex = this.getExpectedSlideIndex();
      if (expectedIndex === null) return true; // Cannot validate

      if (slideIndex !== expectedIndex) {
        console.warn("[CustomInputRangeImageV2] slideIndex mismatch for \"".concat(this.entry, "\":"), "\n  Current slideIndex: ".concat(slideIndex), "\n  Expected slideIndex: ".concat(expectedIndex), "\n  Component:", this);
        return false;
      }
      return true;
    }

    /**
     * Track initial/default selection when component becomes visible
     * Only fires once per component lifecycle to avoid duplicate tracking
     * Flag is reset only on restart or value change
     */
  }, {
    key: "trackInitialSelection",
    value: function trackInitialSelection() {
      var _this$dataset$labels;
      if (!this.isVisible()) return;

      // Only track once - flag persists across slide navigation
      if (this.hasTrackedInitial) return;
      if (!this.currentPosition) return;
      var labels = ((_this$dataset$labels = this.dataset.labels) === null || _this$dataset$labels === void 0 ? void 0 : _this$dataset$labels.split(',').map(function (s) {
        return s.trim();
      })) || [];
      var labelMap = labels.reduce(function (acc, item, index) {
        acc[index + 1] = item;
        return acc;
      }, {});
      var value = labelMap[this.currentPosition];
      if (!value) return;
      var slideIndex = this.getCurrentSlideIndex();

      // Validate slideIndex
      this.validateSlideIndex(slideIndex);
      document.dispatchEvent(new CustomEvent('quiz:input-changed', {
        detail: {
          type: 'body_condition',
          fieldKey: this.entry,
          value: this.currentPosition,
          valueLabel: value,
          source: 'default_value',
          slideIndex: slideIndex
        }
      }));
      this.hasTrackedInitial = true;
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      // Check if component is in the active swiper slide
      var swiperSlide = this.closest('.swiper-slide');
      if (swiperSlide && !swiperSlide.classList.contains('swiper-slide-active')) {
        return false;
      }
      return this.offsetParent !== null && window.getComputedStyle(this).display !== 'none';
    }

    /**
     * Update dog name in title or show fallback text
     */
  }, {
    key: "updateDogName",
    value: function updateDogName() {
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      var dogName = quizData.dogName || quizData.name;
      var nameSpan = this.querySelector('.dog-name');

      // If there's a .dog-name placeholder
      if (nameSpan) {
        if (dogName && dogName.trim() !== '') {
          // Update with actual dog name
          nameSpan.textContent = dogName;
        } else if (this.titleContainer && this.nothingFoundText) {
          // Show "Nothing found" only if name placeholder exists but no name available
          this.titleContainer.innerHTML = this.nothingFoundText;
        }
      }
      // If no .dog-name placeholder exists, do nothing (title doesn't need dog name)
    }
  }, {
    key: "enableNextButton",
    value: function enableNextButton() {
      // Only enable if visible on current slide
      if (!this.isVisible()) {
        return;
      }
      var nextButton = document.querySelector('.button--next');
      if (nextButton) {
        nextButton.classList.remove('button--disabled');
        nextButton.disabled = false;
      }
    }
  }, {
    key: "init",
    value: function init() {
      var _this$titleContainer;
      // Get DOM elements
      this.container = this.querySelector('[data-draggable]');
      this.handle = this.querySelector('[data-handle]');
      this.divider = this.querySelector('[data-divider]');
      this.rightImage = this.querySelector('[data-right-image]');
      this.leftImage = this.querySelector('.range-image-v2-comparison__image--left');
      this.handleLabel = this.querySelector('[data-handle-label]');
      this.hiddenInput = this.querySelector('[data-input]');
      this.labels = Array.from(this.querySelectorAll('[data-label]'));
      this.titleContainer = this.querySelector('.text-label');
      this.nothingFoundText = ((_this$titleContainer = this.titleContainer) === null || _this$titleContainer === void 0 ? void 0 : _this$titleContainer.dataset.nonameText) || '';
      if (!this.container || !this.handle) {
        console.error('CustomInputRangeImageV2: Required elements not found');
        return;
      }

      // Get entry name
      this.entry = this.dataset.entry;

      // Get quiz container to enable/disable Next button
      this.quizContainer = document.querySelector('quiz-container');

      // Load breed images and listen for breed changes
      this.loadBreedImages();
      this.listenToBreedChanges();

      // Initialize
      this.updateBounds();
      this.setInitialPosition();
      this.attachEventListeners();

      // Restore saved value if exists
      this.restoreSavedValue();

      // Update dog name on init
      // this.updateDogName();
    }
  }, {
    key: "attachEventListeners",
    value: function attachEventListeners() {
      var _this3 = this;
      // Pointer events for dragging
      this.container.addEventListener('pointerdown', this.handlePointerDown);

      // Label clicks
      this.labels.forEach(function (label) {
        label.addEventListener('click', _this3.handleLabelClick);
      });

      // Window resize
      window.addEventListener('resize', this.handleResize);
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      var _this$container,
        _this4 = this;
      (_this$container = this.container) === null || _this$container === void 0 || _this$container.removeEventListener('pointerdown', this.handlePointerDown);
      document.removeEventListener('pointermove', this.handlePointerMove);
      document.removeEventListener('pointerup', this.handlePointerUp);
      this.labels.forEach(function (label) {
        label.removeEventListener('click', _this4.handleLabelClick);
      });
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: "handlePointerDown",
    value: function handlePointerDown(e) {
      e.preventDefault();
      this.isDragging = true;
      this.updateBounds();

      // Change cursor
      this.container.style.cursor = 'grabbing';

      // Add document listeners
      document.addEventListener('pointermove', this.handlePointerMove);
      document.addEventListener('pointerup', this.handlePointerUp);

      // Initial update
      this.updatePositionFromEvent(e);
    }
  }, {
    key: "handlePointerMove",
    value: function handlePointerMove(e) {
      if (!this.isDragging) return;
      e.preventDefault();
      this.updatePositionFromEvent(e);
    }
  }, {
    key: "handlePointerUp",
    value: function handlePointerUp(e) {
      if (!this.isDragging) return;
      e.preventDefault();
      this.isDragging = false;
      this.container.style.cursor = 'grab';

      // Remove document listeners
      document.removeEventListener('pointermove', this.handlePointerMove);
      document.removeEventListener('pointerup', this.handlePointerUp);

      // Snap to nearest position
      this.snapToNearestPosition();
    }
  }, {
    key: "updatePositionFromEvent",
    value: function updatePositionFromEvent(e) {
      if (!this.containerRect) return;

      // Get X position relative to container
      var x = e.clientX - this.containerRect.left;

      // Calculate percentage (clamped 0-100)
      var percentage = x / this.containerRect.width * 100;
      percentage = Math.max(0, Math.min(100, percentage));
      this.currentPercentage = percentage;
      this.updateVisualPosition(percentage, false);
      this.updateLiveSelection(percentage);
    }
  }, {
    key: "snapToNearestPosition",
    value: function snapToNearestPosition() {
      var nearest = this.getNearestSnap(this.currentPercentage);
      if (!nearest) return;

      // Check if position changed
      var oldPosition = this.currentPosition;

      // Snap to it
      this.currentPosition = nearest.position;
      this.currentPercentage = nearest.percentage;

      // Reset tracking flag if position changed (allow re-tracking)
      if (oldPosition !== this.currentPosition) {
        this.hasTrackedInitial = false;
      }

      // Update visuals with animation
      this.updateVisualPosition(nearest.percentage, true);

      // Update hidden input with MAPPED value (not position)
      this.hiddenInput.value = nearest.mappedValue;

      // Update label highlighting
      this.updateLabelHighlight(nearest.position);

      // Update handle label
      this.updateHandleLabel(nearest.position);

      // Store value (user interaction)
      this.saveValue(true);

      // Dispatch event to enable Next CTA
      this.dispatchSelectionEvent();
      console.log("Snapped to position ".concat(nearest.position, ", mapped value: ").concat(nearest.mappedValue));
    }
  }, {
    key: "updateLiveSelection",
    value: function updateLiveSelection(percentage) {
      var nearest = this.getNearestSnap(percentage);
      if (!nearest) return;

      // Skip if position didn't change to avoid redundant DOM ops
      if (this.livePosition === nearest.position) return;
      this.livePosition = nearest.position;

      // Update handle/labels instantly while dragging
      this.currentPosition = nearest.position;
      if (this.hiddenInput) {
        this.hiddenInput.value = nearest.mappedValue;
      }
      this.updateLabelHighlight(nearest.position);
      this.updateHandleLabel(nearest.position);
    }
  }, {
    key: "getNearestSnap",
    value: function getNearestSnap(percentage) {
      if (!this.snapPositions || this.snapPositions.length === 0) return null;
      return this.snapPositions.reduce(function (prev, curr) {
        var prevDiff = Math.abs(prev.percentage - percentage);
        var currDiff = Math.abs(curr.percentage - percentage);
        return currDiff < prevDiff ? curr : prev;
      });
    }
  }, {
    key: "updateVisualPosition",
    value: function updateVisualPosition(percentage) {
      var _this5 = this;
      var animate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!this.handle || !this.divider || !this.rightImage) return;

      // Add/remove transition class
      if (animate) {
        this.handle.style.transition = 'left 0.3s ease';
        this.divider.style.transition = 'left 0.3s ease';
        this.rightImage.style.transition = 'clip-path 0.3s ease';
      } else {
        this.handle.style.transition = 'none';
        this.divider.style.transition = 'none';
        this.rightImage.style.transition = 'none';
      }

      // Update positions
      this.handle.style.left = "".concat(percentage, "%");
      this.divider.style.left = "".concat(percentage, "%");
      this.rightImage.style.clipPath = "inset(0 0 0 ".concat(percentage, "%)");

      // Remove transition after animation completes
      if (animate) {
        setTimeout(function () {
          _this5.handle.style.transition = '';
          _this5.divider.style.transition = '';
          _this5.rightImage.style.transition = '';
        }, 300);
      }
    }
  }, {
    key: "updateLabelHighlight",
    value: function updateLabelHighlight(position) {
      this.labels.forEach(function (label) {
        var _label$dataset$positi;
        var positions = ((_label$dataset$positi = label.dataset.positions) === null || _label$dataset$positi === void 0 ? void 0 : _label$dataset$positi.split(',').map(Number)) || [];
        var isActive = positions.includes(position);
        if (isActive) {
          label.classList.add('is-active');
        } else {
          label.classList.remove('is-active');
        }
      });
    }
  }, {
    key: "updateHandleLabel",
    value: function updateHandleLabel(position) {
      if (!this.handleLabel) return;
      if (!this.dataset.labels) return;
      var labels = this.dataset.labels.split(',');
      var labelMap = labels.reduce(function (acc, item, index) {
        acc[index + 1] = item.trim();
        return acc;
      }, {});
      this.handleLabel.textContent = labelMap[position] || 'Schieben';
    }
  }, {
    key: "handleLabelClick",
    value: function handleLabelClick(e) {
      var _label$dataset$positi2;
      var label = e.currentTarget;
      var positions = ((_label$dataset$positi2 = label.dataset.positions) === null || _label$dataset$positi2 === void 0 ? void 0 : _label$dataset$positi2.split(',').map(Number)) || [];
      if (positions.length === 0) return;

      // For right label, select the last position (5); for others, select the first
      var labelType = label.dataset.label;
      var targetPosition = labelType === 'right' ? positions[positions.length - 1] // Last position for right label (position 5)
      : positions[0]; // First position for left/center labels

      var snapData = this.snapPositions.find(function (s) {
        return s.position === targetPosition;
      });
      if (snapData) {
        this.currentPosition = snapData.position;
        this.currentPercentage = snapData.percentage;

        // Update visual position with animation
        this.updateVisualPosition(snapData.percentage, true);

        // Update hidden input with mapped value
        this.hiddenInput.value = snapData.mappedValue;

        // Update label highlighting
        this.updateLabelHighlight(snapData.position);

        // Update handle label text
        this.updateHandleLabel(snapData.position);

        // Save to localStorage (user interaction)
        this.saveValue(true);

        // Dispatch selection event
        this.dispatchSelectionEvent();
        console.log("Label clicked (".concat(labelType, "): position ").concat(targetPosition, ", percentage ").concat(snapData.percentage, "%, mapped value: ").concat(snapData.mappedValue));
      }
    }
  }, {
    key: "handleResize",
    value: function handleResize() {
      this.updateBounds();
    }
  }, {
    key: "updateBounds",
    value: function updateBounds() {
      if (this.container) {
        this.containerRect = this.container.getBoundingClientRect();
      }
    }
  }, {
    key: "setInitialPosition",
    value: function setInitialPosition() {
      var _quizData$rangeValues;
      // Check if there's already a saved value - don't overwrite it
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      var hasSavedValue = (_quizData$rangeValues = quizData.rangeValues) === null || _quizData$rangeValues === void 0 || (_quizData$rangeValues = _quizData$rangeValues[this.entry]) === null || _quizData$rangeValues === void 0 ? void 0 : _quizData$rangeValues.position;
      if (hasSavedValue) {
        // Will be restored by restoreSavedValue()
        return;
      }

      // Start at 50% (position 3 - ideal)
      var defaultSnap = this.snapPositions.find(function (s) {
        return s.percentage === 50;
      });
      if (defaultSnap) {
        this.currentPosition = defaultSnap.position;
        this.currentPercentage = defaultSnap.percentage;

        // Update visual position
        this.updateVisualPosition(defaultSnap.percentage, false);

        // Update hidden input
        if (this.hiddenInput) {
          this.hiddenInput.value = defaultSnap.mappedValue;
        }

        // Update label highlight
        this.updateLabelHighlight(defaultSnap.position);

        // Update handle label
        this.updateHandleLabel(defaultSnap.position);

        // Save default value to localStorage (without tracking)
        this.saveValue(false);
      } else {
        // Fallback
        this.currentPercentage = 50;
        this.updateVisualPosition(50, false);
      }
    }
  }, {
    key: "restoreSavedValue",
    value: function restoreSavedValue() {
      var _quizData$rangeValues2;
      if (!this.entry) return;
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      var saved = (_quizData$rangeValues2 = quizData.rangeValues) === null || _quizData$rangeValues2 === void 0 ? void 0 : _quizData$rangeValues2[this.entry];
      if (!saved || !saved.position) return;
      var snapData = this.snapPositions.find(function (s) {
        return s.position === Number(saved.position);
      });
      if (!snapData) return;
      this.currentPosition = snapData.position;
      this.currentPercentage = snapData.percentage;
      this.updateVisualPosition(snapData.percentage, false);
      this.hiddenInput.value = snapData.mappedValue;
      this.updateLabelHighlight(snapData.position);
      this.updateHandleLabel(snapData.position);
      if (this.quizContainer) {
        this.quizContainer.enableNextBtn();
      }
      console.log("Restored: position ".concat(saved.position, ", value \"").concat(saved.value, "\""));
    }
  }, {
    key: "saveValue",
    value: function saveValue() {
      var _this$dataset$labels2;
      var isUserInteraction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!this.entry) return;
      var position = this.currentPosition;
      if (!position) return;

      // Строим динамический labelMap
      var labels = ((_this$dataset$labels2 = this.dataset.labels) === null || _this$dataset$labels2 === void 0 ? void 0 : _this$dataset$labels2.split(',').map(function (s) {
        return s.trim();
      })) || [];
      var labelMap = labels.reduce(function (acc, item, index) {
        acc[index + 1] = item;
        return acc;
      }, {});
      var value = labelMap[position];
      if (!value) return;
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      if (!quizData.rangeValues) {
        quizData.rangeValues = {};
      }
      quizData.rangeValues[this.entry] = {
        position: position,
        value: value
      };
      try {
        localStorage.setItem('quiz', JSON.stringify(quizData));
        console.log("Saved rangeValues[".concat(this.entry, "] ="), {
          position: position,
          value: value
        });

        // Dispatch tracking event only for user interactions (not initial/default values)
        if (this.isVisible() && isUserInteraction) {
          document.dispatchEvent(new CustomEvent('quiz:input-changed', {
            detail: {
              type: 'body_condition',
              fieldKey: this.entry,
              value: position,
              valueLabel: value,
              source: 'user_interaction',
              slideIndex: this.getCurrentSlideIndex()
            }
          }));
        }
      } catch (e) {
        console.error('Failed to save to localStorage:', e);
      }

      // Enable Next button
      if (this.quizContainer) {
        this.quizContainer.enableNextBtn();
      }
    }
  }, {
    key: "dispatchSelectionEvent",
    value: function dispatchSelectionEvent() {
      // Dispatch custom event for compatibility with other quiz components
      var event = new CustomEvent('quiz:input-change', {
        bubbles: true,
        detail: {
          entry: this.entry,
          value: this.hiddenInput.value,
          position: this.currentPosition,
          isValid: true
        }
      });
      this.dispatchEvent(event);
    }

    /**
     * Reset component to initial state
     */
  }, {
    key: "reset",
    value: function reset() {
      // Reset tracking flag
      this.hasTrackedInitial = false;

      // Reset to default position (50% - position 3 - ideal)
      var defaultSnap = this.snapPositions.find(function (s) {
        return s.percentage === 50;
      });
      if (defaultSnap) {
        this.currentPosition = defaultSnap.position;
        this.currentPercentage = defaultSnap.percentage;

        // Update visual position without animation
        this.updateVisualPosition(defaultSnap.percentage, false);

        // Update hidden input
        if (this.hiddenInput) {
          this.hiddenInput.value = defaultSnap.mappedValue;
        }

        // Update label highlight
        this.updateLabelHighlight(defaultSnap.position);

        // Update handle label
        this.updateHandleLabel(defaultSnap.position);

        // Save default value to localStorage (without tracking)
        this.saveValue(false);
      } else {
        // Fallback
        this.currentPosition = null;
        this.currentPercentage = 50;
        this.updateVisualPosition(50, false);
        if (this.hiddenInput) {
          this.hiddenInput.value = '';
        }
        this.labels.forEach(function (label) {
          label.classList.remove('is-active');
        });
        if (this.handleLabel) {
          this.handleLabel.textContent = 'Schieben';
        }
      }
      console.log('CustomInputRangeImageV2 reset');
    }

    /**
     * Load breed images from JSON script tag
     */
  }, {
    key: "loadBreedImages",
    value: function loadBreedImages() {
      try {
        var scriptTag = this.querySelector('script[type="application/json"]');
        if (scriptTag) {
          var parsedData = JSON.parse(scriptTag.textContent);
          if (Array.isArray(parsedData)) {
            this.breedImages = parsedData;
            console.log('Range slider breed images loaded:', this.breedImages.length, 'images');
          } else {
            console.error('Breed images data is not an array:', parsedData);
            this.breedImages = [];
          }
        } else {
          console.warn('No breed images script tag found in range slider component');
          this.breedImages = [];
        }
      } catch (error) {
        console.error('Error loading breed images:', error);
        this.breedImages = [];
      }
    }

    /**
     * Listen to breed selection changes from localStorage
     */
  }, {
    key: "listenToBreedChanges",
    value: function listenToBreedChanges() {
      var _this6 = this;
      // Initial check
      this.checkAndUpdateImages();

      // Listen for storage changes
      window.addEventListener('storage', function () {
        _this6.checkAndUpdateImages();
      });

      // Listen for custom quiz events
      document.addEventListener('quiz:input-changed', function (event) {
        if (event.detail.type === 'dropdown' && event.detail.fieldKey === 'entry.62437307') {
          setTimeout(function () {
            _this6.checkAndUpdateImages();
          }, 100);
        }
      });

      // Poll for changes (fallback)
      setInterval(function () {
        _this6.checkAndUpdateImages();
      }, 1000);
    }

    /**
     * Check localStorage and update images if breed changed
     */
  }, {
    key: "checkAndUpdateImages",
    value: function checkAndUpdateImages() {
      var _quizData$dropdownSta;
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      var breedDataString = (_quizData$dropdownSta = quizData.dropdownStates) === null || _quizData$dropdownSta === void 0 ? void 0 : _quizData$dropdownSta['entry.62437307'];
      if (!breedDataString) {
        // No breed selected, use default (retrievers)
        this.updateImagesForBreedGroup('retrievers');
        return;
      }
      var breedData = this.parseBreedData(breedDataString);
      if (breedData.breedType === 'not_sure') {
        // Use default images (retrievers)
        this.updateImagesForBreedGroup('retrievers');
      } else if (breedData.breeds.length > 0) {
        // Use first breed to determine group
        var primaryBreed = breedData.breeds[0];
        var groupKey = this.findGroupByBreedName(primaryBreed);
        this.updateImagesForBreedGroup(groupKey);
      }
    }

    /**
     * Parse breed data from localStorage string
     */
  }, {
    key: "parseBreedData",
    value: function parseBreedData(breedDataString) {
      if (!breedDataString) {
        return {
          breedType: 'unknown',
          breeds: []
        };
      }
      if (breedDataString === 'not_sure') {
        return {
          breedType: 'not_sure',
          breeds: []
        };
      }
      var parts = breedDataString.split(';').map(function (s) {
        return s.trim();
      });
      var result = {
        breedType: 'unknown',
        breeds: []
      };
      parts.forEach(function (part) {
        var _part$split = part.split(':'),
          _part$split2 = _toArray(_part$split),
          key = _part$split2[0],
          valueParts = _part$split2.slice(1);
        var value = valueParts.join(':').trim();
        if (key.trim() === 'breedTypeStates') {
          result.breedType = value;
        } else if (key.trim() === 'value') {
          result.breeds.push(value);
        } else if (key.trim() === 'value_1') {
          result.breeds.push(value);
        } else if (key.trim() === 'value_2') {
          result.breeds.push(value);
        }
      });
      return result;
    }

    /**
     * Find breed group by breed name (similar to custom-input-radio.js)
     */
  }, {
    key: "findGroupByBreedName",
    value: function findGroupByBreedName(breedName) {
      if (!breedName) return 'retrievers';
      var lower = breedName.toLowerCase();
      var list = window.breedSearchDatabreed_1 || [];

      // Search by URL in breed data
      var _iterator = _createForOfIteratorHelper(list),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var entry = _step.value;
          if (entry.breedList.some(function (b) {
            return b.toLowerCase() === lower;
          })) {
            var url = (entry.breedUrl || '').toLowerCase();
            if (url.includes('bulldogs') || url.includes('bully')) return 'bully';
            if (url.includes('ravishing-retrievers')) return 'retrievers';
            if (url.includes('shine-bright-shepherds')) return 'shepherds';
            if (url.includes('collections/minis') || url.includes('marvelous-minis')) return 'mini';
            if (url.includes('happy-herders')) return 'herders';
            if (url.includes('hearty-hunters')) return 'kleine_jagdhunde';
            if (url.includes('big-buddies')) return 'molosser';
            if (url.includes('heroic-hunters')) return 'grosse_jagdhunde';
          }
        }

        // Fallback: search by keywords in breed name
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (lower.includes('bulldog') || lower.includes('frenchie') || lower.includes('mops') || lower.includes('boston')) return 'bully';
      if (lower.includes('retriever') || lower.includes('labrador') || lower.includes('golden')) return 'retrievers';
      if (lower.includes('schäfer') || lower.includes('shepherd') || lower.includes('malinois')) return 'shepherds';
      if (lower.includes('chihuahua') || lower.includes('york') || lower.includes('malteser') || lower.includes('havaneser') || lower.includes('jack russell')) return 'mini';
      if (lower.includes('collie') || lower.includes('australian shepherd') || lower.includes('border')) return 'herders';
      if (lower.includes('mastiff') || lower.includes('cane corso') || lower.includes('rottweiler') || lower.includes('dogge')) return 'molosser';
      if (lower.includes('weimaraner') || lower.includes('vizsla') || lower.includes('pointer') || lower.includes('setter')) return 'grosse_jagdhunde';

      // Default to retrievers
      return 'retrievers';
    }

    /**
     * Update images for specific breed group
     */
  }, {
    key: "updateImagesForBreedGroup",
    value: function updateImagesForBreedGroup(groupKey) {
      if (!this.breedImages || !Array.isArray(this.breedImages) || this.breedImages.length === 0) {
        console.warn('Breed images not loaded or empty');
        return;
      }

      // Don't update if already showing this group
      if (this.currentBreedGroup === groupKey) {
        return;
      }

      // Normalize group key for matching with Liquid template names
      var normalizedGroupKey = groupKey;

      // Map JavaScript group names to Liquid template names
      var groupNameMap = {
        bully: 'bulldogs',
        kleine_jagdhunde: 'kleine-jagdhunde',
        grosse_jagdhunde: 'grosse-jagdhunde',
        retrievers: 'retrievers',
        shepherds: 'shepherds',
        mini: 'mini',
        herders: 'herders',
        molosser: 'molosser'
      };
      normalizedGroupKey = groupNameMap[groupKey] || groupKey;

      // Filter images by group name
      var groupImages = this.breedImages.filter(function (img) {
        return img.name === normalizedGroupKey;
      });

      // If no images for this group, use retrievers as default
      var imagesToUse = groupImages.length > 0 ? groupImages : this.breedImages.filter(function (img) {
        return img.name === 'retrievers';
      });
      if (imagesToUse.length < 2) {
        console.warn("Not enough images found for group ".concat(groupKey, " (need 2, found ").concat(imagesToUse.length, ")"));
        return;
      }
      console.log("Updating range slider images for breed group: ".concat(groupKey, " (normalized: ").concat(normalizedGroupKey, "), found ").concat(imagesToUse.length, " images"));

      // Update left image (first image)
      if (this.leftImage) {
        var leftImg = this.leftImage.querySelector('img');
        if (leftImg && imagesToUse[0]) {
          leftImg.src = imagesToUse[0].src;
          if (imagesToUse[0].srcset) {
            leftImg.srcset = imagesToUse[0].srcset;
          }
          console.log("Updated left image to ".concat(groupKey, ":"), imagesToUse[0].src);
        }
      }

      // Update right image (second image)
      if (this.rightImage) {
        var rightImg = this.rightImage.querySelector('img');
        if (rightImg && imagesToUse[1]) {
          rightImg.src = imagesToUse[1].src;
          if (imagesToUse[1].srcset) {
            rightImg.srcset = imagesToUse[1].srcset;
          }
          console.log("Updated right image to ".concat(groupKey, ":"), imagesToUse[1].src);
        }
      }

      // Update current breed group
      this.currentBreedGroup = groupKey;
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.removeEventListeners();
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomInputRangeImageV2);

/***/ }),

/***/ "./src/assets/js/quiz-components-v2/custom-input-text.js":
/*!***************************************************************!*\
  !*** ./src/assets/js/quiz-components-v2/custom-input-text.js ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var CustomInpuText = /*#__PURE__*/function (_HTMLElement) {
  function CustomInpuText() {
    var _this;
    _classCallCheck(this, CustomInpuText);
    _this = _callSuper(this, CustomInpuText);
    _this.input = _this.querySelector('input');
    _this.icon = _this.querySelector('.custom-input-text__icon');
    _this.quizContainer = _this.closest('quiz-container');
    _this.entry = _this.dataset.entry;
    _this.isName = _this.dataset.isName;
    _this.nextButton = document.querySelector('.button--next');
    _this.typingTimer = null;
    _this.typingDelay = 500;
    return _this;
  }
  _inherits(CustomInpuText, _HTMLElement);
  return _createClass(CustomInpuText, [{
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this2 = this;
      this.input.oninput = function () {
        _this2.saveInputValue();
        _this2.handleTyping();
        _this2.validateInput();
      };
      this.input.addEventListener('change', function () {
        _this2.saveInputValue();
        _this2.updateIconVisibility();
        _this2.validateInput();
      });
      this.input.addEventListener('blur', function () {
        _this2.saveInputValue();
        _this2.updateIconVisibility();
        _this2.validateInput();
      });
    }
  }, {
    key: "validateInput",
    value: function validateInput() {
      var currentSlide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      // Re-query button reference to ensure it's fresh
      this.nextButton = document.querySelector('.button--next');

      // Text inputs should always have enabled button (no validation needed)
      this.enableNextButton(currentSlide);
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      // Check if component is in the active swiper slide
      var swiperSlide = this.closest('.swiper-slide');
      if (swiperSlide && !swiperSlide.classList.contains('swiper-slide-active')) {
        return false;
      }
      return this.offsetParent !== null && window.getComputedStyle(this).display !== 'none';
    }
  }, {
    key: "enableNextButton",
    value: function enableNextButton() {
      var currentSlide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      // Check if this component is on the current slide
      // Use currentSlide if provided (more reliable than CSS class during transitions)
      var isOnCurrentSlide = currentSlide ? currentSlide.contains(this) : this.isVisible();

      // Only affect button if this component is on the current visible slide
      if (!isOnCurrentSlide) {
        console.log('custom-input-text: Not on current slide, skipping button enable');
        return;
      }
      if (this.nextButton) {
        this.nextButton.classList.remove('button--disabled');
        this.nextButton.disabled = false;
        console.log('custom-input-text: Enabled Next button');
      }
    }
  }, {
    key: "disableNextButton",
    value: function disableNextButton() {
      // Only affect button if this component is on the current visible slide
      if (!this.isVisible()) return;

      // if (this.nextButton) {
      //   this.nextButton.classList.add('button--disabled');
      //   this.nextButton.disabled = true;
      // }
    }
  }, {
    key: "handleTyping",
    value: function handleTyping() {
      var _this3 = this;
      this.hideIcon();
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(function () {
        _this3.updateIconVisibility();
      }, this.typingDelay);
    }
  }, {
    key: "updateIconVisibility",
    value: function updateIconVisibility() {
      if (this.input.value !== '') {
        this.showIcon();
      } else {
        this.hideIcon();
      }
    }
  }, {
    key: "showIcon",
    value: function showIcon() {
      var _this$icon;
      (_this$icon = this.icon) === null || _this$icon === void 0 || _this$icon.classList.remove('tw-hidden');
    }
  }, {
    key: "hideIcon",
    value: function hideIcon() {
      var _this$icon2;
      (_this$icon2 = this.icon) === null || _this$icon2 === void 0 || _this$icon2.classList.add('tw-hidden');
    }
  }, {
    key: "saveInputValue",
    value: function saveInputValue() {
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      if (!quizData.inputs) quizData.inputs = {};
      quizData.inputs[this.input.id] = {
        value: this.input.value,
        entry: this.entry
      };
      if (this.isName) {
        quizData.dogName = this.input.value;
      }
      localStorage.setItem('quiz', JSON.stringify(quizData));
      var quizContainer = this.closest('quiz-container');
      if (quizContainer !== null && quizContainer !== void 0 && quizContainer.replaceDogName) {
        setTimeout(function () {
          return quizContainer.replaceDogName();
        }, 50);
      }

      // Note: Tracking event is now dispatched on slide change, not on every input
    }

    /**
     * Dispatch tracking event when user confirms input (on slide change)
     */
  }, {
    key: "trackInputValue",
    value: function trackInputValue() {
      if (!this.isVisible()) return;
      var value = this.input.value.trim() || null;
      var valueLabel = value;

      // Special handling for dog name
      if (this.isName) {
        valueLabel = value || 'your dog';
      }
      document.dispatchEvent(new CustomEvent('quiz:input-changed', {
        detail: {
          type: 'text',
          fieldKey: this.entry,
          value: value,
          valueLabel: valueLabel,
          isName: this.isName === 'true',
          slideIndex: this.getCurrentSlideIndex()
        }
      }));
    }

    /**
     * Get current slide index from parent quiz container
     */
  }, {
    key: "getCurrentSlideIndex",
    value: function getCurrentSlideIndex() {
      var quizContainer = this.closest('quiz-container');
      if (quizContainer && quizContainer.activeSlider) {
        return quizContainer.activeSlider.activeIndex;
      }
      return 0;
    }
  }, {
    key: "restoreInputValue",
    value: function restoreInputValue() {
      var _quizData$inputs;
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      if ((_quizData$inputs = quizData.inputs) !== null && _quizData$inputs !== void 0 && _quizData$inputs[this.input.id]) {
        this.input.value = quizData.inputs[this.input.id].value;
      }
    }

    /**
     * Reset component to initial state
     */
  }, {
    key: "reset",
    value: function reset() {
      var _this$input;
      // Re-query button reference
      this.nextButton = document.querySelector('.button--next');

      // Clear input value
      if (this.input) {
        this.input.value = '';
      }

      // Hide icon
      this.hideIcon();

      // Clear from localStorage
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      if (quizData.inputs && (_this$input = this.input) !== null && _this$input !== void 0 && _this$input.id) {
        delete quizData.inputs[this.input.id];
      }
      if (this.isName) {
        delete quizData.dogName;
      }
      localStorage.setItem('quiz', JSON.stringify(quizData));

      // Enable next button (text input is always optional)
      this.enableNextButton();
      console.log('CustomInputText reset');
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.setEventListeners();
      this.restoreInputValue();
      this.updateIconVisibility();
      this.validateInput();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this.typingTimer) {
        clearTimeout(this.typingTimer);
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomInpuText);

/***/ }),

/***/ "./src/assets/js/quiz-components-v2/custom-product-output.js":
/*!*******************************************************************!*\
  !*** ./src/assets/js/quiz-components-v2/custom-product-output.js ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
/**
 * Custom Product Output - Quiz result display
 * Handles dog name and breed name replacement based on quiz data
 * Dynamically loads and displays correct product based on quiz calculations
 */
var CustomProductOutput = /*#__PURE__*/function (_HTMLElement) {
  function CustomProductOutput() {
    var _this;
    _classCallCheck(this, CustomProductOutput);
    _this = _callSuper(this, CustomProductOutput);
    _this.target = 'custom-product-output';
    _this.initialized = false;
    _this.defaultDog = _this.dataset.defaultDog;
    _this.parentSection = _this.closest('.new-product-section');

    // DOM element references
    _this.loaderEl = null;
    _this.contentEl = null;

    // Event handler references for cleanup
    _this.quizCompleteHandler = null;
    _this.nothingFoundText = _this.dataset.noNameTitle;
    _this.titleContainer = _this.querySelector('.text-label');
    _this.defaultBreed = _this.dataset.defaultBreed;

    // Final page type and breed-specific images
    _this.finalPageType = _this.dataset.finalPageType;
    _this.currentBreed = null;
    _this.originalProductData = null; // Store original product data
    _this.breedListenerInitialized = false; // Prevent duplicate listeners
    return _this;
  }
  _inherits(CustomProductOutput, _HTMLElement);
  return _createClass(CustomProductOutput, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      if (this.initialized) {
        return;
      }

      // Get DOM elements
      this.loaderEl = this.querySelector('[data-loader]');
      this.contentEl = this.querySelector('[data-content]');

      // Setup event listener for quiz calculations complete
      this.quizCompleteHandler = function () {
        return _this2.onQuizCalculationsComplete();
      };
      document.addEventListener('quiz:calculationsComplete', this.quizCompleteHandler);

      // Check if quiz data already exists
      var quizData = JSON.parse(localStorage.getItem('quiz') || '{}');
      if (quizData.dogName || quizData.dropdownStates) {
        this.onQuizCalculationsComplete();
      }
      this.initialized = true;
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this.quizCompleteHandler) {
        document.removeEventListener('quiz:calculationsComplete', this.quizCompleteHandler);
        this.quizCompleteHandler = null;
      }
    }
  }, {
    key: "updateDogName",
    value: function updateDogName() {
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      var dogName = quizData.dogName || quizData.name;
      var nameSpan = this.querySelector('.dog-name');

      // If there's a .dog-name placeholder
      if (nameSpan) {
        if (dogName && dogName.trim() !== '') {
          // Update with actual dog name
          nameSpan.textContent = dogName;
        } else if (this.titleContainer && this.nothingFoundText) {
          // Show "Nothing found" only if name placeholder exists but no name available
          this.titleContainer.innerHTML = this.nothingFoundText;
        }
      }
      // If no .dog-name placeholder exists, do nothing (title doesn't need dog name)
    }

    /**
     * Handle quiz calculations complete event
     */
  }, {
    key: "onQuizCalculationsComplete",
    value: (function () {
      var _onQuizCalculationsComplete = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              // Replace placeholders with quiz data
              // this.replaceDogName();
              this.replaceBreedName();

              // Update product display with correct product from calculations
              _context.n = 1;
              return this.updateProductDisplay();
            case 1:
              // For variant B, check and load breed-specific images immediately
              if (this.finalPageType === 'b') {
                this.checkAndUpdateImages();
              }

              // Complete loading - hide loader, show content
              this.completeLoading();

              // Dispatch event for other components
              document.dispatchEvent(new CustomEvent('product:loadingComplete'));
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function onQuizCalculationsComplete() {
        return _onQuizCalculationsComplete.apply(this, arguments);
      }
      return onQuizCalculationsComplete;
    }()
    /**
     * Get food composition from checkbox-based selection
     * Replaces slider-based ratio logic
     * 
     * Rules:
     * - Trockenfutter only → 100% dry / 0% wet
     * - Nassfutter only → 100% wet
     * - BARF only → 100% wet
     * - Trockenfutter + any wet option(s) → 50% dry / 50% wet
     * - Nassfutter + BARF (without Trockenfutter) → 100% wet
     */
    )
  }, {
    key: "getFoodCompositionFromCheckboxes",
    value: function getFoodCompositionFromCheckboxes(quizData) {
      var _quizData$checkboxSta, _quizData$twoSliderSt;
      var foodCheckboxes = (quizData === null || quizData === void 0 || (_quizData$checkboxSta = quizData.checkboxStates) === null || _quizData$checkboxSta === void 0 ? void 0 : _quizData$checkboxSta['entry.306846565']) || [];
      var isChecked = function isChecked(key) {
        return foodCheckboxes.some(function (item) {
          return (item.value === key || item.id === key) && item.checked === true;
        });
      };
      var hasDry = isChecked('trockenfutter');
      var hasWet = isChecked('nassfutter');
      var hasBarf = isChecked('barf');
      var hasAnyWet = hasWet || hasBarf;
      if (hasDry && !hasAnyWet) {
        return {
          dryPercent: 100,
          wetPercent: 0
        };
      }
      if (hasDry && hasAnyWet) {
        return {
          dryPercent: 50,
          wetPercent: 50
        };
      }
      if (!hasDry && hasAnyWet) {
        return {
          dryPercent: 0,
          wetPercent: 100
        };
      }

      // Legacy fallback for old slider data
      var legacy = (_quizData$twoSliderSt = quizData.twoSliderStates) === null || _quizData$twoSliderSt === void 0 ? void 0 : _quizData$twoSliderSt['food-composition'];
      if (legacy) {
        return {
          dryPercent: legacy.Trockenfutter || 0,
          wetPercent: legacy.Nassfutter || 0
        };
      }
      return {
        dryPercent: 50,
        wetPercent: 50
      };
    }

    /**
     * Update product display based on calculated groupKey
     * Fetches correct product data and updates DOM
     */
  }, {
    key: "updateProductDisplay",
    value: (function () {
      var _updateProductDisplay = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _quizData$dailyFoodCa, _window$PACKED_PRODUC;
        var quizData, groupKey, group, productHandle, foodComposition, wetPercent, wetVariant, productData, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              quizData = JSON.parse(localStorage.getItem('quiz') || '{}');
              groupKey = (_quizData$dailyFoodCa = quizData.dailyFoodCalculation) === null || _quizData$dailyFoodCa === void 0 ? void 0 : _quizData$dailyFoodCa.groupKey;
              if (!(!groupKey || !((_window$PACKED_PRODUC = window.PACKED_PRODUCTS) !== null && _window$PACKED_PRODUC !== void 0 && _window$PACKED_PRODUC.groups[groupKey]))) {
                _context2.n = 1;
                break;
              }
              console.log('CustomProductOutput: No valid groupKey found');
              return _context2.a(2);
            case 1:
              group = window.PACKED_PRODUCTS.groups[groupKey]; // Determine which product to display (wet food has priority for display)
              productHandle = null; // Check food composition to determine primary product (from checkbox-based selection)
              foodComposition = this.getFoodCompositionFromCheckboxes(quizData);
              wetPercent = foodComposition.wetPercent / 100;
              if (wetPercent > 0 && group.wet) {
                // For wet food, handle special cases like Minis with multiple variants
                if (group.wet.huhn && group.wet.forelle) {
                  wetVariant = group.wet["default"] || 'huhn';
                  productHandle = group.wet[wetVariant].handle;
                } else {
                  productHandle = group.wet.handle;
                }
              } else if (group.dry) {
                productHandle = group.dry.handle;
              }
              if (productHandle) {
                _context2.n = 2;
                break;
              }
              console.log('CustomProductOutput: No product handle found for group', groupKey);
              return _context2.a(2);
            case 2:
              console.log('CustomProductOutput: Loading product', productHandle, 'for group', groupKey);
              _context2.p = 3;
              _context2.n = 4;
              return this.fetchProductData(productHandle);
            case 4:
              productData = _context2.v;
              if (productData) {
                this.renderProductData(productData);
              }
              _context2.n = 6;
              break;
            case 5:
              _context2.p = 5;
              _t = _context2.v;
              console.error('CustomProductOutput: Error loading product', _t);
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this, [[3, 5]]);
      }));
      function updateProductDisplay() {
        return _updateProductDisplay.apply(this, arguments);
      }
      return updateProductDisplay;
    }()
    /**
     * Fetch product data from Shopify
     */
    )
  }, {
    key: "fetchProductData",
    value: (function () {
      var _fetchProductData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(handle) {
        var response, data, subtitle, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return fetch("/products/".concat(handle, ".js"));
            case 1:
              response = _context3.v;
              if (response.ok) {
                _context3.n = 2;
                break;
              }
              throw new Error("HTTP ".concat(response.status));
            case 2:
              _context3.n = 3;
              return response.json();
            case 3:
              data = _context3.v;
              _context3.n = 4;
              return this.fetchProductSubtitle(handle);
            case 4:
              subtitle = _context3.v;
              if (subtitle) {
                data.subtitle = subtitle;
              }
              return _context3.a(2, data);
            case 5:
              _context3.p = 5;
              _t2 = _context3.v;
              console.error("Error fetching product ".concat(handle, ":"), _t2);
              return _context3.a(2, null);
          }
        }, _callee3, this, [[0, 5]]);
      }));
      function fetchProductData(_x) {
        return _fetchProductData.apply(this, arguments);
      }
      return fetchProductData;
    }()
    /**
     * Fetch product subtitle from product page HTML
     */
    )
  }, {
    key: "fetchProductSubtitle",
    value: (function () {
      var _fetchProductSubtitle = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(handle) {
        var response, html, parser, doc, subtitleEl, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.p = 0;
              _context4.n = 1;
              return fetch("/products/".concat(handle));
            case 1:
              response = _context4.v;
              if (response.ok) {
                _context4.n = 2;
                break;
              }
              return _context4.a(2, null);
            case 2:
              _context4.n = 3;
              return response.text();
            case 3:
              html = _context4.v;
              parser = new DOMParser();
              doc = parser.parseFromString(html, 'text/html'); // Find subtitle element in product page
              subtitleEl = doc.querySelector('.custom_subtitle');
              return _context4.a(2, subtitleEl ? subtitleEl.textContent.trim() : null);
            case 4:
              _context4.p = 4;
              _t3 = _context4.v;
              console.error("Error fetching subtitle for ".concat(handle, ":"), _t3);
              return _context4.a(2, null);
          }
        }, _callee4, null, [[0, 4]]);
      }));
      function fetchProductSubtitle(_x2) {
        return _fetchProductSubtitle.apply(this, arguments);
      }
      return fetchProductSubtitle;
    }()
    /**
     * Render product data to DOM
     */
    )
  }, {
    key: "renderProductData",
    value: function renderProductData(productData) {
      // Store original product data
      this.originalProductData = productData;

      // Update product title
      var titleEl = this.querySelector('h2');
      if (titleEl) {
        titleEl.textContent = productData.title;
      }

      // Update product subtitle
      var subtitleEl = this.querySelector('.custom_subtitle');
      if (subtitleEl && productData.subtitle) {
        subtitleEl.textContent = productData.subtitle;
      }

      // Update product handle data attribute
      var productContainer = this.querySelector('.custom-product');
      if (productContainer) {
        productContainer.dataset.productHandle = productData.handle;
        productContainer.dataset.productId = productData.id;
      }

      // Update slider images
      // For variant B, breed-specific images will be loaded separately
      if (this.finalPageType !== 'b') {
        this.updateSliderImages(productData);
      }

      // Update vstar rating with new product data
      var vstarWidget = this.querySelector('vstar-rating-update');
      if (vstarWidget && typeof vstarWidget.updateProduct === 'function') {
        vstarWidget.updateProduct(productData.id, productData.handle);
      }
      console.log('CustomProductOutput: Product display updated to', productData.title);
    }

    /**
     * Update slider images with new product images
     */
  }, {
    key: "updateSliderImages",
    value: function updateSliderImages(productData) {
      if (!productData.images || productData.images.length === 0) return;
      var swiperComponent = this.querySelector('swiper-component');
      if (!swiperComponent) return;

      // Rebuild main slider slides (.top-slider is the swiper-wrapper)
      var mainSliderWrapper = swiperComponent.querySelector('.top-slider');
      if (mainSliderWrapper) {
        mainSliderWrapper.innerHTML = productData.images.map(function (imgUrl, index) {
          return "\n            <div class=\"swiper-slide product-slide\">\n              <div data-fancybox=\"gallery\" data-src=\"".concat(imgUrl, "\" class=\"fancybox-link\">\n                <img \n                  src=\"").concat(imgUrl, "\" \n                  alt=\"").concat(productData.title, "\" \n                  loading=\"").concat(index === 0 ? 'eager' : 'lazy', "\"\n                  width=\"600\"\n                  height=\"600\"\n                >\n              </div>\n            </div>\n          ");
        }).join('');
      }

      // Rebuild thumbnail slider slides (.thumbslider is the swiper-wrapper)
      var thumbSliderWrapper = swiperComponent.querySelector('.thumbslider');
      if (thumbSliderWrapper) {
        thumbSliderWrapper.innerHTML = productData.images.map(function (imgUrl) {
          return "\n            <div class=\"swiper-slide swiper-thumb\">\n              <div data-fancybox=\"gallery\" data-src=\"".concat(imgUrl, "\" class=\"fancybox-link\">\n                <img src=\"").concat(imgUrl, "\" alt=\"").concat(productData.title, "\" loading=\"lazy\" width=\"285\" height=\"285\">\n              </div>\n            </div>\n          ");
        }).join('');
      }

      // Update pagination dots
      var pagination = swiperComponent.querySelector('.swiper-pagination');
      if (pagination) {
        pagination.innerHTML = productData.images.map(function (_, index) {
          return "<span class=\"swiper-pagination-bullet".concat(index === 0 ? ' swiper-pagination-bullet-active' : '', "\" tabindex=\"0\" role=\"button\" aria-label=\"Go to slide ").concat(index + 1, "\"></span>");
        }).join('');
      }

      // Update LCP preload image
      var lcpWrapper = this.querySelector('.lcp-image-wrapper');
      if (lcpWrapper && productData.images[0]) {
        lcpWrapper.innerHTML = "\n          <img \n            src=\"".concat(productData.images[0], "\" \n            alt=\"").concat(productData.title, "\"\n            width=\"600\"\n            height=\"600\"\n            loading=\"eager\"\n            fetchpriority=\"high\"\n            class=\"lcp-image\"\n          >\n        ");
      }

      // Reinitialize Swiper
      this.reinitializeSwiper(swiperComponent);
    }

    /**
     * Reinitialize Swiper after DOM changes
     */
  }, {
    key: "reinitializeSwiper",
    value: function reinitializeSwiper(swiperComponent) {
      // Destroy existing Swiper instances
      if (swiperComponent.swiper) {
        swiperComponent.swiper.destroy(true, true);
        swiperComponent.swiper = null;
      }
      if (swiperComponent.galleryThumbs) {
        swiperComponent.galleryThumbs.destroy(true, true);
        swiperComponent.galleryThumbs = null;
      }

      // Re-query DOM elements after innerHTML change
      swiperComponent.swiperElement = swiperComponent.querySelector('.main-slider');
      swiperComponent.swiperElement2 = swiperComponent.querySelector('.thumbs-slider');
      swiperComponent.arrowPrev = swiperComponent.querySelector('.swiper-button-prev');
      swiperComponent.arrowNext = swiperComponent.querySelector('.swiper-button-next');

      // Reinitialize Swiper using component's method
      if (typeof swiperComponent.initializeSwiper === 'function') {
        swiperComponent.initializeSwiper();
      }
    }

    /**
     * Replace dog name placeholders in DOM
     */
  }, {
    key: "replaceDogName",
    value: function replaceDogName() {
      var _this$parentSection;
      var quizData = JSON.parse(localStorage.getItem('quiz') || '{}');
      var name = quizData.dogName;
      var titleContainer = this.querySelector('.text-label');
      var nameSpan = this.querySelector('.dog-name');

      // Check if we have a title container with name placeholder
      if (!titleContainer || !nameSpan) {
        return;
      }

      // If no name provided, replace entire title with data-noname-text
      if (!name || name.trim() === '') {
        var noNameText = titleContainer.dataset.nonameText || 'Nichts gefunden';
        titleContainer.textContent = noNameText;
        return;
      }

      // If name exists, update the placeholder
      nameSpan.textContent = name;

      // Also update name in parent section if exists
      (_this$parentSection = this.parentSection) === null || _this$parentSection === void 0 || (_this$parentSection = _this$parentSection.querySelectorAll('.dog-name')) === null || _this$parentSection === void 0 || _this$parentSection.forEach(function (el) {
        el.textContent = name;
      });
    }
  }, {
    key: "parseBreedData",
    value: function parseBreedData(breedDataString) {
      if (!breedDataString) {
        return {
          breedType: 'unknown',
          breeds: []
        };
      }
      if (breedDataString === 'not_sure') {
        return {
          breedType: 'not_sure',
          breeds: []
        };
      }
      var parts = breedDataString.split(';').map(function (s) {
        return s.trim();
      });
      var result = {
        breedType: 'unknown',
        breeds: []
      };
      parts.forEach(function (part) {
        var _part$split = part.split(':'),
          _part$split2 = _toArray(_part$split),
          key = _part$split2[0],
          valueParts = _part$split2.slice(1);
        var value = valueParts.join(':').trim();
        if (key.trim() === 'breedTypeStates') {
          result.breedType = value;
        } else if (key.trim() === 'value') {
          result.breeds.push(value);
        } else if (key.trim() === 'value_1') {
          result.breeds.push(value);
        } else if (key.trim() === 'value_2') {
          result.breeds.push(value);
        }
      });
      return result;
    }

    /**
     * Replace breed name placeholders in DOM
     */
  }, {
    key: "replaceBreedName",
    value: function replaceBreedName() {
      if (localStorage.getItem('quiz') && document.querySelector('.breed-name')) {
        var quizData = JSON.parse(localStorage.getItem('quiz'));
        var breedDataString = quizData.dropdownStates && quizData.dropdownStates['entry.62437307'];
        if (!breedDataString) return;
        var breedData = this.parseBreedData(breedDataString);
        var breedName = '';
        if (breedData.breedType === 'not_sure') {
          breedName = 'Rasse';
        } else if (breedData.breeds.length > 0) {
          // For mixed breeds, use the first breed (value_1) to determine group
          var primaryBreed = breedData.breeds[0];
          var groupKey = this.findGroupByBreedName(primaryBreed);
          breedName = this.getGroupDisplayName(groupKey) || primaryBreed;
        } else {
          breedName = 'Rasse';
        }
        this.querySelectorAll('quiz-result-page .breed-name').forEach(function (el) {
          return el.innerHTML = breedName;
        });
      }
    }

    /**
     * Map group key to translated display name
     */
  }, {
    key: "getGroupDisplayName",
    value: function getGroupDisplayName(groupKey) {
      // Use translations from window object if available
      if (window.breedGroupTranslations && window.breedGroupTranslations[groupKey]) {
        return window.breedGroupTranslations[groupKey];
      }

      // Fallback to German names
      var groupNames = {
        retrievers: 'Retriever',
        bulldogs: 'Bulldoggen',
        herders: 'Hütehunde',
        hunters: 'Kleine Jagdhunde',
        bigbuddies: 'Molosser',
        heroichunters: 'Große Jagdhunde',
        minis: 'Minis',
        shepherds: 'Schäferhunde'
      };
      return groupNames[groupKey] || null;
    }

    /**
     * Find breed group by breed name
     */
  }, {
    key: "findGroupByBreedName",
    value: function findGroupByBreedName(breedName) {
      if (!breedName) return null;
      var lower = breedName.toLowerCase();
      var list = window.breedSearchDatabreed_1 || [];

      // Search by URL in breed data
      var _iterator = _createForOfIteratorHelper(list),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var entry = _step.value;
          if (entry.breedList.some(function (b) {
            return b.toLowerCase() === lower;
          })) {
            var url = (entry.breedUrl || '').toLowerCase();
            if (url.includes('bulldogs')) return 'bulldogs';
            if (url.includes('ravishing-retrievers')) return 'retrievers';
            if (url.includes('shine-bright-shepherds')) return 'shepherds';
            if (url.includes('collections/minis') || url.includes('marvelous-minis')) return 'minis';
            if (url.includes('happy-herders')) return 'herders';
            if (url.includes('hearty-hunters')) return 'hunters';
            if (url.includes('big-buddies')) return 'bigbuddies';
            if (url.includes('heroic-hunters')) return 'heroichunters';
          }
        }

        // Fallback: search by keywords in breed name
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (lower.includes('bulldog') || lower.includes('frenchie') || lower.includes('mops') || lower.includes('boston')) return 'bulldogs';
      if (lower.includes('retriever') || lower.includes('labrador') || lower.includes('golden')) return 'retrievers';
      if (lower.includes('schäfer') || lower.includes('shepherd') || lower.includes('malinois')) return 'shepherds';
      if (lower.includes('chihuahua') || lower.includes('york') || lower.includes('malteser') || lower.includes('havaneser') || lower.includes('jack russell')) return 'minis';
      if (lower.includes('collie') || lower.includes('australian shepherd') || lower.includes('border')) return 'herders';
      if (lower.includes('mastiff') || lower.includes('cane corso') || lower.includes('rottweiler') || lower.includes('dogge')) return 'bigbuddies';
      if (lower.includes('weimaraner') || lower.includes('vizsla') || lower.includes('pointer') || lower.includes('setter')) return 'heroichunters';

      // Default to hunters if no match
      return 'hunters';
    }

    /**
     * Show loader, hide content
     */
  }, {
    key: "showLoader",
    value: function showLoader() {
      if (this.loaderEl) {
        this.loaderEl.classList.remove('tw-hidden');
      }
      if (this.contentEl) {
        this.contentEl.classList.add('tw-hidden');
      }
    }

    /**
     * Hide loader, show content
     */
  }, {
    key: "hideLoader",
    value: function hideLoader() {
      if (this.loaderEl) {
        this.loaderEl.classList.add('tw-hidden');
      }
      if (this.contentEl) {
        this.contentEl.classList.remove('tw-hidden');
      }
    }

    /**
     * Complete loading and dispatch event
     */
  }, {
    key: "completeLoading",
    value: function completeLoading() {
      this.hideLoader();

      // For variant B, start listening to breed changes for images
      if (this.finalPageType === 'b') {
        this.listenToBreedChangesForImages();
      }
    }

    /**
     * Parse specific bundle images data from attribute
     * @returns {Array} Array of breed-specific image objects
     */
  }, {
    key: "parseSpecificBundleImages",
    value: function parseSpecificBundleImages() {
      var dataAttr = this.getAttribute('data-specific-bundle-images');
      if (!dataAttr) return [];
      try {
        var parsed = JSON.parse(dataAttr);
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        console.error('Failed to parse specific-bundle-images:', e);
        return [];
      }
    }

    /**
     * Find specific images for given breed
     * @param {string} breed - Breed key
     * @returns {Array|null} Array of image URLs for breed or null
     */
  }, {
    key: "findImagesForBreed",
    value: function findImagesForBreed(breed) {
      if (!breed) return null;
      var imageData = this.parseSpecificBundleImages();
      var breedEntry = imageData.find(function (entry) {
        return entry.breed === breed;
      });
      return breedEntry && breedEntry.images ? breedEntry.images : null;
    }

    /**
     * Get current breed group from PACKED_PRODUCTS
     * @returns {string} Current breed group key
     */
  }, {
    key: "getCurrentBreedGroup",
    value: function getCurrentBreedGroup() {
      if (window.PACKED_PRODUCTS && typeof window.PACKED_PRODUCTS.resolveGroup === 'function') {
        return window.PACKED_PRODUCTS.resolveGroup();
      }
      return null;
    }

    /**
     * Listen to breed selection changes and update images
     */
  }, {
    key: "listenToBreedChangesForImages",
    value: function listenToBreedChangesForImages() {
      var _this3 = this;
      // Prevent duplicate initialization
      if (this.breedListenerInitialized) {
        console.log('CustomProductOutput: Breed listener already initialized');
        return;
      }
      this.breedListenerInitialized = true;

      // Initial check
      this.checkAndUpdateImages();

      // Listen for custom quiz events
      document.addEventListener('quiz:input-changed', function (event) {
        if (event.detail.type === 'dropdown' && event.detail.fieldKey === 'entry.62437307') {
          setTimeout(function () {
            _this3.checkAndUpdateImages();
          }, 100);
        }
      });

      // Poll for changes (fallback)
      setInterval(function () {
        _this3.checkAndUpdateImages();
      }, 1000);
    }

    /**
     * Check current breed and update slider images if breed changed
     */
  }, {
    key: "checkAndUpdateImages",
    value: function checkAndUpdateImages() {
      var currentBreed = this.getCurrentBreedGroup();
      if (!currentBreed) {
        // No breed selected, show default product images if available
        if (this.originalProductData) {
          this.updateSliderImages(this.originalProductData);
        }
        return;
      }

      // Only update if breed changed
      if (this.currentBreed === currentBreed) return;
      this.currentBreed = currentBreed;
      var specificImages = this.findImagesForBreed(currentBreed);
      if (!specificImages || specificImages.length === 0) {
        console.log("No specific images found for breed: ".concat(currentBreed, ", using default product images"));
        // Fallback to default product images
        if (this.originalProductData) {
          this.updateSliderImages(this.originalProductData);
        }
        return;
      }
      console.log("Updating slider with breed-specific images for: ".concat(currentBreed));
      this.updateSliderWithBreedImages(specificImages);
    }

    /**
     * Update slider with breed-specific images
     * @param {Array} images - Array of image URLs (strings)
     */
  }, {
    key: "updateSliderWithBreedImages",
    value: function updateSliderWithBreedImages(images) {
      var swiperComponent = this.querySelector('swiper-component');
      if (!swiperComponent) return;

      // Images should already be URL strings from Liquid
      var imageUrls = images.filter(function (url) {
        return url && typeof url === 'string';
      });
      if (imageUrls.length === 0) {
        console.warn('No valid image URLs found');
        return;
      }
      console.log('Loading breed-specific images:', imageUrls);

      // Apply restore_margins style for single image
      if (imageUrls.length === 1) {
        swiperComponent.classList.add('!tw-mr-0');
      } else {
        swiperComponent.classList.remove('!tw-mr-0');
      }

      // Rebuild main slider slides
      var mainSliderWrapper = swiperComponent.querySelector('.top-slider');
      if (mainSliderWrapper) {
        mainSliderWrapper.innerHTML = imageUrls.map(function (imgUrl, index) {
          return "\n            <div class=\"swiper-slide product-slide\">\n              <div data-fancybox=\"gallery\" data-src=\"".concat(imgUrl, "\" class=\"fancybox-link\">\n                <img\n                  src=\"").concat(imgUrl, "\"\n                  alt=\"Bundle product\"\n                  loading=\"").concat(index === 0 ? 'eager' : 'lazy', "\"\n                  width=\"600\"\n                  height=\"600\"\n                >\n              </div>\n            </div>\n          ");
        }).join('');
      }

      // Rebuild thumbnail slider slides
      var thumbSliderWrapper = swiperComponent.querySelector('.thumbslider');
      if (thumbSliderWrapper) {
        thumbSliderWrapper.innerHTML = imageUrls.map(function (imgUrl) {
          return "\n            <div class=\"swiper-slide swiper-thumb\">\n              <div data-fancybox=\"gallery\" data-src=\"".concat(imgUrl, "\" class=\"fancybox-link\">\n                <img src=\"").concat(imgUrl, "\" alt=\"Bundle product\" loading=\"lazy\" width=\"285\" height=\"285\">\n              </div>\n            </div>\n          ");
        }).join('');
      }

      // Update pagination dots
      var pagination = swiperComponent.querySelector('.swiper-pagination');
      if (pagination) {
        pagination.innerHTML = imageUrls.map(function (_, index) {
          return "<span class=\"swiper-pagination-bullet".concat(index === 0 ? ' swiper-pagination-bullet-active' : '', "\" tabindex=\"0\" role=\"button\" aria-label=\"Go to slide ").concat(index + 1, "\"></span>");
        }).join('');
      }

      // Update LCP preload image
      var lcpWrapper = this.querySelector('.lcp-image-wrapper');
      if (lcpWrapper && imageUrls[0]) {
        lcpWrapper.innerHTML = "\n          <img\n            src=\"".concat(imageUrls[0], "\"\n            alt=\"Bundle product\"\n            width=\"600\"\n            height=\"600\"\n            loading=\"eager\"\n            fetchpriority=\"high\"\n            class=\"lcp-image\"\n          >\n        ");
      }

      // Reinitialize Swiper
      this.reinitializeSwiper(swiperComponent);
    }

    /**
     * Reset component state for quiz restart
     */
  }, {
    key: "reset",
    value: function reset() {
      var _this$parentSection2;
      this.initialized = false;
      this.showLoader();

      // Reset dog name placeholders to default
      var defaultDog = this.defaultDog;
      (_this$parentSection2 = this.parentSection) === null || _this$parentSection2 === void 0 || (_this$parentSection2 = _this$parentSection2.querySelectorAll('.dog-name')) === null || _this$parentSection2 === void 0 || _this$parentSection2.forEach(function (el) {
        el.textContent = defaultDog;
      });

      // Reset breed name placeholders
      document.querySelectorAll('.breed-name').forEach(function (el) {
        el.textContent = 'Rasse';
      });
      console.log('CustomProductOutput reset');
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomProductOutput);

/***/ }),

/***/ "./src/assets/js/quiz-components-v2/custom-slider-input.js":
/*!*****************************************************************!*\
  !*** ./src/assets/js/quiz-components-v2/custom-slider-input.js ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var CustomSliderInput = /*#__PURE__*/function (_HTMLElement) {
  function CustomSliderInput() {
    var _this$titleContainer;
    var _this;
    _classCallCheck(this, CustomSliderInput);
    _this = _callSuper(this, CustomSliderInput);
    _this.quizContainer = _this.closest('quiz-container');
    _this.entry = _this.dataset.entry;
    _this.componentType = _this.dataset.componentType || 'both';
    _this.min = parseFloat(_this.dataset.min) || 0;
    _this.max = parseFloat(_this.dataset.max) || 100;
    _this.step = parseFloat(_this.dataset.step) || 1;
    _this.defaultValue = _this.dataset["default"] ? parseFloat(_this.dataset["default"]) : _this.min;
    _this.unit = _this.dataset.unit || 'kg';
    _this.titleContainer = _this.querySelector('.text-label');
    _this.nothingFoundText = ((_this$titleContainer = _this.titleContainer) === null || _this$titleContainer === void 0 ? void 0 : _this$titleContainer.dataset.nonameText) || '';
    _this.rangeInput = _this.querySelector('.slider-input__range');
    _this.numberInput = _this.querySelector('.slider-input__number');
    _this.valueDisplay = _this.querySelector('.slider-value-number');
    _this.tooltip = _this.querySelector('.slider-tooltip');
    _this.currentWeight = _this.defaultValue;
    _this.isInteracting = false;
    _this.hasTrackedInitial = false;
    return _this;
  }
  _inherits(CustomSliderInput, _HTMLElement);
  return _createClass(CustomSliderInput, [{
    key: "updateDogName",
    value: function updateDogName() {
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      var dogName = quizData.dogName || quizData.name;
      var nameSpan = this.querySelector('.dog-name');

      // If there's a .dog-name placeholder
      if (nameSpan) {
        if (dogName && dogName.trim() !== '') {
          // Update with actual dog name
          nameSpan.textContent = dogName;
        } else if (this.titleContainer && this.nothingFoundText) {
          // Show "Nothing found" only if name placeholder exists but no name available
          this.titleContainer.innerHTML = this.nothingFoundText;
        }
      }
      // If no .dog-name placeholder exists, do nothing (title doesn't need dog name)
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.restoreSliderState();
      this.setEventListeners();
      this.updateDisplay();
      // this.updateDogName();
      this.positionTooltip(); // Position tooltip initially

      // Enable next button immediately
      this.enableNextButton();

      // Listen for slide changes
      document.addEventListener('sliderChange', function (event) {
        var _event$detail;
        var currentSlideIndex = (_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : _event$detail.activeIndex;
        var mySlideIndex = _this2.getCurrentSlideIndex();

        // Track initial selection when this slide becomes active
        // Only track once - flag is reset only on restart or value change
        if (currentSlideIndex === mySlideIndex && !_this2.hasTrackedInitial) {
          _this2.trackInitialSelection();
        }
      });

      // Listen for restart event
      document.addEventListener('quiz:restart', function () {
        _this2.handleRestart();
      });
    }

    /**
     * Get current slide index from parent quiz container
     */
  }, {
    key: "getCurrentSlideIndex",
    value: function getCurrentSlideIndex() {
      var quizContainer = this.closest('quiz-container');
      if (quizContainer && quizContainer.activeSlider) {
        return quizContainer.activeSlider.activeIndex;
      }
      return 0;
    }

    /**
     * Get the expected slide index for this component
     * (index of the swiper-slide that contains this component)
     */
  }, {
    key: "getExpectedSlideIndex",
    value: function getExpectedSlideIndex() {
      var swiperSlide = this.closest('.swiper-slide');
      if (!swiperSlide) return null;

      // Get the main quiz container's swiper wrapper (not nested swipers like protein)
      var quizContainer = this.closest('quiz-container');
      if (!quizContainer) return null;
      var mainSwiperWrapper = quizContainer.querySelector('.swiper > .swiper-wrapper');
      if (!mainSwiperWrapper) return null;

      // Only count direct children slides of main swiper (excludes nested swiper slides)
      var allSlides = Array.from(mainSwiperWrapper.children).filter(function (el) {
        return el.classList.contains('swiper-slide');
      });
      return allSlides.indexOf(swiperSlide);
    }

    /**
     * Validate that slideIndex matches component position
     */
  }, {
    key: "validateSlideIndex",
    value: function validateSlideIndex(slideIndex) {
      var expectedIndex = this.getExpectedSlideIndex();
      if (expectedIndex === null) return true; // Cannot validate

      if (slideIndex !== expectedIndex) {
        console.warn("[CustomSliderInput] slideIndex mismatch for \"".concat(this.entry, "\":"), "\n  Current slideIndex: ".concat(slideIndex), "\n  Expected slideIndex: ".concat(expectedIndex), "\n  Component:", this);
        return false;
      }
      return true;
    }

    /**
     * Track initial/default selection when component becomes visible
     * Only fires once per component lifecycle to avoid duplicate tracking
     * Flag is reset only on restart or value change
     */
  }, {
    key: "trackInitialSelection",
    value: function trackInitialSelection() {
      if (!this.isVisible()) return;

      // Only track once - flag persists across slide navigation
      if (this.hasTrackedInitial) return;

      // Ensure currentWeight is a valid number
      var weightValue = typeof this.currentWeight === 'number' && !isNaN(this.currentWeight) ? this.currentWeight : this.defaultValue;

      // Ensure unit is defined
      var unitValue = this.unit || 'kg';
      var slideIndex = this.getCurrentSlideIndex();

      // Validate slideIndex
      this.validateSlideIndex(slideIndex);
      document.dispatchEvent(new CustomEvent('quiz:input-changed', {
        detail: {
          type: 'slider',
          fieldKey: this.entry,
          value: weightValue,
          valueLabel: "".concat(weightValue, " ").concat(unitValue),
          unit: unitValue,
          source: 'default_value',
          slideIndex: slideIndex
        }
      }));
      this.hasTrackedInitial = true;
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      // Check if component is in the active swiper slide
      var swiperSlide = this.closest('.swiper-slide');
      if (swiperSlide && !swiperSlide.classList.contains('swiper-slide-active')) {
        return false;
      }
      return this.offsetParent !== null && window.getComputedStyle(this).display !== 'none';
    }
  }, {
    key: "enableNextButton",
    value: function enableNextButton() {
      // Only enable if visible on current slide
      if (!this.isVisible()) {
        return;
      }
      var nextButton = document.querySelector('.button--next');
      if (nextButton) {
        nextButton.classList.remove('button--disabled');
        nextButton.disabled = false;
      }
    }

    // Save state to localStorage
  }, {
    key: "saveSliderState",
    value: function saveSliderState() {
      var isUserInteraction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      if (!quizData.sliderStates) {
        quizData.sliderStates = {};
      }
      quizData.sliderStates[this.entry] = this.currentWeight;
      localStorage.setItem('quiz', JSON.stringify(quizData));

      // Dispatch tracking event only for user interactions (not initial/default values)
      if (this.isVisible() && isUserInteraction) {
        // Ensure currentWeight is a valid number
        var weightValue = typeof this.currentWeight === 'number' && !isNaN(this.currentWeight) ? this.currentWeight : this.defaultValue;

        // Ensure unit is defined
        var unitValue = this.unit || 'kg';
        document.dispatchEvent(new CustomEvent('quiz:input-changed', {
          detail: {
            type: 'slider',
            fieldKey: this.entry,
            value: weightValue,
            valueLabel: "".concat(weightValue, " ").concat(unitValue),
            unit: unitValue,
            source: 'user_interaction',
            slideIndex: this.getCurrentSlideIndex()
          }
        }));
      }
    }

    // Restore state from localStorage
  }, {
    key: "restoreSliderState",
    value: function restoreSliderState() {
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      if (quizData && quizData.sliderStates && quizData.sliderStates[this.entry] !== undefined) {
        this.currentWeight = parseFloat(quizData.sliderStates[this.entry]);
      } else {
        // Save default value to localStorage on first load (without tracking)
        this.currentWeight = this.defaultValue;
        this.saveSliderState(false);
      }
    }

    // Handle restart event
  }, {
    key: "handleRestart",
    value: function handleRestart() {
      this.reset();
    }

    /**
     * Reset component to initial state
     */
  }, {
    key: "reset",
    value: function reset() {
      // Reset tracking flag
      this.hasTrackedInitial = false;

      // Reset to default value
      this.currentWeight = this.defaultValue;
      this.updateDisplay();

      // Save reset state to localStorage (without tracking)
      this.saveSliderState(false);

      // Reset tooltip visibility
      this.isInteracting = false;
      if (this.tooltip) {
        this.tooltip.style.display = 'block';
        this.positionTooltip();
      }
    }

    // Position tooltip based on slider thumb position
  }, {
    key: "positionTooltip",
    value: function positionTooltip() {
      if (!this.tooltip || !this.rangeInput) return;
      var percent = (this.currentWeight - this.min) / (this.max - this.min);
      // Account for thumb width (33px) to center tooltip
      var thumbOffset = 16.5; // half of thumb width
      var trackWidth = this.rangeInput.offsetWidth - 33; // subtract thumb width
      var position = percent * trackWidth + thumbOffset;
      this.tooltip.style.left = "".concat(position, "px");
      this.tooltip.style.display = 'block';
    }

    // Round to nearest step
  }, {
    key: "roundToStep",
    value: function roundToStep(value) {
      return Math.round(value / this.step) * this.step;
    }

    // Clamp value to min/max
  }, {
    key: "clampValue",
    value: function clampValue(value) {
      return Math.max(this.min, Math.min(this.max, value));
    }

    // Update all displays
  }, {
    key: "updateDisplay",
    value: function updateDisplay() {
      if (this.rangeInput) {
        this.rangeInput.value = this.currentWeight;
      }
      if (this.numberInput) {
        this.numberInput.value = this.currentWeight;
      }
      if (this.valueDisplay) {
        this.valueDisplay.textContent = this.currentWeight;
      }
    }

    // Handle range input change
  }, {
    key: "handleRangeChange",
    value: function handleRangeChange(e) {
      var rawValue = parseFloat(e.target.value);
      var oldWeight = this.currentWeight;
      this.currentWeight = this.clampValue(rawValue);

      // Reset tracking flag if value changed (allow re-tracking if user returns to default)
      if (oldWeight !== this.currentWeight) {
        this.hasTrackedInitial = false;
      }
      this.updateDisplay();
      this.positionTooltip(); // Update tooltip position while dragging
      this.saveSliderState(true); // User interaction
      this.validateInputs();
    }

    // Handle number input change
  }, {
    key: "handleNumberInput",
    value: function handleNumberInput(e) {
      var rawValue = e.target.value;

      // Replace comma with dot for decimal separator
      rawValue = rawValue.replace(',', '.');
      var numValue = parseFloat(rawValue);
      if (!isNaN(numValue)) {
        var oldWeight = this.currentWeight;
        this.currentWeight = this.clampValue(numValue);

        // Reset tracking flag if value changed
        if (oldWeight !== this.currentWeight) {
          this.hasTrackedInitial = false;
        }
        this.updateDisplay();
        this.saveSliderState(true); // User interaction
        this.validateInputs();
      }
    }

    // Handle number input blur (round to step)
  }, {
    key: "handleNumberBlur",
    value: function handleNumberBlur(e) {
      var rawValue = e.target.value;
      var oldWeight = this.currentWeight;
      if (rawValue === '' || rawValue === null) {
        this.currentWeight = this.defaultValue;
      } else {
        rawValue = rawValue.replace(',', '.');
        var numValue = parseFloat(rawValue);
        if (!isNaN(numValue)) {
          this.currentWeight = this.roundToStep(this.clampValue(numValue));
        }
      }

      // Reset tracking flag if value changed
      if (oldWeight !== this.currentWeight) {
        this.hasTrackedInitial = false;
      }
      this.updateDisplay();
      this.saveSliderState(true); // User interaction
      this.validateInputs();
    }

    // Validate inputs
  }, {
    key: "validateInputs",
    value: function validateInputs() {
      if (this.quizContainer && typeof this.quizContainer.validateInputs === 'function') {
        this.quizContainer.validateInputs();
      }
    }

    // Check if value is valid
  }, {
    key: "isValid",
    value: function isValid() {
      if (this.componentType === 'slider') {
        // Slider-only mode: always valid
        return true;
      }

      // With input: check if value is valid and within range
      return !isNaN(this.currentWeight) && this.currentWeight >= this.min && this.currentWeight <= this.max;
    }

    // Hide tooltip on interaction
  }, {
    key: "hideTooltip",
    value: function hideTooltip() {
      if (this.tooltip && !this.isInteracting) {
        this.isInteracting = true;
        this.tooltip.style.display = 'none';
      }
    }

    // Set event listeners
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this3 = this;
      if (this.rangeInput) {
        this.rangeInput.addEventListener('input', function (e) {
          return _this3.handleRangeChange(e);
        });
        this.rangeInput.addEventListener('mousedown', function () {
          return _this3.hideTooltip();
        });
        this.rangeInput.addEventListener('touchstart', function () {
          return _this3.hideTooltip();
        });
      }
      if (this.numberInput) {
        this.numberInput.addEventListener('input', function (e) {
          return _this3.handleNumberInput(e);
        });
        this.numberInput.addEventListener('blur', function (e) {
          return _this3.handleNumberBlur(e);
        });
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomSliderInput);

/***/ }),

/***/ "./src/assets/js/quiz-components-v2/custom-two-input-sliders.js":
/*!**********************************************************************!*\
  !*** ./src/assets/js/quiz-components-v2/custom-two-input-sliders.js ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var CustomTwoSlidersInput = /*#__PURE__*/function (_HTMLElement) {
  function CustomTwoSlidersInput() {
    var _this;
    _classCallCheck(this, CustomTwoSlidersInput);
    _this = _callSuper(this, CustomTwoSlidersInput);
    _this.quizContainer = _this.closest('quiz-container');
    _this.entry = _this.dataset.entry;
    _this.step = parseFloat(_this.dataset.step) || 5;
    _this.defaultRatio = parseFloat(_this.dataset["default"]) || 50;
    _this.componentA = _this.dataset.componentA || 'Component A';
    _this.componentB = _this.dataset.componentB || 'Component B';
    _this.rangeInput = _this.querySelector('.two-sliders-input__range');
    _this.tooltip = _this.querySelector('.two-sliders-tooltip');
    _this.displayComponentA = _this.querySelector('.two-sliders-display__component-a');
    _this.displayComponentB = _this.querySelector('.two-sliders-display__component-b');

    // Label percentage spans
    _this.labelPercentages = _this.querySelectorAll('.two-sliders-label__percentage');

    // Dog name replacement
    _this.titleContainer = _this.querySelector('.text-label');
    _this.nothingFoundText = _this.dataset.noNameTitle;
    _this.currentRatio = _this.defaultRatio;
    _this.isTooltipHidden = false;
    _this.hasTrackedInitial = false;
    return _this;
  }
  _inherits(CustomTwoSlidersInput, _HTMLElement);
  return _createClass(CustomTwoSlidersInput, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.restoreState();
      this.setEventListeners();
      this.updateDisplay();
      // this.updateLabels();
      this.positionTooltip(); // Position tooltip initially

      // Enable next button immediately
      this.enableNextButton();

      // Track initial selection when slide becomes active
      this.trackInitialSelection();

      // Listen for slide changes
      document.addEventListener('sliderChange', function (event) {
        var _event$detail;
        var currentSlideIndex = (_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : _event$detail.activeIndex;
        var mySlideIndex = _this2.getCurrentSlideIndex();

        // Track initial selection when this slide becomes active
        // Only track once - flag is reset only on restart or value change
        if (currentSlideIndex === mySlideIndex && !_this2.hasTrackedInitial) {
          _this2.trackInitialSelection();
        }
      });

      // Update dog name on mount
      // this.updateDogName();

      // // Listen for slide changes to update dog name
      // document.addEventListener('sliderChange', () => {
      //   // Only update if this component is visible (on current slide)
      //   if (this.isVisible()) {
      //     this.updateDogName();
      //   }
      // });
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      // Check if component is in the active swiper slide
      var swiperSlide = this.closest('.swiper-slide');
      if (swiperSlide && !swiperSlide.classList.contains('swiper-slide-active')) {
        return false;
      }
      return this.offsetParent !== null && window.getComputedStyle(this).display !== 'none';
    }

    /**
     * Get current slide index from parent quiz container
     */
  }, {
    key: "getCurrentSlideIndex",
    value: function getCurrentSlideIndex() {
      var quizContainer = this.closest('quiz-container');
      if (quizContainer && quizContainer.activeSlider) {
        return quizContainer.activeSlider.activeIndex;
      }
      return 0;
    }

    /**
     * Get the expected slide index for this component
     * (index of the swiper-slide that contains this component)
     */
  }, {
    key: "getExpectedSlideIndex",
    value: function getExpectedSlideIndex() {
      var swiperSlide = this.closest('.swiper-slide');
      if (!swiperSlide) return null;

      // Get the main quiz container's swiper wrapper (not nested swipers like protein)
      var quizContainer = this.closest('quiz-container');
      if (!quizContainer) return null;
      var mainSwiperWrapper = quizContainer.querySelector('.swiper > .swiper-wrapper');
      if (!mainSwiperWrapper) return null;

      // Only count direct children slides of main swiper (excludes nested swiper slides)
      var allSlides = Array.from(mainSwiperWrapper.children).filter(function (el) {
        return el.classList.contains('swiper-slide');
      });
      return allSlides.indexOf(swiperSlide);
    }

    /**
     * Validate that slideIndex matches component position
     */
  }, {
    key: "validateSlideIndex",
    value: function validateSlideIndex(slideIndex) {
      var expectedIndex = this.getExpectedSlideIndex();
      if (expectedIndex === null) return true; // Cannot validate

      if (slideIndex !== expectedIndex) {
        console.warn("[CustomTwoSlidersInput] slideIndex mismatch for \"".concat(this.entry, "\":"), "\n  Current slideIndex: ".concat(slideIndex), "\n  Expected slideIndex: ".concat(expectedIndex), "\n  Component:", this);
        return false;
      }
      return true;
    }

    /**
     * Track initial/default selection when component becomes visible
     * Only fires once per component lifecycle to avoid duplicate tracking
     * Flag is reset only on restart or value change
     */
  }, {
    key: "trackInitialSelection",
    value: function trackInitialSelection() {
      if (!this.isVisible()) return;

      // Only track once - flag persists across slide navigation
      if (this.hasTrackedInitial) return;
      var _this$getComponentVal = this.getComponentValues(),
        componentA = _this$getComponentVal.componentA,
        componentB = _this$getComponentVal.componentB;
      var slideIndex = this.getCurrentSlideIndex();

      // Validate slideIndex
      this.validateSlideIndex(slideIndex);
      document.dispatchEvent(new CustomEvent('quiz:input-changed', {
        detail: {
          type: 'slider',
          fieldKey: this.entry,
          value: "".concat(componentA, "/").concat(componentB),
          valueLabel: "".concat(this.componentB, ": ").concat(componentA, "%, ").concat(this.componentA, ": ").concat(componentB, "%"),
          unit: '%',
          source: 'default_value',
          slideIndex: slideIndex
        }
      }));
      this.hasTrackedInitial = true;
    }

    /**
     * Update dog name in title or show fallback text
     */
  }, {
    key: "updateDogName",
    value: function updateDogName() {
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      var dogName = quizData.dogName || quizData.name;
      var nameSpan = this.querySelector('.dog-name');

      // If there's a .dog-name placeholder
      if (nameSpan) {
        if (dogName && dogName.trim() !== '') {
          // Update with actual dog name
          nameSpan.textContent = dogName;
        } else if (this.titleContainer && this.nothingFoundText) {
          // Show "Nothing found" only if name placeholder exists but no name available
          this.titleContainer.innerHTML = this.nothingFoundText;
        }
      }
      // If no .dog-name placeholder exists, do nothing (title doesn't need dog name)
    }
  }, {
    key: "enableNextButton",
    value: function enableNextButton() {
      // Only enable if visible on current slide
      if (!this.isVisible()) {
        return;
      }
      var nextButton = document.querySelector('.button--next');
      if (nextButton) {
        nextButton.classList.remove('button--disabled');
        nextButton.disabled = false;
      }
    }

    // Save state to localStorage
  }, {
    key: "saveState",
    value: function saveState() {
      var isUserInteraction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      if (!quizData.twoSliderStates) {
        quizData.twoSliderStates = {};
      }
      var _this$getComponentVal2 = this.getComponentValues(),
        componentA = _this$getComponentVal2.componentA,
        componentB = _this$getComponentVal2.componentB;
      quizData.twoSliderStates[this.entry] = _defineProperty(_defineProperty({}, this.componentB, componentA), this.componentA, componentB);
      localStorage.setItem('quiz', JSON.stringify(quizData));

      // Dispatch tracking event only for user interactions (not initial/default values)
      if (this.isVisible() && isUserInteraction) {
        document.dispatchEvent(new CustomEvent('quiz:input-changed', {
          detail: {
            type: 'slider',
            fieldKey: this.entry,
            value: "".concat(componentA, "/").concat(componentB),
            valueLabel: "".concat(this.componentB, ": ").concat(componentA, "%, ").concat(this.componentA, ": ").concat(componentB, "%"),
            unit: '%',
            source: 'user_interaction',
            slideIndex: this.getCurrentSlideIndex()
          }
        }));
      }
    }

    // Restore state from localStorage
  }, {
    key: "restoreState",
    value: function restoreState() {
      var _quizData$twoSliderSt2;
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      var entryState = (_quizData$twoSliderSt2 = quizData.twoSliderStates) === null || _quizData$twoSliderSt2 === void 0 ? void 0 : _quizData$twoSliderSt2[this.entry];
      if (entryState && entryState[this.componentA] !== undefined && entryState[this.componentB] !== undefined) {
        var restoredB = parseFloat(entryState[this.componentA]);
        this.currentRatio = Math.min(100, Math.max(0, restoredB));
      } else {
        this.currentRatio = this.defaultRatio;
        this.saveState(false); // Initial save, not user interaction
      }
    }
  }, {
    key: "getComponentValues",
    value: function getComponentValues() {
      var componentA = 100 - this.currentRatio;
      var componentB = this.currentRatio;
      return {
        componentA: componentA,
        componentB: componentB
      };
    }

    // Update all displays
  }, {
    key: "updateDisplay",
    value: function updateDisplay() {
      var _this$getComponentVal3 = this.getComponentValues(),
        componentA = _this$getComponentVal3.componentA,
        componentB = _this$getComponentVal3.componentB;
      if (this.rangeInput) {
        this.rangeInput.value = this.currentRatio;
      }
      if (this.displayComponentA) {
        this.displayComponentA.textContent = componentA;
      }
      if (this.displayComponentB) {
        this.displayComponentB.textContent = componentB;
      }
      var centerLabel = this.querySelector('.two-sliders-label__percentage[data-position="center"]');
      if (centerLabel) {
        centerLabel.textContent = "".concat(componentA, "% / ").concat(componentB, "%");
      }

      // Update tooltip position
      this.positionTooltip();
    }

    // Position tooltip based on slider thumb position
  }, {
    key: "positionTooltip",
    value: function positionTooltip() {
      if (!this.tooltip || !this.rangeInput) return;
      var percent = this.currentRatio / 100;
      // Account for thumb width (33px) to center tooltip
      var thumbOffset = 16.5; // half of thumb width
      var trackWidth = this.rangeInput.offsetWidth - 33; // subtract thumb width
      var position = percent * trackWidth + thumbOffset;
      this.tooltip.style.left = "".concat(position, "px");
      this.tooltip.style.display = 'block';
    }

    // Update label highlighting based on position
  }, {
    key: "updateLabels",
    value: function updateLabels() {
      var _this$getComponentVal4 = this.getComponentValues(),
        componentA = _this$getComponentVal4.componentA,
        componentB = _this$getComponentVal4.componentB;
      this.labelPercentages.forEach(function (label) {
        var position = label.dataset.position;
        var isHighlighted = false;
        if (position === 'left' && componentA === 100) {
          isHighlighted = true;
        } else if (position === 'center' && componentA === 50 && componentB === 50) {
          isHighlighted = true;
        } else if (position === 'right' && componentB === 100) {
          isHighlighted = true;
        }
        var labelParent = label.closest('.two-sliders-label');
        if (labelParent) {
          labelParent.classList.toggle('is-active', isHighlighted);
        }
      });
    }

    // Handle range input change (while dragging)
  }, {
    key: "handleRangeInput",
    value: function handleRangeInput(e) {
      var rawValue = parseFloat(e.target.value);
      this.currentRatio = rawValue;
      this.updateDisplay();
      // this.updateLabels();
      this.hideTooltip();
    }

    // Hide tooltip on interaction
  }, {
    key: "hideTooltip",
    value: function hideTooltip() {
      if (this.tooltip && !this.isTooltipHidden) {
        this.isTooltipHidden = true;
        this.tooltip.style.display = 'none';
      }
    }

    // Handle range input change end (after release)
  }, {
    key: "handleRangeChange",
    value: function handleRangeChange(e) {
      // Round to nearest step on release
      var rawValue = parseFloat(e.target.value);
      var oldRatio = this.currentRatio;
      this.currentRatio = Math.round(rawValue / this.step) * this.step;

      // Reset tracking flag if value changed (allow re-tracking)
      if (oldRatio !== this.currentRatio) {
        this.hasTrackedInitial = false;
      }
      this.updateDisplay();
      // this.updateLabels();
      this.saveState(true); // User interaction
      this.validateInputs();
    }

    // Validate inputs (always valid since it's a constrained slider)
  }, {
    key: "validateInputs",
    value: function validateInputs() {
      if (this.quizContainer && typeof this.quizContainer.validateInputs === 'function') {
        this.quizContainer.validateInputs();
      }
    }

    // Check if value is valid (always true for this component)
  }, {
    key: "isValid",
    value: function isValid() {
      return true;
    }

    // Set event listeners
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this3 = this;
      if (this.rangeInput) {
        // Update display while dragging
        this.rangeInput.addEventListener('input', function (e) {
          return _this3.handleRangeInput(e);
        });
        // Snap to step and save on release
        this.rangeInput.addEventListener('change', function (e) {
          return _this3.handleRangeChange(e);
        });
        // Hide tooltip on interaction start
        this.rangeInput.addEventListener('mousedown', function () {
          return _this3.hideTooltip();
        });
        this.rangeInput.addEventListener('touchstart', function () {
          return _this3.hideTooltip();
        });
      }
    }

    /**
     * Reset component to initial state
     */
  }, {
    key: "reset",
    value: function reset() {
      this.currentRatio = this.defaultRatio;
      this.isTooltipHidden = false;
      this.hasTrackedInitial = false;
      this.updateDisplay();

      // Save reset state to localStorage (without tracking)
      this.saveState(false);

      // Show tooltip again
      if (this.tooltip) {
        this.tooltip.style.display = 'block';
        this.positionTooltip();
      }
      console.log('CustomTwoSlidersInput reset:', this.entry, 'ratio:', this.currentRatio);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomTwoSlidersInput);

/***/ }),

/***/ "./src/assets/js/quiz-components-v2/quiz-calculation-step.js":
/*!*******************************************************************!*\
  !*** ./src/assets/js/quiz-components-v2/quiz-calculation-step.js ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _QuizCalculationStep_brand = /*#__PURE__*/new WeakSet();
/**
 * Quiz Calculation Step Component
 * Shows loading animation with intentional delay before results
 */
var QuizCalculationStep = /*#__PURE__*/function (_HTMLElement) {
  function QuizCalculationStep() {
    var _this;
    _classCallCheck(this, QuizCalculationStep);
    _this = _callSuper(this, QuizCalculationStep);
    /**
     * Set headline text with or without pet name
     * @private
     */
    _classPrivateMethodInitSpec(_this, _QuizCalculationStep_brand);
    _this.animationDuration = parseInt(_this.dataset.duration) || 2500;
    _this.headlineTemplate = _this.dataset.headline || '';
    _this.headlineNoName = _this.dataset.headlineNoName || '';
    _this.isAnimating = false;
    _this.animationTimeout = null;
    _this.maxWaitTimeout = null;
    _this.loadingStates = {
      product: false,
      newProductSection: false
    };
    _this.animationComplete = false;
    return _this;
  }
  _inherits(QuizCalculationStep, _HTMLElement);
  return _createClass(QuizCalculationStep, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.headlineElement = this.querySelector('[data-calculation-text]');
      this.progressBar = this.querySelector('quiz-progress-bar');

      // Hide calculation step by default
      this.classList.add('tw-hidden');

      // Setup loading event listeners
      this.setupLoadingListeners();
    }

    /**
     * Setup listeners for component loading events
     */
  }, {
    key: "setupLoadingListeners",
    value: function setupLoadingListeners() {
      var _this2 = this;
      // Listen for custom-product-output loading
      document.addEventListener('product:loadingStart', function () {
        _this2.loadingStates.product = true;
        console.log('QuizCalculationStep: Product loading started');
      });
      document.addEventListener('product:loadingComplete', function () {
        _this2.loadingStates.product = false;
        console.log('QuizCalculationStep: Product loading complete');
        _this2.checkAndComplete();
      });

      // Listen for new-product-section loading
      document.addEventListener('newProductSection:loadingStart', function () {
        _this2.loadingStates.newProductSection = true;
        console.log('QuizCalculationStep: NewProductSection loading started');
      });
      document.addEventListener('newProductSection:loadingComplete', function () {
        _this2.loadingStates.newProductSection = false;
        console.log('QuizCalculationStep: NewProductSection loading complete');
        _this2.checkAndComplete();
      });
    }

    /**
     * Check if animation and all loading complete, then finish
     */
  }, {
    key: "checkAndComplete",
    value: function checkAndComplete() {
      console.log('QuizCalculationStep: Check completion', {
        animationComplete: this.animationComplete,
        productLoading: this.loadingStates.product,
        newProductSectionLoading: this.loadingStates.newProductSection
      });

      // Only complete if animation is done AND all components loaded
      if (this.animationComplete && !this.loadingStates.product && !this.loadingStates.newProductSection) {
        console.log('QuizCalculationStep: All loading complete, completing calculation');
        _assertClassBrand(_QuizCalculationStep_brand, this, _completeCalculation).call(this);
      }
    }

    /**
     * Start calculation animation
     * @param {string} petName - Name of the pet from quiz data
     */
  }, {
    key: "startCalculation",
    value: function startCalculation() {
      var _this3 = this;
      var petName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (this.isAnimating) return;
      this.isAnimating = true;
      this.animationComplete = false;

      // Reset loading states to prevent hanging from previous states
      this.loadingStates = {
        product: false,
        newProductSection: false
      };

      // Show the component
      this.classList.remove('tw-hidden');

      // Lock body scroll to prevent scrolling during loading
      _assertClassBrand(_QuizCalculationStep_brand, this, _lockBodyScroll).call(this);

      // Set headline with pet name
      _assertClassBrand(_QuizCalculationStep_brand, this, _setHeadline).call(this, petName);

      // Show and set progress bar to 97%
      if (this.progressBar) {
        this.progressBar.classList.remove('tw-hidden');
        this.progressBar.setCalculationProgress();
      }

      // Start animation timer
      this.animationTimeout = setTimeout(function () {
        _this3.animationComplete = true;
        console.log('QuizCalculationStep: Animation complete');
        _this3.checkAndComplete();
      }, this.animationDuration);

      // Failsafe: Force completion after max wait time (animation duration + 3 seconds)
      this.maxWaitTimeout = setTimeout(function () {
        console.warn('QuizCalculationStep: Max wait time exceeded, forcing completion');
        _this3.animationComplete = true;
        _this3.loadingStates.product = false;
        _this3.loadingStates.newProductSection = false;
        _assertClassBrand(_QuizCalculationStep_brand, _this3, _completeCalculation).call(_this3);
      }, this.animationDuration + 3000);
    }
  }, {
    key: "cancelCalculation",
    value:
    /**
     * Cancel ongoing animation (e.g., if user navigates back)
     */
    function cancelCalculation() {
      if (this.animationTimeout) {
        clearTimeout(this.animationTimeout);
        this.animationTimeout = null;
      }
      if (this.maxWaitTimeout) {
        clearTimeout(this.maxWaitTimeout);
        this.maxWaitTimeout = null;
      }
      this.isAnimating = false;
      this.animationComplete = false;
      this.loadingStates = {
        product: false,
        newProductSection: false
      };

      // Unlock body scroll
      _assertClassBrand(_QuizCalculationStep_brand, this, _unlockBodyScroll).call(this);
      this.classList.add('tw-hidden');
    }

    /**
     * Lock body scroll to prevent scrolling during loading
     * @private
     */
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.cancelCalculation();
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
function _setHeadline(petName) {
  if (!this.headlineElement) return;
  var headlineText = '';
  if (petName && petName.trim() !== '') {
    // Use template with name - replace both [name] and {name} placeholders
    headlineText = this.headlineTemplate.replace(/\[name\]/gi, petName.trim()).replace(/\{name\}/gi, petName.trim());
  } else {
    // Use template without name
    headlineText = this.headlineNoName;
  }
  this.headlineElement.textContent = headlineText;
}
/**
 * Complete calculation and trigger next step
 * @private
 */
function _completeCalculation() {
  // Clear all timeouts
  if (this.animationTimeout) {
    clearTimeout(this.animationTimeout);
    this.animationTimeout = null;
  }
  if (this.maxWaitTimeout) {
    clearTimeout(this.maxWaitTimeout);
    this.maxWaitTimeout = null;
  }
  this.isAnimating = false;
  this.animationComplete = false;

  // Dispatch custom event to quiz container
  this.dispatchEvent(new CustomEvent('calculation-complete', {
    bubbles: true,
    detail: {
      timestamp: Date.now()
    }
  }));

  // Unlock body scroll
  _assertClassBrand(_QuizCalculationStep_brand, this, _unlockBodyScroll).call(this);

  // Hide the component
  this.classList.add('tw-hidden');
}
function _lockBodyScroll() {
  document.body.style.overflow = 'hidden';
  document.body.style.position = 'fixed';
  document.body.style.width = '100%';
  document.body.style.height = '100%';
}
/**
 * Unlock body scroll after loading completes
 * @private
 */
function _unlockBodyScroll() {
  document.body.style.overflow = '';
  document.body.style.position = '';
  document.body.style.width = '';
  document.body.style.height = '';
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (QuizCalculationStep);

/***/ }),

/***/ "./src/assets/js/quiz-components-v2/quiz-container.js":
/*!************************************************************!*\
  !*** ./src/assets/js/quiz-components-v2/quiz-container.js ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lz_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lz-string */ "./node_modules/lz-string/libs/lz-string.js");
/* harmony import */ var lz_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lz_string__WEBPACK_IMPORTED_MODULE_0__);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }

var QuizContainer = /*#__PURE__*/function (_HTMLElement) {
  function QuizContainer() {
    var _this$nextButton;
    var _this;
    _classCallCheck(this, QuizContainer);
    _this = _callSuper(this, QuizContainer);
    _this.slider = _this.querySelector('.swiper');
    _this.buttonWrapper = _this.querySelector('.buttons-wrapper');
    _this.prevButton = _this.querySelector('.button--previous');
    _this.nextButton = _this.querySelector('.button--next');
    _this.nextButtonDefaultText = (_this$nextButton = _this.nextButton) === null || _this$nextButton === void 0 ? void 0 : _this$nextButton.dataset.defaulttext;
    _this.footer = _this.querySelector('quiz-footer');
    _this.allowedToShowWarning = false;
    _this.stepSettings = JSON.parse(_this.querySelector('script[data-steps-info]').innerHTML);
    _this.quizRezult = _this.querySelector('quiz-result-page');
    _this.cartFeatures = _this.querySelector('.quiz-cart__feature');
    _this.googleFormUrl = _this.dataset.googleformurl;
    _this.utmParams = _this.getUTMParams(); // Added to store UTM parameters
    _this.quizContainer = _this.closest('quiz-container');
    _this.introCompleted = false; // Track if intro screen has been completed
    _this.checkoutMode = (_this.dataset.checkoutMode || 'cart').toLowerCase();
    _this.discountStorageKey = 'quiz_discount_code';
    _this.calculationStep = _this.querySelector('quiz-calculation-step');
    _this.isShowingCalculation = false;
    _this.calculationShownForSlide = null;
    // Main progress bar reference (excluding the one inside calculation-step)
    _this.mainProgressBar = _this.querySelector('quiz-progress-bar:not(quiz-calculation-step quiz-progress-bar)');
    _this.breedSelector = _this.querySelector('breed-radio-selector');
    _this.maxProgressReached = 0; // Track maximum progress for clamping
    _this.previousSlideIndex = 0; // Track previous slide for navigation direction
    _this.defaultBreed = _this.dataset.defaultBreed;
    _this.quizStartTracked = false; // Track if quiz_start event was fired in this session
    _this.recommendationTracked = false; // Track if quiz_recommendation_ready was fired
    _this.trackedSlides = new Set(); // Track which slides have had their default values tracked
    _this.trackedStepData = {}; // Track what data has been pushed to dataLayer for each step
    _this.customIssueInput = _this.querySelector('.custom-issue__input');

    // Static mapping: entry/fieldKey -> hardcoded step name
    _this.stepMapping = {
      dogName: 'step_1_dogname',
      gender: 'step_0_gender',
      'entry.62437307': 'step_2_breed',
      'entry.249999288': 'step_3_healthissues',
      breed_image_slider: 'step_4_breed_image_slider',
      age: 'step_5_dogage',
      'entry.306846565': 'step_6_foodsplit',
      protein_selections: 'step_7_protein',
      'entry.571080194': 'step_8_weight_kastrait',
      'entry.724027174': 'step_8_weight_kastrait',
      'entry.2024690081': 'step_9_activity_level',
      'entry.1373088848': 'step_10_body_condition',
      body_condition: 'step_10_body_condition',
      snacks: 'step_11_snacks',
      klaviyo_email: 'step_12_klaviyo_step'
    };
    _this.slideToStepMapping = {
      0: 'step_1_dogname',
      // Slide 0 → Step 1
      1: 'step_2_breed',
      // Slide 1 → Step 2
      2: 'step_3_healthissues',
      // Slide 2 → Step 3
      3: 'step_4_breed_image_slider',
      // Slide 3 → Step 4
      4: 'step_5_dogage',
      // Slide 4 → Step 5
      5: 'step_6_foodsplit',
      // Slide 5 → Step 6
      6: 'step_7_protein',
      // Slide 6 → Step 7
      7: 'step_8_weight_kastrait',
      // Slide 7 → Step 8
      8: 'step_9_activity_level',
      // Slide 8 → Step 9
      9: 'step_10_body_condition',
      // Slide 9 → Step 10
      10: 'step_11_snacks',
      // Slide 10 → Step 11
      11: 'step_12_klaviyo_step' // Slide 11 → Step 12
    };
    _this._swiperReady = false;
    return _this;
  }

  /**
   * Restore minimal quiz state from URL ?q= param (used in email links).
   * Must be called synchronously at the start of connectedCallback so that
   * child components see the restored localStorage data when they connect.
   */
  _inherits(QuizContainer, _HTMLElement);
  return _createClass(QuizContainer, [{
    key: "restoreFromUrlParam",
    value: function restoreFromUrlParam() {
      var params = new URLSearchParams(window.location.search);
      var encoded = params.get('q');
      if (!encoded) return;
      try {
        var state = JSON.parse(lz_string__WEBPACK_IMPORTED_MODULE_0___default().decompressFromEncodedURIComponent(encoded));
        var existing = JSON.parse(localStorage.getItem('quiz') || '{}');
        // URL state takes priority; preserve only keys not in the URL state (e.g. currentSlide)
        var merged = _objectSpread({}, existing);
        for (var _i = 0, _Object$keys = Object.keys(state); _i < _Object$keys.length; _i++) {
          var key = _Object$keys[_i];
          merged[key] = state[key];
        }
        localStorage.setItem('quiz', JSON.stringify(merged));
        this._jumpToResults = true;
      } catch (error) {
        console.error('QuizContainer: Error restoring from URL param:', error);
      }
    }
  }, {
    key: "initLocalStorage",
    value: function initLocalStorage() {
      var _this2 = this;
      // Check if 'quiz' object exists in localStorage, if not, create it
      if (!localStorage.getItem('quiz')) {
        localStorage.setItem('quiz', JSON.stringify({
          currentSlide: 0,
          inputs: {}
        }));
      } else {
        // Jump to result slide if state was restored from URL param (?q=...)
        if (this._jumpToResults) {
          if (this._swiperReady) {
            var slides = Array.from(this.slider.querySelectorAll('.swiper-slide'));
            var resultIndex = slides.findIndex(function (s) {
              return s.classList.contains('swiper-slider__result-step');
            });
            if (resultIndex > -1) {
              setTimeout(function () {
                _this2.slider.classList.remove('!tw-hidden');
                _this2.activeSlider.update();
                _this2.activeSlider.slideTo(resultIndex, 0);
              }, 0);
            }
            document.dispatchEvent(new CustomEvent('quiz:calculationsComplete'));
            return;
          }
        }
        var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
        if (quizData.currentSlide !== undefined) {
          setTimeout(function () {
            return _this2.activeSlider.slideTo(quizData.currentSlide);
          }, 0); // Navigate to last viewed slide
        }
      }
    }
  }, {
    key: "getStepNameFromSlideIndex",
    value: function getStepNameFromSlideIndex(slideIndex) {
      var stepName = this.slideToStepMapping[slideIndex];
      return stepName || "step_unknown_".concat(slideIndex);
    }
  }, {
    key: "extractStepNumber",
    value: function extractStepNumber(stepName) {
      if (!stepName || typeof stepName !== 'string') {
        console.warn('[GTM] Invalid stepName:', stepName);
        return 0;
      }

      // Match pattern: step_{number}_...
      var match = stepName.match(/^step_(\d+)_/);
      if (match && match[1]) {
        return parseInt(match[1], 10);
      }
      return 0;
    }
  }, {
    key: "getStepName",
    value: function getStepName(fieldKey) {
      return this.stepMapping[fieldKey] || "step_unknown_".concat(fieldKey);
    }

    /**
     * Push event to GTM dataLayer
     */
  }, {
    key: "pushToDataLayer",
    value: function pushToDataLayer(eventName) {
      var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(_objectSpread({
        event: eventName
      }, parameters));
    }

    /**
     * Calculate progress percentage based on slide index
     * Uses clamping - progress never decreases when navigating back
     * @param {number|null} slideIndex - Optional slide index to calculate progress for (defaults to activeIndex)
     */
  }, {
    key: "calculateProgress",
    value: function calculateProgress() {
      var slideIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (!this.activeSlider || !this.activeSlider.slides) return 0;
      var totalSlides = this.activeSlider.slides.length;
      var indexToUse = slideIndex !== null ? slideIndex : this.activeSlider.activeIndex;

      // Calculate current progress
      var currentProgress = Math.round((indexToUse + 1) / totalSlides * 100);

      // Clamp: progress never goes down
      this.maxProgressReached = Math.max(this.maxProgressReached, currentProgress);
      return Math.min(this.maxProgressReached, 100);
    }

    /**
     * Get dog name from quiz data
     */
  }, {
    key: "getDogName",
    value: function getDogName() {
      var _quizData$dogName;
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      var name = (_quizData$dogName = quizData.dogName) === null || _quizData$dogName === void 0 ? void 0 : _quizData$dogName.trim();
      return name || null;
    }

    /**
     * Get dog name label (fallback to "your dog" if empty)
     */
  }, {
    key: "getDogNameLabel",
    value: function getDogNameLabel() {
      var name = this.getDogName();
      return name || 'your dog';
    }
  }, {
    key: "getDiscountCodeFromUrl",
    value: function getDiscountCodeFromUrl() {
      var params = new URLSearchParams(window.location.search || '');
      var keys = ['discount', 'discount_code', 'discountCode', 'code', 'coupon', 'promo', 'promocode'];
      for (var _i2 = 0, _keys = keys; _i2 < _keys.length; _i2++) {
        var key = _keys[_i2];
        var value = params.get(key);
        if (value && value.trim()) {
          return value.trim();
        }
      }
      return '';
    }
  }, {
    key: "getDiscountCodeFromCookie",
    value: function getDiscountCodeFromCookie() {
      var cookies = document.cookie ? document.cookie.split(';') : [];
      var names = ['discount_code', 'discount', 'discountCode'];
      var _iterator = _createForOfIteratorHelper(cookies),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var rawCookie = _step.value;
          var _rawCookie$split = rawCookie.split('='),
            _rawCookie$split2 = _toArray(_rawCookie$split),
            name = _rawCookie$split2[0],
            rest = _rawCookie$split2.slice(1);
          if (!name || rest.length === 0) continue;
          var key = name.trim();
          if (!names.includes(key)) continue;
          var value = rest.join('=').trim();
          if (value) {
            return decodeURIComponent(value);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return '';
    }
  }, {
    key: "getStoredDiscountCode",
    value: function getStoredDiscountCode() {
      var storedSession = sessionStorage.getItem(this.discountStorageKey);
      if (storedSession && storedSession.trim()) {
        return storedSession.trim();
      }
      return '';
    }
  }, {
    key: "setStoredDiscountCode",
    value: function setStoredDiscountCode(code) {
      if (!code || !code.trim()) return;
      var cleanCode = code.trim();
      sessionStorage.setItem(this.discountStorageKey, cleanCode);
    }
  }, {
    key: "captureDiscountCodeFromUrl",
    value: function captureDiscountCodeFromUrl() {
      var urlCode = this.getDiscountCodeFromUrl();
      if (!urlCode) return;
      var stored = this.getStoredDiscountCode();
      if (stored) return;
      this.setStoredDiscountCode(urlCode);
    }
  }, {
    key: "getCheckoutDiscountCode",
    value: function getCheckoutDiscountCode() {
      var stored = this.getStoredDiscountCode();
      if (stored) return stored;
      var urlCode = this.getDiscountCodeFromUrl();
      if (urlCode) {
        this.setStoredDiscountCode(urlCode);
        return urlCode;
      }
      var cookieCode = this.getDiscountCodeFromCookie();
      if (cookieCode) return cookieCode;
      return 'SAVE30';
    }
  }, {
    key: "buildCheckoutUrlWithDiscount",
    value: function buildCheckoutUrlWithDiscount() {
      var discountCode = this.getCheckoutDiscountCode();
      if (discountCode) {
        return "/discount/".concat(encodeURIComponent(discountCode), "?redirect=/checkout");
      }
      return '/checkout';
    }

    /**
     * Check if step data should be tracked (prevent duplicates)
     * @param {string} stepName - Hardcoded step name (e.g., 'step_1_dogname')
     * @param {string} fieldKey - Field key/entry
     * @param {*} value - Current value
     * @param {string} source - Source of change (user_interaction, default_value)
     * @returns {boolean} True if should track, false if already tracked with same value
     */
  }, {
    key: "shouldTrackStep",
    value: function shouldTrackStep(stepName, fieldKey, value) {
      var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'default_value';
      var trackingKey = "".concat(stepName, "_").concat(fieldKey);

      // Always track user interactions and prefill (they can change values)
      if (source === 'user_interaction' || source === 'prefill') {
        this.trackedStepData[trackingKey] = {
          value: value,
          source: source
        };
        return true;
      }

      // For default values, only track if not already tracked
      if (!this.trackedStepData[trackingKey]) {
        this.trackedStepData[trackingKey] = {
          value: value,
          source: source
        };
        return true;
      }

      // If value changed, allow re-tracking
      var previousValue = this.trackedStepData[trackingKey].value;
      if (JSON.stringify(previousValue) !== JSON.stringify(value)) {
        this.trackedStepData[trackingKey] = {
          value: value,
          source: source
        };
        return true;
      }

      // Already tracked with same value, skip
      return false;
    }

    /**
     * Track quiz step view
     * Note: stepName here is the slide title from Liquid, not the hardcoded step name
     */
  }, {
    key: "trackStepView",
    value: function trackStepView(stepIndex, liquidTitle) {
      var stepName = this.getStepNameFromSlideIndex(stepIndex);
      var stepNumber = this.extractStepNumber(stepName);
      this.pushToDataLayer('quiz_step_view', {
        step_index: stepNumber,
        step_name: stepName
      });
    }

    /**
     * Track single selection (radio, dropdown, text)
     * @param {string} fieldKey - Field key/entry
     * @param {*} value - Selected value
     * @param {string} valueLabel - Label for value (not used in new format)
     * @param {boolean} isName - Whether this is name field
     * @param {number|null} slideIndex - Optional slide index (for progress calculation only)
     * @param {string} source - Source of change (user_interaction, default_value)
     */
  }, {
    key: "trackSelection",
    value: function trackSelection(fieldKey, value, valueLabel) {
      var _this$activeSlider;
      var isName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var slideIndex = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var source = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'user_interaction';
      // Get hardcoded step name from mapping
      var stepName = isName ? this.getStepName('dogName') : this.getStepName(fieldKey);

      // Extract step number from step_name (e.g., step_8_weight_kastrait → 8)
      var stepNumber = this.extractStepNumber(stepName);

      // Check if we should track this step (prevent duplicates)
      if (!this.shouldTrackStep(stepName, fieldKey, value, source)) {
        return;
      }
      var index = slideIndex !== null ? slideIndex : ((_this$activeSlider = this.activeSlider) === null || _this$activeSlider === void 0 ? void 0 : _this$activeSlider.activeIndex) || 0;
      var eventData = {
        step_name: stepName,
        step_index: stepNumber,
        // Use extracted number from step_name
        progress_percent: this.calculateProgress(index)
      };

      // For step_1, dog name only (gender is now tracked separately as step_0_gender)
      if (stepName === 'step_1_dogname_gender') {
        eventData[stepName] = value;
        // For step_8, combine weight and kastration into single object
      } else if (stepName === 'step_8_weight_kastrait') {
        var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
        if (fieldKey === 'entry.724027174') {
          var _quizData$sliderState;
          // Kastration radio - combine with weight
          eventData[stepName] = {
            weight: ((_quizData$sliderState = quizData.sliderStates) === null || _quizData$sliderState === void 0 ? void 0 : _quizData$sliderState['entry.571080194']) || null,
            kastrait: value
          };
        } else {
          // Other radio for this step (shouldn't happen, but fallback)
          eventData[stepName] = value;
        }
      } else {
        // New simplified format: step_name as key, value directly
        eventData[stepName] = value;
      }
      this.pushToDataLayer('quiz_selection', eventData);
    }

    /**
     * Track multi selection (checkboxes)
     * @param {string} fieldKey - Field key/entry
     * @param {Array|Object} selected - Array of selected values OR object for non-dog-issue with custom text
     * @param {number|null} slideIndex - Optional slide index (for progress calculation only)
     * @param {string} source - Source of change (user_interaction, default_value)
     */
  }, {
    key: "trackMultiSelect",
    value: function trackMultiSelect(fieldKey, selected) {
      var _this$activeSlider2;
      var slideIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'user_interaction';
      var stepName = this.getStepName(fieldKey);
      var stepNumber = this.extractStepNumber(stepName);
      if (!this.shouldTrackStep(stepName, fieldKey, selected, source)) {
        return;
      }
      var index = slideIndex !== null ? slideIndex : ((_this$activeSlider2 = this.activeSlider) === null || _this$activeSlider2 === void 0 ? void 0 : _this$activeSlider2.activeIndex) || 0;
      var eventData = {
        step_name: stepName,
        step_index: stepNumber,
        // Use extracted number
        progress_percent: this.calculateProgress(index)
      };
      if (selected && _typeof(selected) === 'object' && !Array.isArray(selected)) {
        eventData[stepName] = selected;
      } else {
        eventData[stepName] = selected;
      }
      this.pushToDataLayer('quiz_multi_select', eventData);
    }

    /**
     * Track slider value
     * @param {string} fieldKey - Field key/entry
     * @param {*} value - Slider value
     * @param {string} valueLabel - Label for value (not used in new format)
     * @param {string|null} unit - Unit of measurement (not used in new format)
     * @param {string|null} source - Source of change (user_interaction, default_value)
     * @param {number|null} slideIndex - Optional slide index (for progress calculation only)
     */
  }, {
    key: "trackSliderSet",
    value: function trackSliderSet(fieldKey, value, valueLabel) {
      var _this$activeSlider3;
      var unit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var source = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'user_interaction';
      var slideIndex = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
      var stepName = this.getStepName(fieldKey);
      var stepNumber = this.extractStepNumber(stepName);
      var validatedValue = value !== undefined && value !== null ? value : 0;
      if (!this.shouldTrackStep(stepName, fieldKey, validatedValue, source)) {
        return;
      }
      var index = slideIndex !== null ? slideIndex : ((_this$activeSlider3 = this.activeSlider) === null || _this$activeSlider3 === void 0 ? void 0 : _this$activeSlider3.activeIndex) || 0;
      var eventData = {
        step_name: stepName,
        step_index: stepNumber,
        // Use extracted number
        progress_percent: this.calculateProgress(index)
      };
      if (stepName === 'step_8_weight_kastrait') {
        var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
        if (fieldKey === 'entry.571080194') {
          var _quizData$radioStates;
          eventData[stepName] = {
            weight: validatedValue,
            kastrait: ((_quizData$radioStates = quizData.radioStates) === null || _quizData$radioStates === void 0 ? void 0 : _quizData$radioStates['entry.724027174']) || null
          };
        } else if (fieldKey === 'entry.724027174') {
          var _quizData$sliderState2;
          eventData[stepName] = {
            weight: ((_quizData$sliderState2 = quizData.sliderStates) === null || _quizData$sliderState2 === void 0 ? void 0 : _quizData$sliderState2['entry.571080194']) || null,
            kastrait: validatedValue
          };
        }
      } else {
        eventData[stepName] = validatedValue;
      }
      this.pushToDataLayer('quiz_slider_set', eventData);
    }

    /**
     * Track combined weight + kastrait for step 7
     * Combines data from slider (weight) and radio (kastrait) components
     * @param {string} type - 'weight' or 'kastrait'
     * @param {*} value - Value to store
     * @param {string} valueLabel - Label for value
     * @param {number} slideIndex - Slide index
     */
  }, {
    key: "trackStep7Combined",
    value: function trackStep7Combined(type, value, valueLabel, slideIndex) {
      // Store the value
      this.step7Data[type] = {
        value: value,
        valueLabel: valueLabel
      };

      // Only push to dataLayer when both values are available
      if (this.step7Data.weight && this.step7Data.kastrait) {
        var stepName = 'step_8_weight_kastrait';
        var stepNumber = this.extractStepNumber(stepName);

        // Combine values: "5kg, Ja"
        var combinedValue = "".concat(this.step7Data.weight.value, "kg, ").concat(this.step7Data.kastrait.value);
        var combinedLabel = "".concat(this.step7Data.weight.valueLabel, ", ").concat(this.step7Data.kastrait.valueLabel);
        var eventData = {
          step_id: "step_".concat(stepNumber),
          step_index: stepNumber,
          step_name: stepName,
          progress_percent: this.calculateProgress(slideIndex),
          field_key: 'weight_kastrait'
        };
        eventData["".concat(stepPrefix, "_value")] = combinedValue;
        eventData["".concat(stepPrefix, "_value_label")] = [combinedLabel];
        eventData["".concat(stepPrefix, "_selected")] = [this.step7Data.weight.value, this.step7Data.kastrait.value];
        this.pushToDataLayer('quiz_step7_combined', eventData);
      }
    }

    /**
     * Track body condition slider
     * @param {number} rawPosition - Raw position (0-4)
     * @param {*} mappedValue - Mapped value
     * @param {number|null} slideIndex - Optional slide index (for progress calculation only)
     * @param {string} source - Source of change (user_interaction, default_value)
     */
  }, {
    key: "trackBodyConditionSet",
    value: function trackBodyConditionSet(rawPosition, mappedValue) {
      var _this$activeSlider4;
      var slideIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'user_interaction';
      var conditionLabels = ['Deutlich unter-gewichtig', 'Leichtes unter-gewichtig', 'Genau richtig', 'Etwas über-gewichtig', 'Stark über-gewichtig'];
      var fieldKey = 'body_condition';
      var stepName = this.getStepName(fieldKey);
      var stepNumber = this.extractStepNumber(stepName);
      if (!this.shouldTrackStep(stepName, fieldKey, rawPosition, source)) {
        return;
      }
      var index = slideIndex !== null ? slideIndex : ((_this$activeSlider4 = this.activeSlider) === null || _this$activeSlider4 === void 0 ? void 0 : _this$activeSlider4.activeIndex) || 0;
      var eventData = {
        step_name: stepName,
        step_index: stepNumber,
        // Use extracted number
        progress_percent: this.calculateProgress(index)
      };
      eventData[stepName] = conditionLabels[rawPosition] || mappedValue;
      this.pushToDataLayer('quiz_body_condition_set', eventData);
    }

    /**
     * Track breed selection (handles both single and multiple breeds)
     * @param {string} fieldKey - Field key/entry
     * @param {string|Array} value - Breed value(s) - string for purebred/not_sure, array for mixed
     * @param {string} valueLabel - Label for display (not used in new format)
     * @param {string} breedType - Type of breed selection (purebred, mixed, not_sure)
     * @param {number|null} slideIndex - Optional slide index (for progress calculation only)
     * @param {string} source - Source of change (user_interaction, default_value)
     */
  }, {
    key: "trackBreedSelection",
    value: function trackBreedSelection(fieldKey, value) {
      var _this$activeSlider5;
      var slideIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'user_interaction';
      var stepName = this.getStepName(fieldKey);
      var stepNumber = this.extractStepNumber(stepName);
      if (!this.shouldTrackStep(stepName, fieldKey, value, source)) {
        return;
      }
      var index = slideIndex !== null ? slideIndex : ((_this$activeSlider5 = this.activeSlider) === null || _this$activeSlider5 === void 0 ? void 0 : _this$activeSlider5.activeIndex) || 0;
      var eventData = {
        step_name: stepName,
        step_index: stepNumber,
        progress_percent: this.calculateProgress(index)
      };
      eventData[stepName] = value;
      this.pushToDataLayer('quiz_breed_selection', eventData);
    }

    /**
     * Track calculation start
     */
  }, {
    key: "trackCalculationStarted",
    value: function trackCalculationStarted() {
      this.pushToDataLayer('quiz_calculation_started', {
        step_name: 'Calculation',
        progress_percent: this.calculateProgress()
      });
    }

    /**
     * Track recommendation ready - only fires once per session
     */
  }, {
    key: "trackRecommendationReady",
    value: function trackRecommendationReady(products) {
      if (this.recommendationTracked) {
        return;
      }
      var quizData = JSON.parse(localStorage.getItem('quiz') || '{}');
      var productHandles = quizData.productHandles || [];
      var productQuantities = quizData.productQuantities || [];
      var productNames = quizData.productNames || [];
      var productsArray = quizData.productsArray || [];
      var subscriptionIntervallWeeks = quizData.subscriptionIntervallWeeks || 4;
      if (productHandles.length === 0) {
        console.warn('[GTM] quiz_recommendation_ready - no products to track');
        return;
      }
      this.recommendationTracked = true;
      this.pushToDataLayer('quiz_recommendation_ready', {
        step_name: 'Recommendation',
        progress_percent: 100,
        product_sku: productHandles,
        product_sku_ammount: productQuantities,
        product_names: productNames,
        products: productsArray,
        products_count: productsArray.length,
        subscription_intervall_weeks: subscriptionIntervallWeeks
      });
    }

    /**
     * Track add to cart event
     * Should be called from product components when user adds item to cart
     */
  }, {
    key: "trackAddToCart",
    value: function trackAddToCart(productData) {
      var _this$activeSlider6;
      var _ref = productData || {},
        _ref$product_sku = _ref.product_sku,
        product_sku = _ref$product_sku === void 0 ? '' : _ref$product_sku,
        _ref$monthly_quantity = _ref.monthly_quantity,
        monthly_quantity = _ref$monthly_quantity === void 0 ? 0 : _ref$monthly_quantity,
        _ref$price_total = _ref.price_total,
        price_total = _ref$price_total === void 0 ? 0 : _ref$price_total,
        _ref$currency = _ref.currency,
        currency = _ref$currency === void 0 ? 'EUR' : _ref$currency;
      this.pushToDataLayer('quiz_add_to_cart', {
        step_index: (((_this$activeSlider6 = this.activeSlider) === null || _this$activeSlider6 === void 0 ? void 0 : _this$activeSlider6.activeIndex) || 0) + 1,
        step_name: this.getCurrentStepName(),
        progress_percent: this.calculateProgress(),
        product_sku: product_sku,
        monthly_quantity: monthly_quantity,
        price_total: price_total,
        currency: currency
      });
    }

    /**
     * Get current step name from slide data
     */
  }, {
    key: "getCurrentStepName",
    value: function getCurrentStepName() {
      var _currentSlide$dataset;
      if (!this.activeSlider || !this.activeSlider.slides) return 'Unknown';
      var currentSlide = this.activeSlider.slides[this.activeSlider.activeIndex];
      return (currentSlide === null || currentSlide === void 0 || (_currentSlide$dataset = currentSlide.dataset) === null || _currentSlide$dataset === void 0 ? void 0 : _currentSlide$dataset.title) || "Step ".concat(this.activeSlider.activeIndex);
    }

    /**
     * Get step title from slide data (for display/logging purposes)
     * @param {number} slideIndex - Slide index
     * @returns {string} Step title from slide dataset
     */
  }, {
    key: "getStepTitle",
    value: function getStepTitle(slideIndex) {
      var _slide$dataset;
      if (!this.activeSlider || !this.activeSlider.slides) return 'Unknown';
      var slide = this.activeSlider.slides[slideIndex];
      return (slide === null || slide === void 0 || (_slide$dataset = slide.dataset) === null || _slide$dataset === void 0 ? void 0 : _slide$dataset.title) || "Step ".concat(slideIndex + 1);
    }

    /**
     * Setup global event listeners for tracking
     */
  }, {
    key: "setupTrackingListeners",
    value: function setupTrackingListeners() {
      var _this3 = this;
      // Listen for input changes from custom components
      document.addEventListener('quiz:input-changed', function (event) {
        var _this3$activeSlider;
        var _ref2 = event.detail || {},
          type = _ref2.type,
          fieldKey = _ref2.fieldKey,
          value = _ref2.value,
          valueLabel = _ref2.valueLabel,
          selected = _ref2.selected,
          unit = _ref2.unit,
          isName = _ref2.isName,
          source = _ref2.source,
          breedType = _ref2.breedType,
          slideIndex = _ref2.slideIndex;
        var index = slideIndex !== null && slideIndex !== undefined ? slideIndex : ((_this3$activeSlider = _this3.activeSlider) === null || _this3$activeSlider === void 0 ? void 0 : _this3$activeSlider.activeIndex) || 0;

        // Check if this is step 7 (weight_kastrait) - index 6
        var isStep7 = index === 6;
        switch (type) {
          case 'radio':
          case 'dropdown':
          case 'text':
            // Special handling for step 7 kastrait radio
            if (isStep7 && type === 'radio') {
              _this3.trackStep7Combined('kastrait', value, valueLabel, index);
            }
            _this3.trackSelection(fieldKey, value, valueLabel, isName, slideIndex);
            break;
          case 'checkbox':
            _this3.trackMultiSelect(fieldKey, selected, slideIndex);
            break;
          case 'slider':
            // Special handling for step 7 weight slider
            if (isStep7) {
              _this3.trackStep7Combined('weight', value, valueLabel, index);
            }
            _this3.trackSliderSet(fieldKey, value, valueLabel, unit, source, slideIndex);
            break;
          case 'body_condition':
            _this3.trackBodyConditionSet(value, valueLabel, slideIndex);
            break;
          case 'breed-selector':
            _this3.trackBreedSelection(fieldKey, value, valueLabel, breedType, slideIndex);
            break;
          case 'klaviyo_form':
            _this3.trackKlaviyoStep(value, slideIndex);
            break;
          case 'protein':
            _this3.trackProteinStep(value, fieldKey, slideIndex);
            break;
        }
      });
    }

    /**
     * Track protein selections step (step 7)
     * @param {object} proteinSelections - Object with protein selections {ingredient: 'yes'|'no'}
     * @param {string} fieldKey - Field key ('protein_selections')
     * @param {number} slideIndex - Slide index
     */
  }, {
    key: "trackProteinStep",
    value: function trackProteinStep(proteinSelections, fieldKey, slideIndex) {
      var stepName = this.stepMapping[fieldKey] || "step_".concat(slideIndex + 1);
      var stepNumber = this.extractStepNumber(stepName);
      var eventData = {
        step_index: stepNumber,
        // Use extracted number
        step_name: stepName,
        progress_percent: this.calculateProgress(slideIndex)
      };
      eventData[stepName] = proteinSelections;
      this.pushToDataLayer('quiz_step_change', eventData);
    }

    /**
     * Track Klaviyo form submission (step 12)
     * @param {object} formData - Form data (email, name, newsletter_optin)
     * @param {number} slideIndex - Slide index
     */
  }, {
    key: "trackKlaviyoStep",
    value: function trackKlaviyoStep(formData, slideIndex) {
      var stepName = 'step_12_klaviyo_step';
      var stepNumber = this.extractStepNumber(stepName);
      var _ref3 = formData || {},
        email = _ref3.email,
        name = _ref3.name,
        newsletter_optin = _ref3.newsletter_optin;
      var eventData = {
        step_id: "step_".concat(stepNumber),
        step_index: stepNumber,
        step_name: stepName,
        progress_percent: this.calculateProgress(slideIndex),
        field_key: 'klaviyo_form'
      };
      var combinedValue = [email, name, newsletter_optin ? 'opted_in' : 'not_opted_in'].filter(Boolean).join(', ');
      eventData["step_".concat(stepNumber, "_klaviyo_step_value")] = combinedValue;
      eventData["step_".concat(stepNumber, "_klaviyo_step_value_label")] = [combinedValue];
      eventData["step_".concat(stepNumber, "_klaviyo_step_selected")] = {
        email: email || '',
        name: name || '',
        newsletter_optin: newsletter_optin || false
      };
      this.pushToDataLayer('quiz_klaviyo_step', eventData);
    }

    /**
     * Track quiz_start event when user completes first question
     * This ensures the event fires even if intro screen was skipped
     */
  }, {
    key: "trackQuizStartOnFirstQuestion",
    value: function trackQuizStartOnFirstQuestion() {
      return;
    }

    /**
     * Track default/unchanged values when leaving a slide
     * This ensures dataLayer is updated even if user doesn't interact with inputs
     *
     * Note: This method should NOT duplicate tracking for components that already
     * track themselves via trackInitialSelection() (sliders, checkboxes, range inputs).
     * It's primarily for components without automatic tracking (like text inputs).
     */
  }, {
    key: "trackSlideDefaultValues",
    value: function trackSlideDefaultValues(slideIndex) {
      var _this$activeSlider7,
        _this4 = this;
      if (this.trackedSlides.has(slideIndex)) return;
      var slide = (_this$activeSlider7 = this.activeSlider) === null || _this$activeSlider7 === void 0 || (_this$activeSlider7 = _this$activeSlider7.slides) === null || _this$activeSlider7 === void 0 ? void 0 : _this$activeSlider7[slideIndex];
      if (!slide) return;
      var quizData = JSON.parse(localStorage.getItem('quiz') || '{}');

      // Track radio selections
      // Radio components already track via trackInitialSelection(), so this is redundant
      // but kept for backwards compatibility and as fallback
      var radioComponents = slide.querySelectorAll('custom-input-radio');
      radioComponents.forEach(function (radio) {
        var _radio$dataset, _quizData$radioStates2;
        var entry = (_radio$dataset = radio.dataset) === null || _radio$dataset === void 0 ? void 0 : _radio$dataset.entry;
        if (entry && (_quizData$radioStates2 = quizData.radioStates) !== null && _quizData$radioStates2 !== void 0 && _quizData$radioStates2[entry]) {
          var value = quizData.radioStates[entry];
          // Use trackSelection with explicit slideIndex
          // trackSelection already wraps valueLabel in array, so we can pass the value directly
          _this4.trackSelection(entry, value, value,
          // valueLabel will be wrapped in array by trackSelection
          false, slideIndex, 'default_value' // Explicitly mark as default value
          );
        }
      });

      // Note: Sliders (custom-slider-input, custom-two-input-sliders) and checkboxes
      // (custom-input-checkbox) are NOT tracked here because they already track themselves
      // via trackInitialSelection() when the slide becomes visible.
      // Tracking them here would cause duplicate events.

      this.trackedSlides.add(slideIndex);
    }

    /**
     * Ensure quiz_recommendation_ready is tracked when user reaches results
     * Can be called from multiple places to ensure event is fired
     */
  }, {
    key: "ensureRecommendationTracked",
    value: function ensureRecommendationTracked() {
      if (this.recommendationTracked) return;
      var quizData = JSON.parse(localStorage.getItem('quiz') || '{}');
      var productHandles = quizData.productHandles || [];

      // Only track if we have product data
      if (productHandles.length === 0) {
        return;
      }
      this.recommendationTracked = true;
      this.trackRecommendationReady(productHandles);
    }

    /**
     * Collect quiz data for Google Sheets submission
     * Returns object matching the structure expected by Google Apps Script
     */
  }, {
    key: "collectQuizDataForSheets",
    value: function collectQuizDataForSheets() {
      var _quizData$checkboxSta, _quizData$radioStates3, _quizData$radioStates4, _quizData$checkboxSta2, _quizData$sliderState3, _quizData$radioStates5, _quizData$rangeValues, _quizData$checkboxSta3, _quizData$twoSliderSt, _quizData$radioStates6, _quizData$dropdownSta;
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};

      // Mapping for body condition values
      var bodyTypeMapping = {
        0: 'Deutlich unter-gewichtig',
        1: 'Leichtes unter-gewichtig',
        2: 'Genau richtig',
        3: 'Etwas über-gewichtig',
        4: 'Stark über-gewichtig'
      };

      // Extract dog name
      var dogName = quizData.dogName || '';

      // Extract health issues from checkboxes
      var healthIssues = '';
      if ((_quizData$checkboxSta = quizData.checkboxStates) !== null && _quizData$checkboxSta !== void 0 && _quizData$checkboxSta['entry.249999288']) {
        var _quizData$customIssue;
        var checkedItems = quizData.checkboxStates['entry.249999288'].filter(function (item) {
          return item.checked;
        });

        // Check if this is a non-dog-issue (Keine)
        var hasNonDogIssue = checkedItems.some(function (item) {
          return item.isNonDogIssue === true;
        });
        if (hasNonDogIssue && (_quizData$customIssue = quizData.customIssueText) !== null && _quizData$customIssue !== void 0 && _quizData$customIssue['entry.249999288']) {
          var _checkedItems$, _checkedItems$2;
          // Non-dog-issue with custom text: send as JSON object
          var customText = quizData.customIssueText['entry.249999288'];
          var issueValue = ((_checkedItems$ = checkedItems[0]) === null || _checkedItems$ === void 0 ? void 0 : _checkedItems$.textValue) || ((_checkedItems$2 = checkedItems[0]) === null || _checkedItems$2 === void 0 ? void 0 : _checkedItems$2.value) || 'Keine';
          var issueName = issueValue.split('/-/')[0].trim();
          healthIssues = JSON.stringify({
            issue: issueName,
            problem_description: customText
          });
        } else {
          // Dog-issues: send as comma-separated string
          healthIssues = checkedItems.map(function (item) {
            var value = item.textValue || item.value || '';
            return value.split('/-/')[0].trim();
          }).join(', ');
        }
      }

      // Extract age
      var dogAge = ((_quizData$radioStates3 = quizData.radioStates) === null || _quizData$radioStates3 === void 0 ? void 0 : _quizData$radioStates3.age) || '';

      // Extract castration status
      var isCastrated = ((_quizData$radioStates4 = quizData.radioStates) === null || _quizData$radioStates4 === void 0 ? void 0 : _quizData$radioStates4['entry.724027174']) || '';

      // Extract current food type - this is CHECKBOXES, not radio buttons
      var currentFood = '';
      if ((_quizData$checkboxSta2 = quizData.checkboxStates) !== null && _quizData$checkboxSta2 !== void 0 && _quizData$checkboxSta2['entry.306846565']) {
        currentFood = quizData.checkboxStates['entry.306846565'].filter(function (item) {
          return item.checked;
        }).map(function (item) {
          var value = item.textValue || item.value || '';
          return value.split('/-/')[0].trim();
        }).join(', ');
      }

      // Extract weight
      var dogWeight = '';
      if ((_quizData$sliderState3 = quizData.sliderStates) !== null && _quizData$sliderState3 !== void 0 && _quizData$sliderState3['entry.571080194']) {
        var weight = parseFloat(quizData.sliderStates['entry.571080194']);
        if (!isNaN(weight) && weight > 0) {
          dogWeight = "".concat(Math.round(weight * 10) / 10, " kg");
        }
      }

      // Extract activity level
      var activityLevel = ((_quizData$radioStates5 = quizData.radioStates) === null || _quizData$radioStates5 === void 0 ? void 0 : _quizData$radioStates5['entry.2024690081']) || '';

      // Extract body condition/type
      var bodyType = '';
      if ((_quizData$rangeValues = quizData.rangeValues) !== null && _quizData$rangeValues !== void 0 && _quizData$rangeValues['entry.1373088848']) {
        var position = quizData.rangeValues['entry.1373088848'].position;
        bodyType = bodyTypeMapping[position] || quizData.rangeValues['entry.1373088848'].value || '';
      }

      // Extract food split composition (from checkbox-based selection)
      var foodSplit = '';
      if ((_quizData$checkboxSta3 = quizData.checkboxStates) !== null && _quizData$checkboxSta3 !== void 0 && _quizData$checkboxSta3['entry.306846565']) {
        var foodCheckboxes = quizData.checkboxStates['entry.306846565'];
        var selected = foodCheckboxes.filter(function (item) {
          return item.checked;
        }).map(function (item) {
          return item.textValue || item.value;
        }).join(', ');
        foodSplit = selected || 'Not selected';
      } else if ((_quizData$twoSliderSt = quizData.twoSliderStates) !== null && _quizData$twoSliderSt !== void 0 && _quizData$twoSliderSt['food-composition']) {
        // Legacy fallback for old slider data
        var composition = quizData.twoSliderStates['food-composition'];
        foodSplit = "Nassfutter: ".concat(composition.Nassfutter || 0, "%, Trockenfutter: ").concat(composition.Trockenfutter || 0, "%");
      }

      // Extract snacks per day
      var snacksPerDay = ((_quizData$radioStates6 = quizData.radioStates) === null || _quizData$radioStates6 === void 0 ? void 0 : _quizData$radioStates6.snacks) || '';

      // Extract user name (first name from Klaviyo form)
      var userName = quizData.customerFirstName || '';

      // Extract email (from Klaviyo form - will be in quiz data after form submission)
      var email = quizData.customerEmail || '';

      // Extract dog protein
      var dogProtein = quizData.proteinSelections || '';

      // Extract dog breed
      var dogBreed = ((_quizData$dropdownSta = quizData.dropdownStates) === null || _quizData$dropdownSta === void 0 ? void 0 : _quizData$dropdownSta['entry.62437307']) || '';

      // Calculate food recommendation from dailyFoodCalculation
      var foodRecommendation = '';
      if (quizData.dailyFoodCalculation) {
        var calc = quizData.dailyFoodCalculation;
        var parts = [];
        if (calc.dailyDryGrams > 0) {
          parts.push("".concat(calc.dailyDryGrams, "g Trockenfutter"));
        }
        if (calc.dailyWetGrams > 0) {
          parts.push("".concat(calc.dailyWetGrams, "g Nassfutter"));
        }
        if (calc.snacksPerDay > 0) {
          parts.push("".concat(calc.snacksPerDay, " Leckerlis"));
        }
        foodRecommendation = parts.join(', ');
      }

      // Extract delivery interval
      var deliveryInterval = '';
      if (quizData.subscriptionIntervallWeeks) {
        deliveryInterval = "".concat(quizData.subscriptionIntervallWeeks, " Wochen");
      }

      // Get UTM parameters
      var utmParams = this.getUTMParams();

      // Build payload matching Google Apps Script structure
      return _objectSpread(_objectSpread({
        dogName: dogName,
        healthIssues: healthIssues,
        dogAge: dogAge,
        isCastrated: isCastrated,
        currentFood: currentFood,
        dogWeight: dogWeight,
        activityLevel: activityLevel,
        bodyType: bodyType,
        foodSplit: foodSplit,
        snacksPerDay: snacksPerDay,
        userName: userName,
        email: email,
        foodRecommendation: foodRecommendation,
        deliveryInterval: deliveryInterval
      }, utmParams), {}, {
        purchased: 'no',
        dogProtein: dogProtein,
        dogBreed: dogBreed
      });
    }

    /**
     * Send quiz data to Google Sheets via Google Apps Script Web App
     */
  }, {
    key: "sendToGoogleSheets",
    value: (function () {
      var _sendToGoogleSheets = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var quizData, googleSheetsUrl, payload, submissionData, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              quizData = JSON.parse(localStorage.getItem('quiz'));
              if (quizData) {
                _context.n = 1;
                break;
              }
              console.error('Quiz data is missing');
              return _context.a(2);
            case 1:
              // Check if Google Sheets URL is configured
              googleSheetsUrl = this.dataset.googlesheetsurl || 'https://script.google.com/macros/s/AKfycbzt9zYB3vqN4Vds4Cify1olmf8XGzLmIK3128YAyx_V13y-UyJ-Ge14uOghtdhz6VGJhg/exec';
              if (googleSheetsUrl) {
                _context.n = 2;
                break;
              }
              console.error('Google Sheets URL is missing');
              return _context.a(2);
            case 2:
              // Collect all quiz data
              payload = this.collectQuizDataForSheets(); // Save submission data to prevent duplicate submissions
              submissionData = JSON.stringify(quizData);
              localStorage.setItem('quizSubmissionData', submissionData);
              _context.p = 3;
              _context.n = 4;
              return fetch(googleSheetsUrl, {
                method: 'POST',
                mode: 'no-cors',
                // Google Apps Script requires no-cors mode
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
              });
            case 4:
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              console.error('Error sending data to Google Sheets:', _t);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[3, 5]]);
      }));
      function sendToGoogleSheets() {
        return _sendToGoogleSheets.apply(this, arguments);
      }
      return sendToGoogleSheets;
    }()
    /**
     * Legacy Google Forms submission (kept for backward compatibility)
     * You can remove this method if you no longer need Google Forms
     */
    )
  }, {
    key: "sendObjectToGoogleForm",
    value: function sendObjectToGoogleForm() {
      var quizData = JSON.parse(localStorage.getItem('quiz'));
      if (!quizData || !this.googleFormUrl) {
        console.error('Quiz data or form URL is missing');
        return;
      }
      var formData = {};
      var valueMappings = {
        0: 'Typ Staubsauger',
        1: 'Foodie',
        2: 'Normalo',
        3: 'Wählerisch',
        4: 'Food Diva'
      };
      var valueMappings_2 = {
        0: 'Deutlich unter-gewichtig',
        1: 'Leichtes unter-gewichtig',
        2: 'Genau richtig',
        3: 'Etwas über-gewichtig',
        4: 'Stark über-gewichtig'
      };
      if (quizData.productHandles) {
        formData['entry.9067533'] = quizData.productHandles[0];
      }

      // Check if inputs exists before processing
      if (quizData.inputs && _typeof(quizData.inputs) === 'object') {
        Object.values(quizData.inputs).forEach(function (_ref4) {
          var entry = _ref4.entry,
            value = _ref4.value;
          if (formData.hasOwnProperty(entry)) {
            formData[entry] = "".concat(formData[entry], ",").concat(value);
          } else {
            formData[entry] = value;
          }
        });
      }
      var addOrUpdateFormData = function addOrUpdateFormData(key, value) {
        if (key === 'entry.300338555') {
          value = valueMappings[value] || value;
        }
        if (key === 'entry.1373088848') {
          value = valueMappings_2[value] || value;
        }
        if (formData.hasOwnProperty(key)) {
          formData[key] += ",".concat(value);
        } else {
          formData[key] = value;
        }
      };
      Object.entries(quizData.radioStates || {}).forEach(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
          key = _ref6[0],
          value = _ref6[1];
        return addOrUpdateFormData(key, value);
      });
      Object.entries(quizData.dropdownStates || {}).forEach(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
          key = _ref8[0],
          value = _ref8[1];
        return addOrUpdateFormData(key, value);
      });
      if (quizData.rangeValues && quizData.rangeValues.hasOwnProperty('date-birthentry')) {
        var dateButton = document.querySelector('.custom-button-date');
        var dateInput = document.querySelector('.custom-input-date');
        var value = dateButton && !dateButton.classList.contains('button--active') && dateInput ? dateInput.value : quizData.rangeValues['date-birthentry'];
        addOrUpdateFormData('entry.349306094', value);
      }
      Object.entries(quizData.rangeValues || {}).forEach(function (_ref9) {
        var _ref0 = _slicedToArray(_ref9, 2),
          key = _ref0[0],
          value = _ref0[1];
        if (key !== 'date-birthentry') {
          addOrUpdateFormData(key, value);
        }
      });
      Object.entries(quizData.checkboxStates || {}).forEach(function (_ref1) {
        var _ref10 = _slicedToArray(_ref1, 2),
          key = _ref10[0],
          checkboxes = _ref10[1];
        checkboxes.filter(function (checkbox) {
          return checkbox.checked;
        }).forEach(function (checkbox) {
          return addOrUpdateFormData(key, checkbox.value);
        });
      });
      var formBody = Object.keys(formData).map(function (key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(formData[key]);
      }).join('&');
      var submissionData = JSON.stringify(quizData);
      localStorage.setItem('quizSubmissionData', submissionData);
      fetch(this.googleFormUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: formBody,
        mode: 'no-cors'
      }).then(function () {
        console.log('Form submitted successfully');
      })["catch"](function (error) {
        console.error('Error submitting form:', error);
      });
    }
  }, {
    key: "getUTMParams",
    value: function getUTMParams() {
      var params = new URLSearchParams(window.location.search);
      return {
        utm_source: params.get('utm_source') || '',
        utm_medium: params.get('utm_medium') || '',
        utm_campaign: params.get('utm_campaign') || '',
        utm_term: params.get('utm_term') || '',
        utm_content: params.get('utm_content') || ''
      };
    }
  }, {
    key: "fireSwitchEvent",
    value: function fireSwitchEvent() {
      var activeIndex = this.activeSlider.activeIndex;
      var event = new CustomEvent('slideChange', {
        detail: {
          activeIndex: activeIndex
        }
      });
      this.dispatchEvent(event);
    }
  }, {
    key: "initSlider",
    value: function initSlider() {
      var _this5 = this;
      this.activeSlider = new Swiper(this.slider, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        allowTouchMove: false,
        effect: 'fade',
        speed: 200,
        fadeEffect: {
          crossFade: true
        },
        autoHeight: true,
        navigation: {
          prevEl: this.prevButton
        },
        draggable: false,
        on: {
          init: function init() {
            _this5._swiperReady = true;
          }
        }
      });

      // Handle next button manually to intercept calculation step and form submission
      if (this.nextButton) {
        this.nextButton.addEventListener('click', /*#__PURE__*/function () {
          var _ref11 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(e) {
            var currentSlide, klaviyoForm, success;
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  if (!(_this5.nextButton.disabled || _this5.nextButton.classList.contains('swiper-button-disabled'))) {
                    _context2.n = 1;
                    break;
                  }
                  return _context2.a(2);
                case 1:
                  // Check if current slide has quiz-klaviyo-form
                  currentSlide = _this5.activeSlider.slides[_this5.activeSlider.activeIndex];
                  klaviyoForm = currentSlide === null || currentSlide === void 0 ? void 0 : currentSlide.querySelector('quiz-klaviyo-form');
                  if (!(klaviyoForm && typeof klaviyoForm.submitForm === 'function')) {
                    _context2.n = 4;
                    break;
                  }
                  // Submit form first
                  e.stopPropagation();
                  e.preventDefault();
                  _context2.n = 2;
                  return klaviyoForm.submitForm();
                case 2:
                  success = _context2.v;
                  if (success) {
                    _context2.n = 3;
                    break;
                  }
                  return _context2.a(2);
                case 3:
                  // Form submitted successfully
                  // Check if next slide is results page and calculation not yet shown
                  if (_this5.isNextSlideResultPage() && _this5.calculationShownForSlide !== _this5.activeSlider.activeIndex + 1) {
                    // Show calculation step before results
                    _this5.showCalculationStep();
                  } else {
                    // Normal slide transition
                    _this5.activeSlider.slideNext();
                  }
                  return _context2.a(2);
                case 4:
                  // Check if next slide is results page and calculation not yet shown
                  if (_this5.isNextSlideResultPage() && _this5.calculationShownForSlide !== _this5.activeSlider.activeIndex + 1) {
                    e.stopPropagation();
                    e.preventDefault();
                    _this5.showCalculationStep();
                  } else {
                    // Normal slide transition
                    _this5.activeSlider.slideNext();
                  }
                case 5:
                  return _context2.a(2);
              }
            }, _callee2);
          }));
          return function (_x) {
            return _ref11.apply(this, arguments);
          };
        }());
      }
      this.activeSlider.on('slideChange', function () {
        var _currentSlide$dataset2, _this5$footer;
        // Safety check: ensure slides array and activeIndex exist
        if (!_this5.activeSlider.slides || _this5.activeSlider.activeIndex === undefined) {
          return;
        }
        var currentSlide = _this5.activeSlider.slides[_this5.activeSlider.activeIndex];
        if (!currentSlide) {
          return;
        }

        // Determine navigation direction
        var isNavigatingBack = _this5.activeSlider.activeIndex < _this5.previousSlideIndex;

        // Track text inputs from previous slide (only when moving forward)
        if (!isNavigatingBack && _this5.previousSlideIndex >= 0) {
          _this5.trackSlideDefaultValues(_this5.previousSlideIndex);
          var previousSlide = _this5.activeSlider.slides[_this5.previousSlideIndex];
          if (previousSlide) {
            var textInputs = previousSlide.querySelectorAll('custom-input-text');
            textInputs.forEach(function (input) {
              if (typeof input.trackInputValue === 'function') {
                input.trackInputValue();
              }
            });
          }
        }

        // Track quiz_start when completing first question (if not already tracked)
        _this5.trackQuizStartOnFirstQuestion();
        var title = ((_currentSlide$dataset2 = currentSlide.dataset) === null || _currentSlide$dataset2 === void 0 ? void 0 : _currentSlide$dataset2.title) || '';
        var text = _this5.returnExtractedText(_this5.activeSlider.activeIndex);

        // Dispatch event slider change with active index
        var event = new CustomEvent('sliderChange', {
          detail: {
            activeIndex: _this5.activeSlider.activeIndex
          }
        });
        document.dispatchEvent(event);
        (_this5$footer = _this5.footer) === null || _this5$footer === void 0 || _this5$footer.updateBoth(title, text);
        _this5.updateButton(_this5.activeSlider.activeIndex);
        _this5.saveCurrentSlide();
        _this5.validateInputs(isNavigatingBack);
        _this5.fireSwitchEvent();
        _this5.replaceDogName();
        _this5.replaceBreedName();
        _this5.trackStepView(_this5.activeSlider.activeIndex, title);
        _this5.clickRestartButton();
        _this5.setLastStepListener();
        _this5.checkLastStep(_this5.activeSlider.activeIndex);
        _this5.hideButtonsBlock(_this5.activeSlider.activeIndex);
        _this5.isResultPage(_this5.activeSlider.activeIndex);
        _this5.replaceNextBtnText(_this5.activeSlider.activeIndex);
        _this5.allowedToShowWarning = false;

        // Update previous slide index for next navigation
        _this5.previousSlideIndex = _this5.activeSlider.activeIndex;
      });

      // Initial setup after slider creation - with safety checks
      if (this.activeSlider.slides && this.activeSlider.activeIndex !== undefined) {
        var currentSlide = this.activeSlider.slides[this.activeSlider.activeIndex];
        if (currentSlide) {
          var _currentSlide$dataset3, _this$footer;
          var title = ((_currentSlide$dataset3 = currentSlide.dataset) === null || _currentSlide$dataset3 === void 0 ? void 0 : _currentSlide$dataset3.title) || '';
          var text = this.returnExtractedText(this.activeSlider.activeIndex);
          (_this$footer = this.footer) === null || _this$footer === void 0 || _this$footer.updateBoth(title, text);
        }
      }
      this.updateButton(this.activeSlider.activeIndex);
      this.validateInputs();
      this.fireSwitchEvent();
      if (this.prevButton) {
        this.prevButton.onclick = function () {
          _this5.allowedToShowWarning = false;
          // Validate inputs on the slide we're navigating TO (after Swiper updates)
          // Use setTimeout to ensure Swiper has finished the slide transition
          setTimeout(function () {
            _this5.validateInputs(true); // Pass true to indicate navigating back
          }, 50);
        };
      }
      this.checkLastStep(this.activeSlider.activeIndex);
      this.isResultPage(this.activeSlider.activeIndex);
      this.replaceNextBtnText(this.activeSlider.activeIndex);
    }

    /**
     * Calculate food composition from multiple-choice checkboxes
     * Replaces slider-based ratio selection
     *
     * Rules:
     * - Trockenfutter only → 100% dry / 0% wet
     * - Nassfutter only → 100% wet
     * - BARF only → 100% wet
     * - Trockenfutter + any wet option(s) → 50% dry / 50% wet
     * - Nassfutter + BARF (without Trockenfutter) → 100% wet
     */
  }, {
    key: "getFoodCompositionFromCheckboxes",
    value: function getFoodCompositionFromCheckboxes(quizData) {
      var _quizData$checkboxSta4;
      var foodCheckboxes = (quizData === null || quizData === void 0 || (_quizData$checkboxSta4 = quizData.checkboxStates) === null || _quizData$checkboxSta4 === void 0 ? void 0 : _quizData$checkboxSta4['entry.306846565']) || [];
      var isChecked = function isChecked(key) {
        return foodCheckboxes.some(function (item) {
          return (item.value === key || item.id === key) && item.checked === true;
        });
      };
      var hasDry = isChecked('trockenfutter');
      var hasWet = isChecked('nassfutter');
      var hasBarf = isChecked('barf');
      var hasAnyWet = hasWet || hasBarf;

      // Trockenfutter only → 100% dry food
      if (hasDry && !hasAnyWet) {
        return {
          dryPercent: 100,
          wetPercent: 0
        };
      }

      // Trockenfutter + any wet option → 50/50 split
      if (hasDry && hasAnyWet) {
        return {
          dryPercent: 50,
          wetPercent: 50
        };
      }

      // Only wet food (Nassfutter and/or BARF) → 100% wet
      if (!hasDry && hasAnyWet) {
        return {
          dryPercent: 0,
          wetPercent: 100
        };
      }

      // Fallback (should not occur in normal flow)
      return {
        dryPercent: 50,
        wetPercent: 50
      };
    }
  }, {
    key: "foodCalculations",
    value: function foodCalculations() {
      var _Object$values, _answers$sliderStates, _answers$dropdownStat, _answers$rangeValues, _answers$radioStates2, _answers$radioStates3, _answers$radioStates4, _window$PACKED_PRODUC, _group$dry, _group$snacks;
      var answers = JSON.parse(localStorage.getItem('quiz')) || {};
      var calculateD6 = function calculateD6(weight) {
        var d6Table = [{
          weight: 2,
          value: 0.41
        }, {
          weight: 5,
          value: 0.33
        }, {
          weight: 10,
          value: 0.28
        }, {
          weight: 15,
          value: 0.25
        }, {
          weight: 20,
          value: 0.23
        }, {
          weight: 25,
          value: 0.22
        }, {
          weight: 30,
          value: 0.21
        }, {
          weight: 35,
          value: 0.2
        }, {
          weight: 40,
          value: 0.2
        }, {
          weight: 50,
          value: 0.19
        }, {
          weight: 60,
          value: 0.18
        }, {
          weight: 80,
          value: 0.17
        }];
        if (weight <= d6Table[0].weight) return d6Table[0].value;
        if (weight >= d6Table[d6Table.length - 1].weight) return d6Table[d6Table.length - 1].value;
        for (var i = 0; i < d6Table.length - 1; i++) {
          var current = d6Table[i];
          var next = d6Table[i + 1];
          if (weight >= current.weight && weight <= next.weight) {
            var ratio = (weight - current.weight) / (next.weight - current.weight);
            return current.value + (next.value - current.value) * ratio;
          }
        }
        return 0.17;
      };
      var ageCalculation = function ageCalculation() {
        var _answers$radioStates;
        var age = 0;
        if (answers.dateStepInput && answers.dateStepInput['date-birthentry']) {
          if (!answers.dateStepInput['date-birthentry'].buttonClicked) {
            var birthday = new Date(answers.dateStepInput['date-birthentry'].date);
            if (isNaN(birthday.getTime())) {
              console.warn('Invalid birthday date');
              return 0;
            }
            var currentDay = new Date();
            var difference = currentDay - birthday;
            age = Math.floor(difference / 31557600000);
          } else {
            age = +answers.rangeValues['date-birthentry'] || 0;
          }
        } else if ((_answers$radioStates = answers.radioStates) !== null && _answers$radioStates !== void 0 && _answers$radioStates.age) {
          var ageRadio = answers.radioStates.age;
          if (ageRadio.includes('welpe')) age = 0.5;else if (ageRadio.includes('junior') || ageRadio.includes('1-2')) age = 1.5;else if (ageRadio.includes('erwachsen') || ageRadio.includes('1-10')) age = 5;else if (ageRadio.includes('senior') || ageRadio.includes('10')) age = 12;
        } else {
          console.warn('Missing age data');
        }
        return Math.max(0, age);
      };

      // Get weight
      var weight = 0;
      var weightFromInputs = (_Object$values = Object.values(answers.inputs || {})) === null || _Object$values === void 0 ? void 0 : _Object$values.find(function (field) {
        return field.entry === 'entry.571080194';
      });
      if (weightFromInputs) {
        weight = +weightFromInputs.value;
      } else if ((_answers$sliderStates = answers.sliderStates) !== null && _answers$sliderStates !== void 0 && _answers$sliderStates['entry.571080194']) {
        weight = +answers.sliderStates['entry.571080194'];
      }
      if (weight <= 0) {
        console.error('Invalid weight:', weight);
        console.groupEnd();
        return;
      }
      var age = ageCalculation();
      var breedDataString = ((_answers$dropdownStat = answers.dropdownStates) === null || _answers$dropdownStat === void 0 ? void 0 : _answers$dropdownStat['entry.62437307']) || '';
      var breedData = this.parseBreedData(breedDataString);
      var breedValue = breedData.breeds.length > 0 ? breedData.breeds[0] : 'Unknown';
      var weightCondition = +((_answers$rangeValues = answers.rangeValues) === null || _answers$rangeValues === void 0 || (_answers$rangeValues = _answers$rangeValues['entry.1373088848']) === null || _answers$rangeValues === void 0 ? void 0 : _answers$rangeValues.position) || 2;
      var kastration = ((_answers$radioStates2 = answers.radioStates) === null || _answers$radioStates2 === void 0 ? void 0 : _answers$radioStates2['entry.724027174']) === 'Ja' ? -5 : 0;
      var activity = ((_answers$radioStates3 = answers.radioStates) === null || _answers$radioStates3 === void 0 ? void 0 : _answers$radioStates3['entry.2024690081']) || 'moderat-aktiv-1-2-stunden';

      // Activity adjustment
      switch (activity) {
        case 'couch-potatoe':
        case 'wenig-aktiv-1-stunde':
          activity = -10;
          break;
        case 'moderat-aktiv-1-2-stunden':
        case 'guter-durchschnitt':
          activity = 0;
          break;
        default:
          activity = 15;
          break;
      }

      // Age adjustment
      var ageAdjustment = 0;
      if (age < 2) {
        ageAdjustment = 0.04;
      } else if (age >= 2 && age < 7) {
        ageAdjustment = 0;
      } else {
        ageAdjustment = -0.1;
      }

      // Weight condition adjustment
      switch (weightCondition) {
        case 0:
          weightCondition = 10;
          break;
        case 1:
          weightCondition = 5;
          break;
        case 2:
          weightCondition = 0;
          break;
        case 3:
          weightCondition = -5;
          break;
        case 4:
          weightCondition = -10;
          break;
        default:
          weightCondition = 0;
      }

      // Breed adjustment
      var breedAdjustmentList = ['Golden Retriever', 'Labrador Retriever', 'Flat Coated Retriever', 'Andere Bulldogge', 'Anderer Retriever', 'Französische Bulldoggen', 'Old English Bulldog', 'American Bulldog', 'Continental Bulldog', 'Mops', 'Beagle', 'Cavalier King Charles Spaniel', 'West Highland White Terrier', 'Welsh Corgi'];
      var breedAdjustment = breedAdjustmentList.some(function (b) {
        return breedValue.includes(b);
      }) ? -5 : 0;
      var D6 = calculateD6(weight);
      var D6_adjusted = D6 + ageAdjustment;
      var adjustmentFactor = (100 + breedAdjustment + weightCondition + kastration + activity) / 100;
      var D12 = D6_adjusted * adjustmentFactor;
      var F12 = D12 * weight;

      // Apply min/max thresholds
      var kgSeventyFive = Math.pow(weight, 0.75);
      var MjHalf = kgSeventyFive * 0.5;
      var N12 = Math.min(F12, MjHalf * 1.25);
      var P12 = Math.max(F12, MjHalf * 0.75);
      var R12 = Math.max(N12, P12);

      // Get snacks per day
      var snacksRadioValue = ((_answers$radioStates4 = answers.radioStates) === null || _answers$radioStates4 === void 0 ? void 0 : _answers$radioStates4.snacks) || 'nie';
      var snacksMapping = {
        nie: 0,
        'manchmal-3-6-am-tag': 4.5,
        'haufig-6-am-tag': 9,
        'haufig-mehr-als-6-am-tag': 9 // Legacy support
      };
      var snacksPerDay = snacksMapping[snacksRadioValue] || 0;
      var composition = this.getFoodCompositionFromCheckboxes(answers);
      var dryPercent = (composition.dryPercent || 0) / 100;
      var wetPercent = (composition.wetPercent || 0) / 100;
      answers.twoSliderStates = answers.twoSliderStates || {};
      answers.twoSliderStates['food-composition'] = {
        Nassfutter: composition.wetPercent || 0,
        Trockenfutter: composition.dryPercent || 0
      };
      answers.foodComposition = {
        nassfutter: composition.wetPercent || 0,
        trockenfutter: composition.dryPercent || 0
      };

      // Get breed-specific calories
      var groupKey = 'hunters';
      if (window.PACKED_PRODUCTS && window.PACKED_PRODUCTS.resolveGroup) {
        groupKey = window.PACKED_PRODUCTS.resolveGroup();
      }
      var group = (_window$PACKED_PRODUC = window.PACKED_PRODUCTS) === null || _window$PACKED_PRODUC === void 0 ? void 0 : _window$PACKED_PRODUC.groups[groupKey];
      var snackEnergyPerPiece = 0;
      if (snacksPerDay > 0 && group !== null && group !== void 0 && group.snacks) {
        var snackGramsPerPiece = group.snacks.gramsPerPiece || 0.8;
        var snackMJPer100g = group.snacks.caloriesPerMJ || 1.441;
        snackEnergyPerPiece = snackGramsPerPiece * snackMJPer100g / 100;
      }

      // Subtract snack energy
      var totalSnackEnergy = snacksPerDay * snackEnergyPerPiece;
      var T12 = R12 - totalSnackEnergy;
      var dailyDryGrams = 0;
      var dailyWetGrams = 0;
      if (dryPercent > 0 && group !== null && group !== void 0 && group.dry) {
        var dryEnergyNeeded = T12 * dryPercent;
        // For minis, use standard dry food calories (calculateOptimalVariant will select soft if needed)
        var dryMJPer100g = group.dry.caloriesPerMJ || 1.637;
        dailyDryGrams = Math.ceil(dryEnergyNeeded / dryMJPer100g * 100);
      }
      if (wetPercent > 0 && group !== null && group !== void 0 && group.wet) {
        var wetEnergyNeeded = T12 * wetPercent;
        var wetData = group.wet;
        if (group.wet.huhn && group.wet.forelle) {
          var wetVariant = group.wet["default"] || 'huhn';
          wetData = group.wet[wetVariant];
        }
        var wetMJPer100g = wetData.caloriesPerMJ;
        dailyWetGrams = Math.ceil(wetEnergyNeeded / wetMJPer100g * 100);
      }
      var foodGrams = this.quizContainer.querySelector('.grams');
      if (foodGrams) {
        var totalDailyGrams = dailyDryGrams + dailyWetGrams;
        foodGrams.innerHTML = "".concat(totalDailyGrams, "g");
      }
      var deliveryInterval = 28;
      var deliveryWeeks = 4;

      // Update UI
      var frequency = this.quizContainer.querySelectorAll('.frequency');
      frequency === null || frequency === void 0 || frequency.forEach(function (el) {
        return el.innerHTML = deliveryWeeks + ' Wochen';
      });
      var newProductSection = this.quizContainer.querySelector('new-product-section');
      if (newProductSection) {
        newProductSection.dataset.frequency = deliveryWeeks;
      }

      // Store calculations
      answers.dailyFoodCalculation = {
        dailyDryGrams: dailyDryGrams,
        dailyWetGrams: dailyWetGrams,
        totalDaily: dailyDryGrams + dailyWetGrams,
        snacksPerDay: snacksPerDay,
        groupKey: groupKey,
        deliveryInterval: deliveryInterval
      };

      // Store subscription interval at top level for Klaviyo form
      answers.subscriptionIntervallWeeks = deliveryWeeks;
      if (!Array.isArray(answers.productHandles)) {
        answers.productHandles = [];
      } else {
        answers.productHandles.length = 0;
      }
      if (group !== null && group !== void 0 && (_group$dry = group.dry) !== null && _group$dry !== void 0 && _group$dry.handle) answers.productHandles.push(group.dry.handle);
      if (group !== null && group !== void 0 && group.wet) {
        if (group.wet.huhn && group.wet.forelle) {
          var _wetVariant = group.wet["default"] || 'huhn';
          answers.productHandles.push(group.wet[_wetVariant].handle);
        } else {
          answers.productHandles.push(group.wet.handle);
        }
      }
      if (group !== null && group !== void 0 && (_group$snacks = group.snacks) !== null && _group$snacks !== void 0 && _group$snacks.handle && snacksPerDay > 0) {
        answers.productHandles.push(group.snacks.handle);
      }
      localStorage.setItem('quiz', JSON.stringify(answers));
      var event = new CustomEvent('quiz:calculationsComplete', {
        detail: {
          dailyFoodCalculation: answers.dailyFoodCalculation,
          productHandles: answers.productHandles
        }
      });
      document.dispatchEvent(event);
    }
  }, {
    key: "hideButtonsBlock",
    value: function hideButtonsBlock(index) {
      // Safety check: ensure slides exist
      if (!this.activeSlider || !this.activeSlider.slides || !this.activeSlider.slides[index]) {
        return;
      }

      // Don't show buttons if intro screen is active
      if (!this.introCompleted) {
        var introScreen = document.querySelector('quiz-intro-screen');
        if (introScreen && !introScreen.classList.contains('tw-hidden')) {
          var _this$buttonWrapper;
          (_this$buttonWrapper = this.buttonWrapper) === null || _this$buttonWrapper === void 0 || _this$buttonWrapper.classList.add('!tw-hidden');
          return;
        }
      }

      // After intro completion, first slide should always show buttons
      if (this.introCompleted && index === 0) {
        var _this$buttonWrapper2;
        (_this$buttonWrapper2 = this.buttonWrapper) === null || _this$buttonWrapper2 === void 0 || _this$buttonWrapper2.classList.remove('!tw-hidden');
        return;
      }
      var currentSlide = this.activeSlider.slides[index];
      if (currentSlide.classList.contains('swiper-slider__hide_buttons_block')) {
        this.buttonWrapper.classList.add('!tw-hidden');
      } else {
        this.buttonWrapper.classList.remove('!tw-hidden');
      }
    }
  }, {
    key: "checkLastStep",
    value: function checkLastStep(index) {
      // Safety check: ensure slides exist
      if (!this.activeSlider || !this.activeSlider.slides || !this.activeSlider.slides[index]) {
        return;
      }
      var currentSlide = this.activeSlider.slides[index];
      if (currentSlide.classList.contains('swiper-slider__last-step') || currentSlide.classList.contains('swiper-slider__bottom-content-hidden')) {
        var _this$cartFeatures, _this$footer2, _this$footer3;
        (_this$cartFeatures = this.cartFeatures) === null || _this$cartFeatures === void 0 || _this$cartFeatures.classList.add('tw-hidden');
        (_this$footer2 = this.footer) === null || _this$footer2 === void 0 || _this$footer2.classList.remove('tw-block');
        (_this$footer3 = this.footer) === null || _this$footer3 === void 0 || _this$footer3.classList.add('tw-hidden');
        this.foodCalculations();
      } else {
        var _this$cartFeatures2, _this$footer4, _this$footer5;
        (_this$cartFeatures2 = this.cartFeatures) === null || _this$cartFeatures2 === void 0 || _this$cartFeatures2.classList.add('tw-hidden');
        (_this$footer4 = this.footer) === null || _this$footer4 === void 0 || _this$footer4.classList.remove('tw-hidden');
        (_this$footer5 = this.footer) === null || _this$footer5 === void 0 || _this$footer5.classList.add('tw-block');
      }
      if (currentSlide.classList.contains('swiper-slider__complete-step')) {
        this.nextButton.classList.add('button-complete-step');
      } else {
        this.nextButton.classList.remove('button-complete-step');
      }
    }
  }, {
    key: "isResultPage",
    value: function isResultPage(index) {
      // Safety check: ensure slides exist
      if (!this.activeSlider || !this.activeSlider.slides || !this.activeSlider.slides[index]) {
        return;
      }
      var currentSlide = this.activeSlider.slides[index];
      if (currentSlide.classList.contains('swiper-slider__result-step')) {
        var currentData = JSON.stringify(JSON.parse(localStorage.getItem('quiz'))); // Adjust if necessary to match your form data structure
        var lastSubmissionData = localStorage.getItem('quizSubmissionData');
        if (!lastSubmissionData || lastSubmissionData && currentData !== lastSubmissionData) {
          // The data is different or it's the first submission, proceed with submitting to Google Sheets
          this.sendToGoogleSheets();
        }

        // Note: trackRecommendationReady is now called in onCalculationComplete()
        // when calculation animation finishes and results slide is shown

        this.removeOverflowForBody();
        this.buttonWrapper.classList.remove('sticky-wrapper');
        this.buttonWrapper.classList.add('simple-button-wrapper');
        this.quizContainer.style.paddingBottom = 0;
        this.nextButton.classList.add('button-result-step');
        if (this.checkoutMode === 'checkout') {
          var _this$nextButton2;
          (_this$nextButton2 = this.nextButton) === null || _this$nextButton2 === void 0 || _this$nextButton2.classList.add('tw-hidden');
        } else {
          var _this$nextButton3;
          (_this$nextButton3 = this.nextButton) === null || _this$nextButton3 === void 0 || _this$nextButton3.classList.remove('tw-hidden');
        }
      } else if (currentSlide.classList.contains('swiper-slider__cart')) {
        var _this$nextButton4;
        this.quizContainer.style.paddingBottom = 70;
        this.buttonWrapper.classList.remove('simple-button-wrapper');
        this.nextButton.classList.remove('button-result-step');
        this.buttonWrapper.classList.add('sticky-wrapper');
        (_this$nextButton4 = this.nextButton) === null || _this$nextButton4 === void 0 || _this$nextButton4.classList.remove('tw-hidden');
      } else {
        var _this$nextButton5;
        this.quizContainer.style.paddingBottom = 70;
        this.buttonWrapper.classList.remove('simple-button-wrapper');
        this.nextButton.classList.remove('button-result-step');
        this.updateButton(this.activeSlider.activeIndex);
        this.buttonWrapper.classList.remove('buttons-cart__last-step');
        this.buttonWrapper.classList.add('sticky-wrapper');
        (_this$nextButton5 = this.nextButton) === null || _this$nextButton5 === void 0 || _this$nextButton5.classList.remove('tw-hidden');
      }
    }
  }, {
    key: "removeOverflowForBody",
    value: function removeOverflowForBody() {
      var body = document.body;
      document.addEventListener('cart:open', function () {
        body.classList.add('remove-overflow');
      });
      document.addEventListener('cart:close', function () {
        body.classList.remove('remove-overflow');
      });
    }
  }, {
    key: "setLastStepListener",
    value: function setLastStepListener() {
      var _this6 = this;
      var button = document.querySelector('button.button.button--next.swiper-button-disabled');
      if (!button) return;
      button.removeAttribute('disabled');
      button.removeAttribute('aria-disabled');
      button.addEventListener('click', function () {
        // Track checkout start
        var checkoutEvent = {
          event: 'start_checkout',
          checkout_type: 'quiz'
        };
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(checkoutEvent);
        var addItemsURL = _this6.checkoutMode === 'checkout' ? _this6.buildCheckoutUrlWithDiscount() : '/checkout';
        window.location.href = addItemsURL;
      });
    }
  }, {
    key: "addCartFeatures",
    value: function addCartFeatures(index) {
      // Safety check: ensure slides exist
      if (!this.activeSlider || !this.activeSlider.slides || !this.activeSlider.slides[index]) {
        return;
      }
      var currentSlide = this.activeSlider.slides[index];
      var totalSlides = this.activeSlider.slides.length;
      var currentIndex = Array.from(this.activeSlider.slides).indexOf(currentSlide);
      if (currentIndex === totalSlides - 1) {
        var _this$cartFeatures3, _document$querySelect;
        this.buttonWrapper.classList.add('buttons-cart__last-step');
        (_this$cartFeatures3 = this.cartFeatures) === null || _this$cartFeatures3 === void 0 || _this$cartFeatures3.classList.remove('tw-hidden');
        (_document$querySelect = document.querySelector('quiz-container')) === null || _document$querySelect === void 0 || _document$querySelect.classList.add('cart__last-step');
      } else {
        var _this$cartFeatures4;
        (_this$cartFeatures4 = this.cartFeatures) === null || _this$cartFeatures4 === void 0 || _this$cartFeatures4.classList.add('tw-hidden');
        this.buttonWrapper.classList.remove('buttons-cart__last-step');
      }
    }
  }, {
    key: "replaceNextBtnText",
    value: function replaceNextBtnText(index) {
      // Safety check: ensure slides exist
      if (!this.activeSlider || !this.activeSlider.slides || !this.activeSlider.slides[index]) {
        return;
      }
      var currentSlide = this.activeSlider.slides[index];

      // Check if current slide contains quiz-klaviyo-form
      var klaviyoForm = currentSlide.querySelector('quiz-klaviyo-form');
      var buttonText;
      if (klaviyoForm) {
        // Use submit text from klaviyo form
        buttonText = klaviyoForm.dataset.submitText || this.nextButtonDefaultText;
      } else {
        var _currentSlide$dataset4;
        // Use slide's custom text or default
        buttonText = ((_currentSlide$dataset4 = currentSlide.dataset) === null || _currentSlide$dataset4 === void 0 ? void 0 : _currentSlide$dataset4.nexttitle) || this.nextButtonDefaultText;
      }
      if (this.nextButton) {
        // Save SVG icon before updating text
        var svgIcon = this.nextButton.querySelector('span.tw-hidden');

        // Update text content only
        var textNode = Array.from(this.nextButton.childNodes).find(function (node) {
          return node.nodeType === Node.TEXT_NODE;
        });
        if (textNode) {
          textNode.textContent = buttonText;
        } else {
          // If no text node, recreate button content
          this.nextButton.innerHTML = buttonText;
          if (svgIcon) {
            this.nextButton.appendChild(svgIcon);
          }
        }
      }
    }
  }, {
    key: "returnExtractedText",
    value: function returnExtractedText(index) {
      var _currentSlide$dataset5;
      // Safety check: ensure slides exist
      if (!this.activeSlider || !this.activeSlider.slides || !this.activeSlider.slides[index]) {
        return '';
      }
      var currentSlide = this.activeSlider.slides[index];
      var text = (_currentSlide$dataset5 = currentSlide.dataset) === null || _currentSlide$dataset5 === void 0 ? void 0 : _currentSlide$dataset5.text;
      var parsedData = text ? JSON.parse(text) : '';
      var extractedText = '';
      if (!parsedData) return extractedText;
      parsedData.children.forEach(function (paragraph) {
        paragraph.children.forEach(function (textElement) {
          extractedText += textElement.value + ' ';
        });
      });
      return extractedText.trim();
    }
  }, {
    key: "replaceDogName",
    value: function replaceDogName() {
      // Search for both .title-label and .text-label classes
      var titleLabels = document.querySelectorAll('.title-label');
      if (titleLabels.length === 0) return;
      var dogName = this.getDogName();
      titleLabels.forEach(function (titleLabel) {
        // Save original HTML on first call
        if (!titleLabel.dataset.originalHtml) {
          titleLabel.dataset.originalHtml = titleLabel.innerHTML;
        }
        if (!dogName) {
          // If no dog name, replace entire content with fallback text
          var fallbackText = titleLabel.dataset.nonameText || '';
          if (fallbackText) {
            titleLabel.innerHTML = fallbackText;
          } else {
            // Restore original HTML if no fallback text
            titleLabel.innerHTML = titleLabel.dataset.originalHtml;
          }
        } else {
          // If dog name exists, restore original HTML first (if .dog-name was removed)
          var dogNameElement = titleLabel.querySelector('.dog-name');
          if (!dogNameElement) {
            titleLabel.innerHTML = titleLabel.dataset.originalHtml;
            dogNameElement = titleLabel.querySelector('.dog-name');
          }

          // Replace .dog-name content with dog name
          if (dogNameElement) {
            dogNameElement.innerHTML = dogName;
          }
        }
      });
    }
  }, {
    key: "parseBreedData",
    value: function parseBreedData(breedDataString) {
      if (!breedDataString) {
        return {
          breedType: 'unknown',
          breeds: []
        };
      }
      if (breedDataString === 'not_sure') {
        return {
          breedType: 'not_sure',
          breeds: []
        };
      }
      var parts = breedDataString.split(';').map(function (s) {
        return s.trim();
      });
      var result = {
        breedType: 'unknown',
        breeds: []
      };
      parts.forEach(function (part) {
        var _part$split = part.split(':'),
          _part$split2 = _toArray(_part$split),
          key = _part$split2[0],
          valueParts = _part$split2.slice(1);
        var value = valueParts.join(':').trim();
        if (key.trim() === 'breedTypeStates') {
          result.breedType = value;
        } else if (key.trim() === 'value') {
          result.breeds.push(value);
        } else if (key.trim() === 'value_1') {
          result.breeds.push(value);
        } else if (key.trim() === 'value_2') {
          result.breeds.push(value);
        }
      });
      return result;
    }
  }, {
    key: "replaceBreedName",
    value: function replaceBreedName() {
      if (localStorage.getItem('quiz') && document.querySelector('.breed-name')) {
        var quizData = JSON.parse(localStorage.getItem('quiz'));
        var breedDataString = quizData.dropdownStates && quizData.dropdownStates['entry.62437307'];
        if (!breedDataString) return;
        var breedData = this.parseBreedData(breedDataString);
        var breedName = '';
        if (breedData.breedType === 'not_sure') {
          breedName = this.defaultBreed;
        } else if (breedData.breeds.length > 0) {
          // For mixed breeds, use the first breed (value_1) to determine group
          var primaryBreed = breedData.breeds[0];
          var groupKey = this.findGroupByBreedName(primaryBreed);
          breedName = this.getGroupDisplayName(groupKey) || primaryBreed;
        } else {
          breedName = this.defaultBreed;
        }
        document.querySelectorAll('.breed-name').forEach(function (el) {
          return el.innerHTML = breedName;
        });
      }
    }

    /**
     * Map group key to translated display name
     */
  }, {
    key: "getGroupDisplayName",
    value: function getGroupDisplayName(groupKey) {
      // Use translations from window object if available
      if (window.breedGroupTranslations && window.breedGroupTranslations[groupKey]) {
        return window.breedGroupTranslations[groupKey];
      }

      // Fallback to German names
      var groupNames = {
        retrievers: 'Retriever',
        bulldogs: 'Bulldoggen',
        herders: 'Hütehunde',
        hunters: 'Kleine Jagdhunde',
        bigbuddies: 'Molosser',
        heroichunters: 'Große Jagdhunde',
        minis: 'Minis',
        shepherds: 'Schäferhunde'
      };
      return groupNames[groupKey] || null;
    }

    /**
     * Find breed group by breed name
     */
  }, {
    key: "findGroupByBreedName",
    value: function findGroupByBreedName(breedName) {
      if (!breedName) return null;
      var lower = breedName.toLowerCase();
      var list = window.breedSearchDatabreed_1 || [];

      // Search by URL in breed data
      var _iterator2 = _createForOfIteratorHelper(list),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var entry = _step2.value;
          if (entry.breedList.some(function (b) {
            return b.toLowerCase() === lower;
          })) {
            var url = (entry.breedUrl || '').toLowerCase();
            if (url.includes('bulldogs')) return 'bulldogs';
            if (url.includes('ravishing-retrievers')) return 'retrievers';
            if (url.includes('shine-bright-shepherds')) return 'shepherds';
            if (url.includes('collections/minis') || url.includes('marvelous-minis')) return 'minis';
            if (url.includes('happy-herders')) return 'herders';
            if (url.includes('hearty-hunters')) return 'hunters';
            if (url.includes('big-buddies')) return 'bigbuddies';
            if (url.includes('heroic-hunters')) return 'heroichunters';
          }
        }

        // Fallback: search by keywords in breed name
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      if (lower.includes('bulldog') || lower.includes('frenchie') || lower.includes('mops') || lower.includes('boston')) return 'bulldogs';
      if (lower.includes('retriever') || lower.includes('labrador') || lower.includes('golden')) return 'retrievers';
      if (lower.includes('schäfer') || lower.includes('shepherd') || lower.includes('malinois')) return 'shepherds';
      if (lower.includes('chihuahua') || lower.includes('york') || lower.includes('malteser') || lower.includes('havaneser') || lower.includes('jack russell')) return 'minis';
      if (lower.includes('collie') || lower.includes('australian shepherd') || lower.includes('border')) return 'herders';
      if (lower.includes('mastiff') || lower.includes('cane corso') || lower.includes('rottweiler') || lower.includes('dogge')) return 'bigbuddies';
      if (lower.includes('weimaraner') || lower.includes('vizsla') || lower.includes('pointer') || lower.includes('setter')) return 'heroichunters';

      // Default to hunters if no match
      return 'hunters';
    }
  }, {
    key: "validateInputs",
    value: function validateInputs() {
      var isNavigatingBack = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      // Safety check: ensure activeSlider and slides exist
      if (!this.activeSlider || !this.activeSlider.slides || this.activeSlider.activeIndex === undefined) {
        return;
      }
      var currentSlide = this.activeSlider.slides[this.activeSlider.activeIndex];
      if (!currentSlide) {
        return;
      }

      // Find all components on current slide
      var breedSelector = currentSlide.querySelector('breed-radio-selector');
      var customRadio = currentSlide.querySelector('custom-input-radio');
      var customText = currentSlide.querySelector('custom-input-text');
      var customCheckbox = currentSlide.querySelector('custom-input-checkbox');
      var customImageSlider = currentSlide.querySelector('custom-image-slider');
      var customSliderInput = currentSlide.querySelector('custom-slider-input');
      var customTwoSliders = currentSlide.querySelector('custom-two-sliders-input');
      var customRangeImage = currentSlide.querySelector('custom-input-range-image-v2');
      var klaviyoForm = currentSlide.querySelector('quiz-klaviyo-form');
      var proteinComponent = currentSlide.querySelector('component-protein-v2');

      // Check for klaviyo form first
      if (klaviyoForm && typeof klaviyoForm.updateNextButtonState === 'function') {
        klaviyoForm.updateNextButtonState();
        return; // Klaviyo form controls button state
      }

      // Check for protein component
      if (proteinComponent && typeof proteinComponent.updateNextButtonState === 'function') {
        proteinComponent.updateNextButtonState(currentSlide);
        return; // Protein component controls button state
      }

      // Validate components that require selection (radio buttons)
      if (breedSelector && typeof breedSelector.validateSelection === 'function') {
        // Always call init() to ensure fresh button references and proper state
        // Pass currentSlide to avoid timing issues with CSS class updates
        breedSelector.init(currentSlide);
        return; // Radio components control button state
      }
      if (customRadio && typeof customRadio.checkRadioSelection === 'function') {
        // Restore radio state when navigating back/forward
        if (typeof customRadio.restoreRadioSelection === 'function') {
          customRadio.restoreRadioSelection();
        }
        customRadio.checkRadioSelection(currentSlide);
        return; // Radio components control button state
      }

      // For all other components, enable button
      if (customText && typeof customText.validateInput === 'function') {
        customText.validateInput(currentSlide);
        return;
      }
      if (customCheckbox && typeof customCheckbox.validateCheckboxes === 'function') {
        // Component manages its own state synchronization via slideChange listener
        // Just validate button state here
        customCheckbox.validateCheckboxes();
        return;
      }
      if (customImageSlider && typeof customImageSlider.enableNextButton === 'function') {
        customImageSlider.enableNextButton();
        return;
      }
      if (customSliderInput && typeof customSliderInput.enableNextButton === 'function') {
        customSliderInput.enableNextButton();
        return;
      }
      if (customTwoSliders && typeof customTwoSliders.enableNextButton === 'function') {
        customTwoSliders.enableNextButton();
        return;
      }
      if (customRangeImage && typeof customRangeImage.enableNextButton === 'function') {
        customRangeImage.enableNextButton();
        return;
      }

      // If no components found, enable button by default
      this.enableNextBtn();
    }
  }, {
    key: "disableNextBtn",
    value: function disableNextBtn() {
      // if (this.nextButton) {
      //   this.nextButton.classList.add('button--disabled');
      //   this.nextButton.disabled = true;
      // }
    }
  }, {
    key: "enableNextBtn",
    value: function enableNextBtn() {
      if (this.nextButton) {
        this.nextButton.classList.remove('button--disabled');
        this.nextButton.disabled = false;
      }
    }
  }, {
    key: "updateButton",
    value: function updateButton(index) {
      if (index === 0) {
        var _this$prevButton, _this$prevButton2, _this$buttonWrapper3, _this$buttonWrapper4;
        (_this$prevButton = this.prevButton) === null || _this$prevButton === void 0 || _this$prevButton.classList.add('tw-opacity-0');
        (_this$prevButton2 = this.prevButton) === null || _this$prevButton2 === void 0 || _this$prevButton2.classList.add('tw-pointer-events-none');
        (_this$buttonWrapper3 = this.buttonWrapper) === null || _this$buttonWrapper3 === void 0 || _this$buttonWrapper3.classList.add('tw-justify-center');
        (_this$buttonWrapper4 = this.buttonWrapper) === null || _this$buttonWrapper4 === void 0 || _this$buttonWrapper4.classList.remove('tw-justify-between');
      } else {
        var _this$prevButton3, _this$prevButton4, _this$buttonWrapper5, _this$buttonWrapper6;
        (_this$prevButton3 = this.prevButton) === null || _this$prevButton3 === void 0 || _this$prevButton3.classList.remove('tw-opacity-0');
        (_this$prevButton4 = this.prevButton) === null || _this$prevButton4 === void 0 || _this$prevButton4.classList.remove('tw-pointer-events-none');
        (_this$buttonWrapper5 = this.buttonWrapper) === null || _this$buttonWrapper5 === void 0 || _this$buttonWrapper5.classList.remove('tw-justify-center');
        (_this$buttonWrapper6 = this.buttonWrapper) === null || _this$buttonWrapper6 === void 0 || _this$buttonWrapper6.classList.add('tw-justify-between');
      }
    }

    /**
     * Initialize restart button listener
     */
  }, {
    key: "clickRestartButton",
    value: function clickRestartButton() {
      var _this7 = this;
      var restartButton = document.querySelector('.quiz__header-restart');
      if (restartButton) {
        // Remove existing listener to avoid duplicates
        restartButton.removeEventListener('click', this.handleRestart);
        restartButton.addEventListener('click', function () {
          return _this7.handleRestart();
        });
      }
    }

    /**
     * Handle quiz restart - complete reset without page reload
     */
  }, {
    key: "handleRestart",
    value: function handleRestart() {
      var _this8 = this;
      // Collect default radio values from all radio components
      var defaultRadioStates = this.collectDefaultRadioStates();

      // Set default localStorage state with initial slider values and radio states
      var defaultQuizState = {
        currentSlide: 0,
        inputs: {},
        radioStates: defaultRadioStates,
        checkboxStates: {},
        dropdownStates: {},
        rangeValues: {},
        dateStepInput: {},
        sliderStates: {
          'entry.571080194': 5
        },
        introShown: false
      };
      localStorage.setItem('quiz', JSON.stringify(defaultQuizState));
      localStorage.removeItem('quizSubmissionData');
      localStorage.removeItem('firstLoadTime');
      localStorage.removeItem('quiz_deleted_products');

      // Reset slider to first slide
      if (this.activeSlider) {
        this.activeSlider.slideTo(0, 0);
      }

      // Reset internal state
      this.introCompleted = false;
      this.isShowingCalculation = false;
      this.calculationShownForSlide = null;
      this.maxProgressReached = 0;
      this.previousSlideIndex = 0;
      // Reset tracking flags for new quiz session
      this.quizStartTracked = false;
      this.recommendationTracked = false;
      this.trackedSlides.clear();
      this.trackedStepData = {};

      // Reset step 7 combined data
      this.step7Data = {
        weight: null,
        kastrait: null
      };

      // Clear all form inputs on all slides
      this.clearAllInputs();

      // Reset all title labels to original state
      this.resetTitleLabels();

      // Reset all progress bars to initial state
      this.resetProgressBars();

      // Re-initialize validation as if quiz just started
      // Small delay to ensure all component reset() methods complete
      setTimeout(function () {
        _this8.reinitializeValidation();
      }, 50);

      // Reset custom-product-output component
      var customProductOutput = document.querySelector('custom-product-output');
      if (customProductOutput && typeof customProductOutput.reset === 'function') {
        customProductOutput.reset();
      }
      if (this.customIssueInput) {
        this.customIssueInput.classList.add('tw-hidden');
      }

      // Reset new-product-section component with full reset
      var newProductSection = document.querySelector('new-product-section');
      if (newProductSection && typeof newProductSection.reset === 'function') {
        newProductSection.reset();
      }

      // Reset quiz-klaviyo-form component
      var klaviyoForm = document.querySelector('quiz-klaviyo-form');
      if (klaviyoForm && typeof klaviyoForm.reset === 'function') {
        klaviyoForm.reset();
      }

      // Reset component-protein-v2 component
      var proteinComponent = document.querySelector('component-protein-v2');
      if (proteinComponent && typeof proteinComponent.reset === 'function') {
        proteinComponent.reset();
      }

      // Reset quiz-review-slider component
      var reviewSlider = this.querySelector('quiz-review-slider');
      if (reviewSlider && typeof reviewSlider.reset === 'function') {
        reviewSlider.reset();
      }

      // Dispatch restart event for components listening
      document.dispatchEvent(new CustomEvent('quiz:restart'));

      // Show intro screen if enabled
      var introScreen = document.querySelector('quiz-intro-screen');
      if (introScreen) {
        introScreen.classList.remove('tw-hidden');
        if (typeof introScreen.resetIntroScreen === 'function') {
          introScreen.resetIntroScreen();
        }

        // Hide quiz elements
        var swiper = this.querySelector('.swiper');
        var footer = this.querySelector('quiz-footer');
        var buttonsWrapper = this.querySelector('.buttons-wrapper');
        if (this.mainProgressBar) this.mainProgressBar.classList.add('tw-hidden');
        if (swiper) swiper.classList.add('!tw-hidden');
        if (footer) footer.classList.add('tw-hidden');
        if (buttonsWrapper) buttonsWrapper.classList.add('!tw-hidden');

        // Hide restart button during intro
        var restartBtn = document.querySelector('.quiz__header-restart');
        if (restartBtn) restartBtn.classList.add('tw-hidden');
      } else {
        // No intro screen - just reset to first slide
        this.introCompleted = true;
        this.updateButton(0);
      }
    }

    /**
     * Collect default radio states from all radio components
     * Returns object with entry -> first radio value pairs
     */
  }, {
    key: "collectDefaultRadioStates",
    value: function collectDefaultRadioStates() {
      var radioStates = {};

      // Get all custom-input-radio components
      this.querySelectorAll('custom-input-radio').forEach(function (component) {
        var entry = component.dataset.entry;
        var firstRadio = component.querySelector('input[type="radio"]');
        if (entry && firstRadio) {
          radioStates[entry] = firstRadio.value;
        }
      });
      return radioStates;
    }

    /**
     * Re-initialize validation as if quiz just started
     * Emulates the initial slider setup state
     */
  }, {
    key: "reinitializeValidation",
    value: function reinitializeValidation() {
      var _currentSlide$dataset6, _this$footer6;
      // Skip if intro screen is active (not completed)
      var introScreen = document.querySelector('quiz-intro-screen');
      if (introScreen && !introScreen.classList.contains('tw-hidden')) {
        return;
      }

      // Safety check
      if (!this.activeSlider || !this.activeSlider.slides) return;
      var currentIndex = 0;
      var currentSlide = this.activeSlider.slides[currentIndex];
      if (!currentSlide) return;

      // Trigger footer update
      var title = ((_currentSlide$dataset6 = currentSlide.dataset) === null || _currentSlide$dataset6 === void 0 ? void 0 : _currentSlide$dataset6.title) || '';
      var text = this.returnExtractedText(currentIndex);
      (_this$footer6 = this.footer) === null || _this$footer6 === void 0 || _this$footer6.updateBoth(title, text);

      // Re-run all initialization methods for slide 0
      this.updateButton(currentIndex);
      this.validateInputs();
      this.fireSwitchEvent();
      this.replaceDogName();
      this.replaceBreedName();
      this.checkLastStep(currentIndex);
      this.hideButtonsBlock(currentIndex);
      this.isResultPage(currentIndex);
      this.replaceNextBtnText(currentIndex);

      // Reset warning state
      this.allowedToShowWarning = false;

      // Dispatch sliderChange event to notify components
      var event = new CustomEvent('sliderChange', {
        detail: {
          activeIndex: currentIndex
        }
      });
      document.dispatchEvent(event);
    }

    /**
     * Reset all progress bars to initial state
     */
  }, {
    key: "resetProgressBars",
    value: function resetProgressBars() {
      // Reset main progress bar
      if (this.mainProgressBar && typeof this.mainProgressBar.reset === 'function') {
        this.mainProgressBar.reset();
      }

      // Reset last step progress bar if exists
      var lastStepProgressBar = this.querySelector('.last-step-progress-bar');
      if (lastStepProgressBar && typeof lastStepProgressBar.reset === 'function') {
        lastStepProgressBar.reset();
      }

      // Reset calculation step progress bar if exists
      if (this.calculationStep) {
        var calcProgressBar = this.calculationStep.querySelector('quiz-progress-bar');
        if (calcProgressBar && typeof calcProgressBar.reset === 'function') {
          calcProgressBar.reset();
        }
      }
    }

    /**
     * Reset all title labels to original HTML state
     */
  }, {
    key: "resetTitleLabels",
    value: function resetTitleLabels() {
      // Reset both .title-label and .text-label classes
      var titleLabels = document.querySelectorAll('.title-label, .text-label');
      titleLabels.forEach(function (titleLabel) {
        if (titleLabel.dataset.originalHtml) {
          titleLabel.innerHTML = titleLabel.dataset.originalHtml;
        }
      });
    }

    /**
     * Clear all input values across all quiz slides
     */
  }, {
    key: "clearAllInputs",
    value: function clearAllInputs() {
      // Clear text inputs (except those in custom components)
      this.querySelectorAll('input[type="text"], input[type="email"], input[type="date"]').forEach(function (input) {
        var isInsideCustomComponent = input.closest('custom-dropdown') || input.closest('custom-input-text') || input.closest('breed-radio-selector');
        if (!isInsideCustomComponent) {
          input.value = '';
        }
      });

      // Clear number inputs (except those in custom-slider-input)
      this.querySelectorAll('input[type="number"]').forEach(function (input) {
        var isInsideCustomComponent = input.closest('custom-slider-input');
        if (!isInsideCustomComponent) {
          input.value = '';
        }
      });

      // Uncheck radio buttons that are NOT inside custom components
      // (components handle their own radios via reset())
      this.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        var isInsideCustomComponent = radio.closest('custom-input-radio') || radio.closest('breed-radio-selector');
        if (!isInsideCustomComponent) {
          radio.checked = false;
        }
      });

      // Uncheck checkboxes that are NOT inside custom components
      this.querySelectorAll('input[type="checkbox"]').forEach(function (checkbox) {
        var isInsideCustomComponent = checkbox.closest('custom-input-checkbox');
        if (!isInsideCustomComponent) {
          checkbox.checked = false;
        }
      });

      // Reset breed-radio-selector components FIRST (handles its own dropdowns internally)
      this.querySelectorAll('breed-radio-selector').forEach(function (component) {
        if (typeof component.reset === 'function') {
          component.reset();
        }
      });

      // Reset custom-dropdown components (skip dropdowns inside breed-radio-selector)
      this.querySelectorAll('custom-dropdown').forEach(function (component) {
        var isInsideBreedSelector = component.closest('breed-radio-selector');
        if (!isInsideBreedSelector && typeof component.reset === 'function') {
          component.reset();
        }
      });

      // Reset custom-input-radio components
      this.querySelectorAll('custom-input-radio').forEach(function (component) {
        if (typeof component.reset === 'function') {
          component.reset();
        }
      });

      // Reset custom-input-checkbox components
      this.querySelectorAll('custom-input-checkbox').forEach(function (component) {
        if (typeof component.reset === 'function') {
          component.reset();
        }
      });

      // Reset custom-slider-input components
      this.querySelectorAll('custom-slider-input').forEach(function (component) {
        if (typeof component.reset === 'function') {
          component.reset();
        }
      });

      // Reset custom-two-sliders-input components
      this.querySelectorAll('custom-two-sliders-input').forEach(function (component) {
        if (typeof component.reset === 'function') {
          component.reset();
        }
      });

      // Reset other custom components
      this.querySelectorAll('custom-input-text, custom-input-range-image-v2').forEach(function (component) {
        if (typeof component.reset === 'function') {
          component.reset();
        }
      });

      // Clear any selections styling (except active classes set by components)
      this.querySelectorAll('.selected, .is-selected').forEach(function (el) {
        el.classList.remove('selected', 'is-selected');
      });
    }

    /**
     * Check if next slide is a results page
     */
  }, {
    key: "isNextSlideResultPage",
    value: function isNextSlideResultPage() {
      if (!this.activeSlider || !this.activeSlider.slides) return false;
      var nextIndex = this.activeSlider.activeIndex + 1;
      if (nextIndex >= this.activeSlider.slides.length) return false;
      var nextSlide = this.activeSlider.slides[nextIndex];
      return nextSlide && nextSlide.classList.contains('swiper-slider__result-step');
    }

    /**
     * Show calculation step before results
     */
  }, {
    key: "showCalculationStep",
    value: function showCalculationStep() {
      var _this$buttonWrapper7, _this$querySelector;
      if (!this.calculationStep || this.isShowingCalculation) return;
      this.isShowingCalculation = true;
      this.calculationShownForSlide = this.activeSlider.activeIndex + 1;

      // Get pet name from quiz data
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      var petName = '';
      if (quizData.inputs) {
        var _nameEntry;
        // Try to find name by entry field containing 'name'
        var nameEntry = Object.values(quizData.inputs).find(function (input) {
          return input.entry && input.entry.toLowerCase().includes('name');
        });

        // If not found, try to find by input ID containing 'name'
        if (!nameEntry) {
          var nameKey = Object.keys(quizData.inputs).find(function (key) {
            return key.toLowerCase().includes('name');
          });
          if (nameKey) {
            nameEntry = quizData.inputs[nameKey];
          }
        }

        // If still not found, try first text input
        if (!nameEntry) {
          var inputKeys = Object.keys(quizData.inputs);
          if (inputKeys.length > 0) {
            nameEntry = quizData.inputs[inputKeys[0]];
          }
        }
        petName = ((_nameEntry = nameEntry) === null || _nameEntry === void 0 ? void 0 : _nameEntry.value) || '';
      }

      // Hide quiz UI elements (but keep main progress bar visible)
      (_this$buttonWrapper7 = this.buttonWrapper) === null || _this$buttonWrapper7 === void 0 || _this$buttonWrapper7.classList.add('tw-hidden');
      (_this$querySelector = this.querySelector('.swiper')) === null || _this$querySelector === void 0 || _this$querySelector.classList.add('tw-hidden');

      // Track calculation started
      this.trackCalculationStarted();

      // Start calculation animation
      this.calculationStep.startCalculation(petName);
    }

    /**
     * Handle calculation completion and transition to results
     */
  }, {
    key: "onCalculationComplete",
    value: function onCalculationComplete() {
      var _this$buttonWrapper8,
        _this$querySelector2,
        _this9 = this;
      this.isShowingCalculation = false;

      // Show quiz UI elements
      (_this$buttonWrapper8 = this.buttonWrapper) === null || _this$buttonWrapper8 === void 0 || _this$buttonWrapper8.classList.remove('tw-hidden');
      (_this$querySelector2 = this.querySelector('.swiper')) === null || _this$querySelector2 === void 0 || _this$querySelector2.classList.remove('tw-hidden');

      // Move to next slide (results page)
      if (this.activeSlider && this.calculationShownForSlide !== null) {
        this.activeSlider.slideNext();
        this.calculationShownForSlide = null;

        // Wait for new-product-section to finish loading before tracking
        // This ensures productQuantities and productNames are saved to localStorage
        var newProductSection = document.querySelector('new-product-section');
        if (newProductSection && newProductSection.isLoading) {
          // Wait for loading to complete
          document.addEventListener('newProductSection:loadingComplete', function () {
            var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
            _this9.trackRecommendationReady(quizData.productHandles || []);
          }, {
            once: true
          });
        } else {
          // Already loaded, track immediately
          var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
          this.trackRecommendationReady(quizData.productHandles || []);
        }
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this0 = this;
      // Must run first — writes to localStorage before child components connect
      this.restoreFromUrlParam();
      this.captureDiscountCodeFromUrl();
      var checkSwiper = setInterval(function () {
        if (typeof Swiper !== 'undefined') {
          _this0.initSlider();
          clearInterval(checkSwiper);
          _this0.initLocalStorage();
          _this0.setupTrackingListeners();
          _this0.handleIntroScreen();
          _this0.validateInputs();
          _this0.replaceDogName();
          _this0.replaceBreedName();
        }
      }, 100);

      // Listen for intro completion event
      document.addEventListener('quiz:intro-completed', function () {
        _this0.onIntroCompleted();
      });

      // Listen for calculation completion event
      if (this.calculationStep) {
        this.calculationStep.addEventListener('calculation-complete', function () {
          _this0.onCalculationComplete();
        });
      }
    }
  }, {
    key: "handleIntroScreen",
    value: function handleIntroScreen() {
      var introScreen = document.querySelector('quiz-intro-screen');

      // When restoring from email link (?q=...), skip intro and go directly to results
      if (this._jumpToResults) {
        if (introScreen) introScreen.classList.add('tw-hidden');
        this.introCompleted = true;
        return;
      }
      if (introScreen && !introScreen.classList.contains('tw-hidden')) {
        // Hide quiz elements when intro screen is active
        var swiper = this.querySelector('.swiper');
        var footer = this.querySelector('quiz-footer');
        if (this.mainProgressBar) this.mainProgressBar.classList.add('tw-hidden');
        if (swiper) swiper.classList.add('tw-hidden');
        if (footer) footer.classList.add('tw-hidden');
        // Note: buttons-wrapper visibility is already controlled by Liquid template and quiz-intro-screen component
      } else {
        // No intro screen or it's already hidden - mark as completed
        this.introCompleted = true;
      }
    }
  }, {
    key: "onIntroCompleted",
    value: function onIntroCompleted() {
      // Quiz elements are already shown by quiz-intro-screen component
      // Just ensure slider is properly initialized
      this.introCompleted = true;

      // Show progress bar after intro completion
      if (this.mainProgressBar) {
        this.mainProgressBar.classList.remove('tw-hidden');
      }

      // Show restart button after intro completion
      var restartBtn = document.querySelector('.quiz__header-restart');
      if (restartBtn) {
        restartBtn.classList.remove('tw-hidden');
      }
      if (this.activeSlider) {
        this.activeSlider.update();

        // Ensure buttons are visible after intro completion
        // First slide after intro should always show buttons for navigation
        if (this.activeSlider.activeIndex === 0) {
          var _this$buttonWrapper9;
          (_this$buttonWrapper9 = this.buttonWrapper) === null || _this$buttonWrapper9 === void 0 || _this$buttonWrapper9.classList.remove('!tw-hidden');
        } else {
          // For other slides, apply normal hide/show logic
          this.hideButtonsBlock(this.activeSlider.activeIndex);
        }
        this.updateButton(this.activeSlider.activeIndex);
      }
    }
  }, {
    key: "saveCurrentSlide",
    value: function saveCurrentSlide() {
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      quizData.currentSlide = this.activeSlider.activeIndex;
      localStorage.setItem('quiz', JSON.stringify(quizData));
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (QuizContainer);

/***/ }),

/***/ "./src/assets/js/quiz-components-v2/quiz-daily-food-collapsible.js":
/*!*************************************************************************!*\
  !*** ./src/assets/js/quiz-components-v2/quiz-daily-food-collapsible.js ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
/**
 * Quiz Daily Food Collapsible Component
 * Displays daily food amounts (dry, wet, snacks) in a collapsible box
 * Design: https://www.figma.com/design/lDSm7eZZHLnDaZRtzaZRgk/HEY-HOLY-Website-ReDesign-AH--Copy-?node-id=10859-9017
 */
var QuizDailyFoodCollapsible = /*#__PURE__*/function (_HTMLElement) {
  function QuizDailyFoodCollapsible() {
    var _this;
    _classCallCheck(this, QuizDailyFoodCollapsible);
    _this = _callSuper(this, QuizDailyFoodCollapsible);
    _this.trigger = null;
    _this.content = null;
    _this.contentInner = null;
    _this.isOpen = false;
    _this.parentContainer = null;
    return _this;
  }
  _inherits(QuizDailyFoodCollapsible, _HTMLElement);
  return _createClass(QuizDailyFoodCollapsible, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      setTimeout(function () {
        return _this2.init();
      }, 10);
    }
  }, {
    key: "init",
    value: function init() {
      var _this3 = this;
      this.trigger = this.querySelector('.quiz-daily-food-collapsible__trigger');
      this.content = this.querySelector('.quiz-daily-food-collapsible__content');
      this.contentInner = this.querySelector('.quiz-daily-food-collapsible__content-inner');
      this.icon = this.querySelector('.quiz-daily-food-collapsible__icon');

      // Find parent container that needs height adjustment
      this.parentContainer = document.querySelector('.last-step-results-page--top');
      if (!this.trigger || !this.content) {
        console.error('Quiz daily food collapsible: Required elements not found');
        return;
      }

      // Setup click handler
      this.trigger.addEventListener('click', function () {
        return _this3.toggle();
      });

      // Load and display food data
      this.loadFoodData();

      // Listen for quiz calculations complete to update data
      document.addEventListener('quiz:calculationsComplete', function () {
        _this3.loadFoodData();
      });

      // Listen for quiz restart to reset state
      document.addEventListener('quiz:restart', function () {
        _this3.reset();
      });
    }

    /**
     * Load food calculation data from localStorage
     */
  }, {
    key: "loadFoodData",
    value: function loadFoodData() {
      try {
        var quizData = JSON.parse(localStorage.getItem('quiz') || '{}');
        var dailyFoodCalc = quizData.dailyFoodCalculation;
        if (!dailyFoodCalc) {
          console.warn('No daily food calculation data found');
          return;
        }
        var _dailyFoodCalc$dailyD = dailyFoodCalc.dailyDryGrams,
          dailyDryGrams = _dailyFoodCalc$dailyD === void 0 ? 0 : _dailyFoodCalc$dailyD,
          _dailyFoodCalc$dailyW = dailyFoodCalc.dailyWetGrams,
          dailyWetGrams = _dailyFoodCalc$dailyW === void 0 ? 0 : _dailyFoodCalc$dailyW,
          _dailyFoodCalc$snacks = dailyFoodCalc.snacksPerDay,
          snacksPerDay = _dailyFoodCalc$snacks === void 0 ? 0 : _dailyFoodCalc$snacks;
        console.log('Daily food data loaded:', {
          dailyDryGrams: dailyDryGrams,
          dailyWetGrams: dailyWetGrams,
          snacksPerDay: snacksPerDay
        });

        // Update dry food
        var dryItem = this.querySelector('[data-food-type="dry"]');
        var dryAmount = this.querySelector('[data-type="dry"]');
        if (dailyDryGrams > 0 && dryItem && dryAmount) {
          dryAmount.textContent = Math.round(dailyDryGrams);
          dryItem.classList.remove('tw-hidden');
        } else if (dryItem) {
          dryItem.classList.add('tw-hidden');
        }

        // Update wet food
        var wetItem = this.querySelector('[data-food-type="wet"]');
        var wetAmount = this.querySelector('[data-type="wet"]');
        if (dailyWetGrams > 0 && wetItem && wetAmount) {
          wetAmount.textContent = Math.round(dailyWetGrams);
          wetItem.classList.remove('tw-hidden');
        } else if (wetItem) {
          wetItem.classList.add('tw-hidden');
        }

        // Update snacks
        var snacksItem = this.querySelector('[data-food-type="snacks"]');
        var snacksAmount = this.querySelector('[data-type="snacks"]');
        if (snacksPerDay > 0 && snacksItem && snacksAmount) {
          snacksAmount.textContent = Math.round(snacksPerDay);
          snacksItem.classList.remove('tw-hidden');
        } else if (snacksItem) {
          snacksItem.classList.add('tw-hidden');
        }
      } catch (error) {
        console.error('Error loading food data:', error);
      }
    }

    /**
     * Toggle collapsible state
     */
  }, {
    key: "toggle",
    value: function toggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }

    /**
     * Open collapsible
     */
  }, {
    key: "open",
    value: function open() {
      if (!this.content || !this.contentInner) {
        console.error('Cannot open: content or contentInner not found');
        return;
      }
      this.isOpen = true;

      // Remove all constraints to measure real height
      this.content.style.maxHeight = '9999px'; // Very large value
      this.content.style.overflow = 'visible';
      this.contentInner.style.opacity = '1';

      // Force reflow
      void this.content.offsetHeight;

      // Get the actual scrollHeight
      var contentHeight = this.contentInner.scrollHeight;

      // If height is still 0, something is wrong
      if (contentHeight === 0) {
        // Try to get height from children directly
        var totalHeight = 0;
        var children = this.contentInner.children;
        var _iterator = _createForOfIteratorHelper(children),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var child = _step.value;
            if (!child.classList.contains('tw-hidden')) {
              totalHeight += child.offsetHeight;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        if (totalHeight > 0) {
          this.content.style.maxHeight = "".concat(totalHeight + 40, "px"); // Add padding
        } else {
          this.content.style.maxHeight = '300px'; // Fallback
        }
      } else {
        // Set the calculated height
        this.content.style.maxHeight = "".concat(contentHeight, "px");
      }
      this.content.style.overflow = '';
      this.content.setAttribute('aria-hidden', 'false');

      // Update trigger
      this.trigger.setAttribute('aria-expanded', 'true');
      this.trigger.classList.add('is-open');

      // Rotate icon (chevron points down when open)
      if (this.icon) {
        this.icon.style.transform = 'rotate(180deg)';
      }

      // Increase parent container height to prevent overlap
      this.adjustParentHeight(contentHeight, true);
      console.log('Collapsible opened with max-height:', this.content.style.maxHeight);
    }

    /**
     * Close collapsible
     */
  }, {
    key: "close",
    value: function close() {
      if (!this.content) return;
      this.isOpen = false;

      // Collapse content
      this.content.style.maxHeight = '0';
      this.content.setAttribute('aria-hidden', 'true');

      // Update trigger
      this.trigger.setAttribute('aria-expanded', 'false');
      this.trigger.classList.remove('is-open');

      // Reset icon rotation (chevron points up when closed)
      if (this.icon) {
        this.icon.style.transform = 'rotate(0deg)';
      }

      // Reset parent container height
      this.adjustParentHeight(0, false);
      console.log('Daily food collapsible closed');
    }

    /**
     * Adjust parent container height to prevent background overlap
     * @param {number} additionalHeight - Height to add/remove
     * @param {boolean} isOpening - Whether we're opening or closing
     */
  }, {
    key: "adjustParentHeight",
    value: function adjustParentHeight(additionalHeight, isOpening) {
      if (!this.parentContainer) return;

      // Add/remove dynamic padding to accommodate collapsible content
      if (isOpening) {
        // Add extra space to prevent overlap with background text
        this.parentContainer.style.paddingBottom = "".concat(additionalHeight + 40, "px");
      } else {
        // Reset padding
        this.parentContainer.style.paddingBottom = '';
      }
    }

    /**
     * Reset component state
     */
  }, {
    key: "reset",
    value: function reset() {
      this.close();
      this.loadFoodData();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      // Cleanup event listeners
      if (this.trigger) {
        this.trigger.removeEventListener('click', this.toggle);
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (QuizDailyFoodCollapsible);

/***/ }),

/***/ "./src/assets/js/quiz-components-v2/quiz-intro-screeen.js":
/*!****************************************************************!*\
  !*** ./src/assets/js/quiz-components-v2/quiz-intro-screeen.js ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var QuizIntroScreen = /*#__PURE__*/function (_HTMLElement) {
  function QuizIntroScreen() {
    var _this;
    _classCallCheck(this, QuizIntroScreen);
    _this = _callSuper(this, QuizIntroScreen);
    _this.startButton = _this.querySelector('[data-intro-start]');
    return _this;
  }
  _inherits(QuizIntroScreen, _HTMLElement);
  return _createClass(QuizIntroScreen, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.checkIntroStatus();
      this.initEventListeners();
    }

    /**
     * Check if intro has been shown before
     * Show intro only on first visit (when quiz data is empty)
     */
  }, {
    key: "checkIntroStatus",
    value: function checkIntroStatus() {
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      var hasBreedPrefill = Boolean(localStorage.getItem('breedfinder_prefill'));
      if (hasBreedPrefill) {
        quizData.intro_completed = true;
        localStorage.setItem('quiz', JSON.stringify(quizData));
        this.skipIntro();
        return;
      }

      // Check if intro was already completed
      if (quizData.intro_completed) {
        this.skipIntro();
        return;
      }

      // Check if user has already started quiz (has any saved data)
      var hasQuizData = quizData.inputs && Object.keys(quizData.inputs).length > 0 || quizData.radioStates && Object.keys(quizData.radioStates).length > 0 || quizData.dropdownStates && Object.keys(quizData.dropdownStates).length > 0 || quizData.checkboxStates && Object.keys(quizData.checkboxStates).length > 0 || quizData.rangeValues && Object.keys(quizData.rangeValues).length > 0 || quizData.sliderStates && Object.keys(quizData.sliderStates).length > 0 || quizData.twoSliderStates && Object.keys(quizData.twoSliderStates).length > 0 || quizData.currentSlide && quizData.currentSlide > 0 || quizData.dogName;
      if (hasQuizData) {
        // Mark as completed and skip
        quizData.intro_completed = true;
        localStorage.setItem('quiz', JSON.stringify(quizData));
        this.skipIntro();
        return;
      }
    }

    /**
     * Skip intro and show quiz immediately
     */
  }, {
    key: "skipIntro",
    value: function skipIntro() {
      this.classList.add('tw-hidden');
      this.showQuizElements();
    }
  }, {
    key: "initEventListeners",
    value: function initEventListeners() {
      var _this2 = this;
      if (this.startButton) {
        this.startButton.addEventListener('click', function () {
          _this2.handleStart();
        });
      }
    }
  }, {
    key: "handleStart",
    value: function handleStart() {
      // Track quiz start in GTM as Step 0
      this.trackQuizStart();

      // Mark intro as completed in localStorage
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      quizData.intro_completed = true;
      localStorage.setItem('quiz', JSON.stringify(quizData));
      console.log('Intro completed, saving to localStorage');

      // Hide intro screen
      this.classList.add('tw-hidden');

      // Show quiz elements
      this.showQuizElements();

      // Dispatch custom event
      var event = new CustomEvent('quiz:intro-completed');
      document.dispatchEvent(event);
    }

    /**
     * Track quiz start event in GTM as Step 0
     * ✅ This is the ONLY place where quiz_start should be tracked
     */
  }, {
    key: "trackQuizStart",
    value: function trackQuizStart() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'quiz_start',
        step_index: 0,
        step_name: 'Step 0',
        progress_percent: 0
      });

      // Mark quiz as started in QuizContainer
      var quizContainer = document.querySelector('quiz-container');
      if (quizContainer) {
        quizContainer.quizStartTracked = true;
      }
    }

    /**
     * Show all quiz elements (progress bar, swiper, footer, buttons)
     */
  }, {
    key: "showQuizElements",
    value: function showQuizElements() {
      // Show progress bar (main progress bar, not the one in calculation step)
      var progressBar = document.querySelector('quiz-progress-bar.main-progress-bar');
      if (progressBar) {
        progressBar.classList.remove('tw-hidden');
        console.log('Progress bar shown');
      }

      // Show swiper
      var swiper = document.querySelector('.swiper');
      if (swiper) {
        swiper.classList.remove('!tw-hidden');
      }

      // Show quiz footer
      var quizFooter = document.querySelector('quiz-footer');
      if (quizFooter) {
        quizFooter.classList.remove('tw-hidden');
      }

      // Show buttons wrapper
      var buttonsWrapper = document.querySelector('.buttons-wrapper');
      if (buttonsWrapper) {
        buttonsWrapper.classList.remove('!tw-hidden');
      }

      // Show restart button
      var restartButton = document.querySelector('.quiz__header-restart');
      if (restartButton) {
        restartButton.classList.remove('tw-hidden');
      }

      // Update quiz-wrapper width by removing intro screen which triggers :has() selector
      var quizWrapper = document.querySelector('.quiz-wrapper');
      if (quizWrapper) {
        // Force reflow to ensure CSS transition applies
        void quizWrapper.offsetWidth;
      }
    }

    /**
     * Reset intro screen to initial state
     * Used when restarting the quiz
     */
  }, {
    key: "resetIntroScreen",
    value: function resetIntroScreen() {
      // Remove completed flag from localStorage
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      delete quizData.intro_completed;
      localStorage.setItem('quiz', JSON.stringify(quizData));

      // Make intro screen visible again
      this.classList.remove('tw-hidden');

      // Reset quiz_start flag in QuizContainer
      var quizContainer = document.querySelector('quiz-container');
      if (quizContainer) {
        quizContainer.quizStartTracked = false;
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('quiz-intro-screen')) {
  customElements.define('quiz-intro-screen', QuizIntroScreen);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (QuizIntroScreen);

/***/ }),

/***/ "./src/assets/js/quiz-components-v2/quiz-klaviyo-form.js":
/*!***************************************************************!*\
  !*** ./src/assets/js/quiz-components-v2/quiz-klaviyo-form.js ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lz_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lz-string */ "./node_modules/lz-string/libs/lz-string.js");
/* harmony import */ var lz_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lz_string__WEBPACK_IMPORTED_MODULE_0__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }

var QuizKlaviyoForm = /*#__PURE__*/function (_HTMLElement) {
  function QuizKlaviyoForm() {
    var _this;
    _classCallCheck(this, QuizKlaviyoForm);
    _this = _callSuper(this, QuizKlaviyoForm);
    _this.form = _this.querySelector('form');
    _this.emailInput = _this.querySelector('#email');
    _this.nameInput = _this.querySelector('#first_name');
    _this.newsletterCheckbox = _this.querySelector('#newsletter_optin');
    _this.messageEl = _this.querySelector('.form-message');
    _this.errorEl = _this.querySelector('.form-error');
    _this.quizContainer = _this.closest('quiz-container');
    _this.isSubmitting = false;
    _this.submittedEmail = null;
    _this.submittedFirstName = null;

    // Klaviyo API credentials
    _this.companyId = 'RwDqhy';
    _this.listId = 'WP5Brn';

    // Google Sheets URL from quiz-container
    _this.googleSheetsUrl = null;

    // Email validation regex
    _this.emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return _this;
  }
  _inherits(QuizKlaviyoForm, _HTMLElement);
  return _createClass(QuizKlaviyoForm, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      // Use setTimeout to ensure DOM is ready
      setTimeout(function () {
        _this2.setupEventListeners();

        // Don't populate on connect - wait for visibility
        // Hidden inputs will be populated when form becomes visible

        _this2.updateNextButtonState(); // Initialize next button state
        _this2.trackEmailCaptureView(); // Track form view

        // Listen for slide change to populate inputs when form is shown
        _this2.setupSlideChangeListener();
      }, 10);
    }

    /**
     * Setup listener for when this form becomes visible (active slide)
     */
  }, {
    key: "setupSlideChangeListener",
    value: function setupSlideChangeListener() {
      var _this3 = this;
      var observer = new MutationObserver(function () {
        if (_this3.isOnActiveSlide()) {
          // Populate inputs every time form becomes visible
          _this3.populateHiddenInputs();
        }
      });

      // Watch parent slide for class changes
      var parentSlide = this.closest('.swiper-slide');
      if (parentSlide) {
        observer.observe(parentSlide, {
          attributes: true,
          attributeFilter: ['class']
        });
      }

      // Also populate when quiz calculations are complete
      document.addEventListener('quiz:calculationsComplete', function () {
        if (_this3.isOnActiveSlide()) {
          _this3.populateHiddenInputs();
        }

        // Update Klaviyo profile with correct quiz URL now that calculations are done
        if (_this3.submittedEmail) {
          _this3.updateKlaviyoProfileUrl();
        }
      });
    }
  }, {
    key: "setupEventListeners",
    value: function setupEventListeners() {
      var _this$emailInput,
        _this4 = this,
        _this$emailInput2,
        _this$nameInput,
        _this$newsletterCheck,
        _this$form;
      // Email input validation
      (_this$emailInput = this.emailInput) === null || _this$emailInput === void 0 || _this$emailInput.addEventListener('input', function () {
        _this4.validateEmail();
        _this4.updateNextButtonState();
        _this4.hideError();
        _this4.saveEmailToStorage(); // Save email to localStorage for Google Sheets
      });
      (_this$emailInput2 = this.emailInput) === null || _this$emailInput2 === void 0 || _this$emailInput2.addEventListener('blur', function () {
        _this4.validateEmail();
        _this4.saveEmailToStorage(); // Save email to localStorage for Google Sheets
      });

      // Name input - just save to localStorage
      (_this$nameInput = this.nameInput) === null || _this$nameInput === void 0 || _this$nameInput.addEventListener('input', function () {
        _this4.saveNameToStorage();
      });

      // Newsletter opt-in checkbox - save state to localStorage
      (_this$newsletterCheck = this.newsletterCheckbox) === null || _this$newsletterCheck === void 0 || _this$newsletterCheck.addEventListener('change', function () {
        _this4.saveNewsletterOptinState();
        _this4.trackNewsletterOptinChange();
        // Toggle active class for visual state
        var label = _this4.newsletterCheckbox.closest('[data-checkbox-label]');
        if (label) {
          label.classList.toggle('is-active', _this4.newsletterCheckbox.checked);
        }
      });

      // Initialize checkbox visual state
      if (this.newsletterCheckbox) {
        var label = this.newsletterCheckbox.closest('[data-checkbox-label]');
        if (label && this.newsletterCheckbox.checked) {
          label.classList.add('is-active');
        }
      }

      // Prevent default form submission - button--next will handle it
      (_this$form = this.form) === null || _this$form === void 0 || _this$form.addEventListener('submit', function (e) {
        e.preventDefault();
      });
    }

    /**
     * Validate email address
     */
  }, {
    key: "validateEmail",
    value: function validateEmail() {
      var _this$emailInput3;
      var email = ((_this$emailInput3 = this.emailInput) === null || _this$emailInput3 === void 0 ? void 0 : _this$emailInput3.value.trim()) || '';
      var isValid = this.emailRegex.test(email);
      if (email && !isValid) {
        var _this$emailInput4;
        (_this$emailInput4 = this.emailInput) === null || _this$emailInput4 === void 0 || _this$emailInput4.classList.add('tw-border-red');
        return false;
      } else {
        var _this$emailInput5;
        (_this$emailInput5 = this.emailInput) === null || _this$emailInput5 === void 0 || _this$emailInput5.classList.remove('tw-border-red');
        return true;
      }
    }

    /**
     * Update next button state based on email validation
     * Only updates if this component is on the active slide
     */
  }, {
    key: "updateNextButtonState",
    value: function updateNextButtonState() {
      var _this$emailInput6;
      // Check if this component is on the active slide
      if (!this.isOnActiveSlide()) {
        return; // Don't update button state if not on active slide
      }
      var nextButton = document.querySelector('.button--next');
      if (!nextButton) return;
      var email = ((_this$emailInput6 = this.emailInput) === null || _this$emailInput6 === void 0 ? void 0 : _this$emailInput6.value.trim()) || '';
      var isValid = this.emailRegex.test(email);
      if (isValid) {
        nextButton.disabled = false;
        nextButton.classList.remove('button--disabled');
      } else {
        nextButton.disabled = true;
        nextButton.classList.add('button--disabled');
      }
    }

    /**
     * Check if this component is on the currently active slide
     */
  }, {
    key: "isOnActiveSlide",
    value: function isOnActiveSlide() {
      if (!this.quizContainer || !this.quizContainer.activeSlider) {
        return false;
      }
      var activeSlide = this.quizContainer.activeSlider.slides[this.quizContainer.activeSlider.activeIndex];
      if (!activeSlide) {
        return false;
      }

      // Check if this component is inside the active slide
      return activeSlide.contains(this);
    }

    /**
     * Check if form is valid (public method)
     */
  }, {
    key: "isValid",
    value: function isValid() {
      var _this$emailInput7;
      var email = ((_this$emailInput7 = this.emailInput) === null || _this$emailInput7 === void 0 ? void 0 : _this$emailInput7.value.trim()) || '';
      return this.emailRegex.test(email);
    }

    /**
     * Save first name to localStorage
     */
  }, {
    key: "saveNameToStorage",
    value: function saveNameToStorage() {
      var _this$nameInput2;
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      quizData.customerFirstName = ((_this$nameInput2 = this.nameInput) === null || _this$nameInput2 === void 0 ? void 0 : _this$nameInput2.value.trim()) || '';
      localStorage.setItem('quiz', JSON.stringify(quizData));
    }

    /**
     * Save email to localStorage
     */
  }, {
    key: "saveEmailToStorage",
    value: function saveEmailToStorage() {
      var _this$emailInput8;
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      quizData.customerEmail = ((_this$emailInput8 = this.emailInput) === null || _this$emailInput8 === void 0 ? void 0 : _this$emailInput8.value.trim()) || '';
      localStorage.setItem('quiz', JSON.stringify(quizData));
    }

    /**
     * Save newsletter opt-in state to localStorage
     */
  }, {
    key: "saveNewsletterOptinState",
    value: function saveNewsletterOptinState() {
      var _this$newsletterCheck2;
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
      quizData.newsletterOptin = ((_this$newsletterCheck2 = this.newsletterCheckbox) === null || _this$newsletterCheck2 === void 0 ? void 0 : _this$newsletterCheck2.checked) || false;
      localStorage.setItem('quiz', JSON.stringify(quizData));
    }

    /**
     * Get newsletter opt-in state
     */
  }, {
    key: "getNewsletterOptinState",
    value: function getNewsletterOptinState() {
      var _this$newsletterCheck3;
      return ((_this$newsletterCheck3 = this.newsletterCheckbox) === null || _this$newsletterCheck3 === void 0 ? void 0 : _this$newsletterCheck3.checked) || false;
    }

    /**
     * Calculate recommended product handle based on quiz data
     * Uses same logic as custom-product-output.js
     */
  }, {
    key: "calculateRecommendedProduct",
    value: function calculateRecommendedProduct() {
      var _quizData$dailyFoodCa, _window$PACKED_PRODUC;
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};

      // Get groupKey - if dailyFoodCalculation exists, use it
      // Otherwise calculate it using PACKED_PRODUCTS.resolveGroup()
      var groupKey = (_quizData$dailyFoodCa = quizData.dailyFoodCalculation) === null || _quizData$dailyFoodCa === void 0 ? void 0 : _quizData$dailyFoodCa.groupKey;
      if (!groupKey && window.PACKED_PRODUCTS && window.PACKED_PRODUCTS.resolveGroup) {
        groupKey = window.PACKED_PRODUCTS.resolveGroup();
      }
      if (!groupKey || !((_window$PACKED_PRODUC = window.PACKED_PRODUCTS) !== null && _window$PACKED_PRODUC !== void 0 && _window$PACKED_PRODUC.groups[groupKey])) {
        console.log('QuizKlaviyoForm: No valid groupKey found');
        return null;
      }
      var group = window.PACKED_PRODUCTS.groups[groupKey];

      // Determine which product to display (wet food has priority for display)
      var productHandle = null;

      // Check food composition to determine primary product (from checkbox-based selection)
      var foodComposition = this.getFoodCompositionFromCheckboxes(quizData);
      var wetPercent = foodComposition.wetPercent / 100;
      if (wetPercent > 0 && group.wet) {
        // For wet food, handle special cases like Minis with multiple variants
        if (group.wet.huhn && group.wet.forelle) {
          var wetVariant = group.wet["default"] || 'huhn';
          productHandle = group.wet[wetVariant].handle;
        } else {
          productHandle = group.wet.handle;
        }
      } else if (group.dry) {
        productHandle = group.dry.handle;
      }
      console.log('QuizKlaviyoForm: Calculated product handle:', productHandle, 'for group:', groupKey);
      return productHandle;
    }

    /**
     * Get food composition from checkbox-based selection
     * Replaces slider-based ratio logic
     *
     * Rules:
     * - Trockenfutter only → 100% dry / 0% wet
     * - Nassfutter only → 100% wet
     * - BARF only → 100% wet
     * - Trockenfutter + any wet option(s) → 50% dry / 50% wet
     * - Nassfutter + BARF (without Trockenfutter) → 100% wet
     */
  }, {
    key: "getFoodCompositionFromCheckboxes",
    value: function getFoodCompositionFromCheckboxes(quizData) {
      var _quizData$checkboxSta, _quizData$twoSliderSt;
      var foodCheckboxes = (quizData === null || quizData === void 0 || (_quizData$checkboxSta = quizData.checkboxStates) === null || _quizData$checkboxSta === void 0 ? void 0 : _quizData$checkboxSta['entry.306846565']) || [];
      var isChecked = function isChecked(key) {
        return foodCheckboxes.some(function (item) {
          return (item.value === key || item.id === key) && item.checked === true;
        });
      };
      var hasDry = isChecked('trockenfutter');
      var hasWet = isChecked('nassfutter');
      var hasBarf = isChecked('barf');
      var hasAnyWet = hasWet || hasBarf;
      if (hasDry && !hasAnyWet) {
        return {
          dryPercent: 100,
          wetPercent: 0
        };
      }
      if (hasDry && hasAnyWet) {
        return {
          dryPercent: 50,
          wetPercent: 50
        };
      }
      if (!hasDry && hasAnyWet) {
        return {
          dryPercent: 0,
          wetPercent: 100
        };
      }

      // Legacy fallback for old slider data
      var legacy = (_quizData$twoSliderSt = quizData.twoSliderStates) === null || _quizData$twoSliderSt === void 0 ? void 0 : _quizData$twoSliderSt['food-composition'];
      if (legacy) {
        return {
          dryPercent: legacy.Trockenfutter || 0,
          wetPercent: legacy.Nassfutter || 0
        };
      }
      return {
        dryPercent: 50,
        wetPercent: 50
      };
    }

    /**
     * Populate hidden inputs from localStorage quiz data
     */
  }, {
    key: "populateHiddenInputs",
    value: function populateHiddenInputs() {
      var _quizData$dropdownSta, _quizData$radioStates, _quizData$sliderState, _quizData$radioStates2, _quizData$radioStates3, _quizData$rangeValues, _quizData$checkboxSta2, _quizData$checkboxSta3, _quizData$customIssue, _quizData$checkboxSta4, _quizData$twoSliderSt2, _quizData$radioStates4;
      var quizData = JSON.parse(localStorage.getItem('quiz')) || {};

      // ===== BASIC DOG INFO =====

      // DOG_NAME
      if (quizData.dogName) {
        this.setHiddenInput('dog_name_hidden', quizData.dogName);
      }

      // DOG_BREED - from dropdownStates["entry.62437307"]
      // Format: "breedTypeStates: purebred; value: Labrador Retriever"
      // We extract just the breed name (e.g., "Labrador Retriever")
      if ((_quizData$dropdownSta = quizData.dropdownStates) !== null && _quizData$dropdownSta !== void 0 && _quizData$dropdownSta['entry.62437307']) {
        var breedValue = quizData.dropdownStates['entry.62437307'];

        // Extract breed type (purebred, mixed, not_sure)
        var breedTypeMatch = breedValue.match(/breedTypeStates:\s*(\w+)/);
        if (breedTypeMatch) {
          this.setHiddenInput('dog_breed_type_hidden', breedTypeMatch[1]);
        }

        // Extract breed names (value, value_1, value_2)
        var breedNames = [];
        var valueMatch = breedValue.match(/value:\s*([^;]+)/);
        var value1Match = breedValue.match(/value_1:\s*([^;]+)/);
        var value2Match = breedValue.match(/value_2:\s*([^;]+)/);
        if (valueMatch) breedNames.push(valueMatch[1].trim());
        if (value1Match) breedNames.push(value1Match[1].trim());
        if (value2Match) breedNames.push(value2Match[1].trim());
        if (breedNames.length > 0) {
          this.setHiddenInput('dog_breed_hidden', breedNames.join(', '));
        }
      }

      // DOG_AGE - from radioStates["age"]
      if ((_quizData$radioStates = quizData.radioStates) !== null && _quizData$radioStates !== void 0 && _quizData$radioStates.age) {
        this.setHiddenInput('dog_age_hidden', quizData.radioStates.age);
      }

      // DOG_WEIGHT - from sliderStates["entry.571080194"]
      if ((_quizData$sliderState = quizData.sliderStates) !== null && _quizData$sliderState !== void 0 && _quizData$sliderState['entry.571080194']) {
        var weight = parseFloat(quizData.sliderStates['entry.571080194']);
        if (!isNaN(weight) && weight > 0) {
          // Round to 1 decimal place for cleaner display
          var roundedWeight = Math.round(weight * 10) / 10;
          this.setHiddenInput('dog_weight_hidden', "".concat(roundedWeight, " kg"));
        }
      }

      // DOG_CASTRATED - from radioStates["entry.724027174"]
      if ((_quizData$radioStates2 = quizData.radioStates) !== null && _quizData$radioStates2 !== void 0 && _quizData$radioStates2['entry.724027174']) {
        this.setHiddenInput('dog_castrated_hidden', quizData.radioStates['entry.724027174']);
      }

      // DOG_ACTIVITY_LEVEL - from radioStates["entry.2024690081"]
      if ((_quizData$radioStates3 = quizData.radioStates) !== null && _quizData$radioStates3 !== void 0 && _quizData$radioStates3['entry.2024690081']) {
        this.setHiddenInput('dog_activity_level_hidden', quizData.radioStates['entry.2024690081']);
      }

      // DOG_BODY_CONDITION - from rangeValues["entry.1373088848"]
      if ((_quizData$rangeValues = quizData.rangeValues) !== null && _quizData$rangeValues !== void 0 && (_quizData$rangeValues = _quizData$rangeValues['entry.1373088848']) !== null && _quizData$rangeValues !== void 0 && _quizData$rangeValues.value) {
        this.setHiddenInput('dog_body_condition_hidden', quizData.rangeValues['entry.1373088848'].value);
      }

      // ===== FOOD PREFERENCES =====

      // DOG_FOOD_TYPE - from checkboxStates["entry.306846565"] (все checked)
      if ((_quizData$checkboxSta2 = quizData.checkboxStates) !== null && _quizData$checkboxSta2 !== void 0 && _quizData$checkboxSta2['entry.306846565']) {
        var selectedFoodTypes = quizData.checkboxStates['entry.306846565'].filter(function (item) {
          return item.checked;
        }).map(function (item) {
          var value = item.textValue || item.value || '';
          return value.split('/-/')[0].trim();
        }).join(', ');
        if (selectedFoodTypes) {
          this.setHiddenInput('dog_food_type_hidden', selectedFoodTypes);
        }
      }

      // DOG_HEALTH_GOALS - from checkboxStates["entry.249999288"] (все checked)
      if ((_quizData$checkboxSta3 = quizData.checkboxStates) !== null && _quizData$checkboxSta3 !== void 0 && _quizData$checkboxSta3['entry.249999288']) {
        var selectedGoals = quizData.checkboxStates['entry.249999288'].filter(function (item) {
          return item.checked;
        }).map(function (item) {
          var value = item.textValue || item.value || '';
          return value.split('/-/')[0].trim();
        }).join(', ');
        if (selectedGoals) {
          this.setHiddenInput('dog_health_goals_hidden', selectedGoals);
        }
      }

      // DOG_HEALTH_OPEN - custom text for non-dog-issue (Keine)
      if ((_quizData$customIssue = quizData.customIssueText) !== null && _quizData$customIssue !== void 0 && _quizData$customIssue['entry.249999288']) {
        var customText = quizData.customIssueText['entry.249999288'];
        if (customText) {
          this.setHiddenInput('dog_health_open_hidden', customText);
        }
      }

      // DOG_FOODSPLIT - from checkbox-based selection (entry.306846565)
      if ((_quizData$checkboxSta4 = quizData.checkboxStates) !== null && _quizData$checkboxSta4 !== void 0 && _quizData$checkboxSta4['entry.306846565']) {
        var composition = this.getFoodCompositionFromCheckboxes(quizData);
        var splitValue = "Nassfutter: ".concat(composition.wetPercent, "%, Trockenfutter: ").concat(composition.dryPercent, "%");
        this.setHiddenInput('dog_foodsplit_hidden', splitValue);
      } else if ((_quizData$twoSliderSt2 = quizData.twoSliderStates) !== null && _quizData$twoSliderSt2 !== void 0 && _quizData$twoSliderSt2['food-composition']) {
        // Legacy fallback for old slider data
        var _composition = quizData.twoSliderStates['food-composition'];
        var _splitValue = "Nassfutter: ".concat(_composition.Nassfutter, "%, Trockenfutter: ").concat(_composition.Trockenfutter, "%");
        this.setHiddenInput('dog_foodsplit_hidden', _splitValue);
      }

      // DOG_SNACKS - from radioStates["snacks"]
      if ((_quizData$radioStates4 = quizData.radioStates) !== null && _quizData$radioStates4 !== void 0 && _quizData$radioStates4.snacks) {
        this.setHiddenInput('dog_snacks_hidden', quizData.radioStates.snacks);
      }

      // DOG_PROTEIN - from proteinSelections (component-protein-v2)
      if (quizData.proteinSelections) {
        var proteinList = Object.entries(quizData.proteinSelections).map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            ingredient = _ref2[0],
            choice = _ref2[1];
          var capitalized = ingredient.charAt(0).toUpperCase() + ingredient.slice(1);
          var choiceLabel = choice === 'yes' ? 'Yes' : 'No';
          return "".concat(capitalized, ": ").concat(choiceLabel);
        }).join(', ');
        if (proteinList) {
          this.setHiddenInput('dog_protein_hidden', proteinList);
        }
      }

      // ===== CALCULATIONS - DAILY AMOUNTS =====

      if (quizData.dailyFoodCalculation) {
        var calc = quizData.dailyFoodCalculation;

        // Daily dry grams
        if (calc.dailyDryGrams) {
          this.setHiddenInput('daily_dry_grams_hidden', "".concat(calc.dailyDryGrams, "g"));
        }

        // Daily wet grams
        if (calc.dailyWetGrams) {
          this.setHiddenInput('daily_wet_grams_hidden', "".concat(calc.dailyWetGrams, "g"));
        }

        // Snacks per day
        if (calc.snacksPerDay !== undefined) {
          this.setHiddenInput('snacks_per_day_hidden', "".concat(calc.snacksPerDay, " pieces"));
        }

        // Group key (breed size group)
        if (calc.groupKey) {
          this.setHiddenInput('group_key_hidden', calc.groupKey);
        }
      }

      // ===== FINAL PRODUCTS AND PRICING =====

      // Get final products from new-product-section component
      var finalProductsData = this.getFinalProductsData();
      if (finalProductsData) {
        // Products list (handles with quantities)
        if (finalProductsData.productsList) {
          this.setHiddenInput('final_products_list_hidden', finalProductsData.productsList);
        }

        // Total price
        if (finalProductsData.totalPrice) {
          this.setHiddenInput('final_total_price_hidden', finalProductsData.totalPrice);
        }

        // Product SKUs
        if (finalProductsData.productSkus) {
          this.setHiddenInput('final_product_skus_hidden', finalProductsData.productSkus);
        }
      }

      // ===== SUBSCRIPTION SETTINGS =====

      // DOG_DELIVERY - from subscriptionIntervallWeeks
      if (quizData.subscriptionIntervallWeeks) {
        this.setHiddenInput('dog_delivery_hidden', "".concat(quizData.subscriptionIntervallWeeks, " weeks"));
      }

      // ===== RECOMMENDED PRODUCT =====

      // DOG_RECOMMENDED_PRODUCT - calculate from current quiz data
      var recommendedProduct = this.calculateRecommendedProduct();
      if (recommendedProduct) {
        this.setHiddenInput('dog_recommended_product_hidden', recommendedProduct);
      } else if (quizData.productHandles && quizData.productHandles.length > 0) {
        // Fallback to productHandles if calculation fails
        this.setHiddenInput('dog_recommended_product_hidden', quizData.productHandles.join(', '));
      }

      // ===== FULL QUIZ DATA JSON (for backup/debugging) =====

      // Save full quiz data as JSON string
      try {
        // Create a clean copy with all important data
        var fullQuizData = {
          dogName: quizData.dogName,
          radioStates: quizData.radioStates,
          checkboxStates: quizData.checkboxStates,
          sliderStates: quizData.sliderStates,
          rangeValues: quizData.rangeValues,
          dropdownStates: quizData.dropdownStates,
          twoSliderStates: quizData.twoSliderStates,
          dailyFoodCalculation: quizData.dailyFoodCalculation,
          subscriptionIntervallWeeks: quizData.subscriptionIntervallWeeks,
          productSkuAmount: quizData.productSkuAmount,
          productHandles: quizData.productHandles,
          customerFirstName: quizData.customerFirstName,
          newsletterOptin: quizData.newsletterOptin,
          timestamp: new Date().toISOString()
        };
      } catch (error) {
        console.error('Error serializing quiz data to JSON:', error);
      }
      console.log('Hidden inputs populated from quiz data');
    }

    /**
     * Get final products data from new-product-section component
     * Returns formatted strings with product handles, quantities, SKUs and total price
     */
  }, {
    key: "getFinalProductsData",
    value: function getFinalProductsData() {
      try {
        var newProductSection = document.querySelector('new-product-section');
        if (!newProductSection) {
          console.warn('new-product-section component not found');
          return null;
        }
        var products = newProductSection.products || [];
        var recommendationProduct = newProductSection.recommendationProduct;

        // Build products list with all products (including recommendation)
        var allProducts = _toConsumableArray(products);
        if (recommendationProduct) {
          allProducts.push(recommendationProduct);
        }
        if (allProducts.length === 0) {
          return null;
        }

        // Format: "handle1 x2, handle2 x1, handle3 x1"
        var productsList = allProducts.map(function (p) {
          return "".concat(p.handle, " x").concat(p.quantity);
        }).join(', ');

        // Format: "sku1, sku1, sku2, sku3" (repeated by quantity)
        var productSkus = [];
        var _iterator = _createForOfIteratorHelper(allProducts),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var product = _step.value;
            var sku = product.sku || product.handle;
            for (var i = 0; i < product.quantity; i++) {
              productSkus.push(sku);
            }
          }

          // Get total price from DOM
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        var totalPriceEl = document.querySelector('[data-total-price]');
        var totalPrice = totalPriceEl ? totalPriceEl.textContent.trim() : null;
        return {
          productsList: productsList,
          productSkus: productSkus.join(', '),
          totalPrice: totalPrice
        };
      } catch (error) {
        console.error('Error getting final products data:', error);
        return null;
      }
    }

    /**
     * Set value of hidden input
     */
  }, {
    key: "setHiddenInput",
    value: function setHiddenInput(id, value) {
      var input = document.getElementById(id);
      if (input && value) {
        input.value = value;
      }
    }

    /**
     * Update dog name in personalized title
     */

    /**
     * Show error message
     */
  }, {
    key: "showError",
    value: function showError() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Ein Fehler ist aufgetreten. Bitte versuche es erneut.';
      if (this.errorEl) {
        this.errorEl.textContent = message;
        this.errorEl.classList.remove('tw-hidden');
      }
    }

    /**
     * Hide error message
     */
  }, {
    key: "hideError",
    value: function hideError() {
      if (this.errorEl) {
        this.errorEl.classList.add('tw-hidden');
      }
    }

    /**
     * Submit form (called by quiz-container when button--next is clicked)
     * Returns promise that resolves when submission is complete
     */
  }, {
    key: "submitForm",
    value: (function () {
      var _submitForm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$emailInput9, _this$nameInput3;
        var email, firstName, klaviyoSuccess, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!this.isSubmitting) {
                _context.n = 1;
                break;
              }
              return _context.a(2, false);
            case 1:
              email = (_this$emailInput9 = this.emailInput) === null || _this$emailInput9 === void 0 ? void 0 : _this$emailInput9.value.trim();
              firstName = ((_this$nameInput3 = this.nameInput) === null || _this$nameInput3 === void 0 ? void 0 : _this$nameInput3.value.trim()) || ''; // Validate email
              if (!(!email || !this.emailRegex.test(email))) {
                _context.n = 2;
                break;
              }
              this.showError('Bitte gib eine gültige E-Mail-Adresse ein.');
              return _context.a(2, false);
            case 2:
              this.isSubmitting = true;
              this.hideError();

              // Save email and name to localStorage before submission
              this.saveEmailToStorage();
              this.saveNameToStorage();
              this.populateHiddenInputs();

              // Track submit attempt
              this.trackEmailSubmit(email);
              _context.p = 3;
              _context.n = 4;
              return this.submitToKlaviyo(email, firstName);
            case 4:
              klaviyoSuccess = _context.v;
              if (klaviyoSuccess) {
                _context.n = 5;
                break;
              }
              throw new Error('Klaviyo submission failed');
            case 5:
              // Submit to Google Sheets (non-blocking)
              if (this.googleSheetsUrl) {
                this.submitToGoogleSheets(email, firstName)["catch"](function (err) {
                  console.warn('Google Sheets submission failed (non-blocking):', err);
                });
              }

              // Track success event
              this.trackEmailSubmitSuccess();

              // Store for deferred quiz URL update (sent after calculations complete)
              this.submittedEmail = email;
              this.submittedFirstName = firstName;
              this.isSubmitting = false;
              return _context.a(2, true);
            case 6:
              _context.p = 6;
              _t = _context.v;
              console.error('Form submission error:', _t);
              this.showError(_t.message || 'Ein Fehler ist aufgetreten. Bitte versuche es erneut.');
              this.isSubmitting = false;
              return _context.a(2, false);
          }
        }, _callee, this, [[3, 6]]);
      }));
      function submitForm() {
        return _submitForm.apply(this, arguments);
      }
      return submitForm;
    }()
    /**
     * Generate a shareable URL encoding minimal quiz state as Base64.
     * Handles Unicode characters (e.g. German umlauts in dog names).
     * @returns {string|null} Full URL or null on error
     */
    )
  }, {
    key: "generateQuizUrl",
    value: function generateQuizUrl() {
      try {
        var _quizData$dailyFoodCa2, _quizData$dailyFoodCa3, _quizData$dailyFoodCa4, _localStorage$getItem, _quizData$productHand, _quizData$dropdownSta2, _quizData$sliderState2, _quizData$rangeValues2;
        var quizData = JSON.parse(localStorage.getItem('quiz')) || {};
        var debugSnapshot = {
          dogName: quizData.dogName,
          groupKey: (_quizData$dailyFoodCa2 = quizData.dailyFoodCalculation) === null || _quizData$dailyFoodCa2 === void 0 ? void 0 : _quizData$dailyFoodCa2.groupKey,
          dailyDryGrams: (_quizData$dailyFoodCa3 = quizData.dailyFoodCalculation) === null || _quizData$dailyFoodCa3 === void 0 ? void 0 : _quizData$dailyFoodCa3.dailyDryGrams,
          dailyWetGrams: (_quizData$dailyFoodCa4 = quizData.dailyFoodCalculation) === null || _quizData$dailyFoodCa4 === void 0 ? void 0 : _quizData$dailyFoodCa4.dailyWetGrams,
          productHandles: quizData.productHandles,
          subscriptionIntervallWeeks: quizData.subscriptionIntervallWeeks,
          checkboxKeys: Object.keys(quizData.checkboxStates || {}),
          proteinKeys: Object.keys(quizData.proteinSelections || {}),
          rawLocalStorageSize: (_localStorage$getItem = localStorage.getItem('quiz')) === null || _localStorage$getItem === void 0 ? void 0 : _localStorage$getItem.length
        };
        console.group('🔍 generateQuizUrl — localStorage snapshot');
        console.log(JSON.stringify(debugSnapshot, null, 2));
        console.log('Full quiz object:', quizData);
        console.groupEnd();

        // checkboxStates: only checked items to reduce payload size.
        // entry.306846565 (food type): textValue not needed — getFoodCompositionFromCheckboxes uses only value/id + checked.
        // entry.249999288 (health issues): textValue kept — quiz-result-page uses it for handleize.
        var checkboxStates = {};
        for (var _i = 0, _Object$entries = Object.entries(quizData.checkboxStates || {}); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            items = _Object$entries$_i[1];
          if (!Array.isArray(items)) continue;
          var checked = items.filter(function (item) {
            return item.checked;
          });
          if (checked.length === 0) continue;
          checkboxStates[key] = key === 'entry.306846565' ? checked.map(function (_ref3) {
            var id = _ref3.id,
              value = _ref3.value,
              c = _ref3.checked;
            return {
              id: id,
              value: value,
              checked: c
            };
          }) : checked;
        }

        // Only include fields that have actual values — omit nulls/empty
        var minimalState = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, quizData.dailyFoodCalculation && {
          dailyFoodCalculation: quizData.dailyFoodCalculation
        }), Object.keys(checkboxStates).length > 0 && {
          checkboxStates: checkboxStates
        }), quizData.proteinSelections && {
          proteinSelections: quizData.proteinSelections
        }), quizData.subscriptionIntervallWeeks && {
          subscriptionIntervallWeeks: quizData.subscriptionIntervallWeeks
        }), quizData.dogName && {
          dogName: quizData.dogName
        }), ((_quizData$productHand = quizData.productHandles) === null || _quizData$productHand === void 0 ? void 0 : _quizData$productHand.length) > 0 && {
          productHandles: quizData.productHandles
        }), quizData.productSkuAmount && {
          productSkuAmount: quizData.productSkuAmount
        }), ((_quizData$dropdownSta2 = quizData.dropdownStates) === null || _quizData$dropdownSta2 === void 0 ? void 0 : _quizData$dropdownSta2['entry.62437307']) && {
          dropdownStates: {
            'entry.62437307': quizData.dropdownStates['entry.62437307']
          }
        }), ((_quizData$sliderState2 = quizData.sliderStates) === null || _quizData$sliderState2 === void 0 ? void 0 : _quizData$sliderState2['entry.571080194']) && {
          sliderStates: {
            'entry.571080194': quizData.sliderStates['entry.571080194']
          }
        }), quizData.radioStates && {
          radioStates: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, quizData.radioStates.age && {
            age: quizData.radioStates.age
          }), quizData.radioStates['entry.724027174'] && {
            'entry.724027174': quizData.radioStates['entry.724027174']
          }), quizData.radioStates['entry.2024690081'] && {
            'entry.2024690081': quizData.radioStates['entry.2024690081']
          }), quizData.radioStates.snacks && {
            snacks: quizData.radioStates.snacks
          })
        }), ((_quizData$rangeValues2 = quizData.rangeValues) === null || _quizData$rangeValues2 === void 0 ? void 0 : _quizData$rangeValues2['entry.1373088848']) && {
          rangeValues: {
            'entry.1373088848': quizData.rangeValues['entry.1373088848']
          }
        }), {}, {
          _ts: Date.now()
        });
        var encoded = lz_string__WEBPACK_IMPORTED_MODULE_0___default().compressToEncodedURIComponent(JSON.stringify(minimalState));
        console.log('🔗 Generated encoded param (first 80 chars):', encoded.substring(0, 80));
        return "".concat(window.location.origin, "/pages/quiz?q=").concat(encoded);
      } catch (error) {
        console.error('QuizKlaviyoForm: Error generating quiz URL:', error);
        return null;
      }
    }

    /**
     * Submit to Klaviyo API with custom properties
     * Newsletter opt-in controls whether user receives marketing emails (double opt-in)
     * Recommendation email is always sent (transactional)
     */
  }, {
    key: "submitToKlaviyo",
    value: (function () {
      var _submitToKlaviyo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(email, firstName) {
        var properties, hiddenInputs, newsletterOptin, profileAttributes, body, response, _errorData$errors, errorData, errorMessage, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              // Collect all properties from hidden inputs
              properties = {};
              hiddenInputs = this.form.querySelectorAll('input[type="hidden"]');
              console.log('Collecting hidden inputs for Klaviyo:', hiddenInputs.length);
              hiddenInputs.forEach(function (input) {
                if (input.value && input.name) {
                  properties[input.name] = input.value;
                  console.log("  - ".concat(input.name, ": ").concat(input.value.substring(0, 100)).concat(input.value.length > 100 ? '...' : ''));
                }
              });

              // Get newsletter opt-in state (GDPR compliant - not preselected)
              newsletterOptin = this.getNewsletterOptinState(); // Add newsletter opt-in state to properties
              properties.NEWSLETTER_OPTIN = newsletterOptin ? 'Yes' : 'No';

              // Add submission timestamp
              properties.SUBMISSION_TIMESTAMP = new Date().toISOString();
              properties.SUBMISSION_DATE = new Date().toLocaleDateString('de-DE');

              // Build profile attributes
              profileAttributes = {
                email: email
              }; // Add first_name if provided
              if (firstName) {
                profileAttributes.first_name = firstName;
              }

              // Add all properties (including DOG_*, DAILY_*, FINAL_*, QUIZ_DATA_JSON)
              profileAttributes.properties = properties;

              // Build Klaviyo API request body
              // Note: Newsletter opt-in will trigger double opt-in flow in Klaviyo
              // Recommendation email is sent separately as transactional email
              body = {
                data: {
                  type: 'subscription',
                  attributes: {
                    profile: {
                      data: {
                        type: 'profile',
                        attributes: profileAttributes
                      }
                    }
                  },
                  relationships: {
                    list: {
                      data: {
                        type: 'list',
                        id: this.listId
                      }
                    }
                  }
                }
              };
              _context2.p = 1;
              _context2.n = 2;
              return fetch("https://a.klaviyo.com/client/subscriptions?company_id=".concat(this.companyId), {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/vnd.api+json',
                  revision: '2023-12-15'
                },
                body: JSON.stringify(body)
              });
            case 2:
              response = _context2.v;
              if (response.ok) {
                _context2.n = 4;
                break;
              }
              _context2.n = 3;
              return response.json()["catch"](function () {
                return null;
              });
            case 3:
              errorData = _context2.v;
              errorMessage = (errorData === null || errorData === void 0 || (_errorData$errors = errorData.errors) === null || _errorData$errors === void 0 || (_errorData$errors = _errorData$errors[0]) === null || _errorData$errors === void 0 ? void 0 : _errorData$errors.detail) || 'Subscription failed';
              throw new Error(errorMessage);
            case 4:
              return _context2.a(2, true);
            case 5:
              _context2.p = 5;
              _t2 = _context2.v;
              console.error('Klaviyo API error:', _t2);
              throw _t2;
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 5]]);
      }));
      function submitToKlaviyo(_x, _x2) {
        return _submitToKlaviyo.apply(this, arguments);
      }
      return submitToKlaviyo;
    }()
    /**
     * Submit to Google Sheets
     */
    )
  }, {
    key: "submitToGoogleSheets",
    value: (function () {
      var _submitToGoogleSheets = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(email, firstName) {
        var formData, hiddenInputs, entryIndex, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (this.googleSheetsUrl) {
                _context3.n = 1;
                break;
              }
              console.warn('Google Sheets URL not configured');
              return _context3.a(2);
            case 1:
              // Build form data for Google Sheets
              formData = new FormData();
              formData.append('entry.2000000001', new Date().toISOString()); // Timestamp
              formData.append('entry.2000000002', email); // Email
              formData.append('entry.2000000003', firstName); // First Name
              formData.append('entry.2000000004', 'quiz'); // Source

              // Add all DOG_* properties from hidden inputs
              hiddenInputs = this.form.querySelectorAll('input[type="hidden"]');
              entryIndex = 2000000005;
              hiddenInputs.forEach(function (input) {
                if (input.value && input.name) {
                  formData.append("entry.".concat(entryIndex), "".concat(input.name, ": ").concat(input.value));
                  entryIndex++;
                }
              });
              _context3.p = 2;
              _context3.n = 3;
              return fetch(this.googleSheetsUrl, {
                method: 'POST',
                body: formData,
                mode: 'no-cors' // Google Forms requires no-cors
              });
            case 3:
              console.log('Google Sheets submission sent (no-cors, cannot verify success)');
              _context3.n = 5;
              break;
            case 4:
              _context3.p = 4;
              _t3 = _context3.v;
              console.error('Google Sheets submission error:', _t3);
              // Don't throw - this is non-blocking
            case 5:
              return _context3.a(2);
          }
        }, _callee3, this, [[2, 4]]);
      }));
      function submitToGoogleSheets(_x3, _x4) {
        return _submitToGoogleSheets.apply(this, arguments);
      }
      return submitToGoogleSheets;
    }()
    /**
     * Update Klaviyo profile with quiz recommendation URL after calculations complete.
     * Called deferred via quiz:calculationsComplete event so localStorage has full data.
     */
    )
  }, {
    key: "updateKlaviyoProfileUrl",
    value: (function () {
      var _updateKlaviyoProfileUrl = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var quizUrl, body, _t4;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              quizUrl = this.generateQuizUrl();
              if (!(!quizUrl || !this.submittedEmail)) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              body = {
                data: {
                  type: 'profile',
                  attributes: {
                    email: this.submittedEmail,
                    properties: {
                      QUIZ_RECOMMENDATION_URL: quizUrl
                    }
                  }
                }
              };
              _context4.p = 2;
              _context4.n = 3;
              return fetch("https://a.klaviyo.com/client/profiles/?company_id=".concat(this.companyId), {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/vnd.api+json',
                  revision: '2023-12-15'
                },
                body: JSON.stringify(body)
              });
            case 3:
              console.log('QuizKlaviyoForm: Quiz URL updated in Klaviyo profile', quizUrl);
              _context4.n = 5;
              break;
            case 4:
              _context4.p = 4;
              _t4 = _context4.v;
              console.warn('QuizKlaviyoForm: Failed to update quiz URL in Klaviyo:', _t4);
            case 5:
              return _context4.a(2);
          }
        }, _callee4, this, [[2, 4]]);
      }));
      function updateKlaviyoProfileUrl() {
        return _updateKlaviyoProfileUrl.apply(this, arguments);
      }
      return updateKlaviyoProfileUrl;
    }()
    /**
     * Track email capture view
     */
    )
  }, {
    key: "trackEmailCaptureView",
    value: function trackEmailCaptureView() {
      var _this$quizContainer;
      if ((_this$quizContainer = this.quizContainer) !== null && _this$quizContainer !== void 0 && _this$quizContainer.pushToDataLayer) {
        var _this$quizContainer$a, _this$quizContainer$c, _this$quizContainer2;
        this.quizContainer.pushToDataLayer('quiz_email_capture_view', {
          step_name: 'step_12_klaviyo_step',
          step_index: (((_this$quizContainer$a = this.quizContainer.activeSlider) === null || _this$quizContainer$a === void 0 ? void 0 : _this$quizContainer$a.activeIndex) || 0) + 1,
          progress_percent: ((_this$quizContainer$c = (_this$quizContainer2 = this.quizContainer).calculateProgress) === null || _this$quizContainer$c === void 0 ? void 0 : _this$quizContainer$c.call(_this$quizContainer2)) || 0
        });
      }
    }

    /**
     * Track email submit attempt
     */
  }, {
    key: "trackEmailSubmit",
    value: function trackEmailSubmit(email) {
      var _this$quizContainer3;
      if ((_this$quizContainer3 = this.quizContainer) !== null && _this$quizContainer3 !== void 0 && _this$quizContainer3.pushToDataLayer) {
        var _this$nameInput4;
        this.quizContainer.pushToDataLayer('quiz_email_submit', {
          step_name: 'step_12_klaviyo_step',
          step_12_klaviyo_step: {
            email: email,
            first_name: ((_this$nameInput4 = this.nameInput) === null || _this$nameInput4 === void 0 ? void 0 : _this$nameInput4.value.trim()) || null
          }
        });
      }
    }

    /**
     * Track email submit success
     */
  }, {
    key: "trackEmailSubmitSuccess",
    value: function trackEmailSubmitSuccess() {
      var _this$quizContainer4, _this$emailInput0, _this$nameInput5, _this$quizContainer5;
      if ((_this$quizContainer4 = this.quizContainer) !== null && _this$quizContainer4 !== void 0 && _this$quizContainer4.pushToDataLayer) {
        this.quizContainer.pushToDataLayer('quiz_email_submit_success', {
          step_name: 'step_12_klaviyo_step',
          newsletter_optin: this.getNewsletterOptinState()
        });
      }

      // Dispatch klaviyo_form event for step tracking (step_12_klaviyo_step)
      var email = ((_this$emailInput0 = this.emailInput) === null || _this$emailInput0 === void 0 ? void 0 : _this$emailInput0.value.trim()) || '';
      var name = ((_this$nameInput5 = this.nameInput) === null || _this$nameInput5 === void 0 ? void 0 : _this$nameInput5.value.trim()) || '';
      var newsletterOptin = this.getNewsletterOptinState();
      document.dispatchEvent(new CustomEvent('quiz:input-changed', {
        detail: {
          type: 'klaviyo_form',
          fieldKey: 'klaviyo_form',
          value: {
            email: email,
            name: name,
            newsletter_optin: newsletterOptin
          },
          slideIndex: ((_this$quizContainer5 = this.quizContainer) === null || _this$quizContainer5 === void 0 || (_this$quizContainer5 = _this$quizContainer5.activeSlider) === null || _this$quizContainer5 === void 0 ? void 0 : _this$quizContainer5.activeIndex) || 10
        }
      }));
    }

    /**
     * Track newsletter opt-in change
     */
  }, {
    key: "trackNewsletterOptinChange",
    value: function trackNewsletterOptinChange() {
      var _this$quizContainer6;
      if ((_this$quizContainer6 = this.quizContainer) !== null && _this$quizContainer6 !== void 0 && _this$quizContainer6.pushToDataLayer) {
        this.quizContainer.pushToDataLayer('quiz_newsletter_optin_change', {
          step_name: 'step_12_klaviyo_step',
          newsletter_optin: this.getNewsletterOptinState()
        });
      }
    }

    /**
     * Reset form to initial state
     * Called when quiz is restarted
     */
  }, {
    key: "reset",
    value: function reset() {
      var _this$form2;
      console.log('QuizKlaviyoForm: Resetting form');

      // Clear email and name inputs
      if (this.emailInput) {
        this.emailInput.value = '';
        this.emailInput.classList.remove('tw-border-red');
      }
      if (this.nameInput) {
        this.nameInput.value = '';
      }

      // Set newsletter checkbox to checked (default state)
      if (this.newsletterCheckbox) {
        this.newsletterCheckbox.checked = true;
        var label = this.newsletterCheckbox.closest('[data-checkbox-label]');
        if (label) {
          label.classList.add('is-active');
        }
      }

      // Clear all hidden inputs
      var hiddenInputs = (_this$form2 = this.form) === null || _this$form2 === void 0 ? void 0 : _this$form2.querySelectorAll('input[type="hidden"]');
      if (hiddenInputs) {
        hiddenInputs.forEach(function (input) {
          input.value = '';
        });
      }

      // Hide any error messages
      this.hideError();

      // Reset submission flag
      this.isSubmitting = false;
      this.submittedEmail = null;
      this.submittedFirstName = null;

      // Update button state
      this.updateNextButtonState();
      console.log('QuizKlaviyoForm: Reset complete');
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register component
if (!customElements.get('quiz-klaviyo-form')) {
  customElements.define('quiz-klaviyo-form', QuizKlaviyoForm);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (QuizKlaviyoForm);

/***/ }),

/***/ "./src/assets/js/quiz-components-v2/quiz-progress-bar.js":
/*!***************************************************************!*\
  !*** ./src/assets/js/quiz-components-v2/quiz-progress-bar.js ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var QuizProgress = /*#__PURE__*/function (_HTMLElement) {
  function QuizProgress() {
    var _this;
    _classCallCheck(this, QuizProgress);
    _this = _callSuper(this, QuizProgress);
    _this.progressBar = null;
    _this.counterText = null;
    _this.parentQuiz = null;
    _this.stepsInfo = null;
    _this.totalSteps = 0;
    _this.progressMap = {};
    _this.maxReachedProgress = 0;
    _this.isInitialized = false;

    // Non-linear progress configuration for 15 steps (target spec)
    _this.progressMapFull = {
      0: 10,
      // Step 1
      1: 20,
      // Step 2
      2: 30,
      // Step 3
      3: 40,
      // Step 4
      4: 40,
      // Step 5 (Info)
      5: 50,
      // Step 6
      6: 60,
      // Step 7
      7: 70,
      // Step 8
      8: 75,
      // Step 9
      9: 80,
      // Step 10
      10: 90,
      // Step 11
      11: 95,
      // Step 12
      12: 98,
      // Step 13
      14: 100 // Step 15 (Final)
    };
    return _this;
  }

  /**
   * Initialize component data when parent quiz is ready
   */
  _inherits(QuizProgress, _HTMLElement);
  return _createClass(QuizProgress, [{
    key: "initializeData",
    value: function initializeData() {
      if (this.isInitialized) return true;
      this.progressBar = this.querySelector('.quiz-progress-bar__fill');
      this.counterText = this.querySelector('.quiz-progress-bar__counter');
      this.parentQuiz = this.closest('quiz-container');
      if (!this.parentQuiz || !this.parentQuiz.activeSlider) {
        return false;
      }

      // Get actual slide count from Swiper
      var swiperSlides = this.parentQuiz.activeSlider.slides;
      if (!swiperSlides || swiperSlides.length === 0) {
        return false;
      }
      this.totalSteps = swiperSlides.length;
      this.progressMap = this.generateProgressMap();
      this.isInitialized = true;
      return true;
    }

    /**
     * Generate non-linear progress map for current step count
     * Maintains fast initial progress and slower precision later
     */
  }, {
    key: "generateProgressMap",
    value: function generateProgressMap() {
      var map = {};
      if (this.totalSteps === 15) {
        // Use full spec mapping for 15 steps
        return this.progressMapFull;
      }

      // For 3 steps: maintain non-linear progression
      if (this.totalSteps === 3) {
        map[0] = 30; // Step 1: Fast start
        map[1] = 60; // Step 2: Middle progress
        map[2] = 100; // Step 3: Complete
        return map;
      }

      // For other step counts: calculate proportional non-linear progression
      for (var i = 0; i < this.totalSteps; i++) {
        if (i === 0) {
          // First step: quick momentum (10%)
          map[i] = 10;
        } else if (i === this.totalSteps - 1) {
          // Last step: complete (100%)
          map[i] = 100;
        } else {
          // Middle steps: distribute remaining 90% non-linearly
          // Early steps progress faster, later steps slower
          var position = i / (this.totalSteps - 1);
          var curveAdjustment = Math.pow(position, 0.8); // Slight curve for non-linearity
          map[i] = Math.round(10 + curveAdjustment * 88); // 10% to 98%
        }
      }
      return map;
    }

    /**
     * Set progress to 97% for calculation step
     * Called directly by quiz-calculation-step component
     */
  }, {
    key: "setCalculationProgress",
    value: function setCalculationProgress() {
      if (!this.progressBar) {
        this.progressBar = this.querySelector('.quiz-progress-bar__fill');
      }
      if (this.progressBar) {
        this.progressBar.style.width = '97%';
      }
      this.maxReachedProgress = Math.max(97, this.maxReachedProgress);

      // Remove complete state if applied
      this.classList.remove('is-complete');
    }
  }, {
    key: "updateProgress",
    value: function updateProgress(currentIndex) {
      if (!this.isInitialized) {
        if (!this.initializeData()) {
          return;
        }
      }

      // Get configured progress for current step
      var configuredProgress = this.progressMap[currentIndex] || 0;

      // Apply clamp: never drop below max reached
      var actualProgress = Math.max(configuredProgress, this.maxReachedProgress);
      this.maxReachedProgress = actualProgress;

      // Update progress bar fill with smooth animation
      if (this.progressBar) {
        this.progressBar.style.width = "".concat(actualProgress, "%");
      }

      // Update counter (current/total)
      if (this.counterText) {
        this.counterText.textContent = "".concat(currentIndex + 1, "/").concat(this.totalSteps);
      }

      // Toggle complete state at 100%
      if (actualProgress >= 100) {
        this.classList.add('is-complete');
      } else {
        this.classList.remove('is-complete');
      }
    }

    /**
     * Reset progress bar to initial state
     * Used when restarting the quiz
     */
  }, {
    key: "reset",
    value: function reset() {
      // Reset progress tracking
      this.maxReachedProgress = 0;

      // Reset visual elements
      if (this.progressBar) {
        this.progressBar.style.width = '0%';
      }
      if (this.counterText && this.totalSteps > 0) {
        this.counterText.textContent = "1/".concat(this.totalSteps);
      }

      // Remove complete state
      this.classList.remove('is-complete');

      // Update to first step (index 0)
      this.updateProgress(0);
      console.log('Progress bar reset to initial state');
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      // Check if this is a calculation step progress bar
      var isCalculationStepBar = this.closest('quiz-calculation-step');
      if (isCalculationStepBar) {
        // Simple initialization for calculation step - just find fill element
        this.progressBar = this.querySelector('.quiz-progress-bar__fill');
        this.setCalculationProgress();
        return;
      }

      // Wait for parent quiz container to initialize
      var _initializeWithDelay = function initializeWithDelay() {
        if (_this2.initializeData()) {
          var _this2$parentQuiz$act;
          // Successfully initialized - update to current step
          var currentIndex = ((_this2$parentQuiz$act = _this2.parentQuiz.activeSlider) === null || _this2$parentQuiz$act === void 0 ? void 0 : _this2$parentQuiz$act.activeIndex) || 0;
          _this2.updateProgress(currentIndex);

          // Listen for slide changes
          _this2.parentQuiz.addEventListener('slideChange', function (event) {
            _this2.updateProgress(event.detail.activeIndex);
          });
        } else {
          // Retry initialization after delay
          setTimeout(_initializeWithDelay, 100);
        }
      };

      // Start initialization attempt
      setTimeout(_initializeWithDelay, 50);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (QuizProgress);

/***/ }),

/***/ "./src/assets/js/quiz-components-v2/quiz-result-page.js":
/*!**************************************************************!*\
  !*** ./src/assets/js/quiz-components-v2/quiz-result-page.js ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
/**
 * Quiz Results Page - Health issues bullets display
 * Logic: 1 issue = 3 bullets, 2 issues = 2+1 bullets, 3+ issues = 1+1+1 bullets
 */
var QuizResultsPage = /*#__PURE__*/function (_HTMLElement) {
  function QuizResultsPage() {
    var _this;
    _classCallCheck(this, QuizResultsPage);
    _this = _callSuper(this, QuizResultsPage);
    _this.quizContainer = _this.closest('quiz-container');
    _this.bulletItems = null;
    return _this;
  }

  /**
   * Convert string to handle format (like Shopify's handleize filter)
   * @param {string} str - Input string
   * @returns {string} - Handleized string
   */
  _inherits(QuizResultsPage, _HTMLElement);
  return _createClass(QuizResultsPage, [{
    key: "handleize",
    value: function handleize(str) {
      if (!str) return '';
      return str.toLowerCase().replace(/[äÄ]/g, 'a').replace(/[öÖ]/g, 'o').replace(/[üÜ]/g, 'u').replace(/ß/g, 'ss').replace(/[^a-z0-9]+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.bulletItems = this.querySelectorAll('.result-page__bullet-item');
      this.showBullets();

      // Start listening for breed changes
      this.listenToBreedChanges();

      // Listen for quiz data updates
      document.addEventListener('quiz:calculationsComplete', function () {
        _this2.showBullets();
        _this2.checkAndUpdateText();
      });
      document.addEventListener('product:loadingComplete', function () {
        _this2.bulletItems = _this2.querySelectorAll('.result-page__bullet-item');
        _this2.showBullets();
        _this2.checkAndUpdateText();
      });
    }

    /**
     * Get checked health issues from quiz localStorage
     * @returns {Array} Array of handleized issue names
     */
  }, {
    key: "getCheckedIssues",
    value: function getCheckedIssues() {
      var _this3 = this;
      var quizData = JSON.parse(localStorage.getItem('quiz') || '{}');
      var problems = quizData.checkboxStates && quizData.checkboxStates['entry.249999288'];
      if (!problems || !Array.isArray(problems)) {
        return [];
      }

      // Filter out "keine probleme" and get checked items
      return problems.filter(function (item) {
        if (!item.checked || !item.textValue) return false;
        var lowerText = item.textValue.toLowerCase();
        return !lowerText.includes('keine probleme');
      }).map(function (item) {
        return _this3.handleize(item.textValue.split('/-/')[0].trim());
      });
    }

    /**
     * Show bullets based on checked health issues
     * Logic:
     * - 1 issue: bullet_1 + bullet_2 + bullet_3 of that issue (3 bullets)
     * - 2 issues: bullet_1 of 1st + bullet_1 of 2nd + bullet_2 of 1st (3 bullets)
     * - 3+ issues: bullet_1 of each matched issue (show as many as selected)
     */
  }, {
    key: "showBullets",
    value: function showBullets() {
      if (!this.bulletItems || this.bulletItems.length === 0) {
        this.bulletItems = this.querySelectorAll('.result-page__bullet-item');
        if (!this.bulletItems || this.bulletItems.length === 0) return;
      }

      // Hide all bullets first
      this.bulletItems.forEach(function (el) {
        return el.classList.add('!tw-hidden');
      });
      var checkedIssues = this.getCheckedIssues();
      var issueCount = checkedIssues.length;
      if (issueCount === 0) {
        return;
      }

      // Build map of bullets by issue handle
      var bulletMap = {};
      var allHandles = [];
      this.bulletItems.forEach(function (el) {
        var handle = el.dataset.issueHandle;
        var bulletIndex = parseInt(el.dataset.bulletIndex, 10);
        if (!bulletMap[handle]) {
          bulletMap[handle] = {};
          allHandles.push(handle);
        }
        bulletMap[handle][bulletIndex] = el;
      });

      // Match checked issues to metaobject handles (partial match support)
      var matchedHandles = [];
      checkedIssues.forEach(function (checkedHandle) {
        // Try exact match first
        if (bulletMap[checkedHandle]) {
          matchedHandles.push(checkedHandle);
          return;
        }
        // Try partial match - check if metaobject handle contains quiz handle or vice versa
        var partialMatch = allHandles.find(function (metaHandle) {
          return metaHandle.includes(checkedHandle) || checkedHandle.includes(metaHandle);
        });
        if (partialMatch && !matchedHandles.includes(partialMatch)) {
          matchedHandles.push(partialMatch);
        }
      });
      var matchedCount = matchedHandles.length;
      if (matchedCount === 0) {
        return;
      }
      var bulletsToShow = [];
      if (matchedCount === 1) {
        // 1 issue: show bullet_1, bullet_2, bullet_3 of that issue
        var issue = matchedHandles[0];
        if (bulletMap[issue][1]) bulletsToShow.push(bulletMap[issue][1]);
        if (bulletMap[issue][2]) bulletsToShow.push(bulletMap[issue][2]);
        if (bulletMap[issue][3]) bulletsToShow.push(bulletMap[issue][3]);
      } else if (matchedCount === 2) {
        // 2 issues: bullet_1 of 1st + bullet_1 of 2nd + bullet_2 of 1st (or 2nd)
        var issue1 = matchedHandles[0];
        var issue2 = matchedHandles[1];
        if (bulletMap[issue1][1]) bulletsToShow.push(bulletMap[issue1][1]);
        if (bulletMap[issue2][1]) bulletsToShow.push(bulletMap[issue2][1]);

        // Add bullet_2 from first issue if exists, otherwise from second
        if (bulletMap[issue1][2]) {
          bulletsToShow.push(bulletMap[issue1][2]);
        } else if (bulletMap[issue2][2]) {
          bulletsToShow.push(bulletMap[issue2][2]);
        }
      } else {
        // 3+ issues: bullet_1 of each matched issue (show all selected, not limited to 3)
        for (var i = 0; i < matchedCount; i++) {
          var _issue = matchedHandles[i];
          if (bulletMap[_issue][1]) bulletsToShow.push(bulletMap[_issue][1]);
        }
      }

      // Show all selected bullets
      bulletsToShow.forEach(function (el) {
        el.classList.remove('!tw-hidden');
      });
    }

    /**
     * Get current breed group from PACKED_PRODUCTS
     * @returns {string} Current breed group key
     */
  }, {
    key: "getCurrentBreed",
    value: function getCurrentBreed() {
      if (window.PACKED_PRODUCTS && typeof window.PACKED_PRODUCTS.resolveGroup === 'function') {
        return window.PACKED_PRODUCTS.resolveGroup();
      }
      return null;
    }

    /**
     * Parse specific vet text data from attribute
     * @returns {Array} Array of breed-specific text objects
     */
  }, {
    key: "parseSpecificVetText",
    value: function parseSpecificVetText() {
      var dataAttr = this.getAttribute('data-specific-vet-text');
      if (!dataAttr) return [];
      try {
        var parsed = JSON.parse(dataAttr);
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        console.error('Failed to parse specific-vet-text:', e);
        return [];
      }
    }

    /**
     * Find specific text for given breed
     * @param {string} breed - Breed key
     * @returns {string|null} Specific text for breed or null
     */
  }, {
    key: "findTextForBreed",
    value: function findTextForBreed(breed) {
      if (!breed) return null;
      var textData = this.parseSpecificVetText();
      var breedEntry = textData.find(function (entry) {
        return entry.breed === breed;
      });
      return breedEntry ? breedEntry.specific_text : null;
    }

    /**
     * Insert specific vet text into content block
     */
  }, {
    key: "insertSpecificVetText",
    value: function insertSpecificVetText() {
      var contentTextBlock = this.querySelector('.result-page__content-text');
      if (!contentTextBlock) return;
      var currentBreed = this.getCurrentBreed();
      if (!currentBreed) return;
      var specificText = this.findTextForBreed(currentBreed);
      if (!specificText) return;

      // Overwrite content with specific vet text
      contentTextBlock.innerHTML = specificText;
    }

    /**
     * Listen to breed selection changes from localStorage
     */
  }, {
    key: "listenToBreedChanges",
    value: function listenToBreedChanges() {
      var _this4 = this;
      // Initial check
      this.checkAndUpdateText();

      // Listen for storage changes
      window.addEventListener('storage', function () {
        _this4.checkAndUpdateText();
      });

      // Listen for custom quiz events
      document.addEventListener('quiz:input-changed', function (event) {
        if (event.detail.type === 'dropdown' && event.detail.fieldKey === 'entry.62437307') {
          setTimeout(function () {
            _this4.checkAndUpdateText();
          }, 100);
        }
      });

      // Poll for changes (fallback)
      setInterval(function () {
        _this4.checkAndUpdateText();
      }, 1000);
    }

    /**
     * Check localStorage and update text if breed changed
     */
  }, {
    key: "checkAndUpdateText",
    value: function checkAndUpdateText() {
      var currentBreed = this.getCurrentBreed();
      if (!currentBreed) return;
      var contentTextBlock = this.querySelector('.result-page__content-text');
      if (!contentTextBlock) return;
      var specificText = this.findTextForBreed(currentBreed);
      if (!specificText) return;

      // Update text only if different from current content
      if (contentTextBlock.innerHTML !== specificText) {
        contentTextBlock.innerHTML = specificText;
        console.log("Updated specific vet text for breed: ".concat(currentBreed));
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (QuizResultsPage);

/***/ }),

/***/ "./src/assets/js/quiz-v2.js":
/*!**********************************!*\
  !*** ./src/assets/js/quiz-v2.js ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _quiz_components_v2_quiz_container__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./quiz-components-v2/quiz-container */ "./src/assets/js/quiz-components-v2/quiz-container.js");
/* harmony import */ var _quiz_components_v2_breed_radio_selector__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./quiz-components-v2/breed-radio-selector */ "./src/assets/js/quiz-components-v2/breed-radio-selector.js");
/* harmony import */ var _quiz_components_v2_custom_dropdown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./quiz-components-v2/custom-dropdown */ "./src/assets/js/quiz-components-v2/custom-dropdown.js");
/* harmony import */ var _quiz_components_v2_custom_image_slider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./quiz-components-v2/custom-image-slider */ "./src/assets/js/quiz-components-v2/custom-image-slider.js");
/* harmony import */ var _quiz_components_v2_custom_input_checkbox__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./quiz-components-v2/custom-input-checkbox */ "./src/assets/js/quiz-components-v2/custom-input-checkbox.js");
/* harmony import */ var _quiz_components_v2_custom_input_radio__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./quiz-components-v2/custom-input-radio */ "./src/assets/js/quiz-components-v2/custom-input-radio.js");
/* harmony import */ var _quiz_components_v2_custom_input_range_image_v2__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./quiz-components-v2/custom-input-range-image-v2 */ "./src/assets/js/quiz-components-v2/custom-input-range-image-v2.js");
/* harmony import */ var _quiz_components_v2_custom_input_text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./quiz-components-v2/custom-input-text */ "./src/assets/js/quiz-components-v2/custom-input-text.js");
/* harmony import */ var _quiz_components_v2_custom_product_output__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./quiz-components-v2/custom-product-output */ "./src/assets/js/quiz-components-v2/custom-product-output.js");
/* harmony import */ var _quiz_components_v2_custom_slider_input__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./quiz-components-v2/custom-slider-input */ "./src/assets/js/quiz-components-v2/custom-slider-input.js");
/* harmony import */ var _quiz_components_v2_custom_two_input_sliders__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./quiz-components-v2/custom-two-input-sliders */ "./src/assets/js/quiz-components-v2/custom-two-input-sliders.js");
/* harmony import */ var _quiz_components_v2_quiz_calculation_step__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./quiz-components-v2/quiz-calculation-step */ "./src/assets/js/quiz-components-v2/quiz-calculation-step.js");
/* harmony import */ var _quiz_components_v2_quiz_intro_screeen__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./quiz-components-v2/quiz-intro-screeen */ "./src/assets/js/quiz-components-v2/quiz-intro-screeen.js");
/* harmony import */ var _quiz_components_v2_quiz_progress_bar__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./quiz-components-v2/quiz-progress-bar */ "./src/assets/js/quiz-components-v2/quiz-progress-bar.js");
/* harmony import */ var _quiz_components_v2_quiz_result_page__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./quiz-components-v2/quiz-result-page */ "./src/assets/js/quiz-components-v2/quiz-result-page.js");
/* harmony import */ var _quiz_components_v2_quiz_klaviyo_form__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./quiz-components-v2/quiz-klaviyo-form */ "./src/assets/js/quiz-components-v2/quiz-klaviyo-form.js");
/* harmony import */ var _quiz_components_v2_quiz_daily_food_collapsible__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./quiz-components-v2/quiz-daily-food-collapsible */ "./src/assets/js/quiz-components-v2/quiz-daily-food-collapsible.js");
/* harmony import */ var _quiz_components_v2_component_protein_v2__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./quiz-components-v2/component-protein-v2 */ "./src/assets/js/quiz-components-v2/component-protein-v2.js");


















if (!customElements.get('component-protein-v2')) {
  customElements.define('component-protein-v2', _quiz_components_v2_component_protein_v2__WEBPACK_IMPORTED_MODULE_17__["default"]);
}
if (!customElements.get('quiz-daily-food-collapsible')) {
  customElements.define('quiz-daily-food-collapsible', _quiz_components_v2_quiz_daily_food_collapsible__WEBPACK_IMPORTED_MODULE_16__["default"]);
}
if (!customElements.get('quiz-container')) {
  customElements.define('quiz-container', _quiz_components_v2_quiz_container__WEBPACK_IMPORTED_MODULE_0__["default"]);
}
if (!customElements.get('quiz-result-page')) {
  customElements.define('quiz-result-page', _quiz_components_v2_quiz_result_page__WEBPACK_IMPORTED_MODULE_14__["default"]);
}
if (!customElements.get('quiz-progress-bar')) {
  customElements.define('quiz-progress-bar', _quiz_components_v2_quiz_progress_bar__WEBPACK_IMPORTED_MODULE_13__["default"]);
}
if (!customElements.get('quiz-intro-screen')) {
  customElements.define('quiz-intro-screen', _quiz_components_v2_quiz_intro_screeen__WEBPACK_IMPORTED_MODULE_12__["default"]);
}
if (!customElements.get('quiz-calculation-step')) {
  customElements.define('quiz-calculation-step', _quiz_components_v2_quiz_calculation_step__WEBPACK_IMPORTED_MODULE_11__["default"]);
}
if (!customElements.get('custom-two-input-sliders')) {
  customElements.define('custom-two-input-sliders', _quiz_components_v2_custom_two_input_sliders__WEBPACK_IMPORTED_MODULE_10__["default"]);
}
if (!customElements.get('custom-slider-input')) {
  customElements.define('custom-slider-input', _quiz_components_v2_custom_slider_input__WEBPACK_IMPORTED_MODULE_9__["default"]);
}
if (!customElements.get('custom-product-output')) {
  customElements.define('custom-product-output', _quiz_components_v2_custom_product_output__WEBPACK_IMPORTED_MODULE_8__["default"]);
}
if (!customElements.get('custom-input-text')) {
  customElements.define('custom-input-text', _quiz_components_v2_custom_input_text__WEBPACK_IMPORTED_MODULE_7__["default"]);
}
if (!customElements.get('custom-input-range-image-v2')) {
  customElements.define('custom-input-range-image-v2', _quiz_components_v2_custom_input_range_image_v2__WEBPACK_IMPORTED_MODULE_6__["default"]);
}
if (!customElements.get('custom-input-radio')) {
  customElements.define('custom-input-radio', _quiz_components_v2_custom_input_radio__WEBPACK_IMPORTED_MODULE_5__["default"]);
}
if (!customElements.get('custom-input-checkbox')) {
  customElements.define('custom-input-checkbox', _quiz_components_v2_custom_input_checkbox__WEBPACK_IMPORTED_MODULE_4__["default"]);
}
if (!customElements.get('custom-image-slider')) {
  customElements.define('custom-image-slider', _quiz_components_v2_custom_image_slider__WEBPACK_IMPORTED_MODULE_3__["default"]);
}
if (!customElements.get('breed-radio-selector')) {
  customElements.define('breed-radio-selector', _quiz_components_v2_breed_radio_selector__WEBPACK_IMPORTED_MODULE_1__["default"]);
}
if (!customElements.get('custom-dropdown')) {
  customElements.define('custom-dropdown', _quiz_components_v2_custom_dropdown__WEBPACK_IMPORTED_MODULE_2__["default"]);
}
if (!customElements.get('quiz-klaviyo-form')) {
  customElements.define('quiz-klaviyo-form', _quiz_components_v2_quiz_klaviyo_form__WEBPACK_IMPORTED_MODULE_15__["default"]);
}

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__("./src/assets/js/quiz-v2.js"));
/******/ }
]);